var __defProp = Object.defineProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};

// app/HVThemeProvider.tsx
import "@mantine/core/styles.css";
import "@mantine/notifications/styles.css";
import { MantineProvider } from "@mantine/core";

// hvCommonColors.ts
var commonColors = {
  /* Colors (Light Theme) */
  white: "var(--hv-white)",
  black: "var(--hv-black)",
  surface: "var(--hv-surface)",
  surfaceWidget: "var(--hv-surface-widget)",
  surfacePopup: "var(--hv-surface-popup)",
  surfacePopupPanel: "var(--hv-surface-popup-panel)",
  /* Interaction */
  interactionHover: "var(--hv-interaction-hover)",
  interactionPress: "var(--hv-interaction-press)",
  interactionSelectGray: "var(--hv-interaction-select-gray)",
  interactionSelectOrange: "var(--hv-interaction-select-orange)",
  /* Brand */
  brandPrimary: "var(--hv-brand-primary)",
  /* Data */
  dataBlue: "var(--hv-data-blue)",
  dataRed: "var(--hv-data-red)",
  dataGray: "var(--hv-data-gray)",
  dataGreen: "var(--hv-data-green)",
  dataYellow: "var(--hv-data-yellow)",
  dataSapphire: "var(--hv-data-sapphire)",
  dataOrange: "var(--hv-data-orange)",
  dataEmerald: "var(--hv-data-emerald)",
  dataCoral: "var(--hv-data-coral)",
  dataIndigo: "var(--hv-data-indigo)",
  dataPurple: "var(--hv-data-purple)",
  dataViolet: "var(--hv-data-violet)",
  dataPink: "var(--hv-data-pink)",
  /* Primary Button */
  buttonPrimaryDefault: "var(--hv-button-primary-default)",
  buttonPrimaryHover: "var(--hv-button-primary-hover)",
  buttonPrimaryPress: "var(--hv-button-primary-press)",
  buttonPrimaryDisabled: "var(--hv-button-primary-disabled)",
  /* Secondary Button */
  buttonSecondaryDefault: "var(--hv-button-secondary-default)",
  buttonSecondaryHover: "var(--hv-button-secondary-hover)",
  buttonSecondaryPress: "var(--hv-button-secondary-press)",
  buttonSecondaryDisabled: "var(--hv-button-secondary-disabled)",
  /* Tertiary Button */
  buttonTertiaryHover: "var(--hv-button-tertiary-hover)",
  buttonTertiaryPress: "var(--hv-button-tertiary-press)",
  buttonTertiaryOutlineDefault: "var(--hv-button-tertiary-outline-default)",
  /* Ghost Button */
  buttonGhostHover: "var(--hv-button-ghost-hover)",
  buttonGhostPress: "var(--hv-button-ghost-press)",
  buttonGhostDisabled: "var(--hv-button-ghost-disabled)",
  /* Normal Icon */
  iconNormalPrimary: "var(--hv-icon-normal-primary)",
  iconNormalSecondary: "var(--hv-icon-normal-secondary)",
  iconNormalTertiary: "var(--hv-icon-normal-tertiary)",
  iconNormalDisabled: "var(--hv-icon-normal-disabled)",
  /* On-Brand Icon */
  iconOnBrandPrimary: "var(--hv-icon-on-brand-primary)",
  iconOnBrandSecondary: "var(--hv-icon-on-brand-secondary)",
  iconOnBrandTertiary: "var(--hv-icon-on-brand-tertiary)",
  iconOnBrandDisabled: "var(--hv-icon-on-brand-disabled)",
  /* Normal Text */
  textNormalPrimary: "var(--hv-text-normal-primary)",
  textNormalSecondary: "var(--hv-text-normal-secondary)",
  textNormalTertiary: "var(--hv-text-normal-tertiary)",
  textNormalDisabled: "var(--hv-text-normal-disabled)",
  /* On-Brand Text */
  textOnBrandPrimary: "var(--hv-text-on-brand-primary)",
  textOnBrandSecondary: "var(--hv-text-on-brand-secondary)",
  textOnBrandTertiary: "var(--hv-text-on-brand-tertiary)",
  textOnBrandDisabled: "var(--hv-text-on-brand-disabled)",
  /* Input Foreground Colors */
  inputForegroundDefault: "var(--hv-input-foreground-default)",
  inputForegroundHover: "var(--hv-input-foreground-hover)",
  inputForegroundPress: "var(--hv-input-foreground-press)",
  inputForegroundDisabled: "var(--hv-input-foreground-disabled)",
  /* Input Outline Colors */
  inputOutlineActive: "var(--hv-input-outline-active)",
  inputOutlineDefault: "var(--hv-input-outline-default)",
  inputOutlineHover: "var(--hv-input-outline-hover)",
  inputOutlinePress: "var(--hv-input-outline-press)",
  /* Border Colors */
  borderDefault: "var(--hv-border-default)",
  borderEmphasis: "var(--hv-border-emphasis)",
  /* Scroll Colors */
  scrollDefault: "var(--hv-scroll-default)",
  scrollHover: "var(--hv-scroll-hover)",
  /* Table Header Colors */
  tableHeaderDefault: "var(--hv-table-header-default)",
  /* Loading Colors */
  loadingCircuitRingDefault: "var(--hv-loading-circuit-ring-default)",
  loadingSpinnerPrimary: "var(--hv-loading-spinner-primary)",
  loadingSpinnerSecondary: "var(--hv-loading-spinner-secondary)",
  /* Alert Colors */
  alertTextDefault: "var(--hv-alert-text-default)",
  alertIconDefault: "var(--hv-alert-icon-default)",
  alertBackgroundDefault: "var(--hv-alert-background-default)",
  /* Snack Bar Colors */
  snackBarTextDefault: "var(--hv-snack-bar-text-default)",
  snackBarIconDefault: "var(--hv-snack-bar-icon-default)",
  snackBarIconHover: "var(--hv-snack-bar-icon-hover)",
  snackBarIconPress: "var(--hv-snack-bar-icon-press)",
  snackBarBackgroundDefault: "var(--hv-snack-bar-background-default)",
  /* Tooltip Colors */
  tooltipBackground: "var(--hv-tooltip-background)",
  /* Dropdown Colors */
  optionsBackgoundColor: "var(--hv-options-backgound-color)",
  optionsBorderColor: "var(--hv-options-border-color)",
  /* Avatar Colors */
  avatarBackgroundPrimaryTop: "var(--hv-avatar-background-primary-top)",
  avatarBackgroundPrimaryBottom: "var(--hv-avatar-background-primary-bottom)",
  avatarBackgroundSecondaryTop: "var(--hv-avatar-background-secondary-top)",
  avatarBackgroundSecondaryBottom: "var(--hv-avatar-background-secondary-bottom)",
  avatarTextPrimary: "var(--hv-avatar-text-primary)",
  avatarTextSecondary: "var(--hv-avatar-text-secondary)",
  /* Toggle Colors */
  toggleDefault: "var(--hv-toggle-default)",
  toggleSelectedGreen: "var(--hv-toggle-selected-green)",
  toggleSelectedOrange: "var(--hv-toggle-selected-orange)",
  toggleDisabled: "var(--hv-toggle-disabled)",
  toggleHandle: "var(--hv-toggle-handle)",
  /* PI Logo Colors */
  piLogoOrange: "var(--hv-pi-logo-orange)",
  piLogoIntersection: "var(--hv-pi-logo-intersection)",
  piLogoGray: "var(--hv-pi-logo-gray)",
  piLogoLeft: "var(--hv-pi-logo-left)",
  piLogoIntersectionGray: "var(--hv-pi-logo-intersection-gray)",
  piLogoRight: "var(--hv-pi-logo-right)"
};

// hvThemeColors.ts
var themeColors = {
  /* Font Weights */
  "--hv-font-weight-regular": "var(--hv-font-weight-regular)",
  "--hv-font-weight-medium": "var(--hv-font-weight-medium)",
  "--hv-font-weight-semibold": "var(--hv-font-weight-semibold)",
  "--hv-font-weight-bold": "var(--hv-font-weight-bold)",
  /* Radius */
  "--hv-radius-none": "var(--hv-radius-none)",
  "--hv-radius-xs": "var(--hv-radius-xs)",
  "--hv-radius-sm": "var(--hv-radius-sm)",
  "--hv-radius-md": "var(--hv-radius-md)",
  "--hv-radius-lg": "var(--hv-radius-lg)",
  "--hv-radius-xl": "var(--hv-radius-xl)",
  /* Spacing */
  "--hv-spacing-none": "var(--hv-spacing-none)",
  "--hv-spacing-1": "var(--hv-spacing-1)",
  "--hv-spacing-2": "var(--hv-spacing-2)",
  "--hv-spacing-3": "var(--hv-spacing-3)",
  "--hv-spacing-4": "var(--hv-spacing-4)",
  "--hv-spacing-5": "var(--hv-spacing-5)",
  "--hv-spacing-6": "var(--hv-spacing-6)",
  "--hv-spacing-7": "var(--hv-spacing-7)",
  "--hv-spacing-8": "var(--hv-spacing-8)",
  "--hv-spacing-9": "var(--hv-spacing-9)",
  "--hv-spacing-10": "var(--hv-spacing-10)",
  "--hv-spacing-full": "var(--hv-spacing-full)",
  /* Font Sizes */
  "--hv-fontsize-body-xs": "var(--hv-fontsize-body-xs)",
  "--hv-fontsize-body-sm": "var(--hv-fontsize-body-sm)",
  "--hv-fontsize-body-md": "var(--hv-fontsize-body-md)",
  "--hv-fontsize-body-lg": "var(--hv-fontsize-body-lg)",
  "--hv-fontsize-headline-2xs": "var(--hv-fontsize-headline-2xs)",
  "--hv-fontsize-headline-xs": "var(--hv-fontsize-headline-xs)",
  "--hv-fontsize-headline-sm": "var(--hv-fontsize-headline-sm)",
  "--hv-fontsize-headline-md": "var(--hv-fontsize-headline-md)",
  "--hv-fontsize-headline-lg": "var(--hv-fontsize-headline-lg)",
  "--hv-fontsize-headline-xl": "var(--hv-fontsize-headline-xl)",
  /* Line Height */
  "--hv-lineheight-body-xs": "var(--hv-lineheight-body-xs)",
  "--hv-lineheight-body-sm": "var(--hv-lineheight-body-sm)",
  "--hv-lineheight-body-md": "var(--hv-lineheight-body-md)",
  "--hv-lineheight-body-lg": "var(--hv-lineheight-body-lg)",
  "--hv-lineheight-headline-2xs": "var(--hv-lineheight-headline-2xs)",
  "--hv-lineheight-headline-xs": "var(--hv-lineheight-headline-xs)",
  "--hv-lineheight-headline-sm": "var(--hv-lineheight-headline-sm)",
  "--hv-lineheight-headline-md": "var(--hv-lineheight-headline-md)",
  "--hv-lineheight-headline-lg": "var(--hv-lineheight-headline-lg)",
  "--hv-lineheight-headline-xl": "var(--hv-lineheight-headline-xl)",
  /* Colors (Light Theme) */
  "--hv-white": "var(--hv-white)",
  "--hv-black": "var(--hv-black)",
  "--hv-surface": "var(--hv-surface)",
  "--hv-surface-widget": "var(--hv-surface-widget)",
  "--hv-surface-popup": "var(--hv-surface-popup)",
  "--hv-surface-popup-panel": "var(--hv-surface-popup-panel)",
  /* Interaction */
  "--hv-interaction-hover": "var(--hv-interaction-hover)",
  "--hv-interaction-press": "var(--hv-interaction-press)",
  "--hv-interaction-select-gray": "var(--hv-interaction-select-gray)",
  "--hv-interaction-select-orange": "var(--hv-interaction-select-orange)",
  /* Brand */
  "--hv-brand-primary": "var(--hv-brand-primary)",
  /* Data */
  "--hv-data-blue": "var(--hv-data-blue)",
  "--hv-data-red": "var(--hv-data-red)",
  "--hv-data-gray": "var(--hv-data-gray)",
  "--hv-data-green": "var(--hv-data-green)",
  "--hv-data-yellow": "var(--hv-data-yellow)",
  "--hv-data-sapphire": "var(--hv-data-sapphire)",
  "--hv-data-orange": "var(--hv-data-orange)",
  "--hv-data-emerald": "var(--hv-data-emerald)",
  "--hv-data-coral": "var(--hv-data-coral)",
  "--hv-data-indigo": "var(--hv-data-indigo)",
  "--hv-data-purple": "var(--hv-data-purple)",
  "--hv-data-violet": "var(--hv-data-violet)",
  "--hv-data-pink": "var(--hv-data-pink)",
  /* Primary Button */
  "--hv-button-primary-default": "var(--hv-button-primary-default)",
  "--hv-button-primary-hover": "var(--hv-button-primary-hover)",
  "--hv-button-primary-press": "var(--hv-button-primary-press)",
  "--hv-button-primary-disabled": "var(--hv-button-primary-disabled)",
  /* Secondary Button */
  "--hv-button-secondary-default": "var(--hv-button-secondary-default)",
  "--hv-button-secondary-hover": "var(--hv-button-secondary-hover)",
  "--hv-button-secondary-press": "var(--hv-button-secondary-press)",
  "--hv-button-secondary-disabled": "var(--hv-button-secondary-disabled)",
  /* Tertiary Button */
  "--hv-button-tertiary-hover": "var(--hv-button-tertiary-hover)",
  "--hv-button-tertiary-press": "var(--hv-button-tertiary-press)",
  "--hv-button-tertiary-outline-default": "var(--hv-button-tertiary-outline-default)",
  /* Ghost Button */
  "--hv-button-ghost-hover": "var(--hv-button-ghost-hover)",
  "--hv-button-ghost-press": "var(--hv-button-ghost-press)",
  "--hv-button-ghost-disabled": "var(--hv-button-ghost-disabled)",
  /* Normal Icon */
  "--hv-icon-normal-primary": "var(--hv-icon-normal-primary)",
  "--hv-icon-normal-secondary": "var(--hv-icon-normal-secondary)",
  "--hv-icon-normal-tertiary": "var(--hv-icon-normal-tertiary)",
  "--hv-icon-normal-disabled": "var(--hv-icon-normal-disabled)",
  /* On-Brand Icon */
  "--hv-icon-on-brand-primary": "var(--hv-icon-on-brand-primary)",
  "--hv-icon-on-brand-secondary": "var(--hv-icon-on-brand-secondary)",
  "--hv-icon-on-brand-tertiary": "var(--hv-icon-on-brand-tertiary)",
  "--hv-icon-on-brand-disabled": "var(--hv-icon-on-brand-disabled)",
  /* Normal Text */
  "--hv-text-normal-primary": "var(--hv-text-normal-primary)",
  "--hv-text-normal-secondary": "var(--hv-text-normal-secondary)",
  "--hv-text-normal-tertiary": "var(--hv-text-normal-tertiary)",
  "--hv-text-normal-disabled": "var(--hv-text-normal-disabled)",
  /* On-Brand Text */
  "--hv-text-on-brand-primary": "var(--hv-text-on-brand-primary)",
  "--hv-text-on-brand-secondary": "var(--hv-text-on-brand-secondary)",
  "--hv-text-on-brand-tertiary": "var(--hv-text-on-brand-tertiary)",
  "--hv-text-on-brand-disabled": "var(--hv-text-on-brand-disabled)",
  /* Input Foreground Colors */
  "--hv-input-foreground-default": "var(--hv-input-foreground-default)",
  "--hv-input-foreground-hover": "var(--hv-input-foreground-hover)",
  "--hv-input-foreground-press": "var(--hv-input-foreground-press)",
  "--hv-input-foreground-disabled": "var(--hv-input-foreground-disabled)",
  /* Input Outline Colors */
  "--hv-input-outline-active": "var(--hv-input-outline-active)",
  "--hv-input-outline-default": "var(--hv-input-outline-default)",
  "--hv-input-outline-hover": "var(--hv-input-outline-hover)",
  "--hv-input-outline-press": "var(--hv-input-outline-press)",
  /* Border Colors */
  "--hv-border-default": "var(--hv-border-default)",
  "--hv-border-emphasis": "var(--hv-border-emphasis)",
  /* Scroll Colors */
  "--hv-scroll-default": "var(--hv-scroll-default)",
  "--hv-scroll-hover": "var(--hv-scroll-hover)",
  /* Table Header Colors */
  "--hv-table-header-default": "var(--hv-table-header-default)",
  /* Loading Colors */
  "--hv-loading-circuit-ring-default": "var(--hv-loading-circuit-ring-default)",
  "--hv-loading-spinner-primary": "var(--hv-loading-spinner-primary)",
  "--hv-loading-spinner-secondary": "var(--hv-loading-spinner-secondary)",
  /* Alert Colors */
  "--hv-alert-text-default": "var(--hv-alert-text-default)",
  "--hv-alert-icon-default": "var(--hv-alert-icon-default)",
  "--hv-alert-background-default": "var(--hv-alert-background-default)",
  /* Snack Bar Colors */
  "--hv-snack-bar-text-default": "var(--hv-snack-bar-text-default)",
  "--hv-snack-bar-icon-default": "var(--hv-snack-bar-icon-default)",
  "--hv-snack-bar-icon-hover": "var(--hv-snack-bar-icon-hover)",
  "--hv-snack-bar-icon-press": "var(--hv-snack-bar-icon-press)",
  "--hv-snack-bar-background-default": "var(--hv-snack-bar-background-default)",
  /* Tooltip Colors */
  "--hv-tooltip-background": "var(--hv-tooltip-background)",
  /* Dropdown Colors */
  "--hv-options-backgound-color": "var(--hv-options-backgound-color)",
  "--hv-options-border-color": "var(--hv-options-border-color)",
  /* Avatar Colors */
  "--hv-avatar-background-primary-top": "var(--hv-avatar-background-primary-top)",
  "--hv-avatar-background-primary-bottom": "var(--hv-avatar-background-primary-bottom)",
  "--hv-avatar-background-secondary-top": "var(--hv-avatar-background-secondary-top)",
  "--hv-avatar-background-secondary-bottom": "var(--hv-avatar-background-secondary-bottom)",
  "--hv-avatar-text-primary": "var(--hv-avatar-text-primary)",
  "--hv-avatar-text-secondary": "var(--hv-avatar-text-secondary)",
  /* Toggle Colors */
  "--hv-toggle-default": "var(--hv-toggle-default)",
  "--hv-toggle-selected-green": "var(--hv-toggle-selected-green)",
  "--hv-toggle-selected-orange": "var(--hv-toggle-selected-orange)",
  "--hv-toggle-disabled": "var(--hv-toggle-disabled)",
  "--hv-toggle-handle": "var(--hv-toggle-handle)",
  /* PI Logo Colors */
  "--hv-pi-logo-orange": "var(--hv-pi-logo-orange)",
  "--hv-pi-logo-intersection": "var(--hv-pi-logo-intersection)",
  "--hv-pi-logo-gray": "var(--hv-pi-logo-gray)",
  "--hv-pi-logo-left": "var(--hv-pi-logo-left)",
  "--hv-pi-logo-intersection-gray": "var(--hv-pi-logo-intersection-gray)",
  "--hv-pi-logo-right": "var(--hv-pi-logo-right)",
  /* Shadows */
  "--hv-shadow-1": "var(--hv-shadow-1)",
  "--hv-shadow-2": "var(--hv-shadow-2)",
  "--hv-shadow-3": "var(--hv-shadow-3)",
  "--hv-shadow-4": "var(--hv-shadow-4)",
  "--hv-shadow-5": "var(--hv-shadow-5)"
};

// hvTheme.ts
var fontSizes = {
  xsBody: "12px",
  smBody: "14px",
  mdBody: "16px",
  lgBody: "18px",
  "2xsHeadline": "20px",
  xsHeadline: "24px",
  smHeadline: "28px",
  mdHeadline: "32px",
  lgHeadline: "40px",
  xlHeadline: "60px"
};
var lineHeights = {
  xsBody: "18px",
  smBody: "20px",
  mdBody: "24px",
  lgBody: "26px",
  "2xsHeadline": "28px",
  xsHeadline: "32px",
  smHeadline: "36px",
  mdHeadline: "40px",
  lgHeadline: "48px",
  xlHeadline: "68px"
};
var mantineThemeColors = {
  //Background Colors
  BGDark: [
    "#000000",
    // BG 0
    "#080809",
    // BG 1
    "#101011",
    // BG 2
    "#181819",
    // BG 3
    "#202021",
    // BG 4
    "#282829",
    // BG 5
    "#303031",
    // BG 6
    "#383839",
    // BG 7
    "#404041",
    // BG 8
    "#484849",
    // BG 9
    "#505051",
    // BG 10
    "#585859",
    // BG 11
    "#606062"
    // BG 12
  ],
  BGLight: [
    "#FFFFFF",
    // BG 0
    "#F9FAFB",
    // BG 1
    "#F6F7F8",
    // BG 2
    "#EEEFF1",
    // BG 3
    "#E5E7EB",
    // BG 4
    "#DDDFE4",
    // BG 5
    "#D4D7DD",
    // BG 6
    "#CCCFD7",
    // BG 7
    "#C3C6D0",
    // BG 8
    "#BABEC9",
    // BG 9
    "#B2B6C2",
    // BG 10
    "#A9AEBC",
    // BG 11
    "#A1A6B5"
    // BG 12
  ],
  //Contrast
  CDark: [
    "#FFFFFF",
    // C 0
    "#FFFFFFC4",
    // C 1 (77%)
    "#FFFFFF9C",
    // C 2 (61%)
    "#FFFFFF7D",
    // C 3 (49%)
    "#FFFFFF61",
    // C 4 (38%)
    "#FFFFFF49",
    // C 5 (29%)
    "#FFFFFF36",
    // C 6 (21%)
    "#FFFFFF24",
    // C 7 (14%)
    "#FFFFFF14",
    // C 8 (8%)
    "#FFFFFF0A"
    // C 9 (4%)
  ],
  CLight: [
    "#000000",
    // C 0
    "#000000C4",
    // C 1 (77%)
    "#0000009C",
    // C 2 (61%)
    "#0000007D",
    // C 3 (49%)
    "#00000061",
    // C 4 (38%)
    "#00000049",
    // C 5 (29%)
    "#00000036",
    // C 6 (21%)
    "#00000024",
    // C 7 (14%)
    "#00000014",
    // C 8 (8%)
    "#0000000A"
    // C 9 (4%)
  ],
  //Brand
  BDark: [
    "#F37321",
    // B 0
    "#F37321CC",
    // B 1 (77%)
    "#F373219B",
    // B 2 (61%)
    "#F373217D",
    // B 3 (49%)
    "#F3732161",
    // B 4 (38%)
    "#F3732149",
    // B 5 (29%)
    "#F3732136",
    // B 6 (21%)
    "#F3732124",
    // B 7 (14%)
    "#F3732114",
    // B 8 (8%)
    "#F373210A"
    // B 9 (4%)
  ],
  BLight: [
    "#F37321",
    // B 0
    "#F37321CC",
    // B 1 (77%)
    "#F373219B",
    // B 2 (61%)
    "#F373217D",
    // B 3 (49%)
    "#F3732161",
    // B 4 (38%)
    "#F3732149",
    // B 5 (29%)
    "#F3732136",
    // B 6 (21%)
    "#F3732124",
    // B 7 (14%)
    "#F3732114",
    // B 8 (8%)
    "#F373210A"
    // B 9 (4%)
  ],
  orange: [
    "#F37321",
    // B 0
    "#F37321CC",
    // B 1 (77%)
    "#F373219B",
    // B 2 (61%)
    "#F373217D",
    // B 3 (49%)
    "#F3732161",
    // B 4 (38%)
    "#F3732149",
    // B 5 (29%)
    "#F3732136",
    // B 6 (21%)
    "#F3732124",
    // B 7 (14%)
    "#F3732114",
    // B 8 (8%)
    "#F373210A"
    // B 9 (4%)
  ]
};
var mantineThemeOthers = {
  fontWeight: {
    regular: 400,
    medium: 500,
    semibold: 600,
    bold: 700
  },
  DataDark: {
    blue: "#4891FF",
    red: "#FA4D4D",
    gray: "#56595B",
    green: "#7DC519",
    yellow: "#FFB400",
    sapphire: "#5071F2",
    orange: "#FF6D10",
    emerald: "#00B960",
    coral: "#FD6E55",
    indigo: "#5A44EB",
    purple: "#8333FC",
    violet: "#B93CF0",
    pink: "#FF5082"
  },
  DataLight: {
    blue: "#5596E2",
    red: "#F65A5A",
    gray: "#747E87",
    green: "#8EC63F",
    yellow: "#FFA400",
    sapphire: "#556ED7",
    orange: "#F37321",
    emerald: "#56AB50",
    coral: "#FF816B",
    indigo: "#647AED",
    purple: "#9A57E5",
    violet: "#B95AE5",
    pink: "#FF598E"
  }
};
var theme = {
  fontFamily: "Noto_Sans, sans-serif",
  fontFamilyMonospace: "Noto_Sans, sans-serif",
  //--mantine-font-size
  fontSizes,
  //--mantine-line-height
  lineHeights,
  //--mantine-radius
  radius: {
    none: "0px",
    xs: "4px",
    sm: "8px",
    md: "12px",
    lg: "16px",
    xl: "20px"
  },
  defaultRadius: "none",
  //--mantine-spacing
  spacing: {
    none: "0px",
    1: "4px",
    2: "8px",
    3: "12px",
    4: "16px",
    5: "20px",
    6: "24px",
    7: "28px",
    8: "32px",
    9: "40px",
    10: "48px",
    full: "999px"
  },
  shadows: {
    xs: "0 2px 4px var(--shadow-1)",
    sm: "0px 4px 8px var(--shadow-2)",
    md: "0px 6px 12px var(--shadow-3)",
    lg: "0px 8px 16px var(--shadow-4)",
    xl: "0px 20px 40px var(--shadow-5)"
  },
  primaryColor: "orange",
  primaryShade: 0,
  colors: { ...mantineThemeColors },
  other: mantineThemeOthers,
  themeColors,
  commonColors
};
var cssResolver = () => ({
  variables: {
    //HV 2.2
    // Font Weights
    "--hv-font-weight-regular": theme.other.fontWeight.regular,
    "--hv-font-weight-medium": theme.other.fontWeight.medium,
    "--hv-font-weight-semibold": theme.other.fontWeight.semibold,
    "--hv-font-weight-bold": theme.other.fontWeight.bold,
    // Radius
    "--hv-radius-none": theme.radius.none,
    "--hv-radius-xs": theme.radius.xs,
    "--hv-radius-sm": theme.radius.sm,
    "--hv-radius-md": theme.radius.md,
    "--hv-radius-lg": theme.radius.lg,
    "--hv-radius-xl": theme.radius.xl,
    // Spacing
    "--hv-spacing-none": "0px",
    "--hv-spacing-1": "4px",
    "--hv-spacing-2": "8px",
    "--hv-spacing-3": "12px",
    "--hv-spacing-4": "16px",
    "--hv-spacing-5": "20px",
    "--hv-spacing-6": "24px",
    "--hv-spacing-7": "28px",
    "--hv-spacing-8": "32px",
    "--hv-spacing-9": "40px",
    "--hv-spacing-10": "48px",
    "--hv-spacing-full": "999px",
    // Font Sizes
    "--hv-fontsize-body-xs": theme.fontSizes.xsBody,
    "--hv-fontsize-body-sm": theme.fontSizes.smBody,
    "--hv-fontsize-body-md": theme.fontSizes.mdBody,
    "--hv-fontsize-body-lg": theme.fontSizes.lgBody,
    "--hv-fontsize-headline-2xs": theme.fontSizes["2xsHeadline"],
    "--hv-fontsize-headline-xs": theme.fontSizes.xsHeadline,
    "--hv-fontsize-headline-sm": theme.fontSizes.smHeadline,
    "--hv-fontsize-headline-md": theme.fontSizes.mdHeadline,
    "--hv-fontsize-headline-lg": theme.fontSizes.lgHeadline,
    "--hv-fontsize-headline-xl": theme.fontSizes.xlHeadline,
    // Line Height
    "--hv-lineheight-body-xs": theme.lineHeights.xsBody,
    "--hv-lineheight-body-sm": theme.lineHeights.smBody,
    "--hv-lineheight-body-md": theme.lineHeights.mdBody,
    "--hv-lineheight-body-lg": theme.lineHeights.lgBody,
    "--hv-lineheight-headline-2xs": theme.lineHeights["2xsHeadline"],
    "--hv-lineheight-headline-xs": theme.lineHeights.xsHeadline,
    "--hv-lineheight-headline-sm": theme.lineHeights.smHeadline,
    "--hv-lineheight-headline-md": theme.lineHeights.mdHeadline,
    "--hv-lineheight-headline-lg": theme.lineHeights.lgHeadline,
    "--hv-lineheight-headline-xl": theme.lineHeights.xlHeadline
  },
  light: {
    //Whites
    "--hv-white": theme.colors.CDark[0],
    //#FFFFFF
    //Black
    "--hv-black": theme.colors.CLight[0],
    //#000000
    // Surface
    "--hv-surface": theme.colors.BGLight[3],
    // Color/Light/Background/BG 3: #EEEFF1
    "--hv-surface-widget": theme.colors.BGLight[0],
    // Color/Light/Background/BG 0: #FFFFFF
    "--hv-surface-popup": theme.colors.BGLight[0],
    // Color/Light/Background/BG 0: #FFFFFF
    "--hv-surface-popup-panel": theme.colors.BGLight[2],
    // Color/Light/Background/BG 2: #F6F7F8
    // Interaction
    "--hv-interaction-hover": theme.colors.CLight[9],
    // Color/Light/Contrast/C 9: #0000000A
    "--hv-interaction-press": theme.colors.CLight[8],
    // Color/Light/Contrast/C 8: #00000014
    "--hv-interaction-select-gray": theme.colors.CLight[8],
    // Color/Light/Contrast/C 8: #00000014
    "--hv-interaction-select-orange": theme.colors.BLight[0],
    // Color/Light/Brand/B 0: #F37321
    // Brand
    "--hv-brand-primary": theme.colors.BLight[0],
    // Color/Light/Brand/B 0: #F37321
    // Data
    "--hv-data-blue": theme.other.DataLight.blue,
    // Color/Light/Data/Blue: #5596E2
    "--hv-data-red": theme.other.DataLight.red,
    // Color/Light/Data/Red: #F65A5A
    "--hv-data-gray": theme.other.DataLight.gray,
    // Color/Light/Data/Gray: #747E87
    "--hv-data-green": theme.other.DataLight.green,
    // Color/Light/Data/Green: #8EC63F
    "--hv-data-yellow": theme.other.DataLight.yellow,
    // Color/Light/Data/Yellow: #FFA400
    "--hv-data-sapphire": theme.other.DataLight.sapphire,
    // Color/Light/Data/Sapphire: #556ED7
    "--hv-data-orange": theme.other.DataLight.orange,
    // Color/Light/Data/Orange: #F37321
    "--hv-data-emerald": theme.other.DataLight.emerald,
    // Color/Light/Data/Emerald: #56AB50
    "--hv-data-coral": theme.other.DataLight.coral,
    // Color/Light/Data/Coral: #FF816B
    "--hv-data-indigo": theme.other.DataLight.indigo,
    // Color/Light/Data/Indigo: #647AED
    "--hv-data-purple": theme.other.DataLight.purple,
    // Color/Light/Data/Purple: #9A57E5
    "--hv-data-violet": theme.other.DataLight.violet,
    // Color/Light/Data/Violet: #B95AE5
    "--hv-data-pink": theme.other.DataLight.pink,
    // Color/Light/Data/Pink: #FF598E
    // Primary Button
    "--hv-button-primary-default": theme.colors.BLight[0],
    // Light: Color/Light/Brand/B 0 #F37321
    "--hv-button-primary-hover": theme.colors.BLight[1],
    // Light: Color/Light/Brand/B 1 #F37321CC
    "--hv-button-primary-press": theme.colors.BLight[2],
    // Light: Color/Light/Brand/B 12 #F37321
    "--hv-button-primary-disabled": theme.colors.CLight[9],
    // Light: Color/Light/Contrast/C 9 #0000000A
    // Secondary Button
    "--hv-button-secondary-default": theme.colors.CLight[7],
    // Light: Color/Light/Contrast/C 7
    "--hv-button-secondary-hover": theme.colors.CLight[6],
    // Light: Color/Light/Contrast/C 6
    "--hv-button-secondary-press": theme.colors.CLight[5],
    // Light: Color/Light/Contrast/C 5
    "--hv-button-secondary-disabled": theme.colors.CLight[9],
    // Light: Color/Light/Contrast/C 9 #0000000A
    // Tertiary Button
    "--hv-button-tertiary-hover": theme.colors.CLight[9],
    // Light: Color/Light/Contrast/C 9 #0000000A
    "--hv-button-tertiary-press": theme.colors.CLight[8],
    // Light: Color/Light/Contrast/C 8 #00000014
    "--hv-button-tertiary-outline-default": theme.colors.CLight[6],
    // Light: Color/Light/Contrast/C 6 #00000021
    // Ghost Button
    "--hv-button-ghost-hover": theme.colors.CLight[9],
    // Light: Color/Light/Contrast/C 9 #0000000A
    "--hv-button-ghost-press": theme.colors.CLight[8],
    // Light: Color/Light/Contrast/C 8 #00000014
    "--hv-button-ghost-disabled": theme.colors.CLight[9],
    // Light: Color/Light/Contrast/C 9 #0000000A
    // Normal Icon
    "--hv-icon-normal-primary": theme.colors.CLight[0],
    // Light: Color/Light/Contrast/C 0 #000000
    "--hv-icon-normal-secondary": theme.colors.CLight[1],
    // Light: Color/Light/Contrast/C 1 #000000B2
    "--hv-icon-normal-tertiary": theme.colors.CLight[3],
    // Light: Color/Light/Contrast/C 3 #0000007C
    "--hv-icon-normal-disabled": theme.colors.CLight[5],
    // Light: Color/Light/Contrast/C 5 #0000004A
    // On-Brand Icon (not affected by color mode)
    "--hv-icon-on-brand-primary": theme.colors.CDark[0],
    // Light: Color/Light/Contrast/C 0 #000000
    "--hv-icon-on-brand-secondary": theme.colors.CDark[2],
    // Light: Color/Light/Contrast/C 2 #FFFFFF9B
    "--hv-icon-on-brand-tertiary": theme.colors.CDark[4],
    // Light: Color/Light/Contrast/C 4 #FFFFFF61
    "--hv-icon-on-brand-disabled": theme.colors.CLight[5],
    // Light: Color/Light/Contrast/C 5 #0000004A
    // Normal Text
    "--hv-text-normal-primary": theme.colors.CLight[0],
    // Light: Color/Light/Contrast/C 0 #000000
    "--hv-text-normal-secondary": theme.colors.CLight[1],
    // Light: Color/Light/Contrast/C 1 #000000C3
    "--hv-text-normal-tertiary": theme.colors.CLight[3],
    // Light: Color/Light/Contrast/C 3 #0000007D
    "--hv-text-normal-disabled": theme.colors.CLight[5],
    // Light: Color/Light/Contrast/C 5 #0000004A
    // On-Brand Text (not affected by color mode)
    "--hv-text-on-brand-primary": theme.colors.CDark[0],
    // Dark: Color/Dark/Contrast/C 0 #FFFFFF
    "--hv-text-on-brand-secondary": theme.colors.CDark[2],
    // Dark: Color/Dark/Contrast/C 2 #FFFFFF9B
    "--hv-text-on-brand-tertiary": theme.colors.CDark[4],
    // Dark: Color/Dark/Contrast/C 4 #FFFFFF61
    "--hv-text-on-brand-disabled": theme.colors.CLight[5],
    // Light: Color/Light/Contrast/C 5 #0000004A
    // Input Foreground Colors
    "--hv-input-foreground-default": "none",
    // None
    "--hv-input-foreground-hover": theme.colors.CLight[9],
    // Light: Color/Light/Contrast/C 9 #000000C3
    "--hv-input-foreground-press": theme.colors.CLight[8],
    // Light: Color/Light/Contrast/C 8 #0000007D
    "--hv-input-foreground-disabled": theme.colors.CLight[9],
    // Light: Color/Light/Contrast/C 9 #0000004A
    // Input Outline Colors
    "--hv-input-outline-active": theme.colors.CLight[0],
    // Light: Color/Light/Contrast/C 0 #FFFFFF
    "--hv-input-outline-default": theme.colors.CLight[6],
    // Light: Color/Light/Contrast/C 6 #FFFFFF9B
    "--hv-input-outline-hover": theme.colors.CLight[5],
    // Light: Color/Light/Contrast/C 5 #FFFFFF61
    "--hv-input-outline-press": theme.colors.CLight[4],
    // Light: Color/Light/Contrast/C 4 #0000004A
    // Border Colors
    "--hv-border-default": theme.colors.CLight[8],
    // Light: Color/Light/Contrast/C 8 #00000014
    "--hv-border-emphasis": theme.colors.CLight[6],
    // Light: Color/Light/Contrast/C 6 #00000036
    // Scroll Colors
    "--hv-scroll-default": theme.colors.BGLight[7],
    // Light Mode: Color/Light/Contrast/C 7 #00000024
    "--hv-scroll-hover": theme.colors.BGLight[6],
    // Light Mode: Color/Light/Contrast/C 6 #00000036
    // Table Header Colors
    "--hv-table-header-default": theme.colors.BGLight[3],
    // Light Mode: Color/Light/Background/BG 3 #EEEFF1
    // Loading Colors
    "--hv-loading-circuit-ring-default": theme.colors.CLight[7],
    // Light Mode: Color/Light/Contrast/C 7 #00000024
    "--hv-loading-spinner-primary": theme.colors.BLight[0],
    // Light Mode: Color/Light/Brand/B 0 #F37321
    "--hv-loading-spinner-secondary": theme.colors.CLight[1],
    // Light Mode: Color/Light/Contrast/C 1 #000000C4
    // Alert colors
    "--hv-alert-text-default": theme.colors.CDark[0],
    "--hv-alert-icon-default": theme.colors.CDark[0],
    "--hv-alert-background-default": theme.colors.BGDark[0],
    // Snack Bar Colors
    "--hv-snack-bar-text-default": theme.colors.CDark[0],
    // Light Mode: Color/Dark/Contrast/C 0 #FFFFFF
    "--hv-snack-bar-icon-default": theme.colors.CDark[0],
    // Light Mode: Color/Dark/Contrast/C 0 #FFFFFF
    "--hv-snack-bar-icon-hover": theme.colors.CDark[9],
    // Light Mode: Color/Dark/Contrast/C 9 "#FFFFFF0A", // C 9 (4%)
    "--hv-snack-bar-icon-press": theme.colors.CDark[8],
    // Light Mode: Color/Dark/Contrast/C 8 "#FFFFFF14", // C 8 (8%)
    "--hv-snack-bar-background-default": theme.colors.BGDark[0],
    // Light Mode: Color/Dark/Background/BG 0 #000000
    // Tooltip Colors
    "--hv-tooltip-background": theme.colors.BGDark[6],
    // Dark Mode: Color/Dark/Background/BG 6 #303031
    // Dropdown colors
    "--hv-options-backgound-color": theme.colors.BGLight[0],
    "--hv-options-border-color": theme.colors.CLight[8],
    // Avatar Colors
    "--hv-avatar-background-primary-top": theme.colors.BLight[7],
    // Light Mode: Color/Light/Brand/B 7 #F3732124
    "--hv-avatar-background-primary-bottom": theme.colors.BGLight[0],
    // Light Mode: Color/Light/Background/BG 0 #FFFFFF
    "--hv-avatar-background-secondary-top": theme.colors.CLight[8],
    // Light Mode: Color/Light/Contrast/C 8 #00000014
    "--hv-avatar-background-secondary-bottom": theme.colors.BGLight[0],
    // Light Mode: Color/Light/Background/BG 0 #FFFFFF
    "--hv-avatar-text-primary": theme.colors.BLight[0],
    // Light Mode: Color/Light/Brand/B 0 #F37321
    "--hv-avatar-text-secondary": theme.colors.CLight[2],
    // Light Mode: Color/Light/Contrast/C 2 #0000009C
    // Toggle Colors
    "--hv-toggle-default": theme.colors.CLight[6],
    // Light Mode: Color/Light/Contrast/C 6 #F37321
    "--hv-toggle-selected-green": theme.other.DataLight.emerald,
    // Light Mode: Color/Light/Data/Emerald #56AB50
    "--hv-toggle-selected-orange": theme.colors.BLight[0],
    // Light Mode: Color/Light/Brand/B 0 #F37321
    "--hv-toggle-disabled": theme.colors.CLight[8],
    // Light Mode: Color/Light/Contrast/C 8 #EEEFF1
    "--hv-toggle-handle": theme.colors.BGLight[0],
    // Light Mode: Color/Light/Background/BG 0 #F37321
    // PI Logo Colors
    "--hv-pi-logo-orange": theme.colors.BLight[0],
    // Light Mode: #F37321
    "--hv-pi-logo-intersection": theme.colors.CLight[9],
    // Light Mode: #9B0000
    "--hv-pi-logo-gray": theme.colors.CLight[8],
    // Light Mode: #889199
    "--hv-pi-logo-left": theme.colors.CLight[9],
    // Light Mode: #A1A4A5
    "--hv-pi-logo-intersection-gray": theme.colors.CLight[5],
    // Light Mode: #515152
    "--hv-pi-logo-right": theme.colors.CLight[6],
    // Light Mode: #C9CDCF
    // Light Mode Shadows with Hex Alpha (Approximation)
    "--hv-shadow-1": `0px 2px 4px 0px #0000001F`,
    // Light Mode: Shadow/1 #000000 12% opacity
    "--hv-shadow-2": `0px 4px 8px 0px #0000001F`,
    // Light Mode: Shadow/2 #000000 12% opacity
    "--hv-shadow-3": `0px 12px 20px 0px #00000028`,
    // Light Mode: Shadow/3 #000000 16% opacity
    "--hv-shadow-4": `0px 16px 24px 0px #00000028`,
    // Light Mode: Shadow/4 #000000 16% opacity
    "--hv-shadow-5": `0px 24px 32px 0px #00000033`
    // Light Mode: Shadow/5 #000000 20% opacity
  },
  dark: {
    // Surface
    "--hv-surface": theme.colors.BGDark[2],
    // Color/Dark/Background/BG 2: #101011
    "--hv-surface-widget": theme.colors.BGDark[4],
    // Color/Dark/Background/BG 4: #202021
    "--hv-surface-popup": theme.colors.BGDark[6],
    // Color/Dark/Background/BG 6: #303031
    "--hv-surface-popup-panel": theme.colors.BGDark[5],
    // Color/Dark/Background/BG 5: #282829
    // Interaction
    "--hv-interaction-hover": theme.colors.CDark[9],
    // Color/Dark/Contrast/C 9: #FFFFFF0A
    "--hv-interaction-press": theme.colors.CDark[8],
    // Color/Dark/Contrast/C 8: #FFFFFF14
    "--hv-interaction-select-gray": theme.colors.CDark[8],
    // Color/Dark/Contrast/C 8: #FFFFFF14
    "--hv-interaction-select-orange": theme.colors.BDark[0],
    // Color/Dark/Brand/B 0: #F37321
    // Brand
    "--hv-brand-primary": theme.colors.BDark[0],
    // Color/Dark/Brand/B 0: #F37321
    // Data
    "--hv-data-blue": theme.other.DataDark.blue,
    // Color/Dark/Data/Blue: #4891FF
    "--hv-data-red": theme.other.DataDark.red,
    // Color/Dark/Data/Red: #FA4D4D
    "--hv-data-gray": theme.other.DataDark.gray,
    // Color/Dark/Data/Gray: #56595B
    "--hv-data-green": theme.other.DataDark.green,
    // Color/Dark/Data/Green: #7DC519
    "--hv-data-yellow": theme.other.DataDark.yellow,
    // Color/Dark/Data/Yellow: #FFB400
    "--hv-data-sapphire": theme.other.DataDark.sapphire,
    // Color/Dark/Data/Sapphire: #5071F2
    "--hv-data-orange": theme.other.DataDark.orange,
    // Color/Dark/Data/Orange: #FF6D10
    "--hv-data-emerald": theme.other.DataDark.emerald,
    // Color/Dark/Data/Emerald: #00B960
    "--hv-data-coral": theme.other.DataDark.coral,
    // Color/Dark/Data/Coral: #FD6E55
    "--hv-data-indigo": theme.other.DataDark.indigo,
    // Color/Dark/Data/Indigo: #5A44EB
    "--hv-data-purple": theme.other.DataDark.purple,
    // Color/Dark/Data/Purple: #8333FC
    "--hv-data-violet": theme.other.DataDark.violet,
    // Color/Dark/Data/Violet: #B93CF0
    "--hv-data-pink": theme.other.DataDark.pink,
    // Color/Dark/Data/Pink: #FF5082
    // Primary Button
    "--hv-button-primary-default": theme.colors.BDark[0],
    // Dark: Color/Dark/Brand/B 0 #F37321
    "--hv-button-primary-hover": theme.colors.BDark[1],
    // Dark: Color/Dark/Brand/B 1 #F37321CC
    "--hv-button-primary-press": theme.colors.BDark[2],
    // Dark: Color/Dark/Brand/B 12 #F37321
    "--hv-button-primary-disabled": theme.colors.CDark[9],
    // Dark: Color/Dark/Contrast/C 9 #FFFFFF0A
    // Secondary Button
    "--hv-button-secondary-default": theme.colors.CDark[7],
    // Dark: Color/Dark/Contrast/C 7
    "--hv-button-secondary-hover": theme.colors.CDark[6],
    // Dark: Color/Dark/Contrast/C 6
    "--hv-button-secondary-press": theme.colors.CDark[5],
    // Dark: Color/Dark/Contrast/C 5
    "--hv-button-secondary-disabled": theme.colors.CDark[9],
    // Dark: Color/Dark/Contrast/C 9 #FFFFFF0A
    // Tertiary Button
    "--hv-button-tertiary-hover": theme.colors.CDark[9],
    // Dark: Color/Dark/Contrast/C 9 #FFFFFF0A
    "--hv-button-tertiary-press": theme.colors.CDark[8],
    // Dark: Color/Dark/Contrast/C 8 #FFFFFF14
    "--hv-button-tertiary-outline-default": theme.colors.CDark[7],
    // Dark: Color/Dark/Contrast/C 7 #FFFFFF14
    // Ghost Button
    "--hv-button-ghost-hover": theme.colors.CDark[9],
    // Dark: Color/Dark/Contrast/C 9 #FFFFFF0A
    "--hv-button-ghost-press": theme.colors.CDark[8],
    // Dark: Color/Dark/Contrast/C 8 #FFFFFF14
    "--hv-button-ghost-disabled": theme.colors.CDark[9],
    // Dark: Color/Dark/Contrast/C 9 #FFFFFF0A
    // Normal Icon
    "--hv-icon-normal-primary": theme.colors.CDark[0],
    // Dark: Color/Dark/Contrast/C 0 #FFFFFF
    "--hv-icon-normal-secondary": theme.colors.CDark[2],
    // Dark: Color/Dark/Contrast/C 2 #FFFFFF9B
    "--hv-icon-normal-tertiary": theme.colors.CDark[4],
    // Dark: Color/Dark/Contrast/C 4 #FFFFFF61
    "--hv-icon-normal-disabled": theme.colors.CDark[6],
    // Dark: Color/Dark/Contrast/C 6 #FFFFFF35
    // On-Brand Icon (not affected by color mode)
    "--hv-icon-on-brand-primary": theme.colors.CDark[0],
    // Dark: Color/Dark/Contrast/C 0 #FFFFFF
    "--hv-icon-on-brand-secondary": theme.colors.CDark[2],
    // Dark: Color/Dark/Contrast/C 2 #FFFFFF9B
    "--hv-icon-on-brand-tertiary": theme.colors.CDark[4],
    // Dark: Color/Dark/Contrast/C 4 #FFFFFF61
    "--hv-icon-on-brand-disabled": theme.colors.CDark[6],
    // Dark: Color/Dark/Contrast/C 6 #FFFFFF35
    // Normal Text
    "--hv-text-normal-primary": theme.colors.CDark[0],
    // Dark: Color/Dark/Contrast/C 0 #FFFFFF
    "--hv-text-normal-secondary": theme.colors.CDark[2],
    // Dark: Color/Dark/Contrast/C 2 #FFFFFF9B
    "--hv-text-normal-tertiary": theme.colors.CDark[4],
    // Dark: Color/Dark/Contrast/C 4 #FFFFFF61
    "--hv-text-normal-disabled": theme.colors.CDark[6],
    // Dark: Color/Dark/Contrast/C 6 #FFFFFF35
    // On-Brand Text (not affected by color mode)
    "--hv-text-on-brand-primary": theme.colors.CDark[0],
    // Dark: Color/Dark/Contrast/C 0 #FFFFFF
    "--hv-text-on-brand-secondary": theme.colors.CDark[2],
    // Dark: Color/Dark/Contrast/C 2 #FFFFFF9B
    "--hv-text-on-brand-tertiary": theme.colors.CDark[4],
    // Dark: Color/Dark/Contrast/C 4 #FFFFFF61
    "--hv-text-on-brand-disabled": theme.colors.CDark[6],
    // Dark: Color/Dark/Contrast/C 6 #FFFFFF35
    // Input Foreground Colors
    "--hv-input-foreground-default": theme.colors.CDark[9],
    // Dark: Color/Dark/Contrast/C 9 #FFFFFF
    "--hv-input-foreground-hover": theme.colors.CDark[8],
    // Dark: Color/Dark/Contrast/C 8 #FFFFFF9B
    "--hv-input-foreground-press": theme.colors.CDark[7],
    // Dark: Color/Dark/Contrast/C 7 #FFFFFF61
    "--hv-input-foreground-disabled": theme.colors.CDark[9],
    // Dark: Color/Dark/Contrast/C 9 #FFFFFF35
    // Input Outline Colors
    "--hv-input-outline-active": theme.colors.CDark[0],
    // Dark: Color/Dark/Contrast/C 0 #FFFFFF
    "--hv-input-outline-default": theme.colors.CDark[7],
    // Dark: Color/Dark/Contrast/C 7 #FFFFFF9B
    "--hv-input-outline-hover": theme.colors.CDark[6],
    // Dark: Color/Dark/Contrast/C 6 #FFFFFF61
    "--hv-input-outline-press": theme.colors.CDark[5],
    // Dark: Color/Dark/Contrast/C 5 #FFFFFF35
    // Border Colors
    "--hv-border-default": theme.colors.CDark[8],
    // Dark: Color/Dark/Contrast/C 8 #FFFFFF14
    "--hv-border-emphasis": theme.colors.CDark[6],
    // Light: Color/Dark/Contrast/C 6 #FFFFFF36
    // Scroll Colors
    "--hv-scroll-default": theme.colors.BGDark[7],
    // Dark Mode: Color/Dark/Contrast/C 7 #FFFFFF24
    "--hv-scroll-hover": theme.colors.BGDark[6],
    // Dark Mode: Color/Dark/Contrast/C 6 #FFFFFF36
    // Table Header Colors
    "--hv-table-header-default": theme.colors.BGDark[5],
    // Dark Mode: Color/Dark/Background/BG 5 #282829
    // Loading Colors
    "--hv-loading-circuit-ring-default": theme.colors.CDark[7],
    // Dark Mode: Color/Dark/Contrast/C 7 #FFFFFF24
    "--hv-loading-spinner-primary": theme.colors.BDark[0],
    // Dark Mode: Color/Dark/Brand/B 0 #F37321
    "--hv-loading-spinner-secondary": theme.colors.CDark[2],
    // Dark Mode: Color/Dark/Contrast/C 2 #FFFFFF9C
    // Alert colors
    "--hv-alert-text-default": theme.colors.CLight[0],
    "--hv-alert-icon-default": theme.colors.CLight[0],
    "--hv-alert-background-default": theme.colors.BGLight[0],
    // Snack Bar Colors
    "--hv-snack-bar-text-default": theme.colors.CLight[0],
    // Dark Mode: Color/Light/Contrast/C 0 #000000
    "--hv-snack-bar-icon-default": theme.colors.CLight[0],
    // Dark Mode: Color/Light/Contrast/C 0 #000000
    "--hv-snack-bar-icon-hover": theme.colors.CLight[9],
    // Dark Mode: Color/Light/Contrast/C 9 "#0000000A", // C 9 (4%)
    "--hv-snack-bar-icon-press": theme.colors.CLight[8],
    // Dark Mode: Color/CLight/Contrast/C 8 "#00000014", // C 8 (8%)
    "--hv-snack-bar-background-default": theme.colors.BGLight[0],
    // Dark Mode: Color/Light/Background/BG 0 #FFFFFF
    // Tooltip Colors
    "--hv-tooltip-background": theme.colors.BGDark[6],
    // Dark Mode: Color/Dark/Background/BG 6 #303031
    // Dropdown colors
    "--hv-options-backgound-color": theme.colors.BGDark[6],
    "--hv-options-border-color": theme.colors.CDark[8],
    // Avatar Colors
    "--hv-avatar-background-primary-top": theme.colors.BDark[7],
    // Dark Mode: Color/Dark/Brand/B 7 #F3732124
    "--hv-avatar-background-primary-bottom": theme.colors.BGDark[0],
    // Dark Mode: Color/Dark/Background/BG 0 #000000
    "--hv-avatar-background-secondary-top": theme.colors.CDark[6],
    // Dark Mode: Color/Dark/Contrast/C 6 #FFFFFF36
    "--hv-avatar-background-secondary-bottom": theme.colors.BGDark[0],
    // Dark Mode: Color/Dark/Background/BG 0 #000000
    "--hv-avatar-text-primary": theme.colors.BDark[0],
    // Dark Mode: Color/Dark/Brand/B 0 #F37321
    "--hv-avatar-text-secondary": theme.colors.CDark[2],
    // Dark Mode: Color/Dark/Contrast/C 2 #FFFFFF9C
    // Toggle Colors
    "--hv-toggle-default": theme.colors.CDark[6],
    // Dark Mode: Color/Dark/Contrast/C 6 #FFFFFF36
    "--hv-toggle-selected-green": theme.other.DataDark.emerald,
    // Dark Mode: Color/Dark/Data/Emerald #00B960
    "--hv-toggle-selected-orange": theme.colors.BDark[0],
    // Dark Mode: Color/Dark/Brand/B 0 #F37321
    "--hv-toggle-disabled": theme.colors.CDark[8],
    // Dark Mode: Color/Dark/Contrast/C 8 #FFFFFF14
    "--hv-toggle-handle": theme.colors.CDark[0],
    // Dark Mode: Color/Dark/Contrast/C 0 #FFFFFF
    // PI Logo Colors
    "--hv-pi-logo-orange": theme.colors.BDark[0],
    // Dark Mode: #F37321
    "--hv-pi-logo-intersection": theme.colors.CDark[9],
    // Dark Mode: #9B0000
    "--hv-pi-logo-gray": theme.colors.CDark[8],
    // Dark Mode: #889199
    "--hv-pi-logo-left": theme.colors.CDark[9],
    // Dark Mode: #A1A4A5
    "--hv-pi-logo-intersection-gray": theme.colors.CDark[5],
    // Dark Mode: #515152
    "--hv-pi-logo-right": theme.colors.CDark[6],
    // Dark Mode: #C9CDCF
    // Dark Mode Shadows with Hex Alpha (Approximation)
    "--hv-shadow-1": `0px 2px 4px 0px #00000052`,
    // Dark Mode: Shadow/1 #000000 32% opacity
    "--hv-shadow-2": `0px 4px 8px 0px #00000066`,
    // Dark Mode: Shadow/2 #000000 40% opacity
    "--hv-shadow-3": `0px 12px 20px 0px #0000007A`,
    // Dark Mode: Shadow/3 #000000 48% opacity
    "--hv-shadow-4": `0px 16px 24px 0px #0000008F`,
    // Dark Mode: Shadow/4 #000000 56% opacity
    "--hv-shadow-5": `0px 24px 32px 0px #000000B8`
    // Dark Mode: Shadow/5 #000000 72% opacity
  }
});

// app/HVThemeProvider.tsx
import { Notifications } from "@mantine/notifications";
import { jsx, jsxs } from "react/jsx-runtime";
var HVThemeProvider = ({ children, ...rest }) => {
  return /* @__PURE__ */ jsxs(MantineProvider, { theme, cssVariablesResolver: cssResolver, ...rest, children: [
    /* @__PURE__ */ jsx(Notifications, {}),
    children
  ] });
};
var HVThemeProvider_default = HVThemeProvider;

// components/index.ts
import * as HVCore from "@mantine/core";
import * as HVTableProperties from "mantine-react-table";

// assets/icons/index.ts
var icons_exports = {};
__export(icons_exports, {
  BreadcrumbDivider: () => breadcrumbDivider_default,
  CloudPortalLogo: () => cloudPortal_default,
  HanwhaVisionLogo: () => HanwhaVisionLogo_default,
  IconAI: () => AI_default,
  IconAdd: () => add_default,
  IconAlarm: () => alarm_default,
  IconAnalytics: () => analytics_default,
  IconApps: () => apps_default,
  IconArea: () => area_default,
  IconArrowChevronDown: () => arrow_chevron_down_default,
  IconArrowChevronLeft: () => arrow_chevron_left_default,
  IconArrowChevronRight: () => arrow_chevron_right_default,
  IconArrowChevronUp: () => arrow_chevron_up_default,
  IconArrowDown: () => arrow_down_default,
  IconArrowRight: () => IconArrowRight_default,
  IconArrowTimeInputChevronDown: () => icon_arrow_time_input_chevron_down_default,
  IconArrowTimeInputChevronUp: () => icon_arrow_time_input_chevron_up_default,
  IconArrowUp: () => arrow_up_default,
  IconArrowUpDown: () => arrow_up_down_default,
  IconArrowsSort: () => IconArrowsSort_default,
  IconBookmark: () => bookmark_default,
  IconBuildingOffice1: () => building_office1_default,
  IconBuildingOffice2: () => building_office2_default,
  IconBuildingOffice3: () => building_office3_default,
  IconCalendar: () => calendar_default,
  IconCamera: () => camera_default,
  IconCameraDome: () => camera_dome_default,
  IconCameraDomeCloud: () => camera_dome_cloud_default,
  IconCameraExternal: () => camera_external_default,
  IconCameraFisheye: () => camera_fisheye_default,
  IconCameraMDC: () => camera_MDC_default,
  IconCameraPTZ: () => camera_PTZ_default,
  IconCameraTamp: () => camera_tamp_default,
  IconCaution: () => caution_default,
  IconCertification: () => certification_default,
  IconCgiSender: () => cgi_sender_default,
  IconCheck: () => check_default,
  IconCheckLine: () => icon_check_line_default,
  IconClose: () => close_default,
  IconCloseSign: () => closeSign_default,
  IconCloudUpload: () => cloud_upload_default,
  IconCopy: () => copy_default,
  IconCpu: () => cpu_default,
  IconCrowd: () => crowd_default,
  IconDashboard: () => dashboard_default,
  IconDashboardSign: () => dashboardSign_default,
  IconDashboards: () => dashboards_default,
  IconDefocus: () => defocus_default,
  IconDevice: () => device_default,
  IconDirection: () => direction_default,
  IconDocument: () => document_default,
  IconDownSide: () => arrow_down_side_default,
  IconDrag: () => drag_default,
  IconEdit: () => edit_default,
  IconEmail: () => email_default,
  IconEmpty: () => empty_default,
  IconEvent: () => event_default,
  IconEvents: () => events_default,
  IconExport: () => export_default,
  IconExternalLink: () => external_link_default,
  IconFace: () => face_default,
  IconFail: () => fail_default,
  IconFavorite: () => favorite_default,
  IconFilter: () => filter_default,
  IconFirmware: () => firmware_default,
  IconFocusFar: () => focus_far_default,
  IconFocusNear: () => focus_near_default,
  IconFogDetection: () => fog_detection_default,
  IconFolderClose: () => folder_close_default,
  IconFolderOpen: () => folder_open_default,
  IconFolklift: () => folklift_default,
  IconForkliftCounting: () => forklift_counting_default,
  IconForkliftHeatmap: () => forklift_heatmap_default,
  IconForkliftQueueManagement: () => forklift_queue_management_default,
  IconHeaterHeat: () => heater_heat_default,
  IconHeaterHeat1: () => heater_heat_1_default,
  IconHeatmap: () => heatmap_default,
  IconHelp: () => help_default,
  IconImageGallery: () => image_gallery_default,
  IconInfo: () => info_default,
  IconInformation: () => information_default,
  IconInformationPlain: () => information_plain_default,
  IconLargeIconEmptyState: () => largeIconEmptyState_default,
  IconLeaf: () => IconLeaf_default,
  IconLeftSide: () => arrow_left_side_default,
  IconLicense: () => license_default,
  IconLicensePlate: () => license_plate_default,
  IconLineCrossing: () => line_crossing_default,
  IconLink: () => link_default,
  IconLink1: () => link1_default,
  IconLinkClip: () => link_clip_default,
  IconList: () => list_default,
  IconLive: () => live_default,
  IconLocation: () => location_default,
  IconLockOpen: () => lock_open_default,
  IconLockOrg: () => lock_default,
  IconLog: () => log_default,
  IconLog1: () => log1_default,
  IconLogOut1: () => log_out1_default,
  IconLogout: () => logout_default,
  IconMap: () => map_default,
  IconMediumForEmptyState: () => mediumIconEmptyState_default,
  IconMenu: () => menu_default,
  IconMinus: () => minus_default,
  IconMore: () => more_default,
  IconMotionDetection: () => motion_detection_default,
  IconNetwork: () => network_default,
  IconNote: () => note_default,
  IconNotifications: () => notification_default,
  IconObjectDetection: () => object_detection_default,
  IconOnlineSuccess: () => online_success_default,
  IconOnlineSuccessPlain: () => online_success_plain_default,
  IconPTZ: () => PTZ_default,
  IconPeople: () => people_default,
  IconPeopleHeatmap: () => people_heatmap_default,
  IconPeopleVector: () => people_vector_default,
  IconPlainFail: () => fail_no_fill_default,
  IconPlayback: () => playback_default,
  IconPlus: () => plus_default,
  IconPoE: () => PoE_default,
  IconProfileLogout: () => log_out_default,
  IconQueueManagement: () => queue_management_default,
  IconRam: () => ram_default,
  IconRefresh: () => refresh_default,
  IconRemove: () => remove_default,
  IconReport: () => report_default,
  IconReports: () => reports_default,
  IconReportsOld: () => reports_old_default,
  IconReset: () => reset_default,
  IconRightSide: () => arrow_right_side_default,
  IconRuleSetup: () => rule_setup_default,
  IconSearch: () => search_default,
  IconServer: () => server_default,
  IconServerGateway: () => server_gateway_default,
  IconSetting: () => setting_default,
  IconSettings: () => settings_default,
  IconShare: () => share_default,
  IconShockDetection: () => shock_detection_default,
  IconShoppingCart: () => shopping_cart_default,
  IconShoppingCartCounting: () => shopping_cart_counting_default,
  IconShoppingCartHeatmap: () => shopping_cart_heatmap_default,
  IconShoppingCartQueueManagement: () => shopping_cart_queue_management_default,
  IconSlipFall: () => slip_fall_default,
  IconSoftwareUpdate: () => software_update_default,
  IconSortArrowDown: () => sort_arrow_down_default,
  IconSortArrowUp: () => sort_arrow_up_default,
  IconSortArrowUpDown: () => sort_arrow_up_down_default,
  IconSortAscending: () => IconSortAscending_default,
  IconSortDescending: () => IconSortDescending_default,
  IconSpeakerSoundVolume: () => speaker_sound_volume_default,
  IconSpeakerSoundVolumeMute: () => speaker_sound_volume_mute_default,
  IconStar: () => star_default,
  IconStoppedVehicle: () => stopped_vehicle_default,
  IconStorage: () => storage_default,
  IconSystem: () => system_default,
  IconTamperingDetection: () => tampering_detection_default,
  IconTemperature: () => temperature_default,
  IconTick: () => tick_default,
  IconTime: () => time_default,
  IconTooltipHelp: () => tooltipHelp_default,
  IconTooltipInfo: () => tooltipInfo_default,
  IconTopRank: () => top_rank_default,
  IconTrafficJam: () => traffic_jam_default,
  IconUnlinkClip: () => unlink_clip_default,
  IconUpSide: () => arrow_up_side_default,
  IconUser: () => user_default,
  IconUserGroup: () => user_group_default,
  IconUserProfile: () => user_profile_default,
  IconUserSingle: () => user_single_default,
  IconVehicle: () => vehicle_default,
  IconVehicleBicycle: () => vehicle_bicycle_default,
  IconVehicleBus: () => vehicle_bus_default,
  IconVehicleCounting: () => vehicle_counting_default,
  IconVehicleHeatmap: () => vehicle_heatmap_default,
  IconVehicleMotorcycle: () => vehicle_motorcycle_default,
  IconVehicleQueueManagement: () => vehicle_queue_management_default,
  IconVehicleSedan: () => vehicle_sedan_default,
  IconVehicleSuv: () => vehicle_suv_default,
  IconVehicleTruck: () => vehicle_truck_default,
  IconVehicleVan: () => vehicle_van_default,
  IconVideoLoss: () => video_loss_default,
  IconViewHide: () => view_hide_default,
  IconViewShow: () => view_show_default,
  IconWarning: () => warning_default,
  IconWarningError: () => warning_error_default,
  IconWarranty: () => warranty_default,
  IconWarrantyExpiration: () => warranty_expiration_default,
  RightArrow: () => rightArrow_default,
  SightMindLogo: () => sightMindLogo_default
});

// assets/icons/camera.svg
import * as React from "react";
import { jsx as jsx2, jsxs as jsxs2 } from "react/jsx-runtime";
var SvgCamera = (props) => /* @__PURE__ */ jsxs2("svg", { width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: [
  /* @__PURE__ */ jsx2("path", { d: "M19.5 8.52004V10.985C19.5 15.1333 16.14 18.5 12 18.5C7.86 18.5 4.5 15.1333 4.5 10.985V8.5", stroke: "inherit", strokeLinejoin: "round" }),
  /* @__PURE__ */ jsx2("path", { d: "M12.5 14C12.5 14.2739 12.2739 14.5 12 14.5C11.7261 14.5 11.5 14.2739 11.5 14C11.5 13.7261 11.7261 13.5 12 13.5C12.2739 13.5 12.5 13.7261 12.5 14Z", stroke: "inherit" }),
  /* @__PURE__ */ jsx2("path", { d: "M20.5 4.5H3.5C2.94772 4.5 2.5 4.94772 2.5 5.5V7.5C2.5 8.05228 2.94772 8.5 3.5 8.5H20.5C21.0523 8.5 21.5 8.05228 21.5 7.5V5.5C21.5 4.94772 21.0523 4.5 20.5 4.5Z", stroke: "inherit", strokeMiterlimit: 10 })
] });
var camera_default = SvgCamera;

// assets/icons/events.svg
import * as React2 from "react";
import { jsx as jsx3, jsxs as jsxs3 } from "react/jsx-runtime";
var SvgEvents = (props) => /* @__PURE__ */ jsxs3("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: [
  /* @__PURE__ */ jsx3("rect", { x: 3.75, y: 3, width: 12.5, height: 14, rx: 1, stroke: "inherit", strokeWidth: 1.5, strokeMiterlimit: 10 }),
  /* @__PURE__ */ jsx3("rect", { x: 6, y: 6, width: 8, height: 1.25, rx: 0.625, fill: "inherit" }),
  /* @__PURE__ */ jsx3("rect", { x: 6, y: 9, width: 3.75, height: 1.25, rx: 0.625, fill: "inherit" })
] });
var events_default = SvgEvents;

// assets/icons/user.svg
import * as React3 from "react";
import { jsx as jsx4, jsxs as jsxs4 } from "react/jsx-runtime";
var SvgUser = (props) => /* @__PURE__ */ jsxs4("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: [
  /* @__PURE__ */ jsxs4("g", { clipPath: "url(#clip0_11788_5087)", children: [
    /* @__PURE__ */ jsx4("path", { d: "M12.75 7.25C12.75 8.76643 11.5164 10 10 10C8.48357 10 7.25 8.76643 7.25 7.25C7.25 5.73357 8.48357 4.5 10 4.5C11.5164 4.5 12.75 5.73357 12.75 7.25Z", stroke: "inherit", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }),
    /* @__PURE__ */ jsx4("path", { d: "M4 15.9446C5.05357 13.6166 7.33929 12 9.99107 12C12.6429 12 14.9643 13.6443 16 16", stroke: "inherit", strokeWidth: 1.5, strokeMiterlimit: 10 }),
    /* @__PURE__ */ jsx4("path", { d: "M2 10C2 5.58272 5.58272 2 10 2C14.4173 2 18 5.58272 18 10C18 14.4173 14.4173 18 10 18C5.58272 18 2 14.4173 2 10Z", stroke: "inherit", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" })
  ] }),
  /* @__PURE__ */ jsx4("defs", { children: /* @__PURE__ */ jsx4("clipPath", { id: "clip0_11788_5087", children: /* @__PURE__ */ jsx4("rect", { width: 20, height: 20, fill: "inherit" }) }) })
] });
var user_default = SvgUser;

// assets/icons/log.svg
import * as React4 from "react";
import { jsx as jsx5, jsxs as jsxs5 } from "react/jsx-runtime";
var SvgLog = (props) => /* @__PURE__ */ jsxs5("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: [
  /* @__PURE__ */ jsxs5("g", { clipPath: "url(#clip0_11788_5049)", children: [
    /* @__PURE__ */ jsx5("path", { d: "M6.66406 7.75H13.3307", stroke: "inherit", strokeWidth: 1.25, strokeLinecap: "round", strokeLinejoin: "round" }),
    /* @__PURE__ */ jsx5("path", { d: "M6.66406 10.25H11.6641", stroke: "inherit", strokeWidth: 1.25, strokeLinecap: "round", strokeLinejoin: "round" }),
    /* @__PURE__ */ jsx5("path", { d: "M6.66406 12.75H13.3307", stroke: "inherit", strokeWidth: 1.25, strokeLinecap: "round", strokeLinejoin: "round" }),
    /* @__PURE__ */ jsx5("path", { d: "M13.755 3H15.4183C15.6389 3 15.8504 3.08194 16.0064 3.22781C16.1624 3.37367 16.25 3.5715 16.25 3.77778V16.2222C16.25 16.4285 16.1624 16.6263 16.0064 16.7722C15.8504 16.9181 15.6389 17 15.4183 17H4.58167C4.3611 17 4.14956 16.9181 3.99359 16.7722C3.83762 16.6263 3.75 16.4285 3.75 16.2222V3.77778C3.75 3.5715 3.83762 3.37367 3.99359 3.22781C4.14956 3.08194 4.3611 3 4.58167 3H6.24501", stroke: "inherit", strokeWidth: 1.5, strokeLinejoin: "round" }),
    /* @__PURE__ */ jsx5("path", { d: "M14 4.25C14 4.44891 13.9063 4.63968 13.7397 4.78033C13.573 4.92098 13.3469 5 13.1111 5H6.88889C6.65314 5 6.42705 4.92098 6.26035 4.78033C6.09365 4.63968 6 4.44891 6 4.25V2.75C6 2.55109 6.09365 2.36032 6.26035 2.21967C6.42705 2.07902 6.65314 2 6.88889 2H13.1111C13.3469 2 13.573 2.07902 13.7397 2.21967C13.9063 2.36032 14 2.55109 14 2.75V4.25Z", stroke: "inherit", strokeWidth: 1.25, strokeMiterlimit: 10 })
  ] }),
  /* @__PURE__ */ jsx5("defs", { children: /* @__PURE__ */ jsx5("clipPath", { id: "clip0_11788_5049", children: /* @__PURE__ */ jsx5("rect", { width: 20, height: 20, fill: "inherit" }) }) })
] });
var log_default = SvgLog;

// assets/icons/system.svg
import * as React5 from "react";
import { jsx as jsx6, jsxs as jsxs6 } from "react/jsx-runtime";
var SvgSystem = (props) => /* @__PURE__ */ jsxs6("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: [
  /* @__PURE__ */ jsxs6("g", { clipPath: "url(#clip0_11788_5076)", children: [
    /* @__PURE__ */ jsx6("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M16.272 9.97665C16.272 9.6871 16.244 9.39755 16.2067 9.11734L17.9907 7.72563L15.9731 4.2697L13.8716 5.09165C13.4046 4.72738 12.8908 4.42849 12.3304 4.20432L12.0035 2H7.97782L7.6509 4.20432C7.09048 4.42849 6.57677 4.72738 6.10975 5.09165L4.01751 4.2697L2 7.72563L3.784 9.11734C3.74664 9.39755 3.71862 9.6871 3.71862 9.97665C3.71862 10.2662 3.74664 10.5744 3.784 10.864L2 12.265L4.01751 15.721L6.14711 14.8897C6.60479 15.2446 7.10917 15.5342 7.6509 15.7583L7.98716 18H12.0128L12.3491 15.7583C12.9002 15.5435 13.4046 15.2446 13.8622 14.8897L15.9825 15.721L18 12.265L16.216 10.864C16.2627 10.5744 16.2907 10.2755 16.2907 9.97665H16.272Z", stroke: "inherit", strokeWidth: 1.5, strokeLinejoin: "round" }),
    /* @__PURE__ */ jsx6("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10 12C8.89344 12 8 11.1066 8 10C8 8.89344 8.89344 8 10 8C11.1066 8 12 8.89344 12 10C12 11.1066 11.1066 12 10 12Z", stroke: "inherit", strokeWidth: 1.5, strokeLinejoin: "round" })
  ] }),
  /* @__PURE__ */ jsx6("defs", { children: /* @__PURE__ */ jsx6("clipPath", { id: "clip0_11788_5076", children: /* @__PURE__ */ jsx6("rect", { width: 20, height: 20, fill: "inherit" }) }) })
] });
var system_default = SvgSystem;

// assets/icons/plus.svg
import * as React6 from "react";
import { jsx as jsx7, jsxs as jsxs7 } from "react/jsx-runtime";
var SvgPlus = (props) => /* @__PURE__ */ jsxs7("svg", { width: 16, height: 17, viewBox: "0 0 16 17", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: [
  /* @__PURE__ */ jsx7("path", { d: "M2.3335 9H13.6668", stroke: "inherit", strokeWidth: 1.5, strokeLinejoin: "round" }),
  /* @__PURE__ */ jsx7("path", { d: "M8 3.33331V14.6666", stroke: "inherit", strokeWidth: 1.5, strokeLinejoin: "round" })
] });
var plus_default = SvgPlus;

// assets/icons/star.svg
import * as React7 from "react";
import { jsx as jsx8, jsxs as jsxs8 } from "react/jsx-runtime";
var SvgStar = (props) => /* @__PURE__ */ jsxs8("svg", { width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: [
  /* @__PURE__ */ jsx8("path", { d: "M12 3.5L14.3511 8.26393L19.6085 9.02786L15.8042 12.7361L16.7023 17.9721L12 15.5L7.29772 17.9721L8.19577 12.7361L4.39155 9.02786L9.64886 8.26393L12 3.5Z", fill: "inherit", stroke: "inherit", strokeLinejoin: "round" }),
  /* @__PURE__ */ jsx8("path", { d: "M6 3.5L7 5", stroke: "inherit", strokeLinejoin: "round" }),
  /* @__PURE__ */ jsx8("path", { d: "M3 14.5L5 13.5", stroke: "inherit", strokeLinejoin: "round" }),
  /* @__PURE__ */ jsx8("path", { d: "M18 3.5L17 5", stroke: "inherit", strokeLinejoin: "round" }),
  /* @__PURE__ */ jsx8("path", { d: "M21 14.5L19 13.5", stroke: "inherit", strokeLinejoin: "round" }),
  /* @__PURE__ */ jsx8("path", { d: "M12 18.5V20.5", stroke: "inherit", strokeLinejoin: "round" })
] });
var star_default = SvgStar;

// assets/icons/dashboard.svg
import * as React8 from "react";
import { jsx as jsx9, jsxs as jsxs9 } from "react/jsx-runtime";
var SvgDashboard = (props) => /* @__PURE__ */ jsxs9("svg", { width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: [
  /* @__PURE__ */ jsx9("rect", { x: 3, y: 3.00195, width: 7.71348, height: 7.71348, rx: 1, fill: "inherit" }),
  /* @__PURE__ */ jsx9("rect", { x: 3, y: 13.2871, width: 7.71348, height: 7.71348, rx: 1, fill: "inherit" }),
  /* @__PURE__ */ jsx9("rect", { x: 13.2865, y: 3.00195, width: 7.71348, height: 7.71348, rx: 1, fill: "inherit" }),
  /* @__PURE__ */ jsx9("rect", { x: 13.2866, y: 13.2871, width: 7.71348, height: 7.71348, rx: 1, fill: "inherit" })
] });
var dashboard_default = SvgDashboard;

// assets/icons/tick.svg
import * as React9 from "react";
import { jsx as jsx10, jsxs as jsxs10 } from "react/jsx-runtime";
var SvgTick = (props) => /* @__PURE__ */ jsxs10("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: [
  /* @__PURE__ */ jsx10("circle", { cx: 9.99998, cy: 9.99998, r: 9.16667, fill: "#008847" }),
  /* @__PURE__ */ jsx10("path", { d: "M15 6.66669L8.1829 13.3334L5 10.2133", stroke: "white", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" })
] });
var tick_default = SvgTick;

// assets/icons/caution.svg
import * as React10 from "react";
import { jsx as jsx11, jsxs as jsxs11 } from "react/jsx-runtime";
var SvgCaution = (props) => /* @__PURE__ */ jsxs11("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: [
  /* @__PURE__ */ jsx11("path", { d: "M19.1262 16.5276C19.5139 17.1943 19.0329 18.0303 18.2617 18.0303H1.73828C0.967097 18.0303 0.486147 17.1943 0.873809 16.5276L9.13553 2.31994C9.52111 1.65685 10.4789 1.65685 10.8645 2.31994L19.1262 16.5276Z", fill: "#FFA400", stroke: "#FFA400", strokeLinecap: "round", strokeLinejoin: "round" }),
  /* @__PURE__ */ jsx11("path", { d: "M10.8334 13.3333H9.16669L9.16669 7.5H10.8334L10.8334 13.3333Z", fill: "white" }),
  /* @__PURE__ */ jsx11("circle", { cx: 10, cy: 15, r: 0.833333, fill: "white" })
] });
var caution_default = SvgCaution;

// assets/icons/info.svg
import * as React11 from "react";
import { jsx as jsx12, jsxs as jsxs12 } from "react/jsx-runtime";
var SvgInfo = (props) => /* @__PURE__ */ jsxs12("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: [
  /* @__PURE__ */ jsx12("circle", { cx: 9.99998, cy: 9.99998, r: 9.16667, fill: "#4164F1" }),
  /* @__PURE__ */ jsx12("path", { d: "M10.8334 11.6666H9.16669L9.16669 5.83331H10.8334L10.8334 11.6666Z", fill: "white" }),
  /* @__PURE__ */ jsx12("ellipse", { cx: 10, cy: 13.3333, rx: 0.833333, ry: 0.833333, fill: "white" })
] });
var info_default = SvgInfo;

// assets/icons/minus.svg
import * as React12 from "react";
import { jsx as jsx13 } from "react/jsx-runtime";
var SvgMinus = (props) => /* @__PURE__ */ jsx13("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx13("path", { d: "M2 8H14", stroke: "#797A7B", strokeLinejoin: "round" }) });
var minus_default = SvgMinus;

// assets/icons/logout.svg
import * as React13 from "react";
import { jsx as jsx14, jsxs as jsxs13 } from "react/jsx-runtime";
var SvgLogout = (props) => /* @__PURE__ */ jsxs13("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: [
  /* @__PURE__ */ jsx14("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2 14V2H9V0H1C0.447715 0 0 0.447715 0 1V15C0 15.5523 0.447715 16 1 16H9V14H2Z", fill: "inherit" }),
  /* @__PURE__ */ jsx14("path", { d: "M11.6667 12V9H6V7H11.6667V4L16 8L11.6667 12Z", fill: "inherit" })
] });
var logout_default = SvgLogout;

// assets/icons/IconArrowsSort.svg
import * as React14 from "react";
import { jsx as jsx15, jsxs as jsxs14 } from "react/jsx-runtime";
var SvgIconArrowsSort = (props) => /* @__PURE__ */ jsxs14("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", stroke: "#747E87", xmlns: "http://www.w3.org/2000/svg", ...props, children: [
  /* @__PURE__ */ jsx15("path", { d: "M4.62497 5.4375L7.99997 2.0625L11.375 5.4375", strokeWidth: 1.5, strokeLinejoin: "round" }),
  /* @__PURE__ */ jsx15("path", { d: "M11.375 10.5625L7.99997 13.9375L4.62497 10.5625", strokeWidth: 1.5, strokeLinejoin: "round" })
] });
var IconArrowsSort_default = SvgIconArrowsSort;

// assets/icons/IconSortAscending.svg
import * as React15 from "react";
import { jsx as jsx16, jsxs as jsxs15 } from "react/jsx-runtime";
var SvgIconSortAscending = (props) => /* @__PURE__ */ jsxs15("svg", { width: 16, height: 17, viewBox: "0 0 16 17", fill: "none", stroke: "#747E87", xmlns: "http://www.w3.org/2000/svg", ...props, children: [
  /* @__PURE__ */ jsx16("path", { d: "M8 3.5L8 13.5", strokeWidth: 1.5, strokeLinecap: "square" }),
  /* @__PURE__ */ jsx16("path", { d: "M11 5.5L8 2.5L5 5.5", strokeWidth: 1.5, strokeLinecap: "square" })
] });
var IconSortAscending_default = SvgIconSortAscending;

// assets/icons/IconSortDescending.svg
import * as React16 from "react";
import { jsx as jsx17, jsxs as jsxs16 } from "react/jsx-runtime";
var SvgIconSortDescending = (props) => /* @__PURE__ */ jsxs16("svg", { width: 16, height: 17, viewBox: "0 0 16 17", fill: "none", stroke: "#747E87", xmlns: "http://www.w3.org/2000/svg", ...props, children: [
  /* @__PURE__ */ jsx17("path", { d: "M8 12.5L8 2.5", strokeWidth: 1.5, strokeLinecap: "square" }),
  /* @__PURE__ */ jsx17("path", { d: "M11 10.5L8 13.5L5 10.5", strokeWidth: 1.5, strokeLinecap: "square" })
] });
var IconSortDescending_default = SvgIconSortDescending;

// assets/icons/mediumIconEmptyState.svg
import * as React17 from "react";
import { jsx as jsx18 } from "react/jsx-runtime";
var SvgMediumIconEmptyState = (props) => /* @__PURE__ */ jsx18("svg", { width: 40, height: 40, viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx18("path", { d: "M8.09997 8.09997L31.9 31.9M20 37C10.6112 37 3 29.3888 3 20C3 10.6112 10.6112 3 20 3C29.3888 3 37 10.6112 37 20C37 29.3888 29.3888 37 20 37Z", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" }) });
var mediumIconEmptyState_default = SvgMediumIconEmptyState;

// assets/icons/largeIconEmptyState.svg
import * as React18 from "react";
import { jsx as jsx19, jsxs as jsxs17 } from "react/jsx-runtime";
var SvgLargeIconEmptyState = (props) => /* @__PURE__ */ jsxs17("svg", { width: 60, height: 60, viewBox: "0 0 60 60", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: [
  /* @__PURE__ */ jsx19("path", { d: "M30 17V33", stroke: "", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" }),
  /* @__PURE__ */ jsx19("path", { d: "M30 43.1V43", stroke: "", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" }),
  /* @__PURE__ */ jsx19("path", { d: "M30 57C44.9116 57 57 44.9116 57 30C57 15.0883 44.9116 3 30 3C15.0883 3 3 15.0883 3 30C3 44.9116 15.0883 57 30 57Z", stroke: "", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" })
] });
var largeIconEmptyState_default = SvgLargeIconEmptyState;

// assets/icons/tooltipHelp.svg
import * as React19 from "react";
import { jsx as jsx20 } from "react/jsx-runtime";
var SvgTooltipHelp = (props) => /* @__PURE__ */ jsx20("svg", { width: "100%", height: "100%", viewBox: "0 0 20 20", fill: "none", stroke: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx20("path", { d: "M7.70831 8.12519C7.70831 5.0695 12.2916 5.06933 12.2916 8.12502C12.2916 10.4166 9.99998 9.58334 9.99998 11.25M9.99998 13.75H10.0083M17.5 10C17.5 14.1421 14.1421 17.5 10 17.5C5.85786 17.5 2.5 14.1421 2.5 10C2.5 5.85786 5.85786 2.5 10 2.5C14.1421 2.5 17.5 5.85786 17.5 10ZM10.4166 13.75C10.4166 13.9801 10.2301 14.1667 9.99998 14.1667C9.76986 14.1667 9.58331 13.9801 9.58331 13.75C9.58331 13.5199 9.76986 13.3333 9.99998 13.3333C10.2301 13.3333 10.4166 13.5199 10.4166 13.75Z", stroke: "$stroke", strokeOpacity: 0.77, strokeWidth: 1.25, strokeLinecap: "round", strokeLinejoin: "round" }) });
var tooltipHelp_default = SvgTooltipHelp;

// assets/icons/tooltipInfo.svg
import * as React20 from "react";
import { jsx as jsx21 } from "react/jsx-runtime";
var SvgTooltipInfo = (props) => /* @__PURE__ */ jsx21("svg", { width: "100%", height: "100%", viewBox: "0 0 18 18", fill: "none", stroke: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx21("path", { d: "M9 12.3333V9M9 5.66667H9.00833M16.5 9C16.5 13.1421 13.1421 16.5 9 16.5C4.85786 16.5 1.5 13.1421 1.5 9C1.5 4.85786 4.85786 1.5 9 1.5C13.1421 1.5 16.5 4.85786 16.5 9Z", stroke: "$stroke", strokeOpacity: 0.77, strokeWidth: 1.25, strokeLinecap: "round", strokeLinejoin: "round" }) });
var tooltipInfo_default = SvgTooltipInfo;

// assets/icons/breadcrumbDivider.svg
import * as React21 from "react";
import { jsx as jsx22 } from "react/jsx-runtime";
var SvgBreadcrumbDivider = (props) => /* @__PURE__ */ jsx22("svg", { width: "100%", height: "100%", viewBox: "0 0 16 16", fill: "none", stroke: "black", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx22("path", { d: "M5.99996 3.33337L10.6666 8.00004L5.99996 12.6667", stroke: "$stroke", strokeOpacity: 0.77, strokeLinecap: "round", strokeLinejoin: "round" }) });
var breadcrumbDivider_default = SvgBreadcrumbDivider;

// assets/icons/online-success.svg
import * as React22 from "react";
import { jsx as jsx23 } from "react/jsx-runtime";
var SvgOnlineSuccess = (props) => /* @__PURE__ */ jsx23("svg", { width: 21, height: 20, viewBox: "0 0 21 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx23("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10.5 1.875C6.01268 1.875 2.375 5.51268 2.375 10C2.375 14.4873 6.01268 18.125 10.5 18.125C14.9873 18.125 18.625 14.4873 18.625 10C18.625 5.51268 14.9873 1.875 10.5 1.875ZM14.2598 7.04309C14.5121 7.27861 14.5258 7.6741 14.2903 7.92645L9.6236 12.9264C9.50539 13.0531 9.33993 13.125 9.16669 13.125C8.99345 13.125 8.82798 13.0531 8.70978 12.9264L6.70978 10.7836C6.47426 10.5312 6.48789 10.1358 6.74024 9.90023C6.99258 9.66471 7.38808 9.67835 7.6236 9.93069L9.16669 11.584L13.3764 7.07355C13.612 6.82121 14.0075 6.80757 14.2598 7.04309Z", fill: "#00B960" }) });
var online_success_default = SvgOnlineSuccess;

// assets/icons/warning-error.svg
import * as React23 from "react";
import { jsx as jsx24 } from "react/jsx-runtime";
var SvgWarningError = (props) => /* @__PURE__ */ jsx24("svg", { width: 21, height: 20, viewBox: "0 0 21 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx24("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8.42439 3.02128C9.35285 1.49291 11.647 1.49291 12.5755 3.02128L19.1263 13.8049C20.0936 15.3972 18.8508 17.2917 17.0508 17.2917H3.94908C2.14902 17.2917 0.906225 15.3972 1.87355 13.8049L8.42439 3.02128ZM11.1249 7.5C11.1249 7.15482 10.8451 6.875 10.4999 6.875C10.1548 6.875 9.87494 7.15482 9.87494 7.5V10.8333C9.87494 11.1785 10.1548 11.4583 10.4999 11.4583C10.8451 11.4583 11.1249 11.1785 11.1249 10.8333V7.5ZM11.1249 13.3171C11.1249 12.9719 10.8451 12.6921 10.4999 12.6921C10.1548 12.6921 9.87494 12.9719 9.87494 13.3171V13.3333C9.87494 13.6785 10.1548 13.9583 10.4999 13.9583C10.8451 13.9583 11.1249 13.6785 11.1249 13.3333V13.3171Z", fill: "#FFB400" }) });
var warning_error_default = SvgWarningError;

// assets/icons/information.svg
import * as React24 from "react";
import { jsx as jsx25 } from "react/jsx-runtime";
var SvgInformation = (props) => /* @__PURE__ */ jsx25("svg", { width: 21, height: 20, viewBox: "0 0 21 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx25("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10.5 2.375C6.28883 2.375 2.875 5.78883 2.875 10C2.875 14.2112 6.28883 17.625 10.5 17.625C14.7112 17.625 18.125 14.2112 18.125 10C18.125 5.78883 14.7112 2.375 10.5 2.375ZM10.5 6.375C10.1548 6.375 9.875 6.65482 9.875 7C9.875 7.34518 10.1548 7.625 10.5 7.625H10.5083C10.8535 7.625 11.1333 7.34518 11.1333 7C11.1333 6.65482 10.8535 6.375 10.5083 6.375H10.5ZM11.125 10C11.125 9.65482 10.8452 9.375 10.5 9.375C10.1548 9.375 9.875 9.65482 9.875 10V13C9.875 13.3452 10.1548 13.625 10.5 13.625C10.8452 13.625 11.125 13.3452 11.125 13V10Z", fill: "#4891FF" }) });
var information_default = SvgInformation;

// assets/icons/fail.svg
import * as React25 from "react";
import { jsx as jsx26 } from "react/jsx-runtime";
var SvgFail = (props) => /* @__PURE__ */ jsx26("svg", { width: 21, height: 20, viewBox: "0 0 21 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx26("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2.875 10C2.875 5.78883 6.28883 2.375 10.5 2.375C14.7112 2.375 18.125 5.78883 18.125 10C18.125 14.2112 14.7112 17.625 10.5 17.625C6.28883 17.625 2.875 14.2112 2.875 10ZM13.4419 7.05806C13.686 7.30214 13.686 7.69786 13.4419 7.94194L11.3839 10L13.4419 12.0581C13.686 12.3021 13.686 12.6979 13.4419 12.9419C13.1979 13.186 12.8021 13.186 12.5581 12.9419L10.5 10.8839L8.44194 12.9419C8.19786 13.186 7.80214 13.186 7.55806 12.9419C7.31398 12.6979 7.31398 12.3021 7.55806 12.0581L9.61612 10L7.55806 7.94194C7.31398 7.69786 7.31398 7.30214 7.55806 7.05806C7.80214 6.81398 8.19786 6.81398 8.44194 7.05806L10.5 9.11612L12.5581 7.05806C12.8021 6.81398 13.1979 6.81398 13.4419 7.05806Z", fill: "#FA4D4D" }) });
var fail_default = SvgFail;

// assets/icons/close.svg
import * as React26 from "react";
import { jsx as jsx27, jsxs as jsxs18 } from "react/jsx-runtime";
var SvgClose = (props) => /* @__PURE__ */ jsxs18("svg", { width: 20, height: 22, viewBox: "0 0 20 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: [
  /* @__PURE__ */ jsx27("circle", { cx: 9.99998, cy: 12, r: 8.66667, fill: "#E52E2E", stroke: "#E52E2E" }),
  /* @__PURE__ */ jsx27("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.99999 13.4142L13.4596 16.8738L14.8738 15.4596L11.4142 12L14.8738 8.54043L13.4596 7.12622L9.99999 10.5858L6.54043 7.12622L5.12622 8.54043L8.58578 12L5.12622 15.4596L6.54043 16.8738L9.99999 13.4142Z", fill: "white" })
] });
var close_default = SvgClose;

// assets/icons/rightArrow.svg
import * as React27 from "react";
import { jsx as jsx28 } from "react/jsx-runtime";
var SvgRightArrow = (props) => /* @__PURE__ */ jsx28("svg", { width: 7, height: 12, viewBox: "0 0 7 12", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx28("path", { d: "M1 1L6 6L1 11", strokeOpacity: 0.61, strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }) });
var rightArrow_default = SvgRightArrow;

// assets/icons/settings.svg
import * as React28 from "react";
import { jsx as jsx29, jsxs as jsxs19 } from "react/jsx-runtime";
var SvgSettings = (props) => /* @__PURE__ */ jsxs19("svg", { width: 19, height: 20, viewBox: "0 0 19 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: [
  /* @__PURE__ */ jsx29("path", { d: "M16.6908 10C16.6908 9.35714 17.0036 8.79228 17.4889 8.42968C17.9675 8.07214 18.4049 7.51069 18.1968 6.95145C17.8141 5.92296 17.2448 4.98217 16.5266 4.16561C16.1414 3.72768 15.4552 3.82297 14.9159 4.04619C14.3456 4.28219 13.6751 4.26607 13.0954 3.93674C12.5423 3.62252 12.196 3.09994 12.102 2.53264C12.0026 1.93331 11.7319 1.25 11.1324 1.14433C10.6014 1.05073 10.0559 1 9.5 1C8.93953 1 8.38966 1.04813 7.85455 1.14238C7.25919 1.24724 6.99423 1.9248 6.90042 2.52076C6.80993 3.09568 6.46243 3.62591 5.9046 3.93674C5.32536 4.25949 4.6554 4.27753 4.08544 4.04418C3.54521 3.823 2.85858 3.72768 2.47339 4.16561C1.75755 4.97946 1.18967 5.91674 0.806992 6.94124C0.596848 7.50383 1.04139 8.06956 1.52068 8.43253C2.0005 8.79591 2.3092 9.3614 2.3092 10C2.3092 10.6429 1.99638 11.2077 1.51106 11.5703C1.03252 11.9279 0.595083 12.4893 0.803185 13.0485C1.1859 14.077 1.75517 15.0178 2.47339 15.8344C2.85858 16.2723 3.54476 16.177 4.08414 15.9538C4.65439 15.7178 5.32492 15.7339 5.9046 16.0633C6.45856 16.3719 6.80509 16.897 6.8985 17.4673C6.9967 18.0668 7.26811 18.75 7.86761 18.8557C8.39861 18.9493 8.94409 19 9.5 19C10.0605 19 10.6103 18.9519 11.1455 18.8576C11.7408 18.7528 12.0058 18.0752 12.0996 17.4792C12.1901 16.9043 12.5376 16.3741 13.0954 16.0633C13.6746 15.7405 14.3446 15.7225 14.9146 15.9558C15.4548 16.177 16.1414 16.2723 16.5266 15.8344C17.2425 15.0205 17.8103 14.0833 18.193 13.0588C18.4032 12.4962 17.9586 11.9304 17.4793 11.5675C16.9995 11.2041 16.6908 10.6386 16.6908 10Z", strokeOpacity: 0.77, strokeWidth: 1.5 }),
  /* @__PURE__ */ jsx29("path", { d: "M12.5064 10C12.5064 11.6569 11.1604 13 9.5 13C7.83959 13 6.49356 11.6569 6.49356 10C6.49356 8.34315 7.83959 7 9.5 7C11.1604 7 12.5064 8.34315 12.5064 10Z", strokeOpacity: 0.77, strokeWidth: 1.5 })
] });
var settings_default = SvgSettings;

// assets/icons/report.svg
import * as React29 from "react";
import { jsx as jsx30, jsxs as jsxs20 } from "react/jsx-runtime";
var SvgReport = (props) => /* @__PURE__ */ jsxs20("svg", { width: 25, height: 24, viewBox: "0 0 25 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: [
  /* @__PURE__ */ jsx30("rect", { x: 4.5, y: 4, width: 16, height: 16, rx: 2, strokeOpacity: 0.77, strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }),
  /* @__PURE__ */ jsx30("path", { d: "M8.5 14L8.5 17", strokeOpacity: 0.77, strokeWidth: 1.5, strokeLinecap: "round" }),
  /* @__PURE__ */ jsx30("path", { d: "M16.5 12L16.5 17", strokeOpacity: 0.77, strokeWidth: 1.5, strokeLinecap: "round" }),
  /* @__PURE__ */ jsx30("path", { d: "M12.5 9L12.5 17", strokeOpacity: 0.77, strokeWidth: 1.5, strokeLinecap: "round" })
] });
var report_default = SvgReport;

// assets/icons/empty.svg
import * as React30 from "react";
import { jsx as jsx31 } from "react/jsx-runtime";
var SvgEmpty = (props) => /* @__PURE__ */ jsx31("svg", { width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", stroke: "white", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx31("circle", { cx: 12, cy: 12, r: 9, strokeOpacity: 0.61, strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", strokeDasharray: "0.1 2 0.1 2" }) });
var empty_default = SvgEmpty;

// assets/icons/link.svg
import * as React31 from "react";
import { jsx as jsx32 } from "react/jsx-runtime";
var SvgLink = (props) => /* @__PURE__ */ jsx32("svg", { width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", stroke: "white", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx32("path", { d: "M8.02564 7H17M17 7V15.9744M17 7L7 17", strokeOpacity: 0.61, strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }) });
var link_default = SvgLink;

// assets/icons/log-out.svg
import * as React32 from "react";
import { jsx as jsx33 } from "react/jsx-runtime";
var SvgLogOut = (props) => /* @__PURE__ */ jsx33("svg", { width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", stroke: "black", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx33("path", { d: "M8 20H6C4.89543 20 4 19.1046 4 18V6C4 4.89543 4.89543 4 6 4H8M15 17L20 12M20 12L15 7M20 12H8", strokeOpacity: 0.77, strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }) });
var log_out_default = SvgLogOut;

// assets/icons/sightMindLogo.svg
import * as React33 from "react";
import { jsx as jsx34, jsxs as jsxs21 } from "react/jsx-runtime";
var SvgSightMindLogo = (props) => /* @__PURE__ */ jsxs21("svg", { width: 85, height: 22, viewBox: "0 0 85 22", fill: "white", xmlns: "http://www.w3.org/2000/svg", ...props, children: [
  /* @__PURE__ */ jsx34("path", { d: "M1.00033 16.363L1.86077 14.5179C2.98717 15.1642 4.02492 15.4822 4.95836 15.4822C5.7093 15.4822 6.29857 15.3571 6.7679 15.0704C7.19551 14.8045 7.43018 14.3719 7.43018 13.7986C7.43018 13.2773 7.23202 12.8499 6.87741 12.5268C6.48109 12.2244 5.85531 11.9169 5.00008 11.5937C2.5387 10.8692 1.32365 9.61827 1.32365 7.84608C1.32365 6.73585 1.77212 5.80806 2.66907 5.05227C3.54515 4.33818 4.70805 3.96289 6.15777 3.96289C6.7314 3.96289 7.28416 4.0515 7.82129 4.21308C8.34277 4.3903 8.82253 4.64049 9.28665 4.92717L8.51486 6.69937C8.08724 6.44917 7.67527 6.27195 7.29981 6.12601C6.9087 6.00091 6.49673 5.92794 6.10041 5.92794C5.36512 5.92794 4.81235 6.08952 4.41603 6.41269C4.00406 6.75149 3.80589 7.14763 3.80589 7.59589C3.80589 8.11712 3.9832 8.50805 4.37952 8.79472C4.75499 9.0814 5.41727 9.4202 6.38722 9.77986C7.60227 10.2438 8.49921 10.765 9.07284 11.3175C9.62561 11.8909 9.91242 12.6623 9.91242 13.6057C9.91242 14.7889 9.50045 15.7167 8.71302 16.4152C7.88908 17.1292 6.63753 17.4889 4.95315 17.4889C4.20222 17.4889 3.45129 17.3638 2.69514 17.1136C1.939 16.8634 1.37058 16.6132 0.995117 16.363H1.00033Z", fill: "white" }),
  /* @__PURE__ */ jsx34("path", { d: "M13.5316 3.17578V5.50048H11.1484V3.17578H13.5316ZM11.2423 17.2751V7.95549H13.4638V17.2804H11.2423V17.2751Z", fill: "white" }),
  /* @__PURE__ */ jsx34("path", { d: "M22.2665 7.95526H24.342V15.6487C24.3264 17.473 23.8414 18.8334 22.9079 19.7299C22.0475 20.517 20.8481 20.9131 19.3097 20.9131C18.5953 20.9131 17.8965 20.788 17.2499 20.5535C16.5876 20.3033 16.014 20.001 15.529 19.6569L16.4416 18.1558C16.9787 18.5154 17.5002 18.7656 18.0008 18.9064C18.4649 19.0471 18.9499 19.1201 19.4349 19.1201C20.2953 19.1201 20.9576 18.9064 21.4582 18.4425C21.9223 18.0151 22.1727 17.3844 22.1727 16.5973V15.8259C21.9954 16.1282 21.672 16.4149 21.2079 16.6651C20.7229 16.9309 20.0972 17.0612 19.3097 17.0612C18.126 17.0612 17.1247 16.5973 16.3008 15.6487C15.4612 14.7157 15.0492 13.6628 15.0649 12.4796C15.0492 11.1348 15.4769 10.0089 16.3529 9.08112C17.2134 8.1846 18.2511 7.7207 19.4349 7.7207C20.7751 7.7207 21.7242 8.13248 22.2613 8.91954V7.95526H22.2665ZM22.1049 12.8392V11.8749C22.1049 11.6612 22.0684 11.4267 21.9954 11.1765C21.8546 10.6917 21.5834 10.2643 21.2079 9.88903C20.8116 9.52938 20.3683 9.33653 19.8312 9.33653C19.0959 9.33653 18.5067 9.60236 18.0425 10.1392C17.5784 10.6761 17.3438 11.4475 17.3438 12.4483C17.3438 13.3604 17.5576 14.0745 18.006 14.5958C18.4336 15.1326 19.0646 15.3828 19.8521 15.3828C20.337 15.3828 20.7855 15.2421 21.1766 14.9189C21.573 14.6166 21.8389 14.2205 21.9797 13.7566C22.0527 13.4543 22.1049 13.1467 22.1049 12.8444V12.8392Z", fill: "white" }),
  /* @__PURE__ */ jsx34("path", { d: "M26.3135 17.2751V3.17578H28.535V9.15433C28.7488 8.79468 29.0877 8.45588 29.5727 8.15356C30.0368 7.86688 30.6991 7.7053 31.5596 7.7053C32.4722 7.7053 33.2804 8.06495 33.9584 8.7634C34.6206 9.47749 34.9596 10.5356 34.9596 11.9325V17.2804H32.7225V12.0732C32.7225 10.4261 32.0445 9.58695 30.6991 9.58695C30.2141 9.58695 29.7865 9.72769 29.4267 9.99873C29.0512 10.2854 28.8009 10.6451 28.6758 11.036C28.5663 11.3383 28.535 11.6093 28.535 11.823V17.2804H26.3135V17.2751Z", fill: "white" }),
  /* @__PURE__ */ jsx34("path", { d: "M38.2914 5.08984H40.5129V7.95142H42.8387V9.73925H40.5129V13.8726C40.5129 14.4825 40.6224 14.9099 40.8362 15.1601C41.05 15.4103 41.389 15.5354 41.8583 15.5354C42.1295 15.5354 42.4684 15.4832 42.8596 15.3738V17.2502C42.3224 17.4118 41.7488 17.4848 41.1752 17.4848C40.2782 17.4848 39.5638 17.2189 39.0423 16.6612C38.5417 16.1244 38.2914 15.2122 38.2914 13.9404V9.73403H36.4141V7.9462H38.2914V5.08984Z", fill: "white" }),
  /* @__PURE__ */ jsx34("path", { d: "M56.6065 17.2751L56.085 6.91296L52.4659 17.1135H50.5886L47.4024 6.96509L46.7922 17.2751H44.5029L45.3999 4.10352H48.6748L51.7202 13.6786L54.9795 4.10352H58.2022L58.9896 17.2751H56.6065Z", fill: "white" }),
  /* @__PURE__ */ jsx34("path", { d: "M62.5824 3.17578V5.50048H60.1992V3.17578H62.5824ZM60.2931 17.2751V7.95549H62.5146V17.2804H60.2931V17.2751Z", fill: "white" }),
  /* @__PURE__ */ jsx34("path", { d: "M64.4805 17.2749V7.95526H66.702V9.16973C66.8793 8.83093 67.2234 8.50777 67.7241 8.1846C68.1882 7.88229 68.8505 7.7207 69.6744 7.7207C70.6079 7.7207 71.4266 8.0595 72.1097 8.70583C72.7876 9.3678 73.1318 10.4051 73.1318 11.802V17.2749H70.9677V12.0313C70.9677 11.2807 70.7904 10.6709 70.4671 10.1705C70.1072 9.7066 69.591 9.45641 68.9078 9.45641C68.1934 9.45641 67.6563 9.7066 67.2808 10.1705C66.8845 10.6709 66.7072 11.4058 66.7072 12.3701V17.2749H64.4857H64.4805Z", fill: "white" }),
  /* @__PURE__ */ jsx34("path", { d: "M81.8461 17.2751V16.1858C81.2568 17.0614 80.3077 17.4941 78.9988 17.4941C77.815 17.4941 76.8138 17.0458 75.9898 16.118C75.1503 15.2058 74.7383 13.9705 74.7383 12.412C74.7383 11.1037 75.1346 9.99873 75.922 9.08136C76.6938 8.18483 77.6586 7.73657 78.8058 7.73657C80.2555 7.73657 81.2776 8.16399 81.8513 9.02402V3.17578H84.0728V17.2751H81.8513H81.8461ZM81.8461 11.9794C81.8461 11.8022 81.8096 11.5676 81.7574 11.3018C81.6166 10.7493 81.3298 10.2802 80.9178 9.92575C80.4902 9.58695 80.0209 9.40452 79.4838 9.40452C78.6442 9.40452 78.0132 9.67035 77.6221 10.2072C77.2101 10.7441 77.0119 11.4947 77.0119 12.4433C77.0119 13.4806 77.2257 14.3041 77.6742 14.914C78.1018 15.5238 78.7328 15.8261 79.5203 15.8261C80.073 15.8261 80.5789 15.6124 81.0065 15.1798C81.4341 14.768 81.6844 14.2833 81.7783 13.7464C81.8148 13.4441 81.8513 13.173 81.8513 12.9593V11.9742L81.8461 11.9794Z", fill: "white" })
] });
var sightMindLogo_default = SvgSightMindLogo;

// assets/icons/cloudPortal.svg
import * as React34 from "react";
import { jsx as jsx35, jsxs as jsxs22 } from "react/jsx-runtime";
var SvgCloudPortal = (props) => /* @__PURE__ */ jsxs22("svg", { width: 94, height: 24, viewBox: "0 0 94 24", fill: "white", xmlns: "http://www.w3.org/2000/svg", ...props, children: [
  /* @__PURE__ */ jsx35("path", { d: "M9.91831 17.8771C9.36053 18.1654 8.13849 18.4486 6.58685 18.4486C2.48972 18.4486 0 15.8892 0 11.9742C0 7.73034 2.95115 5.1709 6.89616 5.1709C8.4478 5.1709 9.55829 5.49462 10.0349 5.74247L9.51772 7.614C8.90416 7.34592 8.06243 7.1183 6.99251 7.1183C4.37095 7.1183 2.47451 8.76221 2.47451 11.8578C2.47451 14.6853 4.14277 16.5012 6.97222 16.5012C7.93059 16.5012 8.92445 16.309 9.538 16.0258L9.91831 17.8771Z", fill: "white" }),
  /* @__PURE__ */ jsx35("path", { d: "M11.1656 4.69531H13.5387V18.2563H11.1656V4.69531Z", fill: "white" }),
  /* @__PURE__ */ jsx35("path", { d: "M24.3446 13.522C24.3446 16.9413 21.9309 18.4689 19.5578 18.4689C16.916 18.4689 14.8877 16.653 14.8877 13.6737C14.8877 10.6945 16.9008 8.74707 19.715 8.74707C22.5293 8.74707 24.3496 10.6945 24.3496 13.522H24.3446ZM17.3166 13.6181C17.3166 15.4138 18.1989 16.7694 19.6339 16.7694C20.9725 16.7694 21.9106 15.4492 21.9106 13.5776C21.9106 12.1259 21.2616 10.4618 19.6491 10.4618C18.0366 10.4618 17.3115 12.0652 17.3115 13.613L17.3166 13.6181Z", fill: "white" }),
  /* @__PURE__ */ jsx35("path", { d: "M34.0143 15.469C34.0143 16.5768 34.0549 17.4923 34.0904 18.2561H32.0216L31.9049 16.8449H31.8644C31.4638 17.5126 30.5409 18.4685 28.8777 18.4685C27.2145 18.4685 25.6223 17.4569 25.6223 14.4169V8.9541H27.9802V14.0173C27.9802 15.5651 28.4771 16.5566 29.7245 16.5566C30.6626 16.5566 31.2762 15.8889 31.5246 15.2971C31.6007 15.0846 31.6565 14.8368 31.6565 14.5687V8.9541H34.0143V15.469Z", fill: "white" }),
  /* @__PURE__ */ jsx35("path", { d: "M44.5462 4.69531V15.6412C44.5462 16.5972 44.5868 17.6291 44.6223 18.2563H42.5179L42.4216 16.7844H42.381C41.8232 17.8162 40.6975 18.4637 39.3386 18.4637C37.1176 18.4637 35.353 16.5719 35.353 13.709C35.3327 10.5932 37.2849 8.74186 39.5262 8.74186C40.8091 8.74186 41.7269 9.27803 42.1478 9.96594H42.1883V4.69531H44.5462ZM42.1883 12.8339C42.1883 12.6417 42.168 12.4141 42.1325 12.2219C41.9196 11.3064 41.1742 10.5577 40.1043 10.5577C38.5932 10.5577 37.7464 11.8931 37.7464 13.6331C37.7464 15.3731 38.5881 16.577 40.084 16.577C41.0423 16.577 41.8841 15.9295 42.1123 14.9128C42.168 14.7004 42.1883 14.4728 42.1883 14.2249V12.8289V12.8339Z", fill: "white" }),
  /* @__PURE__ */ jsx35("path", { d: "M49.911 5.55519C50.7527 5.40345 51.9241 5.28711 53.5112 5.28711C55.2353 5.28711 56.4979 5.6513 57.3244 6.33921C58.0901 6.97149 58.587 7.98312 58.587 9.18697C58.587 10.3908 58.2016 11.4227 57.4765 12.1106C56.5384 13.0464 55.0628 13.4864 53.3997 13.4864C52.9585 13.4864 52.5579 13.4662 52.2486 13.4106V18.2614H49.911V5.55519ZM52.2486 11.5542C52.5376 11.6301 52.9179 11.6503 53.3997 11.6503C55.1592 11.6503 56.2342 10.7904 56.2342 9.28308C56.2342 7.77574 55.2403 7.08782 53.6126 7.08782C52.9636 7.08782 52.5021 7.14346 52.2537 7.20416V11.5593L52.2486 11.5542Z", fill: "white" }),
  /* @__PURE__ */ jsx35("path", { d: "M68.2974 13.522C68.2974 16.9413 65.8837 18.4689 63.5106 18.4689C60.8688 18.4689 58.8405 16.653 58.8405 13.6737C58.8405 10.6945 60.8536 8.74707 63.6678 8.74707C66.4821 8.74707 68.3025 10.6945 68.3025 13.522H68.2974ZM61.2694 13.6181C61.2694 15.4138 62.1517 16.7694 63.5867 16.7694C64.9254 16.7694 65.8634 15.4492 65.8634 13.5776C65.8634 12.1259 65.2144 10.4618 63.6019 10.4618C61.9894 10.4618 61.2643 12.0652 61.2643 13.613L61.2694 13.6181Z", fill: "white" }),
  /* @__PURE__ */ jsx35("path", { d: "M69.6207 11.9536C69.6207 10.6942 69.6004 9.7938 69.5446 8.95414H71.5932L71.6692 10.7296H71.7453C72.2067 9.40938 73.2969 8.7417 74.2908 8.7417C74.519 8.7417 74.6559 8.76193 74.8486 8.79734V11.0128C74.6559 10.9724 74.448 10.937 74.159 10.937C73.0282 10.937 72.2625 11.6653 72.0546 12.7124C72.0141 12.9248 71.9786 13.1727 71.9786 13.4408V18.2561H69.6207V11.9536Z", fill: "white" }),
  /* @__PURE__ */ jsx35("path", { d: "M78.9663 6.299V8.95455H81.2075V10.7097H78.9663V14.817C78.9663 15.945 79.2705 16.5368 80.1731 16.5368C80.5737 16.5368 80.883 16.4811 81.0909 16.4204L81.1315 18.2161C80.7866 18.3476 80.1731 18.4437 79.4277 18.4437C78.5657 18.4437 77.8406 18.1554 77.3994 17.6799C76.9025 17.1438 76.6692 16.3041 76.6692 15.08V10.7047H75.3306V8.94949H76.6692V6.85035L78.9663 6.29395V6.299Z", fill: "white" }),
  /* @__PURE__ */ jsx35("path", { d: "M87.6217 18.2565L87.4696 17.2246H87.4138C86.8408 17.953 85.8622 18.4689 84.6554 18.4689C82.7792 18.4689 81.7245 17.1133 81.7245 15.697C81.7245 13.345 83.8136 12.1613 87.2566 12.1816V12.0298C87.2566 11.4178 87.0082 10.4062 85.3602 10.4062C84.4424 10.4062 83.484 10.6945 82.8502 11.0941L82.3887 9.5665C83.0784 9.14667 84.2852 8.74707 85.7608 8.74707C88.7474 8.74707 89.6094 10.6388 89.6094 12.6621V16.0258C89.6094 16.8655 89.65 17.6899 89.7413 18.2615H87.6166L87.6217 18.2565ZM87.3175 13.7091C85.6492 13.6687 84.0621 14.0329 84.0621 15.4492C84.0621 16.3647 84.6554 16.7845 85.4008 16.7845C86.3388 16.7845 87.0285 16.1725 87.2414 15.5048C87.2972 15.3328 87.3175 15.1406 87.3175 14.9889V13.7091Z", fill: "white" }),
  /* @__PURE__ */ jsx35("path", { d: "M91.4959 4.69531H93.869V18.2563H91.4959V4.69531Z", fill: "white" })
] });
var cloudPortal_default = SvgCloudPortal;

// assets/icons/HanwhaVisionLogo.svg
import * as React35 from "react";
import { jsx as jsx36, jsxs as jsxs23 } from "react/jsx-runtime";
var SvgHanwhaVisionLogo = (props) => /* @__PURE__ */ jsxs23("svg", { width: 192, height: 32, viewBox: "0 0 192 32", fill: "white", xmlns: "http://www.w3.org/2000/svg", ...props, children: [
  /* @__PURE__ */ jsx36("path", { d: "M16.3555 16.3718C15.9727 12.8294 19.6599 9.98985 24.5912 10.0295C29.5282 10.0692 33.8459 12.9654 34.2287 16.5078C34.6172 20.0558 30.9355 22.8954 25.9986 22.85C21.0616 22.8217 16.7495 19.9198 16.3555 16.3774M35.1463 17.477C34.7016 13.0901 29.7365 9.48542 24.0565 9.43441C18.3708 9.39474 14.1319 12.9144 14.5766 17.307C15.0213 21.6938 19.9864 25.2929 25.6665 25.3439C31.3465 25.3892 35.591 21.8695 35.1463 17.477Z", fill: "#F8B986" }),
  /* @__PURE__ */ jsx36("path", { d: "M26.5728 25.4236C23.775 28.3708 19.2828 28.6089 16.5413 25.9677C13.7998 23.3265 13.8504 18.7979 16.6482 15.8507C19.446 12.9091 23.9383 12.6654 26.6798 15.3123C29.4213 17.9534 29.3763 22.482 26.5785 25.4236M16.2091 15.7657C12.961 19.1834 12.9047 24.4487 16.0909 27.5207C19.2828 30.5926 24.4956 30.3092 27.755 26.8859C31.0031 23.4682 31.0594 18.2028 27.8732 15.1309C24.687 12.059 19.4685 12.348 16.2148 15.7713", fill: "#F39B56" }),
  /* @__PURE__ */ jsx36("path", { d: "M16.5018 4.74721C22.3226 2.55378 28.0758 4.77555 29.3537 9.71218C30.6316 14.6432 26.95 20.43 21.1348 22.6177C15.314 24.8168 9.56081 22.595 8.27732 17.6584C6.99382 12.7274 10.6811 6.94064 16.4962 4.74154M11.092 6.62891C5.05168 11.4409 3.52049 18.4179 7.65809 22.2096C11.7957 25.9957 20.0483 25.1625 26.0887 20.3563C32.1234 15.5387 33.6658 8.56163 29.517 4.77555C25.3737 0.989472 17.1267 1.81697 11.0864 6.62891", fill: "#EC6A06" }),
  /* @__PURE__ */ jsx36("path", { d: "M51.4941 9.21373V22.8334H49.3775V15.6467H41.3612V22.8334H39.2446V9.21373H41.3612V13.782H49.3775V9.21373H51.4941Z", fill: "white" }),
  /* @__PURE__ */ jsx36("path", { d: "M56.5775 22.8334C55.5867 22.8334 54.8042 22.5556 54.23 21.9945C53.6389 21.4391 53.3462 20.7193 53.3462 19.8408V19.1096C53.3462 18.2198 53.6389 17.5 54.23 16.9389C54.8042 16.3721 55.5867 16.083 56.5775 16.083H62.1055V16.0264C62.1055 14.9381 61.5088 14.3884 60.321 14.3884H54.1737V12.5747H60.2816C61.5539 12.5747 62.5221 12.9034 63.1976 13.5495C63.8788 14.1787 64.2222 15.0912 64.2222 16.2871V19.8975C64.2222 20.8213 63.9126 21.5525 63.2877 22.0852C62.7248 22.5726 61.9254 22.8164 60.9065 22.8164H56.5775V22.8334ZM60.4449 17.9081H57.0898C56.0089 17.9081 55.4629 18.3728 55.4629 19.2967V19.6367C55.4629 20.5493 56.0033 21.0083 57.0898 21.0083H60.4449C61.5538 21.0083 62.1055 20.5493 62.1055 19.6367V19.2967C62.1055 18.3728 61.5538 17.9081 60.4449 17.9081Z", fill: "white" }),
  /* @__PURE__ */ jsx36("path", { d: "M70.4257 12.5917H72.5085C73.8258 12.5917 74.8616 12.9771 75.6159 13.7479C76.3703 14.5187 76.7474 15.59 76.7474 16.9672V22.8334H74.6308V17.0692C74.6308 16.2134 74.4676 15.5956 74.1354 15.2045C73.7245 14.6944 73.1278 14.4394 72.3509 14.4394H70.5495C69.7952 14.4394 69.2097 14.6944 68.7819 15.2045C68.4779 15.5956 68.3203 16.2191 68.3203 17.0692V22.8334H66.2036V16.9672C66.2036 15.59 66.5808 14.5187 67.3351 13.7479C68.0895 12.9771 69.1196 12.5917 70.4257 12.5917Z", fill: "white" }),
  /* @__PURE__ */ jsx36("path", { d: "M86.5144 21.4618C85.7601 22.3743 84.8256 22.8334 83.7054 22.8334H82.3994C81.2228 22.8334 80.2883 22.4593 79.5903 21.7112C78.9317 21.014 78.5995 20.0222 78.5995 18.7412V12.5917H80.6993V18.7639C80.6993 19.5121 80.8569 20.0562 81.1778 20.4019C81.5437 20.793 82.0222 20.9857 82.6077 20.9857H83.5252C84.1276 20.9857 84.6061 20.793 84.972 20.4019C85.3041 20.0562 85.4674 19.5121 85.4674 18.7639V12.5917H87.5502V18.7639C87.5502 19.5121 87.7079 20.0562 88.0287 20.4019C88.3946 20.793 88.8731 20.9857 89.4586 20.9857H90.3762C90.9785 20.9857 91.457 20.793 91.8229 20.4019C92.1494 20.0562 92.3183 19.5121 92.3183 18.7639V12.5917H94.4181V18.7412C94.4181 20.0222 94.0747 21.014 93.3935 21.7112C92.7011 22.4593 91.7554 22.8334 90.5676 22.8334H89.2785C88.1807 22.8334 87.2575 22.3743 86.5032 21.4618H86.5144Z", fill: "white" }),
  /* @__PURE__ */ jsx36("path", { d: "M100.644 14.4394C99.8899 14.4394 99.3045 14.6944 98.8766 15.2045C98.5727 15.5956 98.415 16.2191 98.415 17.0692V22.8334H96.2984V9.17969H98.415V13.2151C99.0286 12.8014 99.7267 12.5917 100.515 12.5917H102.598C103.915 12.5917 104.951 12.9771 105.705 13.7479C106.459 14.5187 106.837 15.5899 106.837 16.9672V22.8334H104.72V17.0692C104.72 16.2134 104.557 15.5956 104.225 15.2045C103.814 14.6944 103.217 14.4394 102.44 14.4394H100.639H100.644Z", fill: "white" }),
  /* @__PURE__ */ jsx36("path", { d: "M111.818 22.8334C110.828 22.8334 110.045 22.5556 109.471 21.9945C108.88 21.4391 108.587 20.7193 108.587 19.8408V19.1096C108.587 18.2198 108.88 17.5 109.471 16.9389C110.045 16.3721 110.833 16.083 111.818 16.083H117.347V16.0264C117.347 14.9381 116.75 14.3884 115.562 14.3884H109.415V12.5747H115.523C116.795 12.5747 117.763 12.9034 118.439 13.5495C119.12 14.1787 119.463 15.0912 119.463 16.2871V19.8975C119.463 20.8213 119.154 21.5525 118.529 22.0852C117.966 22.5726 117.166 22.8164 116.147 22.8164H111.818V22.8334ZM115.686 17.9081H112.331C111.25 17.9081 110.704 18.3728 110.704 19.2967V19.6367C110.704 20.5493 111.244 21.0083 112.331 21.0083H115.686C116.795 21.0083 117.347 20.5493 117.347 19.6367V19.2967C117.347 18.3728 116.795 17.9081 115.686 17.9081Z", fill: "white" }),
  /* @__PURE__ */ jsx36("path", { d: "M133.064 22.8844C132.827 22.8844 132.602 22.8221 132.394 22.686C132.18 22.5557 131.994 22.3403 131.831 22.0456L125.74 9.20805H128.02L133.069 19.8408L138.119 9.20805H140.399L134.308 22.0456C134.156 22.3403 133.97 22.5557 133.751 22.686C133.531 22.8164 133.306 22.8844 133.069 22.8844H133.064Z", fill: "white" }),
  /* @__PURE__ */ jsx36("path", { d: "M144.491 10.5287C144.491 10.9197 144.351 11.2315 144.075 11.4695C143.799 11.7076 143.467 11.8266 143.078 11.8266C142.69 11.8266 142.38 11.7076 142.116 11.4695C141.851 11.2315 141.716 10.9197 141.716 10.5287C141.716 10.1376 141.851 9.82018 142.116 9.57647C142.38 9.33275 142.701 9.21373 143.078 9.21373C143.456 9.21373 143.799 9.33275 144.075 9.57647C144.351 9.82018 144.491 10.1376 144.491 10.5287ZM142.02 22.8334V12.5917H144.176V22.8334H142.02Z", fill: "white" }),
  /* @__PURE__ */ jsx36("path", { d: "M153.482 16.8029C154.624 16.8029 155.457 16.9786 155.992 17.3356C156.662 17.7834 157 18.4919 157 19.4497V20.2149C157 21.1614 156.662 21.8642 155.992 22.3119C155.463 22.6577 154.619 22.8277 153.465 22.8277H146.721V20.98H153.465C154.394 20.98 154.861 20.6626 154.861 20.0222V19.6141C154.861 18.9623 154.394 18.6336 153.465 18.6336H149.969C148.837 18.6336 148.01 18.4635 147.481 18.1178C146.822 17.67 146.49 16.9672 146.49 16.0207V15.2386C146.49 14.2694 146.822 13.5609 147.481 13.1245C148.01 12.7674 148.843 12.5917 149.969 12.5917H156.431V14.4394H150.003C149.085 14.4394 148.623 14.7681 148.623 15.4143V15.8393C148.623 16.4798 149.074 16.7972 149.986 16.7972H153.482V16.8029Z", fill: "white" }),
  /* @__PURE__ */ jsx36("path", { d: "M161.351 10.5287C161.351 10.9197 161.211 11.2315 160.935 11.4695C160.659 11.7076 160.327 11.8266 159.938 11.8266C159.55 11.8266 159.24 11.7076 158.976 11.4695C158.711 11.2315 158.576 10.9197 158.576 10.5287C158.576 10.1376 158.711 9.82018 158.976 9.57647C159.24 9.33275 159.561 9.21373 159.938 9.21373C160.316 9.21373 160.659 9.33275 160.935 9.57647C161.211 9.82018 161.351 10.1376 161.351 10.5287ZM158.88 22.8334V12.5917H161.036V22.8334H158.88Z", fill: "white" }),
  /* @__PURE__ */ jsx36("path", { d: "M170.195 22.8334H167.071C165.81 22.822 164.819 22.4536 164.104 21.7282C163.384 21.014 163.029 19.9995 163.029 18.6676V16.7632C163.029 15.4256 163.389 14.3997 164.104 13.6856C164.819 12.9601 165.81 12.5974 167.071 12.5804H170.195C171.467 12.5917 172.464 12.9601 173.179 13.6856C173.899 14.394 174.254 15.4199 174.254 16.7632V18.6676C174.254 19.9938 173.894 21.014 173.179 21.7282C172.458 22.448 171.467 22.8164 170.195 22.8334ZM170.037 20.9857C170.792 20.9857 171.344 20.7533 171.698 20.2942C171.991 19.9031 172.137 19.3307 172.137 18.5712V16.8992C172.137 16.1284 171.991 15.5503 171.698 15.1592C171.344 14.6831 170.792 14.4507 170.037 14.4507H167.212C166.468 14.4507 165.922 14.6888 165.568 15.1592C165.286 15.5503 165.146 16.1284 165.146 16.8992V18.5712C165.146 19.3307 165.286 19.9031 165.568 20.2942C165.922 20.759 166.468 20.9857 167.212 20.9857H170.037Z", fill: "white" }),
  /* @__PURE__ */ jsx36("path", { d: "M180.345 12.5917H182.428C183.745 12.5917 184.781 12.9771 185.535 13.7479C186.29 14.5187 186.667 15.59 186.667 16.9672V22.8334H184.55V17.0692C184.55 16.2134 184.387 15.5956 184.055 15.2045C183.644 14.6944 183.047 14.4394 182.27 14.4394H180.469C179.714 14.4394 179.129 14.6944 178.701 15.2045C178.397 15.5956 178.24 16.2191 178.24 17.0692V22.8334H176.123V16.9672C176.123 15.59 176.5 14.5187 177.254 13.7479C178.009 12.9771 179.039 12.5917 180.345 12.5917Z", fill: "white" })
] });
var HanwhaVisionLogo_default = SvgHanwhaVisionLogo;

// assets/icons/arrow-up.svg
import * as React36 from "react";
import { jsx as jsx37 } from "react/jsx-runtime";
var SvgArrowUp = (props) => /* @__PURE__ */ jsx37("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx37("path", { d: "M5 12L10 7L15 12", strokeWidth: 1.25, strokeLinecap: "round", strokeLinejoin: "round" }) });
var arrow_up_default = SvgArrowUp;

// assets/icons/arrow-down.svg
import * as React37 from "react";
import { jsx as jsx38 } from "react/jsx-runtime";
var SvgArrowDown = (props) => /* @__PURE__ */ jsx38("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx38("path", { d: "M15 8L10 13L5 8", strokeWidth: 1.25, strokeLinecap: "round", strokeLinejoin: "round" }) });
var arrow_down_default = SvgArrowDown;

// assets/icons/IconLeaf.svg
import * as React38 from "react";
import { jsx as jsx39 } from "react/jsx-runtime";
var SvgIconLeaf = (props) => /* @__PURE__ */ jsx39("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx39("path", { d: "M8 7V15C8 15.5523 8.44772 16 9 16H17", stroke: "#C6CCCE", strokeWidth: 1.5, strokeLinecap: "round" }) });
var IconLeaf_default = SvgIconLeaf;

// assets/icons/add.svg
import * as React39 from "react";
import { jsx as jsx40 } from "react/jsx-runtime";
var SvgAdd = (props) => /* @__PURE__ */ jsx40("svg", { width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx40("path", { d: "M12 3V21M3 12H21", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }) });
var add_default = SvgAdd;

// assets/icons/arrow-up-side.svg
import * as React40 from "react";
import { jsx as jsx41 } from "react/jsx-runtime";
var SvgArrowUpSide = (props) => /* @__PURE__ */ jsx41("svg", { width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx41("path", { d: "M12 3V21M12 3L5 10M12 3L19 10", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }) });
var arrow_up_side_default = SvgArrowUpSide;

// assets/icons/arrow-down-side.svg
import * as React41 from "react";
import { jsx as jsx42 } from "react/jsx-runtime";
var SvgArrowDownSide = (props) => /* @__PURE__ */ jsx42("svg", { width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx42("path", { d: "M12 21L12 3M12 21L19 14M12 21L5 14", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }) });
var arrow_down_side_default = SvgArrowDownSide;

// assets/icons/arrow-left-side.svg
import * as React42 from "react";
import { jsx as jsx43 } from "react/jsx-runtime";
var SvgArrowLeftSide = (props) => /* @__PURE__ */ jsx43("svg", { width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx43("path", { d: "M3 12L21 12M3 12L10 19M3 12L10 5", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }) });
var arrow_left_side_default = SvgArrowLeftSide;

// assets/icons/arrow-right-side.svg
import * as React43 from "react";
import { jsx as jsx44 } from "react/jsx-runtime";
var SvgArrowRightSide = (props) => /* @__PURE__ */ jsx44("svg", { width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx44("path", { d: "M21 12L3 12M21 12L14 5M21 12L14 19", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }) });
var arrow_right_side_default = SvgArrowRightSide;

// assets/icons/arrow-chevron-up.svg
import * as React44 from "react";
import { jsx as jsx45 } from "react/jsx-runtime";
var SvgArrowChevronUp = (props) => /* @__PURE__ */ jsx45("svg", { width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx45("path", { d: "M3 16L12 7L21 16", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }) });
var arrow_chevron_up_default = SvgArrowChevronUp;

// assets/icons/arrow-chevron-right.svg
import * as React45 from "react";
import { jsx as jsx46 } from "react/jsx-runtime";
var SvgArrowChevronRight = (props) => /* @__PURE__ */ jsx46("svg", { width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx46("path", { d: "M8 3L17 12L8 21", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }) });
var arrow_chevron_right_default = SvgArrowChevronRight;

// assets/icons/arrow-chevron-left.svg
import * as React46 from "react";
import { jsx as jsx47 } from "react/jsx-runtime";
var SvgArrowChevronLeft = (props) => /* @__PURE__ */ jsx47("svg", { width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx47("path", { d: "M16 21L7 12L16 3", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }) });
var arrow_chevron_left_default = SvgArrowChevronLeft;

// assets/icons/arrow-chevron-down.svg
import * as React47 from "react";
import { jsx as jsx48 } from "react/jsx-runtime";
var SvgArrowChevronDown = (props) => /* @__PURE__ */ jsx48("svg", { width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx48("path", { d: "M21.5 8L12.5 17L3.5 8", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }) });
var arrow_chevron_down_default = SvgArrowChevronDown;

// assets/icons/arrow-up-down.svg
import * as React48 from "react";
import { jsx as jsx49, jsxs as jsxs24 } from "react/jsx-runtime";
var SvgArrowUpDown = (props) => /* @__PURE__ */ jsxs24("svg", { width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: [
  /* @__PURE__ */ jsx49("path", { d: "M17 21V3M17 3L13 7M17 3L21 7", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }),
  /* @__PURE__ */ jsx49("path", { d: "M7 3V21M7 21L11 17M7 21L3 17", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" })
] });
var arrow_up_down_default = SvgArrowUpDown;

// assets/icons/alarm.svg
import * as React49 from "react";
import { jsx as jsx50 } from "react/jsx-runtime";
var SvgAlarm = (props) => /* @__PURE__ */ jsx50("svg", { width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx50("path", { d: "M17.5 16V12.3472C17.5 9.39403 15.0376 7 12 7C8.96243 7 6.5 9.39403 6.5 12.3472V16M5.5 5.5L4 4M18.5 5.5L20 4M12 4V2M5.87403 20L18.126 20C18.6849 20 19.1001 19.4734 18.9788 18.9183L18.4935 16.6961C18.4046 16.2894 18.0501 16 17.6406 16H6.35941C5.94992 16 5.59537 16.2894 5.50654 16.6961L5.02116 18.9183C4.89991 19.4734 5.3151 20 5.87403 20Z", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }) });
var alarm_default = SvgAlarm;

// assets/icons/apps.svg
import * as React50 from "react";
import { jsx as jsx51, jsxs as jsxs25 } from "react/jsx-runtime";
var SvgApps = (props) => /* @__PURE__ */ jsxs25("svg", { width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", stroke: "black", xmlns: "http://www.w3.org/2000/svg", ...props, children: [
  /* @__PURE__ */ jsx51("path", { d: "M6.3125 5.65625C6.3125 6.01869 6.01869 6.3125 5.65625 6.3125C5.29381 6.3125 5 6.01869 5 5.65625C5 5.29381 5.29381 5 5.65625 5C6.01869 5 6.3125 5.29381 6.3125 5.65625Z", stroke: "black", strokeWidth: 1.5 }),
  /* @__PURE__ */ jsx51("path", { d: "M12.6562 5.65625C12.6562 6.01869 12.3624 6.3125 12 6.3125C11.6376 6.3125 11.3438 6.01869 11.3438 5.65625C11.3438 5.29381 11.6376 5 12 5C12.3624 5 12.6562 5.29381 12.6562 5.65625Z", stroke: "black", strokeWidth: 1.5 }),
  /* @__PURE__ */ jsx51("path", { d: "M19 5.65625C19 6.01869 18.7062 6.3125 18.3438 6.3125C17.9813 6.3125 17.6875 6.01869 17.6875 5.65625C17.6875 5.29381 17.9813 5 18.3438 5C18.7062 5 19 5.29381 19 5.65625Z", stroke: "black", strokeWidth: 1.5 }),
  /* @__PURE__ */ jsx51("path", { d: "M6.3125 12C6.3125 12.3624 6.01869 12.6562 5.65625 12.6562C5.29381 12.6562 5 12.3624 5 12C5 11.6376 5.29381 11.3438 5.65625 11.3438C6.01869 11.3438 6.3125 11.6376 6.3125 12Z", stroke: "black", strokeWidth: 1.5 }),
  /* @__PURE__ */ jsx51("path", { d: "M12.6562 12C12.6562 12.3624 12.3624 12.6562 12 12.6562C11.6376 12.6562 11.3438 12.3624 11.3438 12C11.3438 11.6376 11.6376 11.3438 12 11.3438C12.3624 11.3438 12.6562 11.6376 12.6562 12Z", stroke: "black", strokeWidth: 1.5 }),
  /* @__PURE__ */ jsx51("path", { d: "M19 12C19 12.3624 18.7062 12.6562 18.3438 12.6562C17.9813 12.6562 17.6875 12.3624 17.6875 12C17.6875 11.6376 17.9813 11.3438 18.3438 11.3438C18.7062 11.3438 19 11.6376 19 12Z", stroke: "black", strokeWidth: 1.5 }),
  /* @__PURE__ */ jsx51("path", { d: "M6.3125 18.3438C6.3125 18.7062 6.01869 19 5.65625 19C5.29381 19 5 18.7062 5 18.3438C5 17.9813 5.29381 17.6875 5.65625 17.6875C6.01869 17.6875 6.3125 17.9813 6.3125 18.3438Z", stroke: "black", strokeWidth: 1.5 }),
  /* @__PURE__ */ jsx51("path", { d: "M12.6562 18.3438C12.6562 18.7062 12.3624 19 12 19C11.6376 19 11.3438 18.7062 11.3438 18.3438C11.3438 17.9813 11.6376 17.6875 12 17.6875C12.3624 17.6875 12.6562 17.9813 12.6562 18.3438Z", stroke: "black", strokeWidth: 1.5 }),
  /* @__PURE__ */ jsx51("path", { d: "M19 18.3438C19 18.7062 18.7062 19 18.3438 19C17.9813 19 17.6875 18.7062 17.6875 18.3438C17.6875 17.9813 17.9813 17.6875 18.3438 17.6875C18.7062 17.6875 19 17.9813 19 18.3438Z", stroke: "black", strokeWidth: 1.5 })
] });
var apps_default = SvgApps;

// assets/icons/area.svg
import * as React51 from "react";
import { jsx as jsx52 } from "react/jsx-runtime";
var SvgArea = (props) => /* @__PURE__ */ jsx52("svg", { width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx52("path", { d: "M5 7C3.89543 7 3 6.10457 3 5C3 3.89543 3.89543 3 5 3C6.10457 3 7 3.89543 7 5M5 7C6.10457 7 7 6.10457 7 5M5 7V17M7 5H17M17 19C17 20.1046 17.8954 21 19 21C20.1046 21 21 20.1046 21 19C21 17.8954 20.1046 17 19 17M17 19C17 17.8954 17.8954 17 19 17M17 19H7M19 17V7M19 7C17.8954 7 17 6.10457 17 5M19 7C20.1046 7 21 6.10457 21 5C21 3.89543 20.1046 3 19 3C17.8954 3 17 3.89543 17 5M7 19C7 20.1046 6.10457 21 5 21C3.89543 21 3 20.1046 3 19C3 17.8954 3.89543 17 5 17M7 19C7 17.8954 6.10457 17 5 17", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }) });
var area_default = SvgArea;

// assets/icons/analytics.svg
import * as React52 from "react";
import { jsx as jsx53 } from "react/jsx-runtime";
var SvgAnalytics = (props) => /* @__PURE__ */ jsx53("svg", { width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx53("path", { d: "M12 16V10M8 16V12.5M16 16V14M12.15 4H6C4.89543 4 4 4.89543 4 6V18C4 19.1046 4.89543 20 6 20H18C19.1046 20 20 19.1046 20 18V11.85M19 1L20 4L23 5L20 6L19 9L18 6L15 5L18 4L19 1Z", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }) });
var analytics_default = SvgAnalytics;

// assets/icons/AI.svg
import * as React53 from "react";
import { jsx as jsx54, jsxs as jsxs26 } from "react/jsx-runtime";
var SvgAi = (props) => /* @__PURE__ */ jsxs26("svg", { width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: [
  /* @__PURE__ */ jsx54("path", { d: "M17 14C13.134 14 10 10.866 10 7C10 10.866 6.866 14 3 14C6.866 14 10 17.134 10 21C10 17.134 13.134 14 17 14Z", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }),
  /* @__PURE__ */ jsx54("path", { d: "M16 9C17.3807 9 18.5 7.88071 18.5 6.5C18.5 7.88071 19.6193 9 21 9C19.6193 9 18.5 10.1193 18.5 11.5C18.5 10.1193 17.3807 9 16 9Z", stroke: "black", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }),
  /* @__PURE__ */ jsx54("path", { d: "M12.5 4.25C13.1904 4.25 13.75 3.69036 13.75 3C13.75 3.69036 14.3096 4.25 15 4.25C14.3096 4.25 13.75 4.80964 13.75 5.5C13.75 4.80964 13.1904 4.25 12.5 4.25Z", stroke: "black", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" })
] });
var AI_default = SvgAi;

// assets/icons/bookmark.svg
import * as React54 from "react";
import { jsx as jsx55 } from "react/jsx-runtime";
var SvgBookmark = (props) => /* @__PURE__ */ jsx55("svg", { width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx55("path", { d: "M5 21V13V5C5 3.89543 5.89543 3 7 3H17C18.1046 3 19 3.89543 19 5V13V21L13.0815 17.1953C12.4227 16.7717 11.5773 16.7717 10.9185 17.1953L5 21Z", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }) });
var bookmark_default = SvgBookmark;

// assets/icons/building-office1.svg
import * as React55 from "react";
import { jsx as jsx56 } from "react/jsx-runtime";
var SvgBuildingOffice1 = (props) => /* @__PURE__ */ jsx56("svg", { width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx56("path", { d: "M19 21V5C19 3.89543 18.1046 3 17 3H7C5.89543 3 5 3.89543 5 5V21M19 21L21 21M19 21H14M5 21L3 21M5 21H10M9 6.99998H10M9 11H10M14 6.99998H15M14 11H15M10 21V16C10 15.4477 10.4477 15 11 15H13C13.5523 15 14 15.4477 14 16V21M10 21H14", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }) });
var building_office1_default = SvgBuildingOffice1;

// assets/icons/building-office2.svg
import * as React56 from "react";
import { jsx as jsx57, jsxs as jsxs27 } from "react/jsx-runtime";
var SvgBuildingOffice2 = (props) => /* @__PURE__ */ jsxs27("svg", { width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: [
  /* @__PURE__ */ jsx57("path", { d: "M17 11H18C19.1 11 20 11.9 20 13V21H21H13.5M3 21H4M4 21V13C4 11.9 4.9 11 6 11H7M4 21H7M7 11C7 14.8682 7 17.1095 7 21M7 11C7 10.114 7 6.77371 7 6M7 11V21M7 21H10.5M7 6C7 4.9 7.9 4 9 4H15C16.1 4 17 4.9 17 6V21H15H13.5M7 6C7 5.06559 7 7.07623 7 6ZM13.5 21V16C13.5 15.45 13.05 15 12.5 15H11.5C10.95 15 10.5 15.45 10.5 16V21M13.5 21H10.5", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }),
  /* @__PURE__ */ jsx57("path", { d: "M10 8H10.5", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }),
  /* @__PURE__ */ jsx57("path", { d: "M10 11H10.5", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }),
  /* @__PURE__ */ jsx57("path", { d: "M13.5 8H14", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }),
  /* @__PURE__ */ jsx57("path", { d: "M13.5 11H14", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" })
] });
var building_office2_default = SvgBuildingOffice2;

// assets/icons/building-office3.svg
import * as React57 from "react";
import { jsx as jsx58 } from "react/jsx-runtime";
var SvgBuildingOffice3 = (props) => /* @__PURE__ */ jsx58("svg", { width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx58("path", { d: "M3 20H21M5 20V6C5 4.89543 5.89543 4 7 4H15C16.1046 4 17 4.89543 17 6V11M17 11H14C12.8954 11 12 11.8954 12 13V20H19V13C19 11.8954 18.1046 11 17 11ZM8 8H9M8 12H9M8 16H9M15.5 20V16", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }) });
var building_office3_default = SvgBuildingOffice3;

// assets/icons/check.svg
import * as React58 from "react";
import { jsx as jsx59 } from "react/jsx-runtime";
var SvgCheck = (props) => /* @__PURE__ */ jsx59("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx59("path", { d: "M16.5 5L7.5 14L3.5 10", strokeWidth: 1.25, strokeLinecap: "round", strokeLinejoin: "round" }) });
var check_default = SvgCheck;

// assets/icons/calendar.svg
import * as React59 from "react";
import { jsx as jsx60 } from "react/jsx-runtime";
var SvgCalendar = (props) => /* @__PURE__ */ jsx60("svg", { width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx60("path", { d: "M8 5H5C3.89543 5 3 5.89543 3 7V9.5M8 5V3M8 5H16M16 5H19C20.1046 5 21 5.89543 21 7V9.5M16 5V3M3 9.5V17C3 18.1046 3.89543 19 5 19H19C20.1046 19 21 18.1046 21 17V9.5M3 9.5H21", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }) });
var calendar_default = SvgCalendar;

// assets/icons/closeSign.svg
import * as React60 from "react";
import { jsx as jsx61 } from "react/jsx-runtime";
var SvgCloseSign = (props) => /* @__PURE__ */ jsx61("svg", { width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx61("path", { d: "M5 5L19 19M19 5L5 19", strokeWidth: 1.5, strokeLinecap: "round" }) });
var closeSign_default = SvgCloseSign;

// assets/icons/copy.svg
import * as React61 from "react";
import { jsx as jsx62, jsxs as jsxs28 } from "react/jsx-runtime";
var SvgCopy = (props) => /* @__PURE__ */ jsxs28("svg", { width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: [
  /* @__PURE__ */ jsx62("path", { d: "M16 19C16 20.1046 15.1046 21 14 21H6C4.89543 21 4 20.1046 4 19V9C4 7.89543 4.89543 7 6 7H14C15.1046 7 16 7.89543 16 9V19Z", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }),
  /* @__PURE__ */ jsx62("path", { d: "M8 7V5C8 3.89543 8.89543 3 10 3H18C19.1046 3 20 3.89543 20 5V15C20 16.1046 19.1046 17 18 17H16", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" })
] });
var copy_default = SvgCopy;

// assets/icons/certification.svg
import * as React62 from "react";
import { jsx as jsx63, jsxs as jsxs29 } from "react/jsx-runtime";
var SvgCertification = (props) => /* @__PURE__ */ jsxs29("svg", { width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: [
  /* @__PURE__ */ jsx63("circle", { cx: 12, cy: 9.5, r: 6.5, strokeWidth: 1.5 }),
  /* @__PURE__ */ jsx63("path", { d: "M7.5 14.5V21L12 19L16.5 21V14.5", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }),
  /* @__PURE__ */ jsx63("circle", { cx: 12, cy: 9.5, r: 2, strokeWidth: 1.5 })
] });
var certification_default = SvgCertification;

// assets/icons/camera-dome.svg
import * as React63 from "react";
import { jsx as jsx64 } from "react/jsx-runtime";
var SvgCameraDome = (props) => /* @__PURE__ */ jsx64("svg", { width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx64("path", { d: "M20 9L20.9594 6.45682C21.1488 5.72675 20.6512 5 19.9619 5H4.03811C3.34883 5 2.85119 5.72675 3.04055 6.45683L4 9M20 9H4M20 9V11.381C20 15.5888 16.4183 19 12 19C7.58172 19 4 15.5888 4 11.381V9M14 14C14 15.1 13.1 16 12 16C10.9 16 10 15.1 10 14C10 12.9 10.9 12 12 12C13.1 12 14 12.9 14 14Z", strokeWidth: 1.5, strokeLinecap: "round" }) });
var camera_dome_default = SvgCameraDome;

// assets/icons/camera-dome-cloud.svg
import * as React64 from "react";
import { jsx as jsx65 } from "react/jsx-runtime";
var SvgCameraDomeCloud = (props) => /* @__PURE__ */ jsx65("svg", { width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx65("path", { d: "M20 9L20.9594 6.45682C21.1488 5.72675 20.6512 5 19.9619 5H4.03811C3.34883 5 2.85119 5.72675 3.04055 6.45683L4 9M20 9H4M20 9V11.381C20 11.4351 19.9994 11.4961 19.9982 11.55M4 9V11.381C4 14.9311 6.54955 17.9142 10 18.76C10.0994 18.7843 10.1995 18.8069 10.3004 18.8277M10.7012 15.5178C10.2726 15.1503 10 14.6054 10 14C10 12.9 10.9 12 12 12C12.5697 12 13.0858 12.2414 13.451 12.627M15.025 20C13.9066 20 13 19.1366 13 18.0714C13 17.1299 13.7084 16.346 14.6452 16.1767C14.7568 16.1566 14.848 16.0729 14.876 15.963C15.163 14.8365 16.2289 14 17.5 14C18.7711 14 19.837 14.8365 20.124 15.963C20.152 16.0729 20.2432 16.1566 20.3548 16.1767C21.2916 16.346 22 17.1299 22 18.0714C22 19.1366 21.0934 20 19.975 20C17.9996 20 16.7545 20 15.025 20Z", strokeWidth: 1.5, strokeLinecap: "round" }) });
var camera_dome_cloud_default = SvgCameraDomeCloud;

// assets/icons/camera-fisheye.svg
import * as React65 from "react";
import { jsx as jsx66 } from "react/jsx-runtime";
var SvgCameraFisheye = (props) => /* @__PURE__ */ jsx66("svg", { width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx66("path", { d: "M20 9L20.9594 6.45682C21.1488 5.72675 20.6512 5 19.9619 5H4.03811C3.34883 5 2.85119 5.72675 3.04055 6.45683L4 9M20 9H4M20 9V11.381C20 12.1277 19.8872 12.8494 19.6769 13.5314M4 9V11.381C4 14.854 6.43992 17.7842 9.77631 18.7018M10.8032 15.5997C10.3163 15.234 10 14.6522 10 14C10 12.9 10.9 12 12 12C12.7364 12 13.3831 12.4033 13.7303 13C13.7671 13.0634 13.8006 13.129 13.8305 13.1964M12.5 17.9971L12.5 17.9985M12.5 17.9985C12.5026 18.1551 13.4994 20.494 16.0212 20.494C16.0212 20.494 18.5968 20.6883 20.3862 17.9985M12.5 17.9985L12.5 18M12.5 17.9985C12.5026 17.842 13.4994 15.5031 16.0212 15.5031C16.0212 15.5031 18.5968 15.3087 20.3862 17.9985M20.3862 17.9985C20.8186 17.3486 21.2051 16.5303 21.4982 15.5002M20.3862 17.9985C20.8186 18.6485 21.2051 19.4668 21.4982 20.4969", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }) });
var camera_fisheye_default = SvgCameraFisheye;

// assets/icons/camera-external.svg
import * as React66 from "react";
import { jsx as jsx67 } from "react/jsx-runtime";
var SvgCameraExternal = (props) => /* @__PURE__ */ jsx67("svg", { width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx67("path", { d: "M20.9594 6.45682L21.6612 6.72156L21.6753 6.68399L21.6854 6.64512L20.9594 6.45682ZM3.04055 6.45683L2.31457 6.64512L2.32465 6.68399L2.33883 6.72156L3.04055 6.45683ZM10.1849 16.0627C10.4956 16.3366 10.9696 16.3066 11.2434 15.9958C11.5173 15.6851 11.4873 15.2111 11.1765 14.9373L10.1849 16.0627ZM13.1054 13.4192C13.2998 13.785 13.7539 13.924 14.1197 13.7296C14.4854 13.5352 14.6244 13.0811 14.43 12.7153L13.1054 13.4192ZM19.1227 12.6696C19.0414 13.0758 19.3047 13.4709 19.7109 13.5523C20.117 13.6336 20.5122 13.3703 20.5935 12.9641L19.1227 12.6696ZM10.2183 18.8104L10.0595 19.5434H10.0595L10.2183 18.8104ZM10.197 19.572C10.6031 19.6534 10.9984 19.3902 11.0798 18.984C11.1612 18.5779 10.8979 18.1827 10.4918 18.1013L10.197 19.572ZM15.0303 16.5303C15.3232 16.2374 15.3232 15.7626 15.0303 15.4697C14.7374 15.1768 14.2626 15.1768 13.9697 15.4697L15.0303 16.5303ZM13 17.5L12.4697 16.9697C12.1768 17.2626 12.1768 17.7374 12.4697 18.0303L13 17.5ZM13.9697 19.5303C14.2626 19.8232 14.7374 19.8232 15.0303 19.5303C15.3232 19.2374 15.3232 18.7626 15.0303 18.4697L13.9697 19.5303ZM21.0303 15.4697C20.7374 15.1768 20.2626 15.1768 19.9697 15.4697C19.6768 15.7626 19.6768 16.2374 19.9697 16.5303L21.0303 15.4697ZM22 17.5L22.5303 18.0303C22.8232 17.7374 22.8232 17.2626 22.5303 16.9697L22 17.5ZM19.9697 18.4697C19.6768 18.7626 19.6768 19.2374 19.9697 19.5303C20.2626 19.8232 20.7374 19.8232 21.0303 19.5303L19.9697 18.4697ZM19.1708 15.8354C19.3561 15.4649 19.2059 15.0144 18.8354 14.8292C18.4649 14.6439 18.0144 14.7941 17.8292 15.1646L19.1708 15.8354ZM15.8292 19.1646C15.6439 19.5351 15.7941 19.9856 16.1646 20.1708C16.5351 20.3561 16.9856 20.2059 17.1708 19.8354L15.8292 19.1646ZM4.03811 5.75H19.9619V4.25H4.03811V5.75ZM20.2577 6.19209L19.2983 8.73526L20.7017 9.26474L21.6612 6.72156L20.2577 6.19209ZM4.70172 8.73526L3.74227 6.19209L2.33883 6.72156L3.29828 9.26474L4.70172 8.73526ZM19.9619 5.75C20.0266 5.75 20.1048 5.78127 20.1713 5.87837C20.2389 5.97701 20.2723 6.11875 20.2335 6.26853L21.6854 6.64512C21.9736 5.53401 21.2346 4.25 19.9619 4.25V5.75ZM4.03811 4.25C2.76543 4.25 2.02638 5.53401 2.31457 6.64512L3.76653 6.26853C3.72768 6.11875 3.76112 5.97701 3.82867 5.87837C3.89516 5.78127 3.97342 5.75 4.03811 5.75V4.25ZM4 9.75H20V8.25H4V9.75ZM19.25 9V11.381H20.75V9H19.25ZM4.75 11.381V9H3.25V11.381H4.75ZM10.75 14C10.75 13.3142 11.3142 12.75 12 12.75V11.25C10.4858 11.25 9.25 12.4858 9.25 14H10.75ZM11.1765 14.9373C10.9131 14.7051 10.75 14.3695 10.75 14H9.25C9.25 14.8219 9.61485 15.5604 10.1849 16.0627L11.1765 14.9373ZM12 12.75C12.4733 12.75 12.8927 13.019 13.1054 13.4192L14.43 12.7153C13.9694 11.8487 13.0542 11.25 12 11.25V12.75ZM19.25 11.381C19.25 11.822 19.2062 12.2527 19.1227 12.6696L20.5935 12.9641C20.6963 12.451 20.75 11.9216 20.75 11.381H19.25ZM10.3771 18.0774C7.12983 17.3739 4.75 14.6212 4.75 11.381H3.25C3.25 15.39 6.1854 18.7042 10.0595 19.5434L10.3771 18.0774ZM10.4918 18.1013C10.4534 18.0936 10.4152 18.0856 10.3771 18.0774L10.0595 19.5434C10.1052 19.5533 10.151 19.5628 10.197 19.572L10.4918 18.1013ZM13.9697 15.4697L12.4697 16.9697L13.5303 18.0303L15.0303 16.5303L13.9697 15.4697ZM12.4697 18.0303L13.9697 19.5303L15.0303 18.4697L13.5303 16.9697L12.4697 18.0303ZM19.9697 16.5303L21.4697 18.0303L22.5303 16.9697L21.0303 15.4697L19.9697 16.5303ZM21.4697 16.9697L19.9697 18.4697L21.0303 19.5303L22.5303 18.0303L21.4697 16.9697ZM17.8292 15.1646L15.8292 19.1646L17.1708 19.8354L19.1708 15.8354L17.8292 15.1646Z" }) });
var camera_external_default = SvgCameraExternal;

// assets/icons/camera-MDC.svg
import * as React67 from "react";
import { jsx as jsx68 } from "react/jsx-runtime";
var SvgCameraMdc = (props) => /* @__PURE__ */ jsx68("svg", { width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx68("path", { d: "M21 10L21.9594 7.45682C22.1488 6.72675 21.6512 6 20.9619 6H3.03811C2.34883 6 1.85119 6.72675 2.04055 7.45683L3 10M21 10H3M21 10V14C21 16.2091 19.2091 18 17 18H7C4.79086 18 3 16.2091 3 14V10M7.75 13.75C7.75 14.3 7.4125 14.75 7 14.75C6.5875 14.75 6.25 14.3 6.25 13.75C6.25 13.2 6.5875 12.75 7 12.75C7.4125 12.75 7.75 13.2 7.75 13.75ZM12.75 13.75C12.75 14.3 12.4125 14.75 12 14.75C11.5875 14.75 11.25 14.3 11.25 13.75C11.25 13.2 11.5875 12.75 12 12.75C12.4125 12.75 12.75 13.2 12.75 13.75ZM17.75 13.75C17.75 14.3 17.4125 14.75 17 14.75C16.5875 14.75 16.25 14.3 16.25 13.75C16.25 13.2 16.5875 12.75 17 12.75C17.4125 12.75 17.75 13.2 17.75 13.75Z", strokeWidth: 1.5, strokeLinecap: "round" }) });
var camera_MDC_default = SvgCameraMdc;

// assets/icons/crowd.svg
import * as React68 from "react";
import { jsx as jsx69, jsxs as jsxs30 } from "react/jsx-runtime";
var SvgCrowd = (props) => /* @__PURE__ */ jsxs30("svg", { width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: [
  /* @__PURE__ */ jsx69("path", { d: "M10 8C10 10.2091 11.7909 12 14 12C16.2091 12 18 10.2091 18 8C18 5.79086 16.2091 4 14 4C11.7909 4 10 5.79086 10 8Z", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }),
  /* @__PURE__ */ jsx69("path", { d: "M6 20.5V19C6 16.7909 7.79086 15 10 15H14", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }),
  /* @__PURE__ */ jsx69("path", { d: "M1.5 20.5V19.3636C1.5 16.9537 3.5 15 4.5 15", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }),
  /* @__PURE__ */ jsx69("path", { d: "M8.5 4C7.64183 4.22741 6.88119 4.74395 6.33801 5.46819C5.79483 6.19243 5.5 7.08318 5.5 8C5.5 8.91682 5.79483 9.80757 6.33801 10.5318C6.88119 11.256 7.64183 11.7726 8.5 12", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }),
  /* @__PURE__ */ jsx69("path", { d: "M18 15H22M22 15V19M22 15L17.5 19.5L15.5 17.5L12.5 20.5", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" })
] });
var crowd_default = SvgCrowd;

// assets/icons/cpu.svg
import * as React69 from "react";
import { jsx as jsx70 } from "react/jsx-runtime";
var SvgCpu = (props) => /* @__PURE__ */ jsx70("svg", { width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx70("path", { d: "M9 5V3M15 5V3M9 19V21M15 19V21M19 14H21M19 9H21M5 9H3M5 14H3M10 15H14C14.5523 15 15 14.5523 15 14V10C15 9.44772 14.5523 9 14 9H10C9.44772 9 9 9.44772 9 10V14C9 14.5523 9.44772 15 10 15ZM7 19H17C18.1046 19 19 18.1046 19 17V7C19 5.89543 18.1046 5 17 5H7C5.89543 5 5 5.89543 5 7V17C5 18.1046 5.89543 19 7 19Z", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }) });
var cpu_default = SvgCpu;

// assets/icons/cgi-sender.svg
import * as React70 from "react";
import { jsx as jsx71 } from "react/jsx-runtime";
var SvgCgiSender = (props) => /* @__PURE__ */ jsx71("svg", { width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx71("path", { d: "M15.5 14.5L18 12L15.5 9.5M8.5 9.5L6 12L8.5 14.5M13 7.5L11 16.5M7.8 21H16.2C17.8802 21 18.7202 21 19.362 20.673C19.9265 20.3854 20.3854 19.9265 20.673 19.362C21 18.7202 21 17.8802 21 16.2V7.8C21 6.11984 21 5.27976 20.673 4.63803C20.3854 4.07354 19.9265 3.6146 19.362 3.32698C18.7202 3 17.8802 3 16.2 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V16.2C3 17.8802 3 18.7202 3.32698 19.362C3.6146 19.9265 4.07354 20.3854 4.63803 20.673C5.27976 21 6.11984 21 7.8 21Z", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }) });
var cgi_sender_default = SvgCgiSender;

// assets/icons/camera-PTZ.svg
import * as React71 from "react";
import { jsx as jsx72 } from "react/jsx-runtime";
var SvgCameraPtz = (props) => /* @__PURE__ */ jsx72("svg", { width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx72("path", { d: "M20.9594 6.45682L21.6612 6.72156L21.6753 6.68399L21.6854 6.64512L20.9594 6.45682ZM3.04055 6.45683L2.31457 6.64512L2.32465 6.68399L2.33883 6.72156L3.04055 6.45683ZM19.25 10.75C19.25 11.1642 19.5858 11.5 20 11.5C20.4142 11.5 20.75 11.1642 20.75 10.75H19.25ZM9.54895 19.4171C9.94797 19.5282 10.3615 19.2949 10.4727 18.8958C10.5838 18.4968 10.3505 18.0832 9.95146 17.9721L9.54895 19.4171ZM9.91397 15.7883C10.1838 16.1026 10.6573 16.1386 10.9716 15.8687C11.2858 15.5989 11.3218 15.1254 11.052 14.8111L9.91397 15.7883ZM12.8597 13.0959C13.1597 13.3815 13.6344 13.3699 13.9201 13.0699C14.2057 12.7699 14.194 12.2951 13.894 12.0095L12.8597 13.0959ZM17.5 12.5L18.0303 11.9697C17.7374 11.6768 17.2626 11.6768 16.9697 11.9697L17.5 12.5ZM15.4697 13.4697C15.1768 13.7626 15.1768 14.2374 15.4697 14.5303C15.7626 14.8232 16.2374 14.8232 16.5303 14.5303L15.4697 13.4697ZM18.4697 14.5303C18.7626 14.8232 19.2374 14.8232 19.5303 14.5303C19.8232 14.2374 19.8232 13.7626 19.5303 13.4697L18.4697 14.5303ZM22.5 17.5L23.0303 18.0303C23.3232 17.7374 23.3232 17.2626 23.0303 16.9697L22.5 17.5ZM21.5303 15.4697C21.2374 15.1768 20.7626 15.1768 20.4697 15.4697C20.1768 15.7626 20.1768 16.2374 20.4697 16.5303L21.5303 15.4697ZM20.4697 18.4697C20.1768 18.7626 20.1768 19.2374 20.4697 19.5303C20.7626 19.8232 21.2374 19.8232 21.5303 19.5303L20.4697 18.4697ZM17.5 22.5L16.9697 23.0303C17.2626 23.3232 17.7374 23.3232 18.0303 23.0303L17.5 22.5ZM19.5303 21.5303C19.8232 21.2374 19.8232 20.7626 19.5303 20.4697C19.2374 20.1768 18.7626 20.1768 18.4697 20.4697L19.5303 21.5303ZM16.5303 20.4697C16.2374 20.1768 15.7626 20.1768 15.4697 20.4697C15.1768 20.7626 15.1768 21.2374 15.4697 21.5303L16.5303 20.4697ZM12.5 17.5L11.9697 16.9697C11.6768 17.2626 11.6768 17.7374 11.9697 18.0303L12.5 17.5ZM13.4697 19.5303C13.7626 19.8232 14.2374 19.8232 14.5303 19.5303C14.8232 19.2374 14.8232 18.7626 14.5303 18.4697L13.4697 19.5303ZM14.5303 16.5303C14.8232 16.2374 14.8232 15.7626 14.5303 15.4697C14.2374 15.1768 13.7626 15.1768 13.4697 15.4697L14.5303 16.5303ZM4.03811 5.75H19.9619V4.25H4.03811V5.75ZM20.2577 6.19209L19.2983 8.73526L20.7017 9.26474L21.6612 6.72156L20.2577 6.19209ZM4.70172 8.73526L3.74227 6.19209L2.33883 6.72156L3.29828 9.26474L4.70172 8.73526ZM19.9619 5.75C20.0266 5.75 20.1048 5.78127 20.1713 5.87837C20.2389 5.97701 20.2723 6.11875 20.2335 6.26853L21.6854 6.64512C21.9736 5.53401 21.2346 4.25 19.9619 4.25V5.75ZM4.03811 4.25C2.76543 4.25 2.02638 5.53401 2.31457 6.64512L3.76653 6.26853C3.72768 6.11875 3.76112 5.97701 3.82867 5.87837C3.89516 5.78127 3.97342 5.75 4.03811 5.75V4.25ZM4 9.75H20V8.25H4V9.75ZM19.25 9V10.75H20.75V9H19.25ZM4.75 11.381V9H3.25V11.381H4.75ZM10.75 14C10.75 13.3142 11.3142 12.75 12 12.75V11.25C10.4858 11.25 9.25 12.4858 9.25 14H10.75ZM9.95146 17.9721C6.9228 17.1284 4.75 14.478 4.75 11.381H3.25C3.25 15.2118 5.9316 18.4094 9.54895 19.4171L9.95146 17.9721ZM11.052 14.8111C10.8626 14.5906 10.75 14.3076 10.75 14H9.25C9.25 14.6824 9.50187 15.3084 9.91397 15.7883L11.052 14.8111ZM12 12.75C12.3305 12.75 12.6331 12.8801 12.8597 13.0959L13.894 12.0095C13.4021 11.5412 12.7339 11.25 12 11.25V12.75ZM16.9697 11.9697L15.4697 13.4697L16.5303 14.5303L18.0303 13.0303L16.9697 11.9697ZM19.5303 13.4697L18.0303 11.9697L16.9697 13.0303L18.4697 14.5303L19.5303 13.4697ZM23.0303 16.9697L21.5303 15.4697L20.4697 16.5303L21.9697 18.0303L23.0303 16.9697ZM21.5303 19.5303L23.0303 18.0303L21.9697 16.9697L20.4697 18.4697L21.5303 19.5303ZM18.0303 23.0303L19.5303 21.5303L18.4697 20.4697L16.9697 21.9697L18.0303 23.0303ZM15.4697 21.5303L16.9697 23.0303L18.0303 21.9697L16.5303 20.4697L15.4697 21.5303ZM11.9697 18.0303L13.4697 19.5303L14.5303 18.4697L13.0303 16.9697L11.9697 18.0303ZM13.4697 15.4697L11.9697 16.9697L13.0303 18.0303L14.5303 16.5303L13.4697 15.4697ZM17.5 17.5V19C18.3284 19 19 18.3284 19 17.5H17.5ZM17.5 17.5H16C16 18.3284 16.6716 19 17.5 19V17.5ZM17.5 17.5V16C16.6716 16 16 16.6716 16 17.5H17.5ZM17.5 17.5H19C19 16.6716 18.3284 16 17.5 16V17.5Z" }) });
var camera_PTZ_default = SvgCameraPtz;

// assets/icons/camera-tamp.svg
import * as React72 from "react";
import { jsx as jsx73 } from "react/jsx-runtime";
var SvgCameraTamp = (props) => /* @__PURE__ */ jsx73("svg", { width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx73("path", { d: "M20.9594 6.45682L21.6612 6.72156L21.6753 6.68399L21.6854 6.64512L20.9594 6.45682ZM3.04055 6.45683L2.31457 6.64512L2.32465 6.68399L2.33883 6.72156L3.04055 6.45683ZM19.25 9.75C19.25 10.1642 19.5858 10.5 20 10.5C20.4142 10.5 20.75 10.1642 20.75 9.75H19.25ZM13.2014 19.6717C13.6121 19.6177 13.9013 19.241 13.8473 18.8304C13.7933 18.4197 13.4167 18.1305 13.006 18.1845L13.2014 19.6717ZM17 17.9998L17.4504 18.5995C17.639 18.4578 17.75 18.2357 17.75 17.9998H17ZM20 17.9998H19.25C19.25 18.2357 19.361 18.4578 19.5496 18.5995L20 17.9998ZM22 14.75C22.4142 14.75 22.75 14.4142 22.75 14C22.75 13.5858 22.4142 13.25 22 13.25V14.75ZM20 15.75C19.5858 15.75 19.25 16.0858 19.25 16.5C19.25 16.9142 19.5858 17.25 20 17.25V15.75ZM22 17.25C22.4142 17.25 22.75 16.9142 22.75 16.5C22.75 16.0858 22.4142 15.75 22 15.75V17.25ZM18.5 20V19.25C18.0858 19.25 17.75 19.5858 17.75 20H18.5ZM18.5085 20H19.2585C19.2585 19.5858 18.9227 19.25 18.5085 19.25V20ZM18.5085 20.0085V20.7585C18.9227 20.7585 19.2585 20.4227 19.2585 20.0085H18.5085ZM18.5 20.0085H17.75C17.75 20.4227 18.0858 20.7585 18.5 20.7585V20.0085ZM4.03811 5.75H19.9619V4.25H4.03811V5.75ZM20.2577 6.19209L19.2983 8.73526L20.7017 9.26474L21.6612 6.72156L20.2577 6.19209ZM4.70172 8.73526L3.74227 6.19209L2.33883 6.72156L3.29828 9.26474L4.70172 8.73526ZM19.9619 5.75C20.0266 5.75 20.1048 5.78127 20.1713 5.87837C20.2389 5.97701 20.2723 6.11875 20.2335 6.26853L21.6854 6.64512C21.9736 5.53401 21.2346 4.25 19.9619 4.25V5.75ZM4.03811 4.25C2.76543 4.25 2.02638 5.53401 2.31457 6.64512L3.76653 6.26853C3.72768 6.11875 3.76112 5.97701 3.82867 5.87837C3.89516 5.78127 3.97342 5.75 4.03811 5.75V4.25ZM4 9.75H20V8.25H4V9.75ZM19.25 9V9.75H20.75V9H19.25ZM4.75 11.381V9H3.25V11.381H4.75ZM12 18.25C7.96103 18.25 4.75 15.1406 4.75 11.381H3.25C3.25 16.0371 7.20241 19.75 12 19.75V18.25ZM13.25 14C13.25 14.6858 12.6858 15.25 12 15.25V16.75C13.5142 16.75 14.75 15.5142 14.75 14H13.25ZM12 15.25C11.3142 15.25 10.75 14.6858 10.75 14H9.25C9.25 15.5142 10.4858 16.75 12 16.75V15.25ZM10.75 14C10.75 13.3142 11.3142 12.75 12 12.75V11.25C10.4858 11.25 9.25 12.4858 9.25 14H10.75ZM12 12.75C12.6858 12.75 13.25 13.3142 13.25 14H14.75C14.75 12.4858 13.5142 11.25 12 11.25V12.75ZM13.006 18.1845C12.6775 18.2276 12.3417 18.25 12 18.25V19.75C12.4072 19.75 12.8083 19.7234 13.2014 19.6717L13.006 18.1845ZM17.75 14C17.75 13.5858 18.0858 13.25 18.5 13.25V11.75C17.2574 11.75 16.25 12.7574 16.25 14H17.75ZM17.75 17.9998V14H16.25V17.9998H17.75ZM16.75 20C16.75 19.4279 17.0237 18.92 17.4504 18.5995L16.5496 17.4001C15.7619 17.9918 15.25 18.9362 15.25 20H16.75ZM18.5 21.75C17.5335 21.75 16.75 20.9665 16.75 20H15.25C15.25 21.7949 16.7051 23.25 18.5 23.25V21.75ZM20.25 20C20.25 20.9665 19.4665 21.75 18.5 21.75V23.25C20.2949 23.25 21.75 21.7949 21.75 20H20.25ZM19.5496 18.5995C19.9763 18.92 20.25 19.4279 20.25 20H21.75C21.75 18.9362 21.2381 17.9918 20.4504 17.4001L19.5496 18.5995ZM19.25 14V17.9998H20.75V14H19.25ZM18.5 13.25C18.9142 13.25 19.25 13.5858 19.25 14H20.75C20.75 12.7574 19.7426 11.75 18.5 11.75V13.25ZM20 14.75H22V13.25H20V14.75ZM20 17.25H22V15.75H20V17.25ZM18.5 20.75H18.5085V19.25H18.5V20.75ZM17.7585 20V20.0085H19.2585V20H17.7585ZM18.5085 19.2585H18.5V20.7585H18.5085V19.2585ZM19.25 20.0085V20H17.75V20.0085H19.25Z" }) });
var camera_tamp_default = SvgCameraTamp;

// assets/icons/cloud-upload.svg
import * as React73 from "react";
import { jsx as jsx74 } from "react/jsx-runtime";
var SvgCloudUpload = (props) => /* @__PURE__ */ jsx74("svg", { width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx74("path", { d: "M4 16.2422C2.79401 15.435 2 14.0602 2 12.5C2 10.1564 3.79151 8.23129 6.07974 8.01937C6.54781 5.17213 9.02024 3 12 3C14.9798 3 17.4522 5.17213 17.9203 8.01937C20.2085 8.23129 22 10.1564 22 12.5C22 14.0602 21.206 15.435 20 16.2422M8 16L12 12M12 12L16 16M12 12V21", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }) });
var cloud_upload_default = SvgCloudUpload;

// assets/icons/device.svg
import * as React74 from "react";
import { jsx as jsx75 } from "react/jsx-runtime";
var SvgDevice = (props) => /* @__PURE__ */ jsx75("svg", { width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx75("path", { d: "M16.5 11L20.6876 7.64993C21.015 7.38803 21.5 7.62111 21.5 8.04037V15.9597C21.5 16.379 21.015 16.6121 20.6876 16.3502L16.5 13M4.5 18H14.5C15.6046 18 16.5 17.1046 16.5 16V8C16.5 6.89543 15.6046 6 14.5 6H4.5C3.39543 6 2.5 6.89543 2.5 8V16C2.5 17.1046 3.39543 18 4.5 18Z", strokeWidth: 1.5 }) });
var device_default = SvgDevice;

// assets/icons/dashboardSign.svg
import * as React75 from "react";
import { jsx as jsx76 } from "react/jsx-runtime";
var SvgDashboardSign = (props) => /* @__PURE__ */ jsx76("svg", { width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx76("path", { d: "M9 5L9 19M9 10L21 10M5 19H19C20.1046 19 21 18.1046 21 17V7C21 5.89543 20.1046 5 19 5H5C3.89543 5 3 5.89543 3 7V17C3 18.1046 3.89543 19 5 19Z", strokeWidth: 1.5 }) });
var dashboardSign_default = SvgDashboardSign;

// assets/icons/document.svg
import * as React76 from "react";
import { jsx as jsx77 } from "react/jsx-runtime";
var SvgDocument = (props) => /* @__PURE__ */ jsx77("svg", { width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx77("path", { d: "M19 9H13.8974C13.4018 9 13 8.6269 13 8.16667V3M7 21H17C18.1046 21 19 20.1046 19 19V8.82843C19 8.29799 18.7893 7.78929 18.4142 7.41421L14.5858 3.58579C14.2107 3.21071 13.702 3 13.1716 3H7C5.89543 3 5 3.89543 5 5V19C5 20.1046 5.89543 21 7 21Z", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }) });
var document_default = SvgDocument;

// assets/icons/drag.svg
import * as React77 from "react";
import { jsx as jsx78, jsxs as jsxs31 } from "react/jsx-runtime";
var SvgDrag = (props) => /* @__PURE__ */ jsxs31("svg", { width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: [
  /* @__PURE__ */ jsx78("path", { d: "M9.5 5.75C9.5 6.16421 9.16421 6.5 8.75 6.5C8.33579 6.5 8 6.16421 8 5.75C8 5.33579 8.33579 5 8.75 5C9.16421 5 9.5 5.33579 9.5 5.75Z", strokeWidth: 1.5 }),
  /* @__PURE__ */ jsx78("path", { d: "M9.5 18.25C9.5 18.6642 9.16421 19 8.75 19C8.33579 19 8 18.6642 8 18.25C8 17.8358 8.33579 17.5 8.75 17.5C9.16421 17.5 9.5 17.8358 9.5 18.25Z", strokeWidth: 1.5 }),
  /* @__PURE__ */ jsx78("path", { d: "M9.5 12C9.5 12.4142 9.16421 12.75 8.75 12.75C8.33579 12.75 8 12.4142 8 12C8 11.5858 8.33579 11.25 8.75 11.25C9.16421 11.25 9.5 11.5858 9.5 12Z", strokeWidth: 1.5 }),
  /* @__PURE__ */ jsx78("path", { d: "M16 5.75C16 6.16421 15.6642 6.5 15.25 6.5C14.8358 6.5 14.5 6.16421 14.5 5.75C14.5 5.33579 14.8358 5 15.25 5C15.6642 5 16 5.33579 16 5.75Z", strokeWidth: 1.5 }),
  /* @__PURE__ */ jsx78("path", { d: "M16 18.25C16 18.6642 15.6642 19 15.25 19C14.8358 19 14.5 18.6642 14.5 18.25C14.5 17.8358 14.8358 17.5 15.25 17.5C15.6642 17.5 16 17.8358 16 18.25Z", strokeWidth: 1.5 }),
  /* @__PURE__ */ jsx78("path", { d: "M16 12C16 12.4142 15.6642 12.75 15.25 12.75C14.8358 12.75 14.5 12.4142 14.5 12C14.5 11.5858 14.8358 11.25 15.25 11.25C15.6642 11.25 16 11.5858 16 12Z", strokeWidth: 1.5 })
] });
var drag_default = SvgDrag;

// assets/icons/dashboards.svg
import * as React78 from "react";
import { jsx as jsx79, jsxs as jsxs32 } from "react/jsx-runtime";
var SvgDashboards = (props) => /* @__PURE__ */ jsxs32("svg", { width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: [
  /* @__PURE__ */ jsx79("path", { d: "M4 6C4 4.89543 4.89543 4 6 4H8.5C9.60457 4 10.5 4.89543 10.5 6V8.5C10.5 9.60457 9.60457 10.5 8.5 10.5H6C4.89543 10.5 4 9.60457 4 8.5V6Z", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }),
  /* @__PURE__ */ jsx79("path", { d: "M4 15.5C4 14.3954 4.89543 13.5 6 13.5H8.5C9.60457 13.5 10.5 14.3954 10.5 15.5V18C10.5 19.1046 9.60457 20 8.5 20H6C4.89543 20 4 19.1046 4 18V15.5Z", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }),
  /* @__PURE__ */ jsx79("path", { d: "M13.5 6C13.5 4.89543 14.3954 4 15.5 4H18C19.1046 4 20 4.89543 20 6V8.5C20 9.60457 19.1046 10.5 18 10.5H15.5C14.3954 10.5 13.5 9.60457 13.5 8.5V6Z", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }),
  /* @__PURE__ */ jsx79("path", { d: "M13.5 15.5C13.5 14.3954 14.3954 13.5 15.5 13.5H18C19.1046 13.5 20 14.3954 20 15.5V18C20 19.1046 19.1046 20 18 20H15.5C14.3954 20 13.5 19.1046 13.5 18V15.5Z", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" })
] });
var dashboards_default = SvgDashboards;

// assets/icons/direction.svg
import * as React79 from "react";
import { jsx as jsx80 } from "react/jsx-runtime";
var SvgDirection = (props) => /* @__PURE__ */ jsx80("svg", { width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx80("path", { d: "M21 19.4516L20.4375 16.7097M21 19.4516L18.1875 20M21 19.4516L14.25 14.495M3 19.4516L5.8125 20M3 19.4516L3.5625 16.7097M3 19.4516L9.75 14.495M12 3L9.75 5.19355M12 3L14.25 5.19355M12 3V10.3821", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }) });
var direction_default = SvgDirection;

// assets/icons/defocus.svg
import * as React80 from "react";
import { jsx as jsx81, jsxs as jsxs33 } from "react/jsx-runtime";
var SvgDefocus = (props) => /* @__PURE__ */ jsxs33("svg", { width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: [
  /* @__PURE__ */ jsx81("path", { d: "M13.25 9.99974C13.25 9.58552 13.5858 9.24974 14 9.24974C14.4142 9.24974 14.75 9.58552 14.75 9.99974C14.75 10.4139 14.4142 10.7497 14 10.7497C13.5858 10.7497 13.25 10.4139 13.25 9.99974Z", fill: "black" }),
  /* @__PURE__ */ jsx81("path", { d: "M13.25 13.9997C13.25 13.5855 13.5858 13.2497 14 13.2497C14.4142 13.2497 14.75 13.5855 14.75 13.9997C14.75 14.4139 14.4142 14.7497 14 14.7497C13.5858 14.7497 13.25 14.4139 13.25 13.9997Z", fill: "black" }),
  /* @__PURE__ */ jsx81("path", { d: "M9.25 13.9997C9.25 13.5855 9.58579 13.2497 10 13.2497C10.4142 13.2497 10.75 13.5855 10.75 13.9997C10.75 14.4139 10.4142 14.7497 10 14.7497C9.58579 14.7497 9.25 14.4139 9.25 13.9997Z", fill: "black" }),
  /* @__PURE__ */ jsx81("path", { d: "M9.25 9.99974C9.25 9.58552 9.58579 9.24974 10 9.24974C10.4142 9.24974 10.75 9.58552 10.75 9.99974C10.75 10.4139 10.4142 10.7497 10 10.7497C9.58579 10.7497 9.25 10.4139 9.25 9.99974Z", fill: "black" }),
  /* @__PURE__ */ jsx81("path", { d: "M10 5.99974H10.005M18 9.99974V10.0047M10 17.9997H10.005M6 9.99974V10.0047M14 5.99974H14.005M18 13.9997V14.0047M14 17.9997H14.005M6 13.9997V14.0047M10 6.24974C9.86193 6.24974 9.75 6.13781 9.75 5.99974C9.75 5.86166 9.86193 5.74974 10 5.74974C10.1381 5.74974 10.25 5.86166 10.25 5.99974C10.25 6.13781 10.1381 6.24974 10 6.24974ZM17.75 9.99974C17.75 9.86166 17.8619 9.74974 18 9.74974C18.1381 9.74974 18.25 9.86166 18.25 9.99974C18.25 10.1378 18.1381 10.2497 18 10.2497C17.8619 10.2497 17.75 10.1378 17.75 9.99974ZM10 18.2497C9.86193 18.2497 9.75 18.1378 9.75 17.9997C9.75 17.8617 9.86193 17.7497 10 17.7497C10.1381 17.7497 10.25 17.8617 10.25 17.9997C10.25 18.1378 10.1381 18.2497 10 18.2497ZM5.75 9.99974C5.75 9.86166 5.86193 9.74974 6 9.74974C6.13807 9.74974 6.25 9.86166 6.25 9.99974C6.25 10.1378 6.13807 10.2497 6 10.2497C5.86193 10.2497 5.75 10.1378 5.75 9.99974ZM14 6.24974C13.8619 6.24974 13.75 6.13781 13.75 5.99974C13.75 5.86166 13.8619 5.74974 14 5.74974C14.1381 5.74974 14.25 5.86166 14.25 5.99974C14.25 6.13781 14.1381 6.24974 14 6.24974ZM17.75 13.9997C17.75 13.8617 17.8619 13.7497 18 13.7497C18.1381 13.7497 18.25 13.8617 18.25 13.9997C18.25 14.1378 18.1381 14.2497 18 14.2497C17.8619 14.2497 17.75 14.1378 17.75 13.9997ZM14 18.2497C13.8619 18.2497 13.75 18.1378 13.75 17.9997C13.75 17.8617 13.8619 17.7497 14 17.7497C14.1381 17.7497 14.25 17.8617 14.25 17.9997C14.25 18.1378 14.1381 18.2497 14 18.2497ZM5.75 13.9997C5.75 13.8617 5.86193 13.7497 6 13.7497C6.13807 13.7497 6.25 13.8617 6.25 13.9997C6.25 14.1378 6.13807 14.2497 6 14.2497C5.86193 14.2497 5.75 14.1378 5.75 13.9997ZM10 2.99974V2.99121H10.0085V2.99974H10ZM21 9.99095H21.0085V9.99947H21V9.99095ZM10 20.9997V20.9912H10.0085V20.9997H10ZM3 9.99095H3.00852V9.99947H3L3 9.99095ZM14 2.99974V2.99121H14.0085V2.99974H14ZM21 13.9909H21.0085V13.9995H21V13.9909ZM14 20.9997V20.9912H14.0085V20.9997H14ZM3 13.9909H3.00852V13.9995H3L3 13.9909ZM6 5.99095H6.00852V5.99947H6V5.99095ZM18 5.99095H18.0085V5.99947H18V5.99095ZM18 17.9997H18.0085V18.0083H18V17.9997ZM6 17.9997H6.00852V18.0083H6V17.9997ZM14 10.7497C13.5858 10.7497 13.25 10.4139 13.25 9.99974C13.25 9.58552 13.5858 9.24974 14 9.24974C14.4142 9.24974 14.75 9.58552 14.75 9.99974C14.75 10.4139 14.4142 10.7497 14 10.7497ZM14 14.7497C13.5858 14.7497 13.25 14.4139 13.25 13.9997C13.25 13.5855 13.5858 13.2497 14 13.2497C14.4142 13.2497 14.75 13.5855 14.75 13.9997C14.75 14.4139 14.4142 14.7497 14 14.7497ZM10 14.7497C9.58579 14.7497 9.25 14.4139 9.25 13.9997C9.25 13.5855 9.58579 13.2497 10 13.2497C10.4142 13.2497 10.75 13.5855 10.75 13.9997C10.75 14.4139 10.4142 14.7497 10 14.7497ZM10 10.7497C9.58579 10.7497 9.25 10.4139 9.25 9.99974C9.25 9.58552 9.58579 9.24974 10 9.24974C10.4142 9.24974 10.75 9.58552 10.75 9.99974C10.75 10.4139 10.4142 10.7497 10 10.7497Z", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" })
] });
var defocus_default = SvgDefocus;

// assets/icons/external-link.svg
import * as React81 from "react";
import { jsx as jsx82, jsxs as jsxs34 } from "react/jsx-runtime";
var SvgExternalLink = (props) => /* @__PURE__ */ jsxs34("svg", { width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: [
  /* @__PURE__ */ jsx82("path", { d: "M12 12L19 5", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }),
  /* @__PURE__ */ jsx82("path", { d: "M20 13V18C20 19.1046 19.1046 20 18 20H6C4.89543 20 4 19.1046 4 18V6C4 4.89543 4.89543 4 6 4H11", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }),
  /* @__PURE__ */ jsx82("path", { d: "M15 4H19C19.5523 4 20 4.44772 20 5V9", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }),
  /* @__PURE__ */ jsx82("path", { d: "M20 13V18C20 19.1046 19.1046 20 18 20H6C4.89543 20 4 19.1046 4 18V6C4 4.89543 4.89543 4 6 4H11", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" })
] });
var external_link_default = SvgExternalLink;

// assets/icons/export.svg
import * as React82 from "react";
import { jsx as jsx83, jsxs as jsxs35 } from "react/jsx-runtime";
var SvgExport = (props) => /* @__PURE__ */ jsxs35("svg", { width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: [
  /* @__PURE__ */ jsx83("path", { d: "M4 16V18C4 19.1046 4.89543 20 6 20H18C19.1046 20 20 19.1046 20 18V16", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }),
  /* @__PURE__ */ jsx83("path", { d: "M17 9L12 4M12 4L7 9M12 4V16", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" })
] });
var export_default = SvgExport;

// assets/icons/edit.svg
import * as React83 from "react";
import { jsx as jsx84 } from "react/jsx-runtime";
var SvgEdit = (props) => /* @__PURE__ */ jsx84("svg", { width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx84("path", { d: "M14.2513 5.74302L18.5 10M19.6061 4.8684C18.3992 3.72495 16.4417 3.70589 15.2145 4.83981L4.56274 14.8282C4.4851 14.901 4.43272 14.9967 4.41322 15.1013L3.6329 19.2871C3.56873 19.6313 3.86905 19.9331 4.21355 19.8707L8.72022 19.0544C8.81494 19.0372 8.90269 18.9931 8.97294 18.9273L19.5757 8.99433C20.7928 7.86041 20.813 6.02137 19.6061 4.8684Z", strokeWidth: 1.5, strokeMiterlimit: 10, strokeLinejoin: "round" }) });
var edit_default = SvgEdit;

// assets/icons/email.svg
import * as React84 from "react";
import { jsx as jsx85 } from "react/jsx-runtime";
var SvgEmail = (props) => /* @__PURE__ */ jsx85("svg", { width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx85("path", { d: "M3 7L10.7721 13.045C11.4943 13.6067 12.5057 13.6067 13.2279 13.045L21 7M5 19H19C20.1046 19 21 18.1046 21 17V7C21 5.89543 20.1046 5 19 5H5C3.89543 5 3 5.89543 3 7V17C3 18.1046 3.89543 19 5 19Z", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }) });
var email_default = SvgEmail;

// assets/icons/event.svg
import * as React85 from "react";
import { jsx as jsx86 } from "react/jsx-runtime";
var SvgEvent = (props) => /* @__PURE__ */ jsx86("svg", { width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx86("path", { d: "M19.9594 19.0432L20.6854 18.8549C20.6787 18.829 20.6706 18.8035 20.6612 18.7784L19.9594 19.0432ZM4.04055 19.0432L3.33883 18.7784C3.32938 18.8035 3.32129 18.829 3.31457 18.8549L4.04055 19.0432ZM5 10.5H5.75H5ZM12.75 7C12.75 6.58579 12.4142 6.25 12 6.25C11.5858 6.25 11.25 6.58579 11.25 7H12.75ZM11.25 10.5C11.25 10.9142 11.5858 11.25 12 11.25C12.4142 11.25 12.75 10.9142 12.75 10.5H11.25ZM11.25 13.5C11.25 13.9142 11.5858 14.25 12 14.25C12.4142 14.25 12.75 13.9142 12.75 13.5H11.25ZM5.03811 21.25H18.9619V19.75H5.03811V21.25ZM20.6612 18.7784L19.7017 16.2353L18.2983 16.7647L19.2577 19.3079L20.6612 18.7784ZM4.29828 16.2353L3.33883 18.7784L4.74227 19.3079L5.70172 16.7647L4.29828 16.2353ZM18.9619 21.25C20.2346 21.25 20.9736 19.966 20.6854 18.8549L19.2335 19.2315C19.2723 19.3812 19.2389 19.523 19.1713 19.6216C19.1048 19.7187 19.0266 19.75 18.9619 19.75V21.25ZM5.03811 19.75C4.97342 19.75 4.89516 19.7187 4.82867 19.6216C4.76112 19.523 4.72768 19.3812 4.76653 19.2315L3.31457 18.8549C3.02638 19.966 3.76543 21.25 5.03811 21.25V19.75ZM18.25 10.5V16.5H19.75V10.5H18.25ZM5.75 16.5V10.5H4.25L4.25 16.5H5.75ZM12 4.25C15.4518 4.25 18.25 7.04822 18.25 10.5H19.75C19.75 6.21979 16.2802 2.75 12 2.75V4.25ZM12 2.75C7.71979 2.75 4.25 6.21979 4.25 10.5H5.75C5.75 7.04822 8.54822 4.25 12 4.25V2.75ZM11.25 7V10.5H12.75V7H11.25ZM11.25 13V13.5H12.75V13H11.25ZM11.75 13.5C11.75 13.3619 11.8619 13.25 12 13.25V14.75C12.6904 14.75 13.25 14.1904 13.25 13.5H11.75ZM12 13.25C12.1381 13.25 12.25 13.3619 12.25 13.5H10.75C10.75 14.1904 11.3096 14.75 12 14.75V13.25ZM12.25 13.5C12.25 13.6381 12.1381 13.75 12 13.75V12.25C11.3096 12.25 10.75 12.8096 10.75 13.5H12.25ZM12 13.75C11.8619 13.75 11.75 13.6381 11.75 13.5H13.25C13.25 12.8096 12.6904 12.25 12 12.25V13.75ZM5 17.25H19V15.75H5V17.25Z" }) });
var event_default = SvgEvent;

// assets/icons/fail-no-fill.svg
import * as React86 from "react";
import { jsx as jsx87, jsxs as jsxs36 } from "react/jsx-runtime";
var SvgFailNoFill = (props) => /* @__PURE__ */ jsxs36("svg", { width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: [
  /* @__PURE__ */ jsx87("path", { d: "M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z", strokeWidth: 1.5, strokeMiterlimit: 10, strokeLinecap: "round" }),
  /* @__PURE__ */ jsx87("path", { d: "M15 9L9 15", strokeWidth: 1.5, strokeMiterlimit: 10, strokeLinecap: "round" }),
  /* @__PURE__ */ jsx87("path", { d: "M9 9L15 15", strokeWidth: 1.5, strokeMiterlimit: 10, strokeLinecap: "round" })
] });
var fail_no_fill_default = SvgFailNoFill;

// assets/icons/favorite.svg
import * as React87 from "react";
import { jsx as jsx88 } from "react/jsx-runtime";
var SvgFavorite = (props) => /* @__PURE__ */ jsx88("svg", { width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx88("path", { d: "M11.1335 4.03197C11.4879 3.32268 12.5121 3.32268 12.8665 4.03197L14.8991 8.09923C15.0398 8.38089 15.3119 8.57612 15.6267 8.62128L20.1716 9.2735C20.9642 9.38724 21.2807 10.3492 20.7071 10.9013L17.4184 14.0672C17.1906 14.2864 17.0867 14.6023 17.1405 14.9119L17.9168 19.3822C18.0522 20.1618 17.2237 20.7563 16.5148 20.3883L12.4497 18.2776C12.1682 18.1315 11.8318 18.1315 11.5503 18.2776L7.48523 20.3883C6.77631 20.7563 5.94776 20.1618 6.08315 19.3822L6.85952 14.9119C6.91329 14.6023 6.80936 14.2864 6.58161 14.0672L3.29287 10.9013C2.71935 10.3492 3.03582 9.38724 3.82841 9.2735L8.37334 8.62128C8.68808 8.57612 8.96016 8.38089 9.10092 8.09923L11.1335 4.03197Z", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }) });
var favorite_default = SvgFavorite;

// assets/icons/filter.svg
import * as React88 from "react";
import { jsx as jsx89 } from "react/jsx-runtime";
var SvgFilter = (props) => /* @__PURE__ */ jsx89("svg", { width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx89("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10 12.3059L4.30304 5.48017C3.55659 4.4548 4.27436 3 5.52671 3H18.4733C19.7256 3 20.4434 4.4548 19.697 5.48017L14 12.3059V20.5C14 21.118 13.2944 21.4708 12.8 21.1L10.3 19.225C10.1111 19.0834 10 18.8611 10 18.625V12.3059Z", strokeWidth: 1.5, strokeLinejoin: "round" }) });
var filter_default = SvgFilter;

// assets/icons/folder-close.svg
import * as React89 from "react";
import { jsx as jsx90 } from "react/jsx-runtime";
var SvgFolderClose = (props) => /* @__PURE__ */ jsx90("svg", { width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx90("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M21 8.55172C21 7.41859 20.1941 6.5 19.2 6.5L11.3975 6.5C11.3293 6.5 11.2639 6.46912 11.2156 6.41415L9.76103 5.10094C9.42346 4.71616 8.96563 4.5 8.48824 4.5H4.8C3.80589 4.5 3 5.41859 3 6.55172V17.4483C3 18.5814 3.80589 19.5 4.8 19.5H19.2C20.1941 19.5 21 18.5814 21 17.4483V8.55172Z", strokeWidth: 1.5, strokeMiterlimit: 10 }) });
var folder_close_default = SvgFolderClose;

// assets/icons/folder-open.svg
import * as React90 from "react";
import { jsx as jsx91 } from "react/jsx-runtime";
var SvgFolderOpen = (props) => /* @__PURE__ */ jsx91("svg", { width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx91("path", { d: "M20 10V8.55172C20 7.41859 19.1941 6.5 18.2 6.5L11.3975 6.5C11.3293 6.5 11.2639 6.46912 11.2156 6.41415L9.76103 5.10094C9.42346 4.71616 8.96563 4.5 8.48824 4.5H4.8C3.80589 4.5 3 5.41859 3 6.55172V17.4483C3 18.5814 3.80589 19.5 4.8 19.5H12M5.95987 19.5H18.0295C18.846 19.5 19.5805 19.0037 19.8851 18.2462L21.8957 13.2462C22.4242 11.932 21.4566 10.5 20.0401 10.5H7.97046C7.15398 10.5 6.41947 10.9963 6.11486 11.7538L4.10428 16.7538C3.57581 18.068 4.54338 19.5 5.95987 19.5Z", strokeWidth: 1.5, strokeMiterlimit: 10 }) });
var folder_open_default = SvgFolderOpen;

// assets/icons/folklift.svg
import * as React91 from "react";
import { jsx as jsx92 } from "react/jsx-runtime";
var SvgFolklift = (props) => /* @__PURE__ */ jsx92("svg", { width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx92("path", { d: "M4.5 9.88883V5C4.5 3.89543 5.39543 3 6.5 3H11.083C11.8643 3 12.5741 3.45503 12.9003 4.16504L16.5 12M18 3V16C18 16.5523 18.4477 17 19 17H22M18 17V14C18 12.8954 17.1046 12 16 12H12L9 10H5C3.89543 10 3 10.8954 3 12V17M13 17H8M8 17.5C8 18.8807 6.88071 20 5.5 20C4.11929 20 3 18.8807 3 17.5C3 16.1193 4.11929 15 5.5 15C6.88071 15 8 16.1193 8 17.5ZM18 17.5C18 18.8807 16.8807 20 15.5 20C14.1193 20 13 18.8807 13 17.5C13 16.1193 14.1193 15 15.5 15C16.8807 15 18 16.1193 18 17.5Z", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }) });
var folklift_default = SvgFolklift;

// assets/icons/firmware.svg
import * as React92 from "react";
import { jsx as jsx93 } from "react/jsx-runtime";
var SvgFirmware = (props) => /* @__PURE__ */ jsx93("svg", { width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx93("path", { d: "M14.5858 3.58579L14.0555 4.11612L14.0555 4.11612L14.5858 3.58579ZM18.4142 7.41421L18.9445 6.88388L18.9445 6.88388L18.4142 7.41421ZM18.25 9C18.25 9.41421 18.5858 9.75 19 9.75C19.4142 9.75 19.75 9.41421 19.75 9H18.25ZM9 21.75C9.41421 21.75 9.75 21.4142 9.75 21C9.75 20.5858 9.41421 20.25 9 20.25V21.75ZM16.25 12C16.25 11.5858 15.9142 11.25 15.5 11.25C15.0858 11.25 14.75 11.5858 14.75 12H16.25ZM14.75 13.5C14.75 13.9142 15.0858 14.25 15.5 14.25C15.9142 14.25 16.25 13.9142 16.25 13.5H14.75ZM22 16.25C22.4142 16.25 22.75 15.9142 22.75 15.5C22.75 15.0858 22.4142 14.75 22 14.75V16.25ZM20.5 14.75C20.0858 14.75 19.75 15.0858 19.75 15.5C19.75 15.9142 20.0858 16.25 20.5 16.25V14.75ZM13.5 16.25C13.9142 16.25 14.25 15.9142 14.25 15.5C14.25 15.0858 13.9142 14.75 13.5 14.75V16.25ZM12 14.75C11.5858 14.75 11.25 15.0858 11.25 15.5C11.25 15.9142 11.5858 16.25 12 16.25V14.75ZM16.25 20.5C16.25 20.0858 15.9142 19.75 15.5 19.75C15.0858 19.75 14.75 20.0858 14.75 20.5H16.25ZM14.75 22C14.75 22.4142 15.0858 22.75 15.5 22.75C15.9142 22.75 16.25 22.4142 16.25 22H14.75ZM19.25 12C19.25 11.5858 18.9142 11.25 18.5 11.25C18.0858 11.25 17.75 11.5858 17.75 12H19.25ZM17.75 13.5C17.75 13.9142 18.0858 14.25 18.5 14.25C18.9142 14.25 19.25 13.9142 19.25 13.5H17.75ZM22 19.25C22.4142 19.25 22.75 18.9142 22.75 18.5C22.75 18.0858 22.4142 17.75 22 17.75V19.25ZM20.5 17.75C20.0858 17.75 19.75 18.0858 19.75 18.5C19.75 18.9142 20.0858 19.25 20.5 19.25V17.75ZM13.5 19.25C13.9142 19.25 14.25 18.9142 14.25 18.5C14.25 18.0858 13.9142 17.75 13.5 17.75V19.25ZM12 17.75C11.5858 17.75 11.25 18.0858 11.25 18.5C11.25 18.9142 11.5858 19.25 12 19.25V17.75ZM19.25 20.5C19.25 20.0858 18.9142 19.75 18.5 19.75C18.0858 19.75 17.75 20.0858 17.75 20.5H19.25ZM17.75 22C17.75 22.4142 18.0858 22.75 18.5 22.75C18.9142 22.75 19.25 22.4142 19.25 22H17.75ZM5.75 19V5H4.25V19H5.75ZM7 20.25C6.30964 20.25 5.75 19.6904 5.75 19H4.25C4.25 20.5188 5.48122 21.75 7 21.75V20.25ZM14.0555 4.11612L17.8839 7.94454L18.9445 6.88388L15.1161 3.05546L14.0555 4.11612ZM7 2.25C5.48122 2.25 4.25 3.48122 4.25 5H5.75C5.75 4.30964 6.30964 3.75 7 3.75V2.25ZM7 3.75H13.1716V2.25H7V3.75ZM17.8839 7.94454C18.1183 8.17896 18.25 8.49691 18.25 8.82843H19.75C19.75 8.09908 19.4603 7.39961 18.9445 6.88388L17.8839 7.94454ZM15.1161 3.05546C14.6004 2.53973 13.9009 2.25 13.1716 2.25V3.75C13.5031 3.75 13.821 3.8817 14.0555 4.11612L15.1161 3.05546ZM18.25 8.82843V9H19.75V8.82843H18.25ZM9 20.25H7V21.75H9V20.25ZM15 14.25H19V12.75H15V14.25ZM19.75 15V19H21.25V15H19.75ZM19 19.75H15V21.25H19V19.75ZM14.25 19V15H12.75V19H14.25ZM15 19.75C14.5858 19.75 14.25 19.4142 14.25 19H12.75C12.75 20.2426 13.7574 21.25 15 21.25V19.75ZM19.75 19C19.75 19.4142 19.4142 19.75 19 19.75V21.25C20.2426 21.25 21.25 20.2426 21.25 19H19.75ZM19 14.25C19.4142 14.25 19.75 14.5858 19.75 15H21.25C21.25 13.7574 20.2426 12.75 19 12.75V14.25ZM15 12.75C13.7574 12.75 12.75 13.7574 12.75 15H14.25C14.25 14.5858 14.5858 14.25 15 14.25V12.75ZM16.51 17.25H17.49V15.75H16.51V17.25ZM16.75 16.51V17.49H18.25V16.51H16.75ZM17.49 16.75H16.51V18.25H17.49V16.75ZM17.25 17.49V16.51H15.75V17.49H17.25ZM16.51 16.75C16.9187 16.75 17.25 17.0813 17.25 17.49H15.75C15.75 17.9097 16.0903 18.25 16.51 18.25V16.75ZM16.75 17.49C16.75 17.0813 17.0813 16.75 17.49 16.75V18.25C17.9097 18.25 18.25 17.9097 18.25 17.49H16.75ZM17.49 17.25C17.0813 17.25 16.75 16.9187 16.75 16.51H18.25C18.25 16.0903 17.9097 15.75 17.49 15.75V17.25ZM16.51 15.75C16.0903 15.75 15.75 16.0903 15.75 16.51H17.25C17.25 16.9187 16.9187 17.25 16.51 17.25V15.75ZM14.75 12V13.5H16.25V12H14.75ZM22 14.75H20.5V16.25H22V14.75ZM13.5 14.75H12V16.25H13.5V14.75ZM14.75 20.5V22H16.25V20.5H14.75ZM17.75 12V13.5H19.25V12H17.75ZM22 17.75H20.5V19.25H22V17.75ZM13.5 17.75H12V19.25H13.5V17.75ZM17.75 20.5V22H19.25V20.5H17.75Z" }) });
var firmware_default = SvgFirmware;

// assets/icons/forklift counting.svg
import * as React93 from "react";
import { jsx as jsx94 } from "react/jsx-runtime";
var SvgForkliftCounting = (props) => /* @__PURE__ */ jsx94("svg", { width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx94("path", { d: "M4.5 9.88883V5C4.5 3.89543 5.39543 3 6.5 3H11.083C11.8643 3 12.5741 3.45503 12.9003 4.16504L16.5 12M3 17V12C3 10.8954 3.89543 10 5 10H9L12 12H18V3M8 17H11.5M17.5 15H21M21 15V18.5M21 15L17 19L15.2342 17.2727L12.6001 20M8 17.5C8 18.8807 6.88071 20 5.5 20C4.11929 20 3 18.8807 3 17.5C3 16.1193 4.11929 15 5.5 15C6.88071 15 8 16.1193 8 17.5Z", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }) });
var forklift_counting_default = SvgForkliftCounting;

// assets/icons/forklift-queue-management.svg
import * as React94 from "react";
import { jsx as jsx95 } from "react/jsx-runtime";
var SvgForkliftQueueManagement = (props) => /* @__PURE__ */ jsx95("svg", { width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx95("path", { d: "M3.75 19.09C3.75 20.15 4.57 21 5.58 21C6.59 21 7.41 20.14 7.41 19.09C7.41 18.04 6.59 17.18 5.58 17.18C4.57 17.18 3.75 18.04 3.75 19.09ZM3.75 19.09V14.88C3.75 14.04 4.41 13.35 5.22 13.35H8.15L10.35 14.88H14.28C15.09 14.88 15.75 15.56 15.75 16.41V19.09M15.75 19.09C15.75 20.15 14.93 21 13.92 21C12.91 21 12.09 20.14 12.09 19.09C12.09 18.04 12.91 17.18 13.92 17.18C14.93 17.18 15.75 18.04 15.75 19.09ZM4.85 13.27V9.53C4.85 8.69 5.51 8 6.32 8H9.68C10.25 8 10.77 8.35 11.01 8.89L13.65 14.88M12.08 18.71H7.41M18.25 8V18.21M18.25 18.21C18.25 18.64 18.59 19 19 19H21M18.25 18.21V16.64M7.01001 5.5H11.26C11.88 5.5 12.44 5.87 12.69 6.46L15.21 12.24M8.25 3H12.87C13.49 3 14.05 3.37 14.3 3.96L15.273 6", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }) });
var forklift_queue_management_default = SvgForkliftQueueManagement;

// assets/icons/forklift-heatmap.svg
import * as React95 from "react";
import { jsx as jsx96 } from "react/jsx-runtime";
var SvgForkliftHeatmap = (props) => /* @__PURE__ */ jsx96("svg", { width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx96("path", { d: "M4.5 9.88883V5C4.5 3.89543 5.39543 3 6.5 3H11.083C11.8643 3 12.5741 3.45503 12.9003 4.16504L15.6001 10.0413M18 3V10.0413M3 17V12C3 10.8954 3.89543 10 5 10H9L11.5609 11.7072M8 17H10M8 17.5C8 18.8807 6.88071 20 5.5 20C4.11929 20 3 18.8807 3 17.5C3 16.1193 4.11929 15 5.5 15C6.88071 15 8 16.1193 8 17.5ZM16 15.75H15.75V16H16V15.75ZM16.5 18.5H15.75V19.25H16.5V18.5ZM19.25 19H19V19.25H19.25V19ZM20 22H15C13.8954 22 13 21.1046 13 20V15C13 13.8954 13.8954 13 15 13H20C21.1046 13 22 13.8954 22 15V20C22 21.1046 21.1046 22 20 22Z", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }) });
var forklift_heatmap_default = SvgForkliftHeatmap;

// assets/icons/face.svg
import * as React96 from "react";
import { jsx as jsx97 } from "react/jsx-runtime";
var SvgFace = (props) => /* @__PURE__ */ jsx97("svg", { width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx97("path", { d: "M4.15331 14.0489C4.50819 13.8439 4.92761 13.8655 5.26098 14.0705C8.89588 14.3294 13.5417 11.8373 14.8429 8.37419C16.8002 8.37419 18.5854 11.5999 18.5854 14.0705C18.9187 13.8655 19.3382 13.8439 19.693 14.0489C20.3168 14.3941 20.5856 15.2356 20.2845 15.9369L19.9296 16.7892C19.6393 17.5012 18.8972 17.8033 18.2627 17.4689C18.2197 17.4473 18.166 17.4149 18.166 17.4149H18.209C17.0905 20.166 13.9611 22 11.9178 22C9.87451 22 6.82033 20.1012 5.64813 17.4365V17.4149H5.6804C5.64813 17.4257 5.62663 17.4473 5.58361 17.4689C4.94911 17.8033 4.21783 17.5012 3.91672 16.7892L3.56183 15.9369C3.26071 15.2356 3.52957 14.3834 4.15331 14.0489ZM4.15331 14.0489C0.948572 7.17667 5.15344 3.01233 7.89575 2.30029C11.0897 1.53431 13.617 2.30029 14.8537 3.84304C15.2838 3.5086 15.757 3.14179 17.1443 3.28204C19.3704 3.62727 21.0266 6.27044 20.747 8.90282C20.7039 10.1327 20.0587 12.7867 19.5102 13.9734", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }) });
var face_default = SvgFace;

// assets/icons/fog-detection.svg
import * as React97 from "react";
import { jsx as jsx98 } from "react/jsx-runtime";
var SvgFogDetection = (props) => /* @__PURE__ */ jsx98("svg", { width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx98("path", { d: "M10.5 20H4.22222M12.5 16.571H5.5M3 16.571H2M15 20H13M15 16.571H18C20.2092 16.571 22 14.762 22 12.5303C22 10.426 20.4076 8.69735 18.3736 8.50708C17.9575 5.95042 15.7598 4 13.1111 4C10.4624 4 8.26472 5.95042 7.84866 8.50708C5.81468 8.69735 4.22222 10.426 4.22222 12.5303C4.22222 12.7385 4.2378 12.9429 4.26784 13.1426", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }) });
var fog_detection_default = SvgFogDetection;

// assets/icons/focus-near.svg
import * as React98 from "react";
import { jsx as jsx99 } from "react/jsx-runtime";
var SvgFocusNear = (props) => /* @__PURE__ */ jsx99("svg", { width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx99("path", { d: "M11.9999 17.5051V21.0051M6.52894 17.5051H17.4709C18.1921 17.5051 18.6761 16.765 18.3871 16.1043L12.9161 3.59918C12.5666 2.80027 11.4333 2.80027 11.0838 3.59918L5.61278 16.1043C5.32373 16.765 5.80779 17.5051 6.52894 17.5051Z", strokeWidth: 1.5, strokeLinecap: "round" }) });
var focus_near_default = SvgFocusNear;

// assets/icons/focus-far.svg
import * as React99 from "react";
import { jsx as jsx100 } from "react/jsx-runtime";
var SvgFocusFar = (props) => /* @__PURE__ */ jsx100("svg", { width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx100("path", { d: "M11.5 17.9844H20.2768C21.0446 17.9844 21.526 17.155 21.1451 16.4883L14.8682 5.50386C14.4844 4.83205 13.5157 4.83205 13.1318 5.50386L9.4049 12.0259M3.78306 17.9844H11.2169C11.9979 17.9844 12.4774 17.1293 12.0702 16.463L8.35329 10.3807C7.96336 9.74265 7.03665 9.74265 6.64672 10.3807L2.92978 16.463C2.52257 17.1293 3.00213 17.9844 3.78306 17.9844Z", strokeWidth: 1.5, strokeLinecap: "round" }) });
var focus_far_default = SvgFocusFar;

// assets/icons/help.svg
import * as React100 from "react";
import { jsx as jsx101 } from "react/jsx-runtime";
var SvgHelp = (props) => /* @__PURE__ */ jsx101("svg", { width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", stroke: "black", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx101("path", { d: "M9.25 9.75023C9.25 6.08339 14.75 6.08319 14.75 9.75002C14.75 12.4999 12 11.5 12 13.5M12 16.5H12.01M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12ZM12.5 16.5C12.5 16.7761 12.2761 17 12 17C11.7239 17 11.5 16.7761 11.5 16.5C11.5 16.2239 11.7239 16 12 16C12.2761 16 12.5 16.2239 12.5 16.5Z", stroke: "inherit", strokeOpacity: 0.77, strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }) });
var help_default = SvgHelp;

// assets/icons/heatmap.svg
import * as React101 from "react";
import { jsx as jsx102, jsxs as jsxs37 } from "react/jsx-runtime";
var SvgHeatmap = (props) => /* @__PURE__ */ jsxs37("svg", { width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: [
  /* @__PURE__ */ jsx102("path", { d: "M21 5C21 3.89543 20.1046 3 19 3H5C3.89543 3 3 3.89543 3 5V19C3 20.1046 3.89543 21 5 21H19C20.1046 21 21 20.1046 21 19V5Z", strokeWidth: 1.5, strokeLinejoin: "round" }),
  /* @__PURE__ */ jsx102("path", { d: "M17 16H16.25V16.75H17V16Z", strokeWidth: 1.5, strokeLinejoin: "round" }),
  /* @__PURE__ */ jsx102("path", { d: "M13 15.5H11.5V17H13V15.5Z", strokeWidth: 1.5, strokeLinejoin: "round" }),
  /* @__PURE__ */ jsx102("path", { d: "M8 7H7.25V7.75H8V7Z", strokeWidth: 1.5, strokeLinejoin: "round" }),
  /* @__PURE__ */ jsx102("path", { d: "M12.5 7.5H12.49V7.51H12.5V7.5Z", strokeWidth: 1.5, strokeLinejoin: "round" }),
  /* @__PURE__ */ jsx102("path", { d: "M16.5 12H16.49V12.01H16.5V12Z", strokeWidth: 1.5, strokeLinejoin: "round" }),
  /* @__PURE__ */ jsx102("path", { d: "M16.5 7.5H16.49V7.51H16.5V7.5Z", strokeWidth: 1.5, strokeLinejoin: "round" }),
  /* @__PURE__ */ jsx102("path", { d: "M12.75 11.5H12V12.25H12.75V11.5Z", strokeWidth: 1.5, strokeLinejoin: "round" }),
  /* @__PURE__ */ jsx102("path", { d: "M8.5 11H7V12.5H8.5V11Z", strokeWidth: 1.5, strokeLinejoin: "round" }),
  /* @__PURE__ */ jsx102("path", { d: "M8.5 15.5H7V17H8.5V15.5Z", strokeWidth: 1.5, strokeLinejoin: "round" })
] });
var heatmap_default = SvgHeatmap;

// assets/icons/heater-heat.svg
import * as React102 from "react";
import { jsx as jsx103 } from "react/jsx-runtime";
var SvgHeaterHeat = (props) => /* @__PURE__ */ jsx103("svg", { width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx103("path", { d: "M6 5.5C6 5.5 3.75 8 6 10.5C8.25 13 6 15.5 6 15.5M18 5.5C18 5.5 15.75 8 18 10.5C20.25 13 18 15.5 18 15.5M12 4.5C12 4.5 10.8124 5.81956 11.0256 7.5M8.51849 17.3333C8.80863 14 12 11.5 12 11.5C12 11.5 15.1915 14 15.4816 17.3333C15.6759 19.5651 14.3211 21.5 12 21.5C9.679 21.5 8.32378 19.5704 8.51849 17.3333ZM4 6.25C4.58579 5.17606 5.5 3.5 5.5 3.5L7 6.25H4ZM16 6.25C16.5858 5.17606 17.5 3.5 17.5 3.5L19 6.25H16ZM10 5.25C10.5858 4.17606 11.5 2.5 11.5 2.5L13 5.25H10Z", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }) });
var heater_heat_default = SvgHeaterHeat;

// assets/icons/heater-heat-1.svg
import * as React103 from "react";
import { jsx as jsx104 } from "react/jsx-runtime";
var SvgHeaterHeat1 = (props) => /* @__PURE__ */ jsx104("svg", { width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx104("path", { d: "M12 19C6.47715 19 2 16.5376 2 13.5C2 11.9614 3.14864 10.5704 5 9.57222M18 9.09961C20.4289 10.103 22 11.7006 22 13.5C22 15.3326 20.3705 16.9558 17.8649 17.9553C17.2868 18.1859 16.6621 18.3833 16 18.5424M8.51849 10.8333C8.80863 7.5 12 5 12 5C12 5 15.1915 7.5 15.4816 10.8333C15.6759 13.0651 14.3211 15 12 15C9.679 15 8.32378 13.0704 8.51849 10.8333ZM2.86596 9.2496C4.00434 9.22901 5.78096 9.19688 5.78096 9.19688L4.45572 11.7937L2.86596 9.2496ZM18.2559 19.3246C17.156 19.0306 15.4393 18.5718 15.4393 18.5718L17.429 16.4408L18.2559 19.3246Z", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }) });
var heater_heat_1_default = SvgHeaterHeat1;

// assets/icons/information-plain.svg
import * as React104 from "react";
import { jsx as jsx105, jsxs as jsxs38 } from "react/jsx-runtime";
var SvgInformationPlain = (props) => /* @__PURE__ */ jsxs38("svg", { width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: [
  /* @__PURE__ */ jsx105("circle", { cx: 12, cy: 12, r: 9, strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }),
  /* @__PURE__ */ jsx105("path", { d: "M12 16V12", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }),
  /* @__PURE__ */ jsx105("path", { d: "M12 8H12.01", stroke: "inherit", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" })
] });
var information_plain_default = SvgInformationPlain;

// assets/icons/image-gallery.svg
import * as React105 from "react";
import { jsx as jsx106 } from "react/jsx-runtime";
var SvgImageGallery = (props) => /* @__PURE__ */ jsx106("svg", { width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx106("path", { d: "M4 16L8.58579 11.5858C9.36683 10.8047 10.6332 10.8047 11.4142 11.5858L14 14.0748M14 14.0748L16 16M14 14.0748L15.5858 12.5858C16.3668 11.8047 17.6332 11.8047 18.4142 12.5858L20 14.0748M15.5 8.25C15.5 8.66421 15.1642 9 14.75 9C14.3358 9 14 8.66421 14 8.25C14 7.83579 14.3358 7.5 14.75 7.5C15.1642 7.5 15.5 7.83579 15.5 8.25ZM6 20H18C19.1046 20 20 19.1046 20 18V6C20 4.89543 19.1046 4 18 4H6C4.89543 4 4 4.89543 4 6V18C4 19.1046 4.89543 20 6 20Z", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }) });
var image_gallery_default = SvgImageGallery;

// assets/icons/location.svg
import * as React106 from "react";
import { jsx as jsx107, jsxs as jsxs39 } from "react/jsx-runtime";
var SvgLocation = (props) => /* @__PURE__ */ jsxs39("svg", { width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: [
  /* @__PURE__ */ jsx107("path", { d: "M6.40538 15.4552L10.8937 20.5033C11.4825 21.1656 12.5175 21.1656 13.1063 20.5033L17.5946 15.4552C21.8856 10.6291 18.4587 3 12 3C5.54127 3 2.11441 10.6291 6.40538 15.4552Z", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }),
  /* @__PURE__ */ jsx107("path", { d: "M14.5 10C14.5 11.3808 13.3807 12.5 12 12.5C10.6193 12.5 9.5 11.3808 9.5 10C9.5 8.61929 10.6193 7.5 12 7.5C13.3807 7.5 14.5 8.61929 14.5 10Z", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" })
] });
var location_default = SvgLocation;

// assets/icons/live.svg
import * as React107 from "react";
import { jsx as jsx108 } from "react/jsx-runtime";
var SvgLive = (props) => /* @__PURE__ */ jsx108("svg", { width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx108("path", { d: "M8 20H16M4.8 4H19.2C20.1941 4 21 4.83147 21 5.85714V15.1429C21 16.1685 20.1941 17 19.2 17H4.8C3.80589 17 3 16.1685 3 15.1429V5.85714C3 4.83147 3.80589 4 4.8 4Z", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }) });
var live_default = SvgLive;

// assets/icons/lock.svg
import * as React108 from "react";
import { jsx as jsx109, jsxs as jsxs40 } from "react/jsx-runtime";
var SvgLock = (props) => /* @__PURE__ */ jsxs40("svg", { width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: [
  /* @__PURE__ */ jsx109("path", { d: "M16 10V7C16 4.79086 14.2091 3 12 3V3C9.79086 3 8 4.79086 8 7V10", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }),
  /* @__PURE__ */ jsx109("path", { d: "M5 12C5 10.8954 5.89543 10 7 10H17C18.1046 10 19 10.8954 19 12V19C19 20.1046 18.1046 21 17 21H7C5.89543 21 5 20.1046 5 19V12Z", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }),
  /* @__PURE__ */ jsx109("path", { d: "M12 14L12 16", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" })
] });
var lock_default = SvgLock;

// assets/icons/lock-open.svg
import * as React109 from "react";
import { jsx as jsx110, jsxs as jsxs41 } from "react/jsx-runtime";
var SvgLockOpen = (props) => /* @__PURE__ */ jsxs41("svg", { width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: [
  /* @__PURE__ */ jsx110("path", { d: "M8 10V7C8 4.79086 9.79086 3 12 3C13.1947 3 14.2671 3.52375 15 4.35418", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }),
  /* @__PURE__ */ jsx110("path", { d: "M5 12C5 10.8954 5.89543 10 7 10H17C18.1046 10 19 10.8954 19 12V19C19 20.1046 18.1046 21 17 21H7C5.89543 21 5 20.1046 5 19V12Z", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }),
  /* @__PURE__ */ jsx110("path", { d: "M12 14L12 16", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" })
] });
var lock_open_default = SvgLockOpen;

// assets/icons/link-clip.svg
import * as React110 from "react";
import { jsx as jsx111 } from "react/jsx-runtime";
var SvgLinkClip = (props) => /* @__PURE__ */ jsx111("svg", { width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx111("path", { d: "M10.7273 6.90849L12 5.6357C13.7574 3.87836 16.6066 3.87834 18.364 5.6357C20.1213 7.39304 20.1213 10.2423 18.364 11.9997L17.0912 13.2725M6.90887 10.7269L5.63608 11.9997C3.87873 13.757 3.87873 16.6063 5.63608 18.3636C7.39343 20.121 10.2427 20.121 12 18.3636L13.2728 17.0908M9.17162 14.8281L14.8285 9.17123", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }) });
var link_clip_default = SvgLinkClip;

// assets/icons/unlink-clip.svg
import * as React111 from "react";
import { jsx as jsx112, jsxs as jsxs42 } from "react/jsx-runtime";
var SvgUnlinkClip = (props) => /* @__PURE__ */ jsxs42("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: [
  /* @__PURE__ */ jsx112("g", { clipPath: "url(#clip0_274_1149)", children: /* @__PURE__ */ jsx112("path", { d: "M7.54523 11.3636L5.63604 13.2728C4.23015 14.6787 4.23015 16.9581 5.63604 18.3639C7.0419 19.7698 9.32132 19.7698 10.7272 18.3639L12.6364 16.4548M11.3636 7.54521L13.2728 5.63602C14.6787 4.23016 16.9581 4.23014 18.364 5.63602C19.7698 7.04189 19.7698 9.32133 18.364 10.7272L16.4548 12.6364M5.63606 5.63604L6.90892 6.9089M17.0912 17.0912L18.364 18.364M14.5457 18.3641L14.5457 20.2733M9.45458 3.727L9.45458 5.63619M18.3641 14.5457L20.2733 14.5457M3.727 9.45455L5.63619 9.45455M9.17157 14.8284L14.8284 9.17156", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }) }),
  /* @__PURE__ */ jsx112("defs", { children: /* @__PURE__ */ jsx112("clipPath", { id: "clip0_274_1149", children: /* @__PURE__ */ jsx112("rect", { width: 24, height: 24 }) }) })
] });
var unlink_clip_default = SvgUnlinkClip;

// assets/icons/list.svg
import * as React112 from "react";
import { jsx as jsx113 } from "react/jsx-runtime";
var SvgList = (props) => /* @__PURE__ */ jsx113("svg", { width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx113("path", { d: "M9 6H21M9 12H21M9 18H21M4.5 6C4.5 6.41421 4.16421 6.75 3.75 6.75C3.33579 6.75 3 6.41421 3 6C3 5.58579 3.33579 5.25 3.75 5.25C4.16421 5.25 4.5 5.58579 4.5 6ZM4.5 18C4.5 18.4142 4.16421 18.75 3.75 18.75C3.33579 18.75 3 18.4142 3 18C3 17.5858 3.33579 17.25 3.75 17.25C4.16421 17.25 4.5 17.5858 4.5 18ZM4.5 12C4.5 12.4142 4.16421 12.75 3.75 12.75C3.33579 12.75 3 12.4142 3 12C3 11.5858 3.33579 11.25 3.75 11.25C4.16421 11.25 4.5 11.5858 4.5 12Z", strokeWidth: 1.5, strokeLinecap: "round" }) });
var list_default = SvgList;

// assets/icons/link1.svg
import * as React113 from "react";
import { jsx as jsx114 } from "react/jsx-runtime";
var SvgLink1 = (props) => /* @__PURE__ */ jsx114("svg", { width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx114("path", { d: "M6.4359 5H19M19 5V17.5641M19 5L5 19", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }) });
var link1_default = SvgLink1;

// assets/icons/log-out1.svg
import * as React114 from "react";
import { jsx as jsx115 } from "react/jsx-runtime";
var SvgLogOut1 = (props) => /* @__PURE__ */ jsx115("svg", { width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx115("path", { d: "M8 20H6C4.89543 20 4 19.1046 4 18V6C4 4.89543 4.89543 4 6 4H8M15 17L20 12M20 12L15 7M20 12H8", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }) });
var log_out1_default = SvgLogOut1;

// assets/icons/license.svg
import * as React115 from "react";
import { jsx as jsx116 } from "react/jsx-runtime";
var SvgLicense = (props) => /* @__PURE__ */ jsx116("svg", { width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx116("path", { d: "M20.25 7C20.25 7.41421 20.5858 7.75 21 7.75C21.4142 7.75 21.75 7.41421 21.75 7H20.25ZM14 19.75C14.4142 19.75 14.75 19.4142 14.75 19C14.75 18.5858 14.4142 18.25 14 18.25V19.75ZM7 8.25C6.58579 8.25 6.25 8.58579 6.25 9C6.25 9.41421 6.58579 9.75 7 9.75V8.25ZM11 9.75C11.4142 9.75 11.75 9.41421 11.75 9C11.75 8.58579 11.4142 8.25 11 8.25V9.75ZM7 11.25C6.58579 11.25 6.25 11.5858 6.25 12C6.25 12.4142 6.58579 12.75 7 12.75V11.25ZM11 12.75C11.4142 12.75 11.75 12.4142 11.75 12C11.75 11.5858 11.4142 11.25 11 11.25V12.75ZM17.75 15C17.75 14.5858 17.4142 14.25 17 14.25C16.5858 14.25 16.25 14.5858 16.25 15H17.75ZM17 20H16.25C16.25 20.2841 16.4105 20.5438 16.6646 20.6708C16.9187 20.7979 17.2227 20.7704 17.45 20.6L17 20ZM19 18.5L19.45 17.9C19.1833 17.7 18.8167 17.7 18.55 17.9L19 18.5ZM21 20L20.55 20.6C20.7773 20.7704 21.0813 20.7979 21.3354 20.6708C21.5895 20.5438 21.75 20.2841 21.75 20H21ZM21.75 15C21.75 14.5858 21.4142 14.25 21 14.25C20.5858 14.25 20.25 14.5858 20.25 15H21.75ZM5 5.75H19V4.25H5V5.75ZM3.75 17V7H2.25V17H3.75ZM5 18.25C4.30964 18.25 3.75 17.6904 3.75 17H2.25C2.25 18.5188 3.48122 19.75 5 19.75V18.25ZM19 5.75C19.6904 5.75 20.25 6.30964 20.25 7H21.75C21.75 5.48122 20.5188 4.25 19 4.25V5.75ZM5 4.25C3.48122 4.25 2.25 5.48122 2.25 7H3.75C3.75 6.30964 4.30964 5.75 5 5.75V4.25ZM14 18.25H5V19.75H14V18.25ZM7 9.75H11V8.25H7V9.75ZM7 12.75H11V11.25H7V12.75ZM21.25 12.5C21.25 13.7426 20.2426 14.75 19 14.75V16.25C21.0711 16.25 22.75 14.5711 22.75 12.5H21.25ZM19 14.75C17.7574 14.75 16.75 13.7426 16.75 12.5H15.25C15.25 14.5711 16.9289 16.25 19 16.25V14.75ZM16.75 12.5C16.75 11.2574 17.7574 10.25 19 10.25V8.75C16.9289 8.75 15.25 10.4289 15.25 12.5H16.75ZM19 10.25C20.2426 10.25 21.25 11.2574 21.25 12.5H22.75C22.75 10.4289 21.0711 8.75 19 8.75V10.25ZM16.25 15V20H17.75V15H16.25ZM17.45 20.6L19.45 19.1L18.55 17.9L16.55 19.4L17.45 20.6ZM18.55 19.1L20.55 20.6L21.45 19.4L19.45 17.9L18.55 19.1ZM21.75 20V15H20.25V20H21.75Z" }) });
var license_default = SvgLicense;

// assets/icons/log1.svg
import * as React116 from "react";
import { jsx as jsx117 } from "react/jsx-runtime";
var SvgLog1 = (props) => /* @__PURE__ */ jsx117("svg", { width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx117("path", { d: "M9 10H15M9 13.5H12M8 4.5C8 5.32843 8.67157 6 9.5 6H14.5C15.3284 6 16 5.32843 16 4.5M8 4.5C8 3.67157 8.67157 3 9.5 3H14.5C15.3284 3 16 3.67157 16 4.5M8 4.5H7C5.89543 4.5 5 5.39543 5 6.5V18C5 19.1046 5.89543 20 7 20H17C18.1046 20 19 19.1046 19 18V6.5C19 5.39543 18.1046 4.5 17 4.5H16", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }) });
var log1_default = SvgLog1;

// assets/icons/license-plate.svg
import * as React117 from "react";
import { jsx as jsx118 } from "react/jsx-runtime";
var SvgLicensePlate = (props) => /* @__PURE__ */ jsx118("svg", { width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx118("path", { d: "M4.5 7.5H4.51M4.5 16.5H4.51M19.5 7.5H19.51M19.5 16.5H19.51M11.2499 10.9285L12.6784 9.5V14.4998M15.464 10.7501C15.464 10.7501 15.6426 9.5 16.8925 9.5C18.1425 9.5 18.771 10.569 18.1425 11.4642C18.0128 11.6489 17.7853 11.8213 16.7139 12.5356C15.6426 13.2499 15.464 14.5 15.464 14.5H18.6782M5.25 14.4998L7.39278 9.5L9.53556 14.4998M5.67849 13.5H9.10707M4 19H20C21.1046 19 22 18.1046 22 17V7C22 5.89543 21.1046 5 20 5H4C2.89543 5 2 5.89543 2 7V17C2 18.1046 2.89543 19 4 19Z", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }) });
var license_plate_default = SvgLicensePlate;

// assets/icons/line-crossing.svg
import * as React118 from "react";
import { jsx as jsx119 } from "react/jsx-runtime";
var SvgLineCrossing = (props) => /* @__PURE__ */ jsx119("svg", { width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx119("path", { d: "M17.25 20V4M17.25 4L20.25 7M17.25 4L14.25 7M6.75 4V20M6.75 20L9.75 17M6.75 20L3.75 17M13.5 12H14.5M9.5 12H10.5M3 12H4M20 12H21", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }) });
var line_crossing_default = SvgLineCrossing;

// assets/icons/more.svg
import * as React119 from "react";
import { jsx as jsx120, jsxs as jsxs43 } from "react/jsx-runtime";
var SvgMore = (props) => /* @__PURE__ */ jsxs43("svg", { width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: [
  /* @__PURE__ */ jsx120("path", { d: "M12 12.75C11.5858 12.75 11.25 12.4142 11.25 12C11.25 11.5858 11.5858 11.25 12 11.25C12.4142 11.25 12.75 11.5858 12.75 12C12.75 12.4142 12.4142 12.75 12 12.75Z", strokeWidth: 1.5 }),
  /* @__PURE__ */ jsx120("path", { d: "M18.25 12.75C17.8358 12.75 17.5 12.4142 17.5 12C17.5 11.5858 17.8358 11.25 18.25 11.25C18.6642 11.25 19 11.5858 19 12C19 12.4142 18.6642 12.75 18.25 12.75Z", strokeWidth: 1.5 }),
  /* @__PURE__ */ jsx120("path", { d: "M5.75 12.75C5.33579 12.75 5 12.4142 5 12C5 11.5858 5.33579 11.25 5.75 11.25C6.16421 11.25 6.5 11.5858 6.5 12C6.5 12.4142 6.16421 12.75 5.75 12.75Z", strokeWidth: 1.5 })
] });
var more_default = SvgMore;

// assets/icons/motion-detection.svg
import * as React120 from "react";
import { jsx as jsx121 } from "react/jsx-runtime";
var SvgMotionDetection = (props) => /* @__PURE__ */ jsx121("svg", { width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx121("path", { d: "M8.24851 12.6518L7.86851 13.1718L7.81851 13.2318C7.77851 13.2818 7.73851 13.3218 7.69851 13.3618C7.14851 13.9018 6.26851 13.9818 5.62851 13.5218C5.21851 13.2218 5.03851 12.7718 5.00851 12.3718C4.96851 11.9718 5.06851 11.5318 5.32851 11.1818L7.11851 8.8918C7.19851 8.8018 7.50851 8.5318 7.61851 8.4818L9.95851 6.9118C10.2339 6.71154 10.8831 6.51482 11.2094 6.44479M8.24851 12.6518C8.17851 13.0618 8.22851 13.4918 8.37851 13.8818C8.52851 14.2918 8.78851 14.6418 9.12851 14.9118L11.8485 17.1718L13.0685 20.5218L13.2085 20.9118C13.5085 21.7418 14.4285 22.1618 15.2585 21.8618C15.7185 21.6918 16.0285 21.3118 16.1885 20.9718C16.3485 20.6418 16.4485 20.2018 16.3485 19.7718V19.5218C16.3485 19.4218 16.3285 19.3118 16.2985 19.2118L15.7185 17.4118C15.7185 17.4118 15.7085 17.3818 15.6985 17.3618L14.9985 15.6318C14.9485 15.5118 14.8785 15.4018 14.7885 15.3018L12.9285 13.4118L13.25 12.0501C13.5815 12.4501 13.7899 12.6518 14.4885 13.1918C15.1085 13.4818 16.1485 13.7618 16.7985 13.8518C17.7785 13.9918 18.4985 13.1818 18.4985 12.3318C18.4985 11.4218 17.7785 10.8218 17.0685 10.6718C16.7985 10.6218 15.7685 10.2918 15.7685 10.2918C15.2785 10.0518 14.92 9.7018 14.6 9.2718C14.55 9.2118 14.3785 8.94013 14.2185 8.45013C14.094 8.06334 13.7624 7.43319 13.5 7.15019M8.24851 12.6518L8.71852 11.4423M9.06855 14.8626L5.87911 18.8733L5.78911 18.9733C5.21911 19.6533 5.30911 20.6533 5.98911 21.2233C6.65911 21.7833 7.66911 21.6933 8.23911 21.0233L8.37911 20.8633L11.6417 17M15.5 4.7002C15.5 6.08091 14.3807 7.2002 13 7.2002C11.6193 7.2002 10.5 6.08091 10.5 4.7002C10.5 3.31948 11.6193 2.2002 13 2.2002C14.3807 2.2002 15.5 3.31948 15.5 4.7002Z", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }) });
var motion_detection_default = SvgMotionDetection;

// assets/icons/map.svg
import * as React121 from "react";
import { jsx as jsx122 } from "react/jsx-runtime";
var SvgMap = (props) => /* @__PURE__ */ jsx122("svg", { width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx122("path", { d: "M8.01386 12.6019L7.48808 12.0671L7.48768 12.0675L8.01386 12.6019ZM6.48619 12.6019L5.95864 13.135L5.96 13.1364L6.48619 12.6019ZM3.32398 5.66727L2.63135 5.37954L2.62939 5.38435L3.32398 5.66727ZM7.25002 3V2.24999L7.24635 2.25001L7.25002 3ZM11.1761 5.66727L10.4814 5.95L10.4815 5.95026L11.1761 5.66727ZM7.25002 6.58804C6.83581 6.58804 6.50002 6.92382 6.50002 7.33804C6.50002 7.75225 6.83581 8.08804 7.25002 8.08804V6.58804ZM7.26095 8.08804C7.67516 8.08804 8.01095 7.75225 8.01095 7.33804C8.01095 6.92382 7.67516 6.58804 7.26095 6.58804V8.08804ZM14.5 3.25C14.0858 3.25 13.75 3.58579 13.75 4C13.75 4.41421 14.0858 4.75 14.5 4.75V3.25ZM4.75 14.5C4.75 14.0858 4.41421 13.75 4 13.75C3.58579 13.75 3.25 14.0858 3.25 14.5H4.75ZM7.48768 12.0675C7.42133 12.1328 7.33587 12.1667 7.25002 12.1667V13.6667C7.73404 13.6667 8.19624 13.4749 8.54004 13.1364L7.48768 12.0675ZM7.25002 12.1667C7.16417 12.1667 7.07872 12.1328 7.01237 12.0675L5.96 13.1364C6.30381 13.4749 6.766 13.6667 7.25002 13.6667V12.1667ZM7.01373 12.0688C6.03169 11.097 5.02702 10.1986 4.37701 9.16703C3.7622 8.19133 3.51902 7.17658 4.01857 5.9502L2.62939 5.38435C1.90364 7.16608 2.30407 8.69095 3.10794 9.96669C3.87662 11.1866 5.0657 12.2514 5.95864 13.135L7.01373 12.0688ZM4.01659 5.955C4.28842 5.30065 4.74124 4.74441 5.31677 4.35341L4.47384 3.11266C3.65377 3.6698 3.01397 4.45853 2.63136 5.37955L4.01659 5.955ZM5.31677 4.35341C5.89212 3.96253 6.56551 3.75336 7.2537 3.74999L7.24635 2.25001C6.25804 2.25485 5.29409 2.5554 4.47384 3.11266L5.31677 4.35341ZM7.25002 3.75C8.61877 3.75 9.9347 4.60674 10.4814 5.95L11.8707 5.38455C11.0938 3.47552 9.22807 2.25 7.25002 2.25V3.75ZM10.4815 5.95026C10.9805 7.17506 10.7383 8.1919 10.124 9.16908C9.47542 10.2007 8.47033 11.1015 7.48808 12.0671L8.53964 13.1368C9.43722 12.2544 10.6253 11.19 11.3939 9.96743C12.1967 8.69038 12.5957 7.16389 11.8706 5.38429L10.4815 5.95026ZM7.25002 8.08804H7.26095V6.58804H7.25002V8.08804ZM7.25 8.75C8.21651 8.75 9 7.96651 9 7H7.5C7.5 7.13809 7.38809 7.25 7.25 7.25V8.75ZM9 7C9 6.03352 8.21652 5.25 7.25 5.25V6.75C7.38808 6.75 7.5 6.86192 7.5 7H9ZM7.25 5.25C6.28348 5.25 5.5 6.03352 5.5 7H7C7 6.86192 7.11192 6.75 7.25 6.75V5.25ZM5.5 7C5.5 7.96651 6.28349 8.75 7.25 8.75V7.25C7.11191 7.25 7 7.13809 7 7H5.5ZM20.25 6V19H21.75V6H20.25ZM19 20.25H6V21.75H19V20.25ZM6 20.25C5.30964 20.25 4.75 19.6904 4.75 19H3.25C3.25 20.5188 4.48122 21.75 6 21.75V20.25ZM20.25 19C20.25 19.6904 19.6904 20.25 19 20.25V21.75C20.5188 21.75 21.75 20.5188 21.75 19H20.25ZM19 4.75C19.6904 4.75 20.25 5.30964 20.25 6H21.75C21.75 4.48122 20.5188 3.25 19 3.25V4.75ZM14.5 4.75H19V3.25H14.5V4.75ZM4.75 19V14.5H3.25V19H4.75ZM17.3065 3.71444L13.3065 13.4287L14.6935 13.9998L18.6935 4.28556L17.3065 3.71444ZM13.3065 13.4287L10.3065 20.7144L11.6935 21.2856L14.6935 13.9998L13.3065 13.4287ZM21.2328 15.287L14.2328 13.0013L13.7672 14.4272L20.7672 16.713L21.2328 15.287Z" }) });
var map_default = SvgMap;

// assets/icons/menu.svg
import * as React122 from "react";
import { jsx as jsx123 } from "react/jsx-runtime";
var SvgMenu = (props) => /* @__PURE__ */ jsx123("svg", { width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx123("path", { d: "M4 6H20M4 12H20M4 18H20", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }) });
var menu_default = SvgMenu;

// assets/icons/notification.svg
import * as React123 from "react";
import { jsx as jsx124 } from "react/jsx-runtime";
var SvgNotification = (props) => /* @__PURE__ */ jsx124("svg", { width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", stroke: "black", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx124("path", { d: "M4 18H20M10 21H14M19 18V10C19 6.13401 15.866 3 12 3C8.13401 3 5 6.13401 5 10V18H19Z", strokeWidth: 1.5, strokeLinecap: "round" }) });
var notification_default = SvgNotification;

// assets/icons/note.svg
import * as React124 from "react";
import { jsx as jsx125 } from "react/jsx-runtime";
var SvgNote = (props) => /* @__PURE__ */ jsx125("svg", { width: 17, height: 20, viewBox: "0 0 17 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx125("path", { d: "M5.5 5H11.5M5.5 8L11.5 8M5.5 11H7.5M3.5 19H13.5C14.6046 19 15.5 18.1046 15.5 17V3C15.5 1.89543 14.6046 1 13.5 1H3.5C2.39543 1 1.5 1.89543 1.5 3V17C1.5 18.1046 2.39543 19 3.5 19Z", strokeOpacity: 0.77, strokeWidth: 1.5, strokeLinecap: "round" }) });
var note_default = SvgNote;

// assets/icons/network.svg
import * as React125 from "react";
import { jsx as jsx126 } from "react/jsx-runtime";
var SvgNetwork = (props) => /* @__PURE__ */ jsx126("svg", { width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx126("path", { d: "M17 16V14C17 12.8954 16.1046 12 15 12H9C7.89543 12 7 12.8954 7 14V16M12 8V12M10 8H14C14.5523 8 15 7.55228 15 7V4C15 3.44772 14.5523 3 14 3H10C9.44772 3 9 3.44772 9 4V7C9 7.55228 9.44772 8 10 8ZM15 21H19C19.5523 21 20 20.5523 20 20V17C20 16.4477 19.5523 16 19 16H15C14.4477 16 14 16.4477 14 17V20C14 20.5523 14.4477 21 15 21ZM5 21H9C9.55228 21 10 20.5523 10 20V17C10 16.4477 9.55228 16 9 16H5C4.44772 16 4 16.4477 4 17V20C4 20.5523 4.44772 21 5 21Z", strokeWidth: 1.5 }) });
var network_default = SvgNetwork;

// assets/icons/online-success-plain.svg
import * as React126 from "react";
import { jsx as jsx127, jsxs as jsxs44 } from "react/jsx-runtime";
var SvgOnlineSuccessPlain = (props) => /* @__PURE__ */ jsxs44("svg", { width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: [
  /* @__PURE__ */ jsx127("path", { d: "M8 12.4286L10.4 15L16 9", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }),
  /* @__PURE__ */ jsx127("path", { d: "M12 21C16.9705 21 21 16.9705 21 12C21 7.02943 16.9705 3 12 3C7.02943 3 3 7.02943 3 12C3 16.9705 7.02943 21 12 21Z", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" })
] });
var online_success_plain_default = SvgOnlineSuccessPlain;

// assets/icons/object-detection.svg
import * as React127 from "react";
import { jsx as jsx128 } from "react/jsx-runtime";
var SvgObjectDetection = (props) => /* @__PURE__ */ jsx128("svg", { width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx128("path", { d: "M21 7.5V5C21 3.89543 20.1046 3 19 3H16.5M21 16.5V19C21 20.1046 20.1046 21 19 21H16.5M3 16.5V19C3 20.1046 3.89543 21 5 21H7.5M3 7.5V5C3 3.89543 3.89543 3 5 3H7.5M16 12C16 9.79086 14.2091 8 12 8C9.79086 8 8 9.79086 8 12C8 14.2091 9.79086 16 12 16C14.2091 16 16 14.2091 16 12Z", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }) });
var object_detection_default = SvgObjectDetection;

// assets/icons/playback.svg
import * as React128 from "react";
import { jsx as jsx129, jsxs as jsxs45 } from "react/jsx-runtime";
var SvgPlayback = (props) => /* @__PURE__ */ jsxs45("svg", { width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: [
  /* @__PURE__ */ jsx129("path", { d: "M9.5 9.40116C9.5 8.80214 10.1676 8.44485 10.666 8.77713L14.5639 11.3757C15.0092 11.6726 15.0092 12.3269 14.5639 12.6238L10.666 15.2224C10.1676 15.5547 9.5 15.1974 9.5 14.5984V9.40116Z", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }),
  /* @__PURE__ */ jsx129("rect", { x: 3, y: 3, width: 18, height: 18, rx: 2, strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" })
] });
var playback_default = SvgPlayback;

// assets/icons/PoE.svg
import * as React129 from "react";
import { jsx as jsx130 } from "react/jsx-runtime";
var SvgPoE = (props) => /* @__PURE__ */ jsx130("svg", { width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx130("path", { d: "M12 14V17M12 17C13.1046 17 14 17.8954 14 19M12 17C10.8954 17 10 17.8954 10 19M14 19C14 20.1046 13.1046 21 12 21C10.8954 21 10 20.1046 10 19M14 19H21M10 19H3M10.375 10H10.38M13.625 10H13.63M7.125 10H7.13M16.875 10H16.88M5 14H19C20.1046 14 21 13.1046 21 12V8C21 6.89543 20.1046 6 19 6H5C3.89543 6 3 6.89543 3 8V12C3 13.1046 3.89543 14 5 14ZM10.625 10C10.625 10.1381 10.5131 10.25 10.375 10.25C10.2369 10.25 10.125 10.1381 10.125 10C10.125 9.86193 10.2369 9.75 10.375 9.75C10.5131 9.75 10.625 9.86193 10.625 10ZM13.875 10C13.875 10.1381 13.7631 10.25 13.625 10.25C13.4869 10.25 13.375 10.1381 13.375 10C13.375 9.86193 13.4869 9.75 13.625 9.75C13.7631 9.75 13.875 9.86193 13.875 10ZM7.375 10C7.375 10.1381 7.26307 10.25 7.125 10.25C6.98693 10.25 6.875 10.1381 6.875 10C6.875 9.86193 6.98693 9.75 7.125 9.75C7.26307 9.75 7.375 9.86193 7.375 10ZM17.125 10C17.125 10.1381 17.0131 10.25 16.875 10.25C16.7369 10.25 16.625 10.1381 16.625 10C16.625 9.86193 16.7369 9.75 16.875 9.75C17.0131 9.75 17.125 9.86193 17.125 10Z", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }) });
var PoE_default = SvgPoE;

// assets/icons/people.svg
import * as React130 from "react";
import { jsx as jsx131 } from "react/jsx-runtime";
var SvgPeople = (props) => /* @__PURE__ */ jsx131("svg", { width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx131("path", { d: "M6 11.62C6 7.96 8.68205 6 11.9998 6C15.3176 6 17.9997 7.96 17.9997 11.62M8.99969 10.5V14.0572M8.99969 14.0572C8.99969 14.8272 8.38381 15.4472 7.61893 15.4472H7.39046C6.62558 15.4472 6.0097 14.8272 6.0097 14.0572V11.6172M8.99969 14.0572L9.00916 21.61C9.00916 22.38 9.62504 23 10.3899 23H10.6184C11.3833 23 11.9601 22.2825 11.9601 21.5125M11.9601 15V21.5125M11.9601 21.5125C11.9601 22.2825 12.6264 23 13.3913 23H13.6198C14.3847 23 15.0005 22.38 15.0005 21.61L15.01 14.0572M15.01 14.0572C15.01 14.8272 15.6259 15.4472 16.3908 15.4472H16.6192C17.3841 15.4472 18 14.8272 18 14.0572V11.6172M15.01 14.0572V10.5M14.5 3.50698C14.5 4.87884 13.3789 6 12.007 6C10.6352 6 9.51405 4.8858 9.50012 3.51394C9.4862 2.14905 10.6491 0.993068 12.014 1.00003C13.3858 1.007 14.5 2.13512 14.5 3.50698Z", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }) });
var people_default = SvgPeople;

// assets/icons/people-vector.svg
import * as React131 from "react";
import { jsx as jsx132 } from "react/jsx-runtime";
var SvgPeopleVector = (props) => /* @__PURE__ */ jsx132("svg", { width: 18, height: 24, viewBox: "0 0 18 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx132("path", { d: "M13 15H16.5M16.5 15V18.5M16.5 15L12.4903 19.0909L10.7342 17.2727L8.1001 20M1.5 11.62C1.5 7.96 4.18205 6 7.49984 6C10.8176 6 13.4997 7.96 13.4997 11.62M4.49969 10.5V14.0572M4.49969 14.0572C4.49969 14.8272 3.88381 15.4472 3.11893 15.4472H2.89046C2.12558 15.4472 1.5097 14.8272 1.5097 14.0572V11.6172M4.49969 14.0572L4.50916 21.61C4.50916 22.38 5.12504 23 5.88992 23H6.11839C6.52127 23 6.87197 22.8009 7.1137 22.5M7.46011 15V17M10.51 14.0572V10.5M13.5 11.6172V12M10 3.50698C10 4.87884 8.87886 6 7.50703 6C6.13519 6 5.01405 4.8858 5.00012 3.51394C4.9862 2.14905 6.14912 0.993068 7.51399 1.00003C8.88582 1.007 10 2.13512 10 3.50698Z", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }) });
var people_vector_default = SvgPeopleVector;

// assets/icons/people-heatmap.svg
import * as React132 from "react";
import { jsx as jsx133, jsxs as jsxs46 } from "react/jsx-runtime";
var SvgPeopleHeatmap = (props) => /* @__PURE__ */ jsxs46("svg", { width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: [
  /* @__PURE__ */ jsxs46("g", { clipPath: "url(#clip0_3223_334)", children: [
    /* @__PURE__ */ jsx133("path", { d: "M14.5 3.50698C14.5 4.87884 13.3789 6 12.007 6C10.6352 6 9.51405 4.8858 9.50012 3.51394C9.4862 2.14905 10.6491 0.993068 12.014 1.00003C13.3858 1.007 14.5 2.13512 14.5 3.50698Z", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }),
    /* @__PURE__ */ jsx133("path", { d: "M6 11.62C6 7.96 8.68205 6 11.9998 6C14.7886 6 17.1282 7.3848 17.8034 10M8.99969 10.5V14.0572M8.99969 14.0572C8.99969 14.8272 8.38381 15.4472 7.61893 15.4472H7.39046C6.62558 15.4472 6.0097 14.8272 6.0097 14.0572V11.6172M8.99969 14.0572L9.00916 21.61C9.00916 22.38 9.62504 23 10.3899 23H10.6184C10.752 23 10.8799 22.9781 11 22.9378", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }),
    /* @__PURE__ */ jsx133("rect", { width: 0.25, height: 0.25, transform: "matrix(-1 0 0 1 16 15.75)", strokeWidth: 1.5, strokeLinejoin: "round" }),
    /* @__PURE__ */ jsx133("rect", { width: 0.75, height: 0.75, transform: "matrix(-1 0 0 1 16.5 18.5)", strokeWidth: 1.5, strokeLinejoin: "round" }),
    /* @__PURE__ */ jsx133("rect", { width: 0.25, height: 0.25, transform: "matrix(-1 0 0 1 19.25 19)", strokeWidth: 1.5, strokeLinejoin: "round" }),
    /* @__PURE__ */ jsx133("rect", { width: 9, height: 9, rx: 2, transform: "matrix(-1 0 0 1 22 13)", strokeWidth: 1.5, strokeLinejoin: "round" })
  ] }),
  /* @__PURE__ */ jsx133("defs", { children: /* @__PURE__ */ jsx133("clipPath", { id: "clip0_3223_334", children: /* @__PURE__ */ jsx133("rect", { width: 24, height: 24, fill: "white" }) }) })
] });
var people_heatmap_default = SvgPeopleHeatmap;

// assets/icons/PTZ.svg
import * as React133 from "react";
import { jsx as jsx134 } from "react/jsx-runtime";
var SvgPtz = (props) => /* @__PURE__ */ jsx134("svg", { width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx134("path", { d: "M17 12H22M22 12L19 15M22 12L19 9M7 12H2M2 12L5 9M2 12L5 15M12 22L9 19M12 22L15 19M12 22V17M12 2L15 5M12 2L9 5M12 2V7M14 12C14 13.1046 13.1046 14 12 14C10.8954 14 10 13.1046 10 12C10 10.8954 10.8954 10 12 10C13.1046 10 14 10.8954 14 12Z", strokeWidth: 1.5, strokeMiterlimit: 10, strokeLinecap: "round", strokeLinejoin: "round" }) });
var PTZ_default = SvgPtz;

// assets/icons/queue-management.svg
import * as React134 from "react";
import { jsx as jsx135 } from "react/jsx-runtime";
var SvgQueueManagement = (props) => /* @__PURE__ */ jsx135("svg", { width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx135("path", { d: "M3 12.7722C3 9.8076 5.17246 8.22 7.85987 8.22C10.5473 8.22 12.7197 9.8076 12.7197 12.7722M5.42975 11.865V14.7463M5.42975 14.7463C5.42975 15.37 4.93089 15.8722 4.31133 15.8722H4.12627C3.50672 15.8722 3.00786 15.37 3.00786 14.7463V12.7699M5.42975 14.7463L5.43742 20.8641C5.43742 21.4878 5.93628 21.99 6.55583 21.99H6.74089C7.36045 21.99 7.82769 21.4088 7.82769 20.7851M7.82769 15.51V20.7851M7.82769 20.7851C7.82769 21.4088 8.36741 21.99 8.98696 21.99H9.17202C9.79158 21.99 10.2904 21.4878 10.2904 20.8641L10.2981 14.7463M10.2981 14.7463C10.2981 15.37 10.797 15.8722 11.4165 15.8722H11.6016C12.2211 15.8722 12.72 15.37 12.72 14.7463V12.7699M10.2981 14.7463V11.865M11.26 3.67008C11.62 3.31008 12.13 3.08008 12.68 3.08008C13.8 3.08008 14.7 4.00008 14.7 5.12008C14.7 6.12008 14.15 6.96008 13.19 7.11008C14.74 7.47008 16.94 9.40008 16.94 12.5101V13.6001C16.94 14.6701 15.85 15.3901 15.12 15.3901V19.4501M15.83 2.3C16.14 2.1 16.5 2 16.88 2C18 2 18.9 2.92 18.9 4.04C18.9 5.04 18.35 5.98 17.39 6.14C18.94 6.5 21.14 8.33 21.14 11.43V12.52C21.14 13.6 20.05 14.31 19.32 14.31V18.32M15.13 19.4399C15.13 20.2299 14.5 20.8599 13.72 20.8599H13.48C13.19 20.8599 12.9 20.7599 12.67 20.5799M19.33 18.3C19.33 19.09 18.7 19.72 17.92 19.72H17.68C17.63 19.72 17.57 19.72 17.51 19.71M9.88502 6.20067C9.88502 7.31187 8.9769 8.22001 7.86571 8.22001C6.75453 8.22001 5.8464 7.31751 5.83512 6.20631C5.82384 5.10074 6.76581 4.1644 7.87135 4.17004C8.98254 4.17568 9.88502 5.08946 9.88502 6.20067Z", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }) });
var queue_management_default = SvgQueueManagement;

// assets/icons/refresh.svg
import * as React135 from "react";
import { jsx as jsx136 } from "react/jsx-runtime";
var SvgRefresh = (props) => /* @__PURE__ */ jsx136("svg", { width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx136("path", { d: "M20 16C18.5273 18.9634 15.5337 21 12 21C7.19723 21 3.25944 17.238 3 12.5M20 16H15M20 16V21M4 8C5.4727 5.03656 8.4663 3 12 3C16.8028 3 20.7406 6.76201 21 11.5M4 8H9.00001M4 8L4.00001 3", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }) });
var refresh_default = SvgRefresh;

// assets/icons/reset.svg
import * as React136 from "react";
import { jsx as jsx137 } from "react/jsx-runtime";
var SvgReset = (props) => /* @__PURE__ */ jsx137("svg", { width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx137("path", { d: "M21 4H16M16 4V9M16 4C18.7298 5.54563 21 8.63909 21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }) });
var reset_default = SvgReset;

// assets/icons/remove.svg
import * as React137 from "react";
import { jsx as jsx138, jsxs as jsxs47 } from "react/jsx-runtime";
var SvgRemove = (props) => /* @__PURE__ */ jsxs47("svg", { width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: [
  /* @__PURE__ */ jsx138("path", { d: "M5 6H19V19C19 20.1046 18.1046 21 17 21H7C5.89543 21 5 20.1046 5 19V6Z", strokeWidth: 1.5, strokeMiterlimit: 10, strokeLinecap: "round" }),
  /* @__PURE__ */ jsx138("path", { d: "M3 6H21", strokeWidth: 1.5, strokeMiterlimit: 10, strokeLinecap: "round" }),
  /* @__PURE__ */ jsx138("path", { d: "M8 5C8 3.89543 8.89543 3 10 3H14C15.1046 3 16 3.89543 16 5V6H8V5Z", strokeWidth: 1.5, strokeMiterlimit: 10, strokeLinecap: "round" }),
  /* @__PURE__ */ jsx138("path", { d: "M10 11V16", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }),
  /* @__PURE__ */ jsx138("path", { d: "M14 11V16", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" })
] });
var remove_default = SvgRemove;

// assets/icons/reports-old.svg
import * as React138 from "react";
import { jsx as jsx139, jsxs as jsxs48 } from "react/jsx-runtime";
var SvgReportsOld = (props) => /* @__PURE__ */ jsxs48("svg", { width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: [
  /* @__PURE__ */ jsx139("rect", { x: 4, y: 4, width: 16, height: 16, rx: 2, strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }),
  /* @__PURE__ */ jsx139("path", { d: "M8 14L8 17", strokeWidth: 1.5, strokeLinecap: "round" }),
  /* @__PURE__ */ jsx139("path", { d: "M16 12L16 17", strokeWidth: 1.5, strokeLinecap: "round" }),
  /* @__PURE__ */ jsx139("path", { d: "M12 9L12 17", strokeWidth: 1.5, strokeLinecap: "round" })
] });
var reports_old_default = SvgReportsOld;

// assets/icons/ram.svg
import * as React139 from "react";
import { jsx as jsx140 } from "react/jsx-runtime";
var SvgRam = (props) => /* @__PURE__ */ jsx140("svg", { width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx140("path", { d: "M7 12H10M6 17V19M12 17V19M18 17V19M6 5V7M12 5V7M18 5V7M5 17H19C20.1046 17 21 16.1046 21 15V9C21 7.89543 20.1046 7 19 7H5C3.89543 7 3 7.89543 3 9V15C3 16.1046 3.89543 17 5 17Z", strokeWidth: 1.5, strokeMiterlimit: 10, strokeLinecap: "round" }) });
var ram_default = SvgRam;

// assets/icons/reports.svg
import * as React140 from "react";
import { jsx as jsx141 } from "react/jsx-runtime";
var SvgReports = (props) => /* @__PURE__ */ jsx141("svg", { width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx141("path", { d: "M8 4.5C8 5.32843 8.67157 6 9.5 6H14.5C15.3284 6 16 5.32843 16 4.5M8 4.5C8 3.67157 8.67157 3 9.5 3H14.5C15.3284 3 16 3.67157 16 4.5M8 4.5H7C5.89543 4.5 5 5.39543 5 6.5V18C5 19.1046 5.89543 20 7 20H17C18.1046 20 19 19.1046 19 18V6.5C19 5.39543 18.1046 4.5 17 4.5H16M8 15L11 12L13 14L16 11", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }) });
var reports_default = SvgReports;

// assets/icons/rule-setup.svg
import * as React141 from "react";
import { jsx as jsx142 } from "react/jsx-runtime";
var SvgRuleSetup = (props) => /* @__PURE__ */ jsx142("svg", { width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx142("path", { d: "M8 7H12M15.5 7H12M16 17H14C12.8954 17 12 16.1046 12 15V7M16 14L22 17.5L16 21V14ZM2 4H8V10H2V4ZM21.5 7C21.5 7.59334 21.3241 8.17336 20.9944 8.66671C20.6648 9.16006 20.1962 9.54458 19.6481 9.77164C19.0999 9.9987 18.4967 10.0581 17.9147 9.94236C17.3328 9.8266 16.7982 9.54088 16.3787 9.12132C15.9591 8.70176 15.6734 8.16721 15.5576 7.58527C15.4419 7.00333 15.5013 6.40013 15.7284 5.85195C15.9554 5.30377 16.3399 4.83524 16.8333 4.50559C17.3266 4.17595 17.9067 4 18.5 4C19.2957 4 20.0587 4.31607 20.6213 4.87868C21.1839 5.44129 21.5 6.20435 21.5 7Z", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }) });
var rule_setup_default = SvgRuleSetup;

// assets/icons/search.svg
import * as React142 from "react";
import { jsx as jsx143 } from "react/jsx-runtime";
var SvgSearch = (props) => /* @__PURE__ */ jsx143("svg", { width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx143("path", { d: "M15.8283 15.7782C17.1708 14.423 18 12.5583 18 10.5C18 6.35786 14.6421 3 10.5 3C6.35786 3 3 6.35786 3 10.5C3 14.6421 6.35786 18 10.5 18C12.5838 18 14.4691 17.1502 15.8283 15.7782ZM15.8283 15.7782L21 21", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }) });
var search_default = SvgSearch;

// assets/icons/setting.svg
import * as React143 from "react";
import { jsx as jsx144, jsxs as jsxs49 } from "react/jsx-runtime";
var SvgSetting = (props) => /* @__PURE__ */ jsxs49("svg", { width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: [
  /* @__PURE__ */ jsx144("path", { d: "M19.1908 12C19.1908 11.3571 19.5036 10.7923 19.9889 10.4297C20.4675 10.0721 20.9049 9.51069 20.6968 8.95145C20.3141 7.92296 19.7448 6.98217 19.0266 6.16561C18.6414 5.72768 17.9552 5.82297 17.4159 6.04619C16.8456 6.28219 16.1751 6.26607 15.5954 5.93674C15.0423 5.62252 14.696 5.09994 14.602 4.53264C14.5026 3.93331 14.2319 3.25 13.6324 3.14433C13.1014 3.05073 12.5559 3 12 3C11.4395 3 10.8897 3.04813 10.3545 3.14238C9.75919 3.24724 9.49423 3.9248 9.40042 4.52076C9.30993 5.09568 8.96243 5.62591 8.4046 5.93674C7.82536 6.25949 7.1554 6.27753 6.58544 6.04418C6.04521 5.823 5.35858 5.72768 4.97339 6.16561C4.25755 6.97946 3.68967 7.91674 3.30699 8.94124C3.09685 9.50383 3.54139 10.0696 4.02068 10.4325C4.5005 10.7959 4.8092 11.3614 4.8092 12C4.8092 12.6429 4.49638 13.2077 4.01106 13.5703C3.53252 13.9279 3.09508 14.4893 3.30318 15.0485C3.6859 16.077 4.25517 17.0178 4.97339 17.8344C5.35858 18.2723 6.04476 18.177 6.58414 17.9538C7.15439 17.7178 7.82492 17.7339 8.4046 18.0633C8.95856 18.3719 9.30509 18.897 9.3985 19.4673C9.4967 20.0668 9.76811 20.75 10.3676 20.8557C10.8986 20.9493 11.4441 21 12 21C12.5605 21 13.1103 20.9519 13.6455 20.8576C14.2408 20.7528 14.5058 20.0752 14.5996 19.4792C14.6901 18.9043 15.0376 18.3741 15.5954 18.0633C16.1746 17.7405 16.8446 17.7225 17.4146 17.9558C17.9548 18.177 18.6414 18.2723 19.0266 17.8344C19.7425 17.0205 20.3103 16.0833 20.693 15.0588C20.9032 14.4962 20.4586 13.9304 19.9793 13.5675C19.4995 13.2041 19.1908 12.6386 19.1908 12Z", strokeWidth: 1.5 }),
  /* @__PURE__ */ jsx144("path", { d: "M15.0064 12C15.0064 13.6569 13.6604 15 12 15C10.3396 15 8.99356 13.6569 8.99356 12C8.99356 10.3431 10.3396 9 12 9C13.6604 9 15.0064 10.3431 15.0064 12Z", strokeWidth: 1.5 })
] });
var setting_default = SvgSetting;

// assets/icons/share.svg
import * as React144 from "react";
import { jsx as jsx145 } from "react/jsx-runtime";
var SvgShare = (props) => /* @__PURE__ */ jsx145("svg", { width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx145("path", { d: "M15 6.5L9 10M9 14L15 17.5M18 8C16.3431 8 15 6.65685 15 5C15 3.34315 16.3431 2 18 2C19.6569 2 21 3.34315 21 5C21 6.65685 19.6569 8 18 8ZM18 22C16.3431 22 15 20.6569 15 19C15 17.3431 16.3431 16 18 16C19.6569 16 21 17.3431 21 19C21 20.6569 19.6569 22 18 22ZM6 15C4.34315 15 3 13.6569 3 12C3 10.3431 4.34315 9 6 9C7.65685 9 9 10.3431 9 12C9 13.6569 7.65685 15 6 15Z", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }) });
var share_default = SvgShare;

// assets/icons/server.svg
import * as React145 from "react";
import { jsx as jsx146 } from "react/jsx-runtime";
var SvgServer = (props) => /* @__PURE__ */ jsx146("svg", { width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx146("path", { d: "M7 8H10M7 16H10M5 12H19M5 12C3.89543 12 3 11.1046 3 10V6C3 4.89543 3.89543 4 5 4H19C20.1046 4 21 4.89543 21 6V10C21 11.1046 20.1046 12 19 12M5 12C3.89543 12 3 12.8954 3 14V18C3 19.1046 3.89543 20 5 20H19C20.1046 20 21 19.1046 21 18V14C21 12.8954 20.1046 12 19 12", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }) });
var server_default = SvgServer;

// assets/icons/server-gateway.svg
import * as React146 from "react";
import { jsx as jsx147 } from "react/jsx-runtime";
var SvgServerGateway = (props) => /* @__PURE__ */ jsx147("svg", { width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx147("path", { d: "M12 15V18M12 18C13.1046 18 14 18.8954 14 20M12 18C10.8954 18 10 18.8954 10 20M14 20C14 21.1046 13.1046 22 12 22C10.8954 22 10 21.1046 10 20M14 20H21M10 20H3M8 6H11M8 12H11M6 9H18M6 9C4.89543 9 4 8.10457 4 7V5C4 3.89543 4.89543 3 6 3H18C19.1046 3 20 3.89543 20 5V7C20 8.10457 19.1046 9 18 9M6 9C4.89543 9 4 9.89543 4 11V13C4 14.1046 4.89543 15 6 15H18C19.1046 15 20 14.1046 20 13V11C20 9.89543 19.1046 9 18 9", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }) });
var server_gateway_default = SvgServerGateway;

// assets/icons/storage.svg
import * as React147 from "react";
import { jsx as jsx148 } from "react/jsx-runtime";
var SvgStorage = (props) => /* @__PURE__ */ jsx148("svg", { width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx148("path", { d: "M7 12H10M5 17H19C20.1046 17 21 16.1046 21 15V9C21 7.89543 20.1046 7 19 7H5C3.89543 7 3 7.89543 3 9V15C3 16.1046 3.89543 17 5 17Z", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }) });
var storage_default = SvgStorage;

// assets/icons/speaker-sound-volume.svg
import * as React148 from "react";
import { jsx as jsx149, jsxs as jsxs50 } from "react/jsx-runtime";
var SvgSpeakerSoundVolume = (props) => /* @__PURE__ */ jsxs50("svg", { width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: [
  /* @__PURE__ */ jsx149("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6 15H4C3.44772 15 3 14.5523 3 14V10C3 9.44772 3.44772 9 4 9H6L7.5 9L12.177 4.28135C12.8565 3.67426 14 4.11449 14 4.98318V19.0168C14 19.8855 12.8565 20.3257 12.177 19.7187L7.5 15L6 15Z", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }),
  /* @__PURE__ */ jsx149("path", { d: "M19.6621 7C20.513 8.47087 20.9999 10.1786 20.9999 12C20.9999 13.8214 20.513 15.5291 19.6621 17", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }),
  /* @__PURE__ */ jsx149("path", { d: "M17.1973 9C17.7078 9.88252 18 10.9071 18 12C18 13.0929 17.7078 14.1175 17.1973 15", strokeWidth: 1.5, strokeLinecap: "round" })
] });
var speaker_sound_volume_default = SvgSpeakerSoundVolume;

// assets/icons/speaker-sound-volume-mute.svg
import * as React149 from "react";
import { jsx as jsx150, jsxs as jsxs51 } from "react/jsx-runtime";
var SvgSpeakerSoundVolumeMute = (props) => /* @__PURE__ */ jsxs51("svg", { width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: [
  /* @__PURE__ */ jsx150("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6 15H4C3.44772 15 3 14.5523 3 14V10C3 9.44772 3.44772 9 4 9H6L7.5 9L12.177 4.28135C12.8565 3.67426 14 4.11449 14 4.98318V19.0168C14 19.8855 12.8565 20.3257 12.177 19.7187L7.5 15L6 15Z", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }),
  /* @__PURE__ */ jsx150("path", { d: "M17 14L21 10M17 10L21 14", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" })
] });
var speaker_sound_volume_mute_default = SvgSpeakerSoundVolumeMute;

// assets/icons/software-update.svg
import * as React150 from "react";
import { jsx as jsx151 } from "react/jsx-runtime";
var SvgSoftwareUpdate = (props) => /* @__PURE__ */ jsx151("svg", { width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx151("path", { d: "M9 2V4M15 2V4M2 9H4M2 15H4M9 20V22M15 20V22M20 15H22M20 9H22M8.18599 13.8889C8.88249 15.2883 10.3288 16.25 12 16.25C14.2714 16.25 16.1273 14.4735 16.25 12.2361M8.18599 13.8889H10.3447M8.18599 13.8889H8V16.25M15.814 10.1111C15.1175 8.71171 13.6712 7.75 12 7.75C9.72857 7.75 7.8727 9.5265 7.75 11.7639M15.814 10.1111H13.6553M15.814 10.1111H16.02V7.75M6 20H18C19.1046 20 20 19.1046 20 18V6C20 4.89543 19.1046 4 18 4H6C4.89543 4 4 4.89543 4 6V18C4 19.1046 4.89543 20 6 20Z", strokeWidth: 1.25, strokeLinecap: "round", strokeLinejoin: "round" }) });
var software_update_default = SvgSoftwareUpdate;

// assets/icons/slip-fall.svg
import * as React151 from "react";
import { jsx as jsx152 } from "react/jsx-runtime";
var SvgSlipFall = (props) => /* @__PURE__ */ jsx152("svg", { width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx152("path", { d: "M5.32567 12.0197L2 12.7502L4.76614 15.003L3.42947 18.7292L6.75565 17.998L7.42896 21L9.05604 17.6353M21.0293 16.7503L18.545 13.4941C18.545 13.4941 18.5208 13.4664 18.5136 13.4538C18.4749 13.401 18.4238 13.3554 18.3826 13.3125C18.3485 13.2821 18.3144 13.2517 18.2876 13.2339C18.2535 13.2035 18.2096 13.1705 18.163 13.1473C18.1191 13.1143 18.0726 13.0911 18.0162 13.0654C17.9769 13.0548 17.95 13.0369 17.9133 13.0164C17.8543 13.0005 17.7881 12.9721 17.7291 12.9562C17.6996 12.9482 17.6701 12.9403 17.6504 12.935C17.5816 12.9164 17.5003 12.9051 17.4262 12.9063C17.4065 12.901 17.3967 12.8984 17.3744 12.903C17.2806 12.8989 17.194 12.9074 17.1048 12.9257C17.1048 12.9257 17.1048 12.9257 17.095 12.9231L16.9959 12.9388C16.9959 12.9388 16.9638 12.9407 16.9513 12.948L16.5873 13.0089L17.5532 11.9546L20.1365 12.5448C20.9607 12.7351 21.7745 12.2124 21.9611 11.3933C22.1503 10.5644 21.6305 9.74586 20.8162 9.5582L17.3793 8.76977C17.0423 8.68955 16.7032 8.73597 16.4144 8.87019C16.3895 8.88467 16.3672 8.88926 16.3423 8.90374C16.2826 8.93006 16.2327 8.95902 16.1802 8.99788C16.1303 9.02684 16.0902 9.05845 16.0476 9.09996C16.02 9.12433 15.9924 9.1487 15.9648 9.17308C15.9373 9.19745 15.9123 9.21193 15.8946 9.23895L13.9751 11.3402L12.2012 9.01749L14.6793 5.41299C15.1602 4.71568 14.9836 3.75638 14.2903 3.2727C13.597 2.78902 12.6432 2.96663 12.1623 3.66393L8.12792 9.50994C7.78367 10.0108 7.78292 10.6467 8.06105 11.1457C8.06105 11.1457 8.06825 11.1583 8.07545 11.1708C8.08985 11.1959 8.09705 11.2084 8.11144 11.2335C8.14744 11.2962 8.18344 11.3589 8.22927 11.4243L11.8497 16.1529C12.2871 16.7266 13.0326 16.8957 13.6645 16.6208L16.6911 16.1007L18.6123 18.6221C19.1296 19.2916 20.0857 19.422 20.7513 18.9017C21.4169 18.3814 21.5466 17.4198 21.0293 16.7503ZM9 6.5C9 7.88071 7.88071 9 6.5 9C5.11929 9 4 7.88071 4 6.5C4 5.11929 5.11929 4 6.5 4C7.88071 4 9 5.11929 9 6.5Z", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }) });
var slip_fall_default = SvgSlipFall;

// assets/icons/shopping-cart.svg
import * as React152 from "react";
import { jsx as jsx153 } from "react/jsx-runtime";
var SvgShoppingCart = (props) => /* @__PURE__ */ jsx153("svg", { width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx153("path", { d: "M2 3H4.5L6.37503 17.0005M17.5 17.0005C16.6716 17.0005 16 17.6721 16 18.5005C16 19.3289 16.6716 20.0005 17.5 20.0005C18.3284 20.0005 19 19.3289 19 18.5005C19 17.6721 18.3284 17.0005 17.5 17.0005ZM17.5 17.0005H7M5 6.00049H20L19.219 12.2486C19.0939 13.2494 18.2431 14.0005 17.2344 14.0005H7.76556C6.75692 14.0005 5.90612 13.2494 5.78101 12.2486L5 6.00049ZM8 18.5005C8 19.3289 7.32843 20.0005 6.5 20.0005C5.67157 20.0005 5 19.3289 5 18.5005C5 17.6721 5.67157 17.0005 6.5 17.0005C7.32843 17.0005 8 17.6721 8 18.5005Z", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }) });
var shopping_cart_default = SvgShoppingCart;

// assets/icons/shopping-cart-counting.svg
import * as React153 from "react";
import { jsx as jsx154 } from "react/jsx-runtime";
var SvgShoppingCartCounting = (props) => /* @__PURE__ */ jsx154("svg", { width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx154("path", { d: "M17.5 15H21M21 15V18.5M21 15L17 19L15.2342 17.2727L12.6001 20M19.219 12.2486L20 6.00049H5L5.78101 12.2486C5.90612 13.2494 6.75692 14.0005 7.76556 14.0005H15.25M2 3H4.5L6.37503 17.0005M7 17.0005H12.25M8 18.5005C8 19.3289 7.32843 20.0005 6.5 20.0005C5.67157 20.0005 5 19.3289 5 18.5005C5 17.6721 5.67157 17.0005 6.5 17.0005C7.32843 17.0005 8 17.6721 8 18.5005Z", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }) });
var shopping_cart_counting_default = SvgShoppingCartCounting;

// assets/icons/shopping-cart-queue-management.svg
import * as React154 from "react";
import { jsx as jsx155 } from "react/jsx-runtime";
var SvgShoppingCartQueueManagement = (props) => /* @__PURE__ */ jsx155("svg", { width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx155("path", { d: "M2 8.29947H3.86802L5.26904 18.7665M5.36041 18.7665C4.74112 18.7665 4.24366 19.264 4.24366 19.8832C4.24366 20.5025 4.74112 21 5.36041 21C5.9797 21 6.47716 20.5025 6.47716 19.8832C6.47716 19.264 5.9797 18.7665 5.36041 18.7665ZM5.36041 18.7665H14.0559M4.53808 5.62954H6.4061L6.78173 7.87319H18L17.2081 13.7311C17.1472 14.1879 16.8934 14.5737 16.5381 14.8072M7.40109 3H9.26912L9.64475 5.24366H21.1067L20.193 11.6802C20.1422 12.0762 19.9392 12.4213 19.6549 12.6548M14.066 18.7665C13.4467 18.7665 12.9493 19.264 12.9493 19.8832C12.9493 20.5025 13.4467 21 14.066 21C14.6853 21 15.1828 20.5025 15.1828 19.8832C15.1828 19.264 14.6853 18.7665 14.066 18.7665ZM4.24366 10.5431H14.934L14.3452 15.2132C14.2538 15.9645 13.6142 16.5228 12.863 16.5228H6.31473C5.56346 16.5228 4.92386 15.9645 4.83249 15.2132L4.24366 10.5431Z", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }) });
var shopping_cart_queue_management_default = SvgShoppingCartQueueManagement;

// assets/icons/shopping-cart-heatmap.svg
import * as React155 from "react";
import { jsx as jsx156, jsxs as jsxs52 } from "react/jsx-runtime";
var SvgShoppingCartHeatmap = (props) => /* @__PURE__ */ jsxs52("svg", { width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: [
  /* @__PURE__ */ jsx156("path", { d: "M2 3H4.5L6.37503 17.0005M7 17.0005L10 17M10 14.0005H7.76556C6.75692 14.0005 5.90612 13.2494 5.78101 12.2486L5 6.00049H20L19.5001 10M8 18.5005C8 19.3289 7.32843 20.0005 6.5 20.0005C5.67157 20.0005 5 19.3289 5 18.5005C5 17.6721 5.67157 17.0005 6.5 17.0005C7.32843 17.0005 8 17.6721 8 18.5005Z", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }),
  /* @__PURE__ */ jsx156("rect", { width: 0.25, height: 0.25, transform: "matrix(-1 0 0 1 16 15.75)", strokeWidth: 1.5, strokeLinejoin: "round" }),
  /* @__PURE__ */ jsx156("rect", { width: 0.75, height: 0.75, transform: "matrix(-1 0 0 1 16.5 18.5)", strokeWidth: 1.5, strokeLinejoin: "round" }),
  /* @__PURE__ */ jsx156("rect", { width: 0.25, height: 0.25, transform: "matrix(-1 0 0 1 19.25 19)", strokeWidth: 1.5, strokeLinejoin: "round" }),
  /* @__PURE__ */ jsx156("rect", { width: 9, height: 9, rx: 2, transform: "matrix(-1 0 0 1 22 13)", strokeWidth: 1.5, strokeLinejoin: "round" })
] });
var shopping_cart_heatmap_default = SvgShoppingCartHeatmap;

// assets/icons/stopped-vehicle.svg
import * as React156 from "react";
import { jsx as jsx157 } from "react/jsx-runtime";
var SvgStoppedVehicle = (props) => /* @__PURE__ */ jsx157("svg", { width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx157("path", { d: "M5.69998 5.69998L7 7M18.3 18.3L16.05 16.05M10 12.7368V8H13.4211C14.8453 8 16 9.06038 16 10.3684C16 11.6764 14.8453 12.7368 13.4211 12.7368H10ZM10 12.7368V17M12 21C7.02944 21 3 16.9705 3 12C3 7.02944 7.02944 3 12 3C16.9705 3 21 7.02944 21 12C21 16.9705 16.9705 21 12 21Z", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }) });
var stopped_vehicle_default = SvgStoppedVehicle;

// assets/icons/shock-detection.svg
import * as React157 from "react";
import { jsx as jsx158 } from "react/jsx-runtime";
var SvgShockDetection = (props) => /* @__PURE__ */ jsx158("svg", { width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx158("path", { d: "M17.973 8.93653L18.6714 9.20979L18.6865 9.17127L18.6972 9.13134L17.973 8.93653ZM6.02703 8.93653L5.30277 9.13134L5.31352 9.17128L5.32858 9.20979L6.02703 8.93653ZM12 13C11.5858 13 11.25 13.3358 11.25 13.75C11.25 14.1642 11.5858 14.5 12 14.5V13ZM12.005 14.5C12.4192 14.5 12.755 14.1642 12.755 13.75C12.755 13.3358 12.4192 13 12.005 13V14.5ZM4.36612 6.53033C4.65901 6.23744 4.65901 5.76256 4.36612 5.46967C4.07322 5.17678 3.59835 5.17678 3.30546 5.46967L4.36612 6.53033ZM2.54289 7.29289L3.07322 7.82322L2.54289 7.29289ZM2.54289 8.70711L3.07322 8.17678H3.07322L2.54289 8.70711ZM3.12868 9.29289L3.65901 8.76256L3.65901 8.76256L3.12868 9.29289ZM3.12868 10.7071L3.65901 11.2374H3.65901L3.12868 10.7071ZM2.54289 11.2929L2.01256 10.7626H2.01256L2.54289 11.2929ZM2.54289 12.7071L2.01256 13.2374H2.01256L2.54289 12.7071ZM3.12868 13.2929L3.65901 12.7626H3.65901L3.12868 13.2929ZM3.12868 14.7071L2.59835 14.1768L2.59835 14.1768L3.12868 14.7071ZM2.54289 15.2929L2.01256 14.7626H2.01256L2.54289 15.2929ZM2.54289 16.7071L3.07322 16.1768L3.07322 16.1768L2.54289 16.7071ZM3.30546 18.5303C3.59835 18.8232 4.07322 18.8232 4.36612 18.5303C4.65901 18.2374 4.65901 17.7626 4.36612 17.4697L3.30546 18.5303ZM20.6903 5.46967C20.3974 5.17678 19.9226 5.17678 19.6297 5.46967C19.3368 5.76256 19.3368 6.23744 19.6297 6.53033L20.6903 5.46967ZM21.4529 7.29289L21.9832 6.76256V6.76256L21.4529 7.29289ZM21.4529 8.70711L20.9226 8.17678L21.4529 8.70711ZM20.8671 9.29289L20.3368 8.76256V8.76256L20.8671 9.29289ZM20.8671 10.7071L20.3368 11.2374L20.8671 10.7071ZM21.4529 11.2929L21.9832 10.7626L21.4529 11.2929ZM21.4529 12.7071L21.9832 13.2374L21.4529 12.7071ZM20.8671 13.2929L20.3368 12.7626L20.8671 13.2929ZM20.8671 14.7071L21.3974 14.1768V14.1768L20.8671 14.7071ZM21.4529 15.2929L21.9832 14.7626L21.4529 15.2929ZM21.4529 16.7071L20.9226 16.1768V16.1768L21.4529 16.7071ZM19.6297 17.4697C19.3368 17.7626 19.3368 18.2374 19.6297 18.5303C19.9226 18.8232 20.3974 18.8232 20.6903 18.5303L19.6297 17.4697ZM6.69207 8.75H17.3079V7.25H6.69207V8.75ZM17.2745 8.66327L16.6349 10.2982L18.0318 10.8447L18.6714 9.20979L17.2745 8.66327ZM7.36511 10.2982L6.72548 8.66327L5.32858 9.20979L5.96822 10.8447L7.36511 10.2982ZM17.3079 8.75C17.2932 8.75 17.277 8.7457 17.2643 8.73876C17.2531 8.73261 17.249 8.727 17.2486 8.7265C17.2485 8.72639 17.2516 8.73098 17.2487 8.74172L18.6972 9.13134C18.9358 8.2443 18.3201 7.25 17.3079 7.25V8.75ZM6.69207 7.25C5.6799 7.25 5.06418 8.2443 5.30277 9.13134L6.75129 8.74172C6.7484 8.73098 6.75148 8.72639 6.7514 8.7265C6.75105 8.727 6.74694 8.73261 6.73567 8.73876C6.72296 8.7457 6.70682 8.75 6.69207 8.75V7.25ZM6.66667 11.3214H17.3333V9.82143H6.66667V11.3214ZM16.5833 10.5714V12.102H18.0833V10.5714H16.5833ZM7.41667 12.102V10.5714H5.91667V12.102H7.41667ZM12 16.25C9.40729 16.25 7.41667 14.334 7.41667 12.102H5.91667C5.91667 15.2802 8.70167 17.75 12 17.75V16.25ZM16.5833 12.102C16.5833 14.334 14.5927 16.25 12 16.25V17.75C15.2983 17.75 18.0833 15.2802 18.0833 12.102H16.5833ZM11.75 13.75C11.75 13.6119 11.8619 13.5 12 13.5V15C12.6904 15 13.25 14.4404 13.25 13.75H11.75ZM12 13.5C12.1381 13.5 12.25 13.6119 12.25 13.75H10.75C10.75 14.4404 11.3096 15 12 15V13.5ZM12.25 13.75C12.25 13.8881 12.1381 14 12 14V12.5C11.3096 12.5 10.75 13.0596 10.75 13.75H12.25ZM12 14C11.8619 14 11.75 13.8881 11.75 13.75H13.25C13.25 13.0596 12.6904 12.5 12 12.5V14ZM12 14.5H12.005V13H12V14.5ZM3.30546 5.46967L2.01256 6.76256L3.07322 7.82322L4.36612 6.53033L3.30546 5.46967ZM2.01256 9.23744L2.59835 9.82322L3.65901 8.76256L3.07322 8.17678L2.01256 9.23744ZM2.59835 10.1768L2.01256 10.7626L3.07322 11.8232L3.65901 11.2374L2.59835 10.1768ZM2.01256 13.2374L2.59835 13.8232L3.65901 12.7626L3.07322 12.1768L2.01256 13.2374ZM2.59835 14.1768L2.01256 14.7626L3.07322 15.8232L3.65901 15.2374L2.59835 14.1768ZM2.01256 17.2374L3.30546 18.5303L4.36612 17.4697L3.07322 16.1768L2.01256 17.2374ZM2.01256 14.7626C1.32915 15.446 1.32915 16.554 2.01256 17.2374L3.07322 16.1768C2.97559 16.0791 2.97559 15.9209 3.07322 15.8232L2.01256 14.7626ZM2.59835 13.8232C2.69598 13.9209 2.69598 14.0791 2.59835 14.1768L3.65901 15.2374C4.34243 14.554 4.34243 13.446 3.65901 12.7626L2.59835 13.8232ZM2.01256 10.7626C1.32914 11.446 1.32915 12.554 2.01256 13.2374L3.07322 12.1768C2.97559 12.0791 2.97559 11.9209 3.07322 11.8232L2.01256 10.7626ZM2.59835 9.82322C2.69598 9.92085 2.69598 10.0791 2.59835 10.1768L3.65901 11.2374C4.34243 10.554 4.34243 9.44598 3.65901 8.76256L2.59835 9.82322ZM2.01256 6.76256C1.32914 7.44598 1.32915 8.55402 2.01256 9.23744L3.07322 8.17678C2.97559 8.07915 2.97559 7.92085 3.07322 7.82322L2.01256 6.76256ZM19.6297 6.53033L20.9226 7.82322L21.9832 6.76256L20.6903 5.46967L19.6297 6.53033ZM20.9226 8.17678L20.3368 8.76256L21.3974 9.82322L21.9832 9.23744L20.9226 8.17678ZM20.3368 11.2374L20.9226 11.8232L21.9832 10.7626L21.3974 10.1768L20.3368 11.2374ZM20.9226 12.1768L20.3368 12.7626L21.3974 13.8232L21.9832 13.2374L20.9226 12.1768ZM20.3368 15.2374L20.9226 15.8232L21.9832 14.7626L21.3974 14.1768L20.3368 15.2374ZM20.9226 16.1768L19.6297 17.4697L20.6903 18.5303L21.9832 17.2374L20.9226 16.1768ZM20.9226 15.8232C21.0202 15.9209 21.0202 16.0791 20.9226 16.1768L21.9832 17.2374C22.6666 16.554 22.6666 15.446 21.9832 14.7626L20.9226 15.8232ZM20.3368 12.7626C19.6534 13.446 19.6534 14.554 20.3368 15.2374L21.3974 14.1768C21.2998 14.0791 21.2998 13.9209 21.3974 13.8232L20.3368 12.7626ZM20.9226 11.8232C21.0202 11.9209 21.0202 12.0791 20.9226 12.1768L21.9832 13.2374C22.6666 12.554 22.6666 11.446 21.9832 10.7626L20.9226 11.8232ZM20.3368 8.76256C19.6534 9.44598 19.6534 10.554 20.3368 11.2374L21.3974 10.1768C21.2998 10.0791 21.2998 9.92085 21.3974 9.82322L20.3368 8.76256ZM20.9226 7.82322C21.0202 7.92085 21.0202 8.07914 20.9226 8.17678L21.9832 9.23744C22.6666 8.55402 22.6666 7.44598 21.9832 6.76256L20.9226 7.82322Z" }) });
var shock_detection_default = SvgShockDetection;

// assets/icons/time.svg
import * as React158 from "react";
import { jsx as jsx159, jsxs as jsxs53 } from "react/jsx-runtime";
var SvgTime = (props) => /* @__PURE__ */ jsxs53("svg", { width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: [
  /* @__PURE__ */ jsx159("circle", { cx: 12, cy: 12, r: 9, strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }),
  /* @__PURE__ */ jsx159("path", { d: "M12 7V12H17", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" })
] });
var time_default = SvgTime;

// assets/icons/top-rank.svg
import * as React159 from "react";
import { jsx as jsx160 } from "react/jsx-runtime";
var SvgTopRank = (props) => /* @__PURE__ */ jsx160("svg", { width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx160("path", { d: "M12 16C8.68629 16 6 13.3137 6 10V5H18V10C18 13.3137 15.3137 16 12 16ZM12 16V21M9 21H15M3 7H6V11C4.34315 11 3 9.65685 3 8V7ZM21 7H18V11C19.6569 11 21 9.65685 21 8V7Z", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }) });
var top_rank_default = SvgTopRank;

// assets/icons/traffic-jam.svg
import * as React160 from "react";
import { jsx as jsx161 } from "react/jsx-runtime";
var SvgTrafficJam = (props) => /* @__PURE__ */ jsx161("svg", { width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx161("path", { d: "M5.75 16.5H6.75M13.75 16.5H14.75M15.25 19C16.3546 19 17.25 18.1046 17.25 17V14.2932C17.25 14.0998 17.2103 13.9083 17.1332 13.7305L15.4585 9.86583C15.2309 9.34056 14.7087 9 14.1309 9H6.36913C5.79131 9 5.26909 9.34056 5.04147 9.86583L3.36679 13.7305C3.28974 13.9083 3.25 14.0998 3.25 14.2932V17C3.25 18.1046 4.14543 19 5.25 19M15.25 19V21M15.25 19H5.25M5.25 19L5.25 21M16.25 6L15.4585 3.86583C15.2309 3.34056 14.7087 3 14.1309 3H8.36914C7.79132 3 7.2691 3.34056 7.04148 3.86583L5.68335 6M8.68335 9L10.0415 6.86583C10.2691 6.34056 10.7913 6 11.3691 6H18.1309C18.7087 6 19.2309 6.34056 19.4585 6.86583L21.25 10H22.75M17.25 14H18.75M4.25 6H5.75M1.25 14L19.25 14", strokeWidth: 1.5, strokeLinecap: "round" }) });
var traffic_jam_default = SvgTrafficJam;

// assets/icons/temperature.svg
import * as React161 from "react";
import { jsx as jsx162 } from "react/jsx-runtime";
var SvgTemperature = (props) => /* @__PURE__ */ jsx162("svg", { width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx162("path", { d: "M14.75 5H18M12 17L12 12.5V8M14.75 8H18M14.75 11H18M13.5 17C13.5 17.8284 12.8284 18.5 12 18.5C11.1716 18.5 10.5 17.8284 10.5 17C10.5 16.1716 11.1716 15.5 12 15.5C12.8284 15.5 13.5 16.1716 13.5 17ZM12.75 17C12.75 17.4142 12.4142 17.75 12 17.75C11.5858 17.75 11.25 17.4142 11.25 17C11.25 16.5858 11.5858 16.25 12 16.25C12.4142 16.25 12.75 16.5858 12.75 17ZM9.27273 4.72727C9.27273 3.22104 10.4938 2 12 2C13.5062 2 14.7273 3.22104 14.7273 4.72727V12.8086C16.0956 13.7007 17 15.2447 17 17C17 19.7614 14.7614 22 12 22C9.23858 22 7 19.7614 7 17C7 15.2447 7.90445 13.7007 9.27273 12.8086V4.72727Z", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }) });
var temperature_default = SvgTemperature;

// assets/icons/tampering-detection.svg
import * as React162 from "react";
import { jsx as jsx163 } from "react/jsx-runtime";
var SvgTamperingDetection = (props) => /* @__PURE__ */ jsx163("svg", { width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx163("path", { d: "M20 9L20.9594 6.45682C21.1488 5.72675 20.6512 5 19.9619 5H4.03811C3.34883 5 2.85119 5.72675 3.04055 6.45683L4 9M20 9H4M20 9V11.381C20 15.5888 16.4183 19 12 19C7.58172 19 4 15.5888 4 11.381V9M20.2297 9.5L11 18.7297M15.0029 9L7 17.0029M9.27542 9L4.27542 14", strokeWidth: 1.5, strokeMiterlimit: 10 }) });
var tampering_detection_default = SvgTamperingDetection;

// assets/icons/user-single.svg
import * as React163 from "react";
import { jsx as jsx164, jsxs as jsxs54 } from "react/jsx-runtime";
var SvgUserSingle = (props) => /* @__PURE__ */ jsxs54("svg", { width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: [
  /* @__PURE__ */ jsx164("path", { d: "M20 20V19C20 16.7909 18.2091 15 16 15H8C5.79086 15 4 16.7909 4 19V20", strokeWidth: 1.5, strokeLinecap: "round" }),
  /* @__PURE__ */ jsx164("path", { d: "M16 8C16 10.2091 14.2091 12 12 12C9.79086 12 8 10.2091 8 8C8 5.79086 9.79086 4 12 4C14.2091 4 16 5.79086 16 8Z", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" })
] });
var user_single_default = SvgUserSingle;

// assets/icons/user-profile.svg
import * as React164 from "react";
import { jsx as jsx165 } from "react/jsx-runtime";
var SvgUserProfile = (props) => /* @__PURE__ */ jsx165("svg", { width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx165("path", { d: "M6 18.5C6 18.4161 6.00516 17.8335 6.01518 17.7524C6.13716 16.7646 6.97928 16 8 16H16C16.9671 16 17.7739 16.6864 17.9597 17.5986C17.9861 17.7283 18 18.3625 18 18.5M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12ZM15 10C15 11.6569 13.6568 13 12 13C10.3431 13 9 11.6569 9 10C9 8.34314 10.3431 7 12 7C13.6568 7 15 8.34314 15 10Z", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }) });
var user_profile_default = SvgUserProfile;

// assets/icons/user-group.svg
import * as React165 from "react";
import { jsx as jsx166 } from "react/jsx-runtime";
var SvgUserGroup = (props) => /* @__PURE__ */ jsx166("svg", { width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx166("path", { d: "M16.5 21V19.5C16.5 18.3954 15.6046 17.5 14.5 17.5H9.5C8.39543 17.5 7.5 18.3954 7.5 19.5V21M21 15.5V13.5C21 12.3954 20.1046 11.5 19 11.5H17.5M3 15.5V13.5C3 12.3954 3.89543 11.5 5 11.5H6.5M14.5 12.5C14.5 13.8807 13.3807 15 12 15C10.6193 15 9.5 13.8807 9.5 12.5C9.5 11.1193 10.6193 10 12 10C13.3807 10 14.5 11.1193 14.5 12.5ZM20 6.5C20 7.88071 18.8807 9 17.5 9C16.1193 9 15 7.88071 15 6.5C15 5.11929 16.1193 4 17.5 4C18.8807 4 20 5.11929 20 6.5ZM9 6.5C9 7.88071 7.88071 9 6.5 9C5.11929 9 4 7.88071 4 6.5C4 5.11929 5.11929 4 6.5 4C7.88071 4 9 5.11929 9 6.5Z", strokeWidth: 1.5, strokeLinecap: "round" }) });
var user_group_default = SvgUserGroup;

// assets/icons/view-show.svg
import * as React166 from "react";
import { jsx as jsx167, jsxs as jsxs55 } from "react/jsx-runtime";
var SvgViewShow = (props) => /* @__PURE__ */ jsxs55("svg", { width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: [
  /* @__PURE__ */ jsx167("path", { d: "M3 13C6.6 5 17.4 5 21 13", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }),
  /* @__PURE__ */ jsx167("path", { d: "M12 17C10.3431 17 9 15.6569 9 14C9 12.3431 10.3431 11 12 11C13.6569 11 15 12.3431 15 14C15 15.6569 13.6569 17 12 17Z", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" })
] });
var view_show_default = SvgViewShow;

// assets/icons/view-hide.svg
import * as React167 from "react";
import { jsx as jsx168, jsxs as jsxs56 } from "react/jsx-runtime";
var SvgViewHide = (props) => /* @__PURE__ */ jsxs56("svg", { width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: [
  /* @__PURE__ */ jsx168("path", { d: "M19.5 16L17.0248 12.6038", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }),
  /* @__PURE__ */ jsx168("path", { d: "M12 17.5V14", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }),
  /* @__PURE__ */ jsx168("path", { d: "M4.5 15.9999L6.96895 12.6123", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }),
  /* @__PURE__ */ jsx168("path", { d: "M3 8C6.6 16 17.4 16 21 8", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" })
] });
var view_hide_default = SvgViewHide;

// assets/icons/video-loss.svg
import * as React168 from "react";
import { jsx as jsx169 } from "react/jsx-runtime";
var SvgVideoLoss = (props) => /* @__PURE__ */ jsx169("svg", { width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx169("path", { d: "M5.69998 5.69998L18.3 18.3M12 21C7.02943 21 3 16.9705 3 12C3 7.02943 7.02943 3 12 3C16.9705 3 21 7.02943 21 12C21 16.9705 16.9705 21 12 21Z", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }) });
var video_loss_default = SvgVideoLoss;

// assets/icons/vehicle.svg
import * as React169 from "react";
import { jsx as jsx170 } from "react/jsx-runtime";
var SvgVehicle = (props) => /* @__PURE__ */ jsx170("svg", { width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx170("path", { d: "M5 9.99993H19M5 9.99993C3.89543 9.99993 3 10.8954 3 11.9999L3 14.76C3 15.9971 4.07452 17 5.4 17H18.6C19.9255 17 21 15.9971 21 14.76V11.9999C21 10.8954 20.1046 9.99993 19 9.99993M5 9.99993C5 9.83458 5.03235 9.53541 5.09579 9.37854L6.44121 6.05196C6.69529 5.42374 7.40861 5 8.21208 5H15.4222C16.1758 5 16.8555 5.37344 17.1453 5.94675L18.8564 9.33136C18.9512 9.51885 19 9.79682 19 9.99993M5.4 13V14M9.6 13.08H14.4M18.6 13V14M4.5 17V18.5C4.5 18.7761 4.72386 19 5 19H6.5C6.77614 19 7 18.7761 7 18.5V17M17 17V18.5C17 18.7761 17.2239 19 17.5 19H19C19.2761 19 19.5 18.7761 19.5 18.5V17", strokeWidth: 1.5, strokeLinecap: "round" }) });
var vehicle_default = SvgVehicle;

// assets/icons/vehicle-motorcycle.svg
import * as React170 from "react";
import { jsx as jsx171 } from "react/jsx-runtime";
var SvgVehicleMotorcycle = (props) => /* @__PURE__ */ jsx171("svg", { width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx171("path", { d: "M18.5 16.5L16.46 11.83M15.5 6V9H11.71L6.7 14.31M3 12C4.7 10.73 7.22 10.67 9 11.83M5.5 16.5H13.13C13.8 11.95 16.4 11.55 19 11.58V9.33C19 8.22 18.41 6 16.06 6H13M5.5 19C6.88 19 8 17.88 8 16.5C8 15.12 6.88 14 5.5 14C4.12 14 3 15.12 3 16.5C3 17.88 4.12 19 5.5 19ZM18.5 19C19.88 19 21 17.88 21 16.5C21 15.12 19.88 14 18.5 14C17.12 14 16 15.12 16 16.5C16 17.88 17.12 19 18.5 19Z", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }) });
var vehicle_motorcycle_default = SvgVehicleMotorcycle;

// assets/icons/vehicle_bicycle.svg
import * as React171 from "react";
import { jsx as jsx172 } from "react/jsx-runtime";
var SvgVehicleBicycle = (props) => /* @__PURE__ */ jsx172("svg", { width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx172("path", { d: "M5.5 16.5L9.525 11.7501M9.525 11.7501H15.6794M9.525 11.7501L7.95 8.6001H5.7M9.525 11.7501L12 16.7001M18.5 16.5L14.25 8.6001H17.85L18.75 9.9501M8 16.5001C8 17.8808 6.88071 19.0001 5.5 19.0001C4.11929 19.0001 3 17.8808 3 16.5001C3 15.1194 4.11929 14.0001 5.5 14.0001C6.88071 14.0001 8 15.1194 8 16.5001ZM21 16.5C21 17.8807 19.8807 19 18.5 19C17.1193 19 16 17.8807 16 16.5C16 15.1193 17.1193 14 18.5 14C19.8807 14 21 15.1193 21 16.5Z", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }) });
var vehicle_bicycle_default = SvgVehicleBicycle;

// assets/icons/vehicle-truck.svg
import * as React172 from "react";
import { jsx as jsx173 } from "react/jsx-runtime";
var SvgVehicleTruck = (props) => /* @__PURE__ */ jsx173("svg", { width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx173("path", { d: "M15 8.5H17.4983C18.0086 8.5 18.4949 8.72059 18.8363 9.1069L20.5379 11.0326C20.8354 11.3693 21 11.8062 21 12.2591V14M15 8.5V6.91667C15 6.41041 14.5971 6 14.1 6H5C3.89543 6 3 6.89543 3 8V16.0833C3 16.5896 3.40294 17 3.9 17H4.8M15 8.5V10.5C15 11.3284 15.6716 12 16.5 12H21M15 17H9M15 17C15 18.1046 15.8954 19 17 19C18.1046 19 19 18.1046 19 17M15 17C15 15.8954 15.8954 15 17 15C18.1046 15 19 15.8954 19 17M9 17C9 18.1046 8.10457 19 7 19C5.89543 19 5 18.1046 5 17C5 15.8954 5.89543 15 7 15C8.10457 15 9 15.8954 9 17ZM21 13V16C21 16.5523 20.5523 17 20 17H19", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }) });
var vehicle_truck_default = SvgVehicleTruck;

// assets/icons/vehicle-bus.svg
import * as React173 from "react";
import { jsx as jsx174 } from "react/jsx-runtime";
var SvgVehicleBus = (props) => /* @__PURE__ */ jsx174("svg", { width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx174("path", { d: "M19.2727 16.9646H21.1158C21.6 16.9646 22 16.5751 22 16.0909V12.0105C22 11.5789 21.9684 11.1474 21.8947 10.7263C21.5368 8.57895 19.6526 7 17.4526 7H3.69474C2.75789 7 2 7.74737 2 8.67368V16.0909L4.72727 17M9 17H15M9 17C9 18.1046 8.10457 19 7 19C5.89543 19 5 18.1046 5 17C5 15.8954 5.89543 15 7 15C8.10457 15 9 15.8954 9 17ZM15 17C15 18.1046 15.8954 19 17 19C18.1046 19 19 18.1046 19 17C19 15.8954 18.1046 15 17 15C15.8954 15 15 15.8954 15 17ZM22 12.3462H18C16.8954 12.3462 16 11.5196 16 10.5V7M12 7V11M2 11L16 11M7 7V11", strokeWidth: 1.5, strokeMiterlimit: 10, strokeLinecap: "round", strokeLinejoin: "round" }) });
var vehicle_bus_default = SvgVehicleBus;

// assets/icons/vehicle-van.svg
import * as React174 from "react";
import { jsx as jsx175 } from "react/jsx-runtime";
var SvgVehicleVan = (props) => /* @__PURE__ */ jsx175("svg", { width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx175("path", { d: "M9 17C9 18.1046 8.10457 19 7 19C5.89543 19 5 18.1046 5 17M9 17C9 15.8954 8.10457 15 7 15C5.89543 15 5 15.8954 5 17M9 17H15M5 17C3.89543 17 3 16.1046 3 15V9C3 7.89543 3.89543 7 5 7H15.0617C15.7076 7 16.3137 7.31193 16.6891 7.83752L18.685 10.6318C18.7735 10.7556 18.8758 10.869 18.9901 10.9695C19.4435 11.3684 19.9318 11.7956 20.3137 12.129C20.7496 12.5096 21 13.0595 21 13.6383V15C21 16.1046 20.1046 17 19 17M19 17C19 18.1046 18.1046 19 17 19C15.8954 19 15 18.1046 15 17M19 17C19 15.8954 18.1046 15 17 15C15.8954 15 15 15.8954 15 17M11.8182 7L13.2031 10.4623C13.355 10.842 13.7227 11.0909 14.1316 11.0909H19", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }) });
var vehicle_van_default = SvgVehicleVan;

// assets/icons/vehicle-sedan.svg
import * as React175 from "react";
import { jsx as jsx176 } from "react/jsx-runtime";
var SvgVehicleSedan = (props) => /* @__PURE__ */ jsx176("svg", { width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx176("path", { d: "M13.7936 8.79725L14.3272 8.27019V8.27019L13.7936 8.79725ZM16.4664 12.5703C16.7575 12.865 17.2324 12.8679 17.5271 12.5768C17.8217 12.2858 17.8247 11.8109 17.5336 11.5162L16.4664 12.5703ZM3.72085 16.6281L3.51149 17.3483H3.51149L3.72085 16.6281ZM6.39903 9.11432L5.70705 8.82505V8.82505L6.39903 9.11432ZM5.35983 11.6003L6.0518 11.8896V11.8896L5.35983 11.6003ZM4.71318 12.1758L4.50619 11.4549H4.50619L4.71318 12.1758ZM3.72402 12.4598L3.931 13.1807L3.93101 13.1807L3.72402 12.4598ZM20.1818 17L20.1818 17.75H20.1818V17ZM5.04545 11.2933C4.63124 11.2933 4.29545 11.6291 4.29545 12.0433C4.29545 12.4575 4.63124 12.7933 5.04545 12.7933V11.2933ZM19 12.7933C19.4142 12.7933 19.75 12.4575 19.75 12.0433C19.75 11.6291 19.4142 11.2933 19 11.2933V12.7933ZM11.75 8.5C11.75 8.08579 11.4142 7.75 11 7.75C10.5858 7.75 10.25 8.08579 10.25 8.5H11.75ZM10.25 12.0433C10.25 12.4576 10.5858 12.7933 11 12.7933C11.4142 12.7933 11.75 12.4576 11.75 12.0433H10.25ZM9.00001 17.75H15V16.25H9.00001V17.75ZM8.25001 17C8.25001 17.6903 7.69035 18.25 7 18.25V19.75C8.51879 19.75 9.75001 18.5187 9.75001 17H8.25001ZM7 18.25C6.30964 18.25 5.75 17.6904 5.75 17H4.25C4.25 18.5188 5.48122 19.75 7 19.75V18.25ZM5.75 17C5.75 16.3096 6.30964 15.75 7 15.75V14.25C5.48122 14.25 4.25 15.4812 4.25 17H5.75ZM7 15.75C7.69038 15.75 8.25001 16.3096 8.25001 17H9.75001C9.75001 15.4812 8.51876 14.25 7 14.25V15.75ZM18.25 17C18.25 17.6904 17.6904 18.25 17 18.25V19.75C18.5188 19.75 19.75 18.5188 19.75 17H18.25ZM17 18.25C16.3097 18.25 15.75 17.6903 15.75 17H14.25C14.25 18.5187 15.4812 19.75 17 19.75V18.25ZM15.75 17C15.75 16.3096 16.3096 15.75 17 15.75V14.25C15.4812 14.25 14.25 15.4812 14.25 17H15.75ZM17 15.75C17.6904 15.75 18.25 16.3096 18.25 17H19.75C19.75 15.4812 18.5188 14.25 17 14.25V15.75ZM7.32166 9.25H13.0822V7.75H7.32166V9.25ZM13.26 9.32431L16.4664 12.5703L17.5336 11.5162L14.3272 8.27019L13.26 9.32431ZM5.20936 16.2798L3.93021 15.908L3.51149 17.3483L4.79064 17.7202L5.20936 16.2798ZM5.70705 8.82505L4.66785 11.311L6.0518 11.8896L7.091 9.40358L5.70705 8.82505ZM4.50619 11.4549L3.51703 11.7389L3.93101 13.1807L4.92016 12.8966L4.50619 11.4549ZM2.25 13.421V15.6679H3.75V13.421H2.25ZM3.93021 15.908C3.82344 15.8769 3.75 15.7791 3.75 15.6679H2.25C2.25 16.4463 2.76408 17.1311 3.51149 17.3483L3.93021 15.908ZM3.51703 11.7389C2.76686 11.9543 2.25 12.6405 2.25 13.421H3.75C3.75 13.3095 3.82384 13.2114 3.931 13.1807L3.51703 11.7389ZM13.0822 9.25C13.149 9.25 13.2131 9.27676 13.26 9.32431L14.3272 8.27019C13.9984 7.93734 13.55 7.75 13.0822 7.75V9.25ZM4.66785 11.311C4.63859 11.381 4.57912 11.434 4.50619 11.4549L4.92016 12.8966C5.43066 12.7501 5.84696 12.3796 6.0518 11.8896L4.66785 11.311ZM7.32166 7.75C6.61592 7.75 5.97925 8.17392 5.70705 8.82505L7.091 9.40358C7.12989 9.31056 7.22084 9.25 7.32166 9.25V7.75ZM20.25 13.6823V16.1818H21.75V13.6823H20.25ZM20.25 16.1818C20.25 16.2195 20.2195 16.25 20.1818 16.25V17.75C21.0479 17.75 21.75 17.0479 21.75 16.1818H20.25ZM19.3636 12.7959C19.8532 12.7959 20.25 13.1928 20.25 13.6823H21.75C21.75 12.3643 20.6816 11.2959 19.3636 11.2959V12.7959ZM20.1818 16.25L19 16.25L19 17.75L20.1818 17.75L20.1818 16.25ZM15.6818 12.7959H19.3636V11.2959H15.6818V12.7959ZM5.04545 12.7933L19 12.7933V11.2933L5.04545 11.2933V12.7933ZM10.25 8.5V12.0433H11.75V8.5H10.25Z" }) });
var vehicle_sedan_default = SvgVehicleSedan;

// assets/icons/vehicle-suv.svg
import * as React176 from "react";
import { jsx as jsx177 } from "react/jsx-runtime";
var SvgVehicleSuv = (props) => /* @__PURE__ */ jsx177("svg", { width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx177("path", { d: "M9 17L15 17M9 17C9 18.1046 8.10457 19 7 19C5.89543 19 5 18.1046 5 17M9 17C9 15.8954 8.10457 15 7 15C5.89543 15 5 15.8954 5 17M15 17C15 18.1046 15.8954 19 17 19C18.1046 19 19 18.1046 19 17M15 17C15 15.8954 15.8954 15 17 15C18.1046 15 19 15.8954 19 17M5 17L3.55279 16.2764C3.214 16.107 3 15.7607 3 15.382V11.283C3 11.098 3.05135 10.9166 3.14834 10.7589L4.41427 8.7018C4.77827 8.11031 5.42307 7.75 6.11759 7.75H12.723C13.0402 7.75 13.3385 7.90045 13.5271 8.15547L15.7002 11.0945C15.8888 11.3495 16.1871 11.5 16.5043 11.5H19.5C20.4037 11.5 21 12.5063 21 13.41V16C21 16.5523 20.5523 17 20 17H19M3 11.5L17.5 11.5M9.54544 7.75V11.5", strokeWidth: 1.5, strokeMiterlimit: 10, strokeLinecap: "round", strokeLinejoin: "round" }) });
var vehicle_suv_default = SvgVehicleSuv;

// assets/icons/vehicle-counting.svg
import * as React177 from "react";
import { jsx as jsx178 } from "react/jsx-runtime";
var SvgVehicleCounting = (props) => /* @__PURE__ */ jsx178("svg", { width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx178("path", { d: "M11.5 17.75C11.9142 17.75 12.25 17.4142 12.25 17C12.25 16.5858 11.9142 16.25 11.5 16.25V17.75ZM20.25 12.5C20.25 12.9142 20.5858 13.25 21 13.25C21.4142 13.25 21.75 12.9142 21.75 12.5H20.25ZM6.15 13C6.15 12.5858 5.81421 12.25 5.4 12.25C4.98579 12.25 4.65 12.5858 4.65 13H6.15ZM4.65 14C4.65 14.4142 4.98579 14.75 5.4 14.75C5.81421 14.75 6.15 14.4142 6.15 14H4.65ZM9.6 12.33C9.18579 12.33 8.85 12.6658 8.85 13.08C8.85 13.4942 9.18579 13.83 9.6 13.83V12.33ZM14.4 13.83C14.8142 13.83 15.15 13.4942 15.15 13.08C15.15 12.6658 14.8142 12.33 14.4 12.33V13.83ZM5.25 17C5.25 16.5858 4.91421 16.25 4.5 16.25C4.08579 16.25 3.75 16.5858 3.75 17H5.25ZM6.44121 6.05196L5.74592 5.77075L6.44121 6.05196ZM5.09579 9.37854L5.79108 9.65974V9.65974L5.09579 9.37854ZM18.8564 9.33136L18.1871 9.66974L18.1871 9.66974L18.8564 9.33136ZM17.1453 5.94675L16.476 6.28513V6.28513L17.1453 5.94675ZM17.5 14.25C17.0858 14.25 16.75 14.5858 16.75 15C16.75 15.4142 17.0858 15.75 17.5 15.75V14.25ZM21 15H21.75C21.75 14.5858 21.4142 14.25 21 14.25V15ZM20.25 18.5C20.25 18.9142 20.5858 19.25 21 19.25C21.4142 19.25 21.75 18.9142 21.75 18.5H20.25ZM17 19L16.4755 19.5361C16.7693 19.8235 17.2397 19.8209 17.5303 19.5303L17 19ZM15.2342 17.2727L15.7587 16.7366C15.6159 16.5969 15.4233 16.52 15.2236 16.5228C15.0239 16.5256 14.8335 16.608 14.6948 16.7517L15.2342 17.2727ZM12.0606 19.479C11.7729 19.7769 11.7811 20.2517 12.0791 20.5395C12.377 20.8272 12.8518 20.819 13.1396 20.521L12.0606 19.479ZM2.25 11.9999V14.76H3.75V11.9999H2.25ZM5.4 17.75H7V16.25H5.4V17.75ZM7 17.75H11.5V16.25H7V17.75ZM21.75 12.5V11.9999H20.25V12.5H21.75ZM2.25 14.76C2.25 16.4592 3.70988 17.75 5.4 17.75V16.25C4.43915 16.25 3.75 15.535 3.75 14.76H2.25ZM5 10.7499H19V9.24993H5V10.7499ZM4.65 13V14H6.15V13H4.65ZM9.6 13.83H14.4V12.33H9.6V13.83ZM21.75 11.9999C21.75 10.4811 20.5188 9.24993 19 9.24993V10.7499C19.6904 10.7499 20.25 11.3096 20.25 11.9999H21.75ZM3.75 11.9999C3.75 11.3096 4.30964 10.7499 5 10.7499V9.24993C3.48122 9.24993 2.25 10.4812 2.25 11.9999H3.75ZM6.5 18.25H5V19.75H6.5V18.25ZM5 18.25C5.13807 18.25 5.25 18.3619 5.25 18.5H3.75C3.75 19.1904 4.30964 19.75 5 19.75V18.25ZM6.25 18.5C6.25 18.3619 6.36193 18.25 6.5 18.25V19.75C7.19036 19.75 7.75 19.1904 7.75 18.5H6.25ZM5.25 18.5V17H3.75V18.5H5.25ZM6.25 17V18.5H7.75V17H6.25ZM5.74592 5.77075L4.4005 9.09733L5.79108 9.65974L7.1365 6.33316L5.74592 5.77075ZM19.5257 8.99298L17.8146 5.60836L16.476 6.28513L18.1871 9.66974L19.5257 8.99298ZM15.4222 4.25H8.21208V5.75H15.4222V4.25ZM17.8146 5.60836C17.3723 4.7334 16.399 4.25 15.4222 4.25V5.75C15.9526 5.75 16.3386 6.01349 16.476 6.28513L17.8146 5.60836ZM19.75 9.99993C19.75 9.71613 19.688 9.31396 19.5257 8.99298L18.1871 9.66974C18.1948 9.68495 18.2131 9.7321 18.2288 9.80918C18.2438 9.88294 18.25 9.95305 18.25 9.99993H19.75ZM4.4005 9.09733C4.33349 9.26303 4.29964 9.45061 4.28127 9.58265C4.26128 9.72624 4.25 9.87731 4.25 9.99993H5.75C5.75 9.9572 5.75489 9.87601 5.76694 9.78945C5.77273 9.74787 5.77921 9.71208 5.78547 9.6845C5.79243 9.65381 5.79579 9.64809 5.79108 9.65974L4.4005 9.09733ZM7.1365 6.33316C7.25122 6.0495 7.64236 5.75 8.21208 5.75V4.25C7.17487 4.25 6.13936 4.79798 5.74592 5.77075L7.1365 6.33316ZM17.5 15.75H21V14.25H17.5V15.75ZM20.25 15V18.5H21.75V15H20.25ZM20.4697 14.4697L16.4697 18.4697L17.5303 19.5303L21.5303 15.5303L20.4697 14.4697ZM17.5245 18.4639L15.7587 16.7366L14.7098 17.8089L16.4755 19.5361L17.5245 18.4639ZM14.6948 16.7517L12.0606 19.479L13.1396 20.521L15.7737 17.7938L14.6948 16.7517Z" }) });
var vehicle_counting_default = SvgVehicleCounting;

// assets/icons/vehicle-queue-management.svg
import * as React178 from "react";
import { jsx as jsx179 } from "react/jsx-runtime";
var SvgVehicleQueueManagement = (props) => /* @__PURE__ */ jsx179("svg", { width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx179("path", { d: "M3.66669 13H15.3333M3.66669 13C2.74622 13 2.00003 13.7195 2.00003 14.6071L2 16.6906C2 17.6847 2.89543 18.4906 4 18.4906H15C16.1045 18.4906 17 17.6847 17 16.6906L17 14.6071C17 13.7195 16.2538 13 15.3333 13M3.66669 13C3.66669 12.8671 3.69365 12.8945 3.74652 12.7685L4.8677 10.0953C5.07943 9.5905 5.67387 9.25 6.34342 9.25H12.3519C12.9798 9.25 13.5462 9.55009 13.7878 10.0108L15.2137 12.7306C15.2927 12.8812 15.3333 12.8368 15.3333 13M4.00003 15.6786V16.4821M7.62499 15.8125H11.375M15 15.6786V16.4821M3.25 18.7584L3.25003 20.0982C3.25003 20.3201 3.43658 20.5 3.66669 20.5H4.91669C5.14681 20.5 5.33336 20.3201 5.33336 20.0982L5.33333 18.7584M13.6666 18.7584L13.6667 20.0982C13.6667 20.3201 13.8532 20.5 14.0833 20.5H15.3333C15.5635 20.5 15.75 20.3201 15.75 20.0982L15.75 18.7584M19.617 13.4366L19.617 12.2143C19.617 11.3736 18.9894 10.6742 18.1613 10.5281C17.9853 10.497 17.7946 10.3709 17.7116 10.2126L16.1906 7.3115C15.933 6.82009 15.3289 6.5 14.659 6.5H8.25M21.997 10.4366L21.997 9.21428C21.997 8.37356 21.3694 7.6742 20.5413 7.52806C20.3654 7.49701 20.1746 7.37088 20.0916 7.21259L18.5706 4.3115C18.313 3.82009 17.7089 3.5 17.039 3.5H10.63", strokeWidth: 1.5, strokeLinecap: "round" }) });
var vehicle_queue_management_default = SvgVehicleQueueManagement;

// assets/icons/vehicle-heatmap.svg
import * as React179 from "react";
import { jsx as jsx180, jsxs as jsxs57 } from "react/jsx-runtime";
var SvgVehicleHeatmap = (props) => /* @__PURE__ */ jsxs57("svg", { width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: [
  /* @__PURE__ */ jsx180("rect", { width: 0.25, height: 0.25, transform: "matrix(-1 0 0 1 16 15.75)", strokeWidth: 1.5, strokeLinejoin: "round" }),
  /* @__PURE__ */ jsx180("rect", { width: 0.75, height: 0.75, transform: "matrix(-1 0 0 1 16.5 18.5)", strokeWidth: 1.5, strokeLinejoin: "round" }),
  /* @__PURE__ */ jsx180("rect", { width: 0.25, height: 0.25, transform: "matrix(-1 0 0 1 19.25 19)", strokeWidth: 1.5, strokeLinejoin: "round" }),
  /* @__PURE__ */ jsx180("rect", { width: 9, height: 9, rx: 2, transform: "matrix(-1 0 0 1 22 13)", strokeWidth: 1.5, strokeLinejoin: "round" }),
  /* @__PURE__ */ jsx180("path", { d: "M5 9.99993H19M5 9.99993C3.89543 9.99993 3 10.8954 3 11.9999L3 14.76C3 15.9971 4.07452 17 5.4 17H10M5 9.99993C5 9.83458 5.03235 9.53541 5.09579 9.37854L6.44121 6.05196C6.69529 5.42374 7.40861 5 8.21208 5H15.4222C16.1758 5 16.8555 5.37344 17.1453 5.94675L18.8564 9.33136C18.9512 9.51885 19 9.79682 19 9.99993M19 9.99993C19.3643 9.99993 19.7058 10.0973 20 10.2675M5.4 13V14M4.5 17V18.5C4.5 18.7761 4.72386 19 5 19H6.5C6.77614 19 7 18.7761 7 18.5V17", strokeWidth: 1.5, strokeLinecap: "round" })
] });
var vehicle_heatmap_default = SvgVehicleHeatmap;

// assets/icons/warning.svg
import * as React180 from "react";
import { jsx as jsx181 } from "react/jsx-runtime";
var SvgWarning = (props) => /* @__PURE__ */ jsx181("svg", { width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx181("path", { d: "M12 9V13M12 16V15.9805M4.13898 20H19.861C21.5052 20 22.5327 18.3085 21.7107 16.9552L13.8497 4.01493C13.0276 2.66169 10.9724 2.66169 10.1503 4.01493L2.28933 16.9552C1.46726 18.3085 2.49485 20 4.13898 20Z", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }) });
var warning_default = SvgWarning;

// assets/icons/warranty.svg
import * as React181 from "react";
import { jsx as jsx182 } from "react/jsx-runtime";
var SvgWarranty = (props) => /* @__PURE__ */ jsx182("svg", { width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx182("path", { d: "M8 14H16M8 17H16M7 21H17C18.1046 21 19 20.1046 19 19V5C19 3.89543 18.1046 3 17 3H7C5.89543 3 5 3.89543 5 5V19C5 20.1046 5.89543 21 7 21ZM10 6L10.6178 7.25654L12 7.4555L11.0052 8.42932L11.2356 9.81152L10 9.1623L8.7644 9.81152L8.99476 8.42932L8 7.4555L9.3822 7.25654L10 6Z", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }) });
var warranty_default = SvgWarranty;

// assets/icons/warranty-expiration.svg
import * as React182 from "react";
import { jsx as jsx183 } from "react/jsx-runtime";
var SvgWarrantyExpiration = (props) => /* @__PURE__ */ jsx183("svg", { width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx183("path", { d: "M9.99988 21.75C10.4141 21.75 10.7499 21.4142 10.7499 21C10.7499 20.5858 10.4141 20.25 9.99988 20.25V21.75ZM17.2499 9C17.2499 9.41421 17.5857 9.75 17.9999 9.75C18.4141 9.75 18.7499 9.41421 18.7499 9H17.2499ZM9.00003 6.00005L9.67308 5.66914C9.54694 5.41258 9.28592 5.25005 9.00003 5.25005C8.71415 5.25005 8.45312 5.41258 8.32698 5.66914L9.00003 6.00005ZM9.61783 7.2566L8.94479 7.58751C9.05403 7.80971 9.26591 7.96367 9.51098 7.99895L9.61783 7.2566ZM11 7.45555L11.5247 7.99149C11.7286 7.79186 11.8016 7.4938 11.7129 7.22254C11.6243 6.95129 11.3893 6.75386 11.1069 6.7132L11 7.45555ZM10.0053 8.42937L9.48061 7.89343C9.30551 8.06484 9.22519 8.31097 9.26547 8.55267L10.0053 8.42937ZM10.2356 9.81157L9.88679 10.4755C10.1389 10.608 10.4443 10.5862 10.6751 10.4193C10.9059 10.2524 11.0223 9.96921 10.9754 9.68827L10.2356 9.81157ZM9.00003 9.16236L9.34888 8.49842C9.13047 8.38367 8.8696 8.38367 8.65119 8.49842L9.00003 9.16236ZM7.76443 9.81157L7.02464 9.68827C6.97781 9.96921 7.09416 10.2524 7.32495 10.4193C7.55574 10.5862 7.86115 10.608 8.11328 10.4755L7.76443 9.81157ZM7.9948 8.42937L8.73459 8.55267C8.77488 8.31097 8.69455 8.06484 8.51946 7.89343L7.9948 8.42937ZM7.00003 7.45555L6.89318 6.7132C6.61072 6.75386 6.3758 6.95129 6.28715 7.22254C6.19849 7.4938 6.27145 7.79186 6.47537 7.99149L7.00003 7.45555ZM8.38223 7.2566L8.48909 7.99895C8.73416 7.96367 8.94603 7.80971 9.05528 7.58751L8.38223 7.2566ZM20.5 12.5001V11.7501V12.5001ZM20.5 13.3621H19.75L19.75 13.365L20.5 13.3621ZM14.5001 13.3621L15.2501 13.3644V13.3621H14.5001ZM20.5 21.638L19.75 21.6351V21.638H20.5ZM14.5001 21.638H15.2501L15.25 21.6357L14.5001 21.638ZM22 13.2501C22.4142 13.2501 22.75 12.9143 22.75 12.5001C22.75 12.0858 22.4142 11.7501 22 11.7501V13.2501ZM22 23.2501C22.4142 23.2501 22.75 22.9143 22.75 22.5001C22.75 22.0858 22.4142 21.7501 22 21.7501V23.2501ZM13 11.7501C12.5858 11.7501 12.25 12.0858 12.25 12.5001C12.25 12.9143 12.5858 13.2501 13 13.2501V11.7501ZM13 21.7501C12.5858 21.7501 12.25 22.0858 12.25 22.5001C12.25 22.9143 12.5858 23.2501 13 23.2501V21.7501ZM5.99988 3.75H15.9999V2.25H5.99988V3.75ZM4.74988 19V5H3.24988V19H4.74988ZM5.99988 20.25C5.30952 20.25 4.74988 19.6904 4.74988 19H3.24988C3.24988 20.5188 4.4811 21.75 5.99988 21.75V20.25ZM15.9999 3.75C16.6902 3.75 17.2499 4.30964 17.2499 5H18.7499C18.7499 3.48122 17.5187 2.25 15.9999 2.25V3.75ZM5.99988 2.25C4.48109 2.25 3.24988 3.48122 3.24988 5H4.74988C4.74988 4.30964 5.30952 3.75 5.99988 3.75V2.25ZM9.99988 20.25H5.99988V21.75H9.99988V20.25ZM17.2499 5V9H18.7499V5H17.2499ZM8.32698 6.33097L8.94479 7.58751L10.2909 6.92568L9.67308 5.66914L8.32698 6.33097ZM9.51098 7.99895L10.8932 8.1979L11.1069 6.7132L9.72469 6.51425L9.51098 7.99895ZM10.4754 6.91961L9.48061 7.89343L10.5299 8.96531L11.5247 7.99149L10.4754 6.91961ZM9.26547 8.55267L9.49584 9.93487L10.9754 9.68827L10.7451 8.30607L9.26547 8.55267ZM10.5845 9.14764L9.34888 8.49842L8.65119 9.82629L9.88679 10.4755L10.5845 9.14764ZM8.65119 8.49842L7.41559 9.14764L8.11328 10.4755L9.34888 9.82629L8.65119 8.49842ZM8.50423 9.93487L8.73459 8.55267L7.255 8.30607L7.02464 9.68827L8.50423 9.93487ZM8.51946 7.89343L7.52469 6.91961L6.47537 7.99149L7.47014 8.96531L8.51946 7.89343ZM7.10689 8.1979L8.48909 7.99895L8.27538 6.51425L6.89318 6.7132L7.10689 8.1979ZM9.05528 7.58751L9.67308 6.33097L8.32698 5.66914L7.70918 6.92568L9.05528 7.58751ZM14.5001 13.2501H20.5V11.7501H14.5001V13.2501ZM19.75 12.5001V13.3621H21.25V12.5001H19.75ZM19.75 13.365C19.7529 14.12 19.5155 14.8573 19.0707 15.472L20.2859 16.3514C20.9164 15.4801 21.2542 14.433 21.25 13.3592L19.75 13.365ZM19.0707 15.472C18.6258 16.0867 17.9958 16.5477 17.2696 16.788L17.7409 18.2121C18.7645 17.8733 19.6554 17.2226 20.2859 16.3514L19.0707 15.472ZM17.7391 16.7874C17.0113 16.5486 16.3794 16.0882 15.9328 15.4734L14.7192 16.3548C15.352 17.2262 16.2455 17.876 17.2714 18.2127L17.7391 16.7874ZM15.9328 15.4734C15.4864 14.8586 15.2477 14.1205 15.25 13.3644L13.7501 13.3598C13.7467 14.4351 14.0863 15.4834 14.7192 16.3548L15.9328 15.4734ZM15.2501 13.3621V12.5001H13.7501V13.3621H15.2501ZM14.5001 23.2501H20.5V21.7501H14.5001V23.2501ZM21.25 22.5001V21.638H19.75V22.5001H21.25ZM21.25 21.6409C21.2542 20.5671 20.9164 19.52 20.2859 18.6487L19.0707 19.5281C19.5155 20.1428 19.7529 20.8801 19.75 21.6351L21.25 21.6409ZM20.2859 18.6487C19.6554 17.7775 18.7645 17.1268 17.7409 16.788L17.2696 18.2121C17.9958 18.4524 18.6258 18.9134 19.0707 19.5281L20.2859 18.6487ZM17.2714 16.7874C16.2455 17.1241 15.352 17.7739 14.7192 18.6453L15.9328 19.5267C16.3794 18.9119 17.0113 18.4515 17.7391 18.2127L17.2714 16.7874ZM14.7192 18.6453C14.0863 19.5168 13.7467 20.565 13.7501 21.6403L15.25 21.6357C15.2477 20.8796 15.4864 20.1415 15.9328 19.5267L14.7192 18.6453ZM13.7501 21.638V22.5001H15.2501V21.638H13.7501ZM20.5 13.2501L22 13.2501V11.7501L20.5 11.7501V13.2501ZM20.5 23.2501H22V21.7501H20.5V23.2501ZM13 13.2501H14.5001V11.7501H13V13.2501ZM13 23.2501H14.5001V21.7501H13V23.2501Z" }) });
var warranty_expiration_default = SvgWarrantyExpiration;

// assets/icons/sort-arrow-up-down.svg
import * as React183 from "react";
import { jsx as jsx184 } from "react/jsx-runtime";
var SvgSortArrowUpDown = (props) => /* @__PURE__ */ jsx184("svg", { width: "inherit", height: "inherit", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx184("path", { d: "M12.5 13.3334L10 15.8334L7.5 13.3334M12.5 6.66675L10 4.16675L7.5 6.66675", strokeOpacity: 0.77, strokeWidth: 1.25, strokeLinecap: "round", strokeLinejoin: "round" }) });
var sort_arrow_up_down_default = SvgSortArrowUpDown;

// assets/icons/sort-arrow-down.svg
import * as React184 from "react";
import { jsx as jsx185 } from "react/jsx-runtime";
var SvgSortArrowDown = (props) => /* @__PURE__ */ jsx185("svg", { width: "inherit", height: "inherit", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx185("path", { d: "M7.5 13.3335L10 15.8335M10 15.8335L12.5 13.3335M10 15.8335L10 4.16683", strokeOpacity: 0.77, strokeWidth: 1.25, strokeLinecap: "round", strokeLinejoin: "round" }) });
var sort_arrow_down_default = SvgSortArrowDown;

// assets/icons/sort-arrow-up.svg
import * as React185 from "react";
import { jsx as jsx186 } from "react/jsx-runtime";
var SvgSortArrowUp = (props) => /* @__PURE__ */ jsx186("svg", { width: "inherit", height: "inherit", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx186("path", { d: "M7.5 6.6665L10 4.1665M10 4.1665L12.5 6.6665M10 4.1665L10 15.8338", strokeOpacity: 0.77, strokeWidth: 1.25, strokeLinecap: "round", strokeLinejoin: "round" }) });
var sort_arrow_up_default = SvgSortArrowUp;

// assets/icons/IconArrowRight.svg
import * as React186 from "react";
import { jsx as jsx187 } from "react/jsx-runtime";
var SvgIconArrowRight = (props) => /* @__PURE__ */ jsx187("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx187("path", { d: "M8.84467 6.84467C8.55178 7.13756 8.55178 7.61244 8.84467 7.90533L13.5643 12.625L8.84467 17.3447C8.55178 17.6376 8.55178 18.1124 8.84467 18.4053C9.13756 18.6982 9.61244 18.6982 9.90533 18.4053L15.1553 13.1553C15.4482 12.8624 15.4482 12.3876 15.1553 12.0947L9.90533 6.84467C9.61244 6.55178 9.13756 6.55178 8.84467 6.84467Z", fill: "#747E87" }) });
var IconArrowRight_default = SvgIconArrowRight;

// assets/icons/icon-check-line.svg
import * as React187 from "react";
import { jsx as jsx188 } from "react/jsx-runtime";
var SvgIconCheckLine = (props) => /* @__PURE__ */ jsx188("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx188("path", { d: "M9.99974 15.1735L19.1917 5.98047L20.6067 7.39447L9.99974 18.0015L3.63574 11.6375L5.04974 10.2235L9.99974 15.1735Z", fill: "#CCCFD1" }) });
var icon_check_line_default = SvgIconCheckLine;

// assets/icons/icon-arrow-time-input-chevron-down.svg
import * as React188 from "react";
import { jsx as jsx189 } from "react/jsx-runtime";
var SvgIconArrowTimeInputChevronDown = (props) => /* @__PURE__ */ jsx189("svg", { width: 20, height: 12, viewBox: "0 0 20 12", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx189("path", { d: "M13 5L10 8L7 5", stroke: "white", strokeOpacity: 0.61, strokeWidth: 1.25, strokeLinecap: "round", strokeLinejoin: "round" }) });
var icon_arrow_time_input_chevron_down_default = SvgIconArrowTimeInputChevronDown;

// assets/icons/icon-arrow-time-input-chevron-up.svg
import * as React189 from "react";
import { jsx as jsx190 } from "react/jsx-runtime";
var SvgIconArrowTimeInputChevronUp = (props) => /* @__PURE__ */ jsx190("svg", { width: 20, height: 12, viewBox: "0 0 20 12", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx190("path", { d: "M7 7L10 4L13 7", stroke: "white", strokeOpacity: 0.61, strokeWidth: 1.25, strokeLinecap: "round", strokeLinejoin: "round" }) });
var icon_arrow_time_input_chevron_up_default = SvgIconArrowTimeInputChevronUp;

// useHVTheme.ts
import { useMantineTheme } from "@mantine/core";
var useHVTheme = () => {
  return useMantineTheme();
};
var useHVTheme_default = useHVTheme;

// components/HVAlert/HVAlert.tsx
import { Alert } from "@mantine/core";
import styles from "./HVAlert.module-5CRB5E6E.module.css";
import { jsx as jsx191 } from "react/jsx-runtime";
var HVAlert = ({
  children,
  title,
  withCloseButton,
  onClose,
  icon,
  alertProps
}) => {
  return /* @__PURE__ */ jsx191(
    Alert,
    {
      variant: "default",
      title,
      withCloseButton,
      icon,
      onClose,
      classNames: styles,
      ...alertProps,
      children
    }
  );
};
var HVAlert_default = HVAlert;

// components/HVAvatar/HVAvatar.tsx
import { Avatar } from "@mantine/core";
import styles2 from "./HVAvatar.module-XYSNZOTO.module.css";

// components/HVText/HVText.tsx
import { forwardRef } from "react";
import { createPolymorphicComponent, Text } from "@mantine/core";
import style from "./HVText.module-IK2M7FPE.module.css";
import { jsx as jsx192 } from "react/jsx-runtime";
var HVText = createPolymorphicComponent(
  forwardRef(
    ({ type, weight, children, ...rest }, ref) => /* @__PURE__ */ jsx192(
      Text,
      {
        component: "p",
        ref,
        style: {
          fontWeight: `var(--hv-font-weight-${weight?.toLowerCase() || "regular"})`
        },
        ...rest,
        className: `${style.root} ${style[`${type?.toLowerCase()}`] || style["body-md"]} ${rest?.className}`,
        children
      }
    )
  )
);
var HVText_default = HVText;

// components/HVAvatar/HVAvatar.tsx
import { jsx as jsx193, jsxs as jsxs58 } from "react/jsx-runtime";
var getTextType = (avatarSize) => {
  if (avatarSize === "lg") {
    return "Headline-xs";
  } else if (avatarSize === "xl") {
    return "Headline-lg";
  } else if (avatarSize === "md") {
    return "Body-sm";
  } else if (avatarSize === "sm") {
    return "Body-xs";
  }
};
var getAvatarSizeByType = (avatarSize) => {
  if (avatarSize === "lg") {
    return "72px";
  } else if (avatarSize === "xl") {
    return "120px";
  } else if (avatarSize === "md") {
    return "40px";
  } else if (avatarSize === "sm") {
    return "32px";
  }
};
var AvtarItem = ({ avatarData, ...avtarItemContainerProps }) => {
  return /* @__PURE__ */ jsx193(
    Avatar,
    {
      size: getAvatarSizeByType(avatarData.size),
      className: `${styles2.root}`,
      src: avatarData.type !== "text" ? avatarData.imageSrc : null,
      ...avtarItemContainerProps,
      children: avatarData.type === "text" && /* @__PURE__ */ jsx193(
        HVText_default,
        {
          fw: 700,
          c: "var( --hv-avatar-text-primary)",
          type: getTextType(avatarData.size),
          ...avatarData.textProps,
          children: avatarData.text
        }
      )
    }
  );
};
var AvtarGroup = ({
  groupedAvtarData,
  groupLimit,
  ...avtarGroupProps
}) => {
  const clonedAvatarData = groupedAvtarData;
  const maxAvatarIcons = groupLimit ? groupLimit : groupedAvtarData.length;
  return /* @__PURE__ */ jsxs58(Avatar.Group, { ...avtarGroupProps, children: [
    clonedAvatarData.map((avatarData, index) => {
      if (index < maxAvatarIcons) {
        return /* @__PURE__ */ jsx193(
          AvtarItem,
          {
            avatarData,
            ...avtarGroupProps
          },
          index.toString()
        );
      }
    }),
    maxAvatarIcons < groupedAvtarData.length && /* @__PURE__ */ jsx193(
      AvtarItem,
      {
        avatarData: {
          size: clonedAvatarData[0].size,
          textProps: { c: "var(--hv-avatar-text-secondary)" },
          type: "text",
          text: `+${clonedAvatarData.length - maxAvatarIcons}`
        }
      }
    )
  ] });
};
var HVAvatar = ({ group, groupLimit, item, avtarGroupProps, avtarItemContainerProps }) => {
  return !group ? /* @__PURE__ */ jsx193(AvtarItem, { avatarData: item, ...avtarItemContainerProps }) : /* @__PURE__ */ jsx193(
    AvtarGroup,
    {
      groupLimit,
      groupedAvtarData: item,
      ...avtarGroupProps
    }
  );
};
var HVAvatar_default = HVAvatar;

// components/HVAppsMenu/HVAppsMenu.tsx
import styles3 from "./HVAppsMenu.module-TFA3DIR2.module.css";
import { jsx as jsx194, jsxs as jsxs59 } from "react/jsx-runtime";
import { createElement } from "react";
function HVAppsMenu({
  appsMenuContainerProps,
  apps,
  helpSection,
  helpText,
  onHelpClick,
  logoContainerProps,
  subLogoContainerProps,
  helpContainerProps,
  helpSectionIconProps,
  helpTextProps,
  subHelpContainerProps,
  subHelpSectionIconProps
}) {
  return /* @__PURE__ */ jsxs59(
    HVFlex_default,
    {
      className: styles3.appsMenuContainer,
      direction: "row",
      wrap: "wrap",
      ...appsMenuContainerProps,
      children: [
        /* @__PURE__ */ jsx194(HVFlex_default, { ...logoContainerProps, className: styles3.logoContainer, children: apps.map((app) => /* @__PURE__ */ createElement(HVFlex_default, { ...subLogoContainerProps, key: app.text }, /* @__PURE__ */ jsx194(HVLogo_default, { ...app }))) }),
        helpSection && /* @__PURE__ */ jsxs59(
          HVFlex_default,
          {
            ...helpContainerProps,
            className: styles3.helpContainer,
            direction: "row",
            onClick: onHelpClick,
            children: [
              /* @__PURE__ */ jsx194(
                HVIcon_default,
                {
                  ...helpSectionIconProps,
                  name: "help",
                  svgProps: { width: 24, stroke: "var(--hv-icon-normal-secondary)" }
                }
              ),
              /* @__PURE__ */ jsx194(HVText_default, { ...helpTextProps, children: helpText || "Help" }),
              /* @__PURE__ */ jsx194(HVFlex_default, { className: styles3.rightIcon, ...subHelpContainerProps, children: /* @__PURE__ */ jsx194(
                HVIcon_default,
                {
                  ...subHelpSectionIconProps,
                  name: "arrow-chevron-right",
                  svgProps: {
                    width: 16,
                    stroke: "var(--hv-icon-normal-secondary)"
                  }
                }
              ) })
            ]
          }
        )
      ]
    }
  );
}
var HVAppsMenu_default = HVAppsMenu;

// components/HVBreadcrumbs/HVBreadcrumbs.tsx
import { Breadcrumbs } from "@mantine/core";
import styles4 from "./HVBreadcrumbs.module-TOCMW4DR.module.css";

// components/HVFlex/HVFlex.tsx
import { Flex } from "@mantine/core";
import { jsx as jsx195 } from "react/jsx-runtime";
var HVFlex = ({
  direction,
  gap,
  justify,
  children,
  ...rest
}) => {
  return /* @__PURE__ */ jsx195(
    Flex,
    {
      direction: direction || "column",
      gap,
      justify,
      wrap: "nowrap",
      ...rest,
      children
    }
  );
};
var HVFlex_default = HVFlex;

// assets/newIcons/arrow_none-large-line.svg
import * as React191 from "react";
import { jsx as jsx196 } from "react/jsx-runtime";
var SvgArrowNoneLargeLine = (props) => /* @__PURE__ */ jsx196("svg", { stroke: "black", width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx196("rect", { x: 5, y: 11.25, width: 14, height: 1.5, rx: 0.75, stroke: "inherit", strokeWidth: 1.5, strokeLinecap: "round" }) });
var arrow_none_large_line_default = SvgArrowNoneLargeLine;

// assets/newIcons/add-large-line.svg
import * as React192 from "react";
import { jsx as jsx197 } from "react/jsx-runtime";
var SvgAddLargeLine = (props) => /* @__PURE__ */ jsx197("svg", { stroke: "black", width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx197("path", { d: "M12 3V21M3 12H21", stroke: "inherit", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }) });
var add_large_line_default = SvgAddLargeLine;

// assets/newIcons/add-medium-line.svg
import * as React193 from "react";
import { jsx as jsx198 } from "react/jsx-runtime";
var SvgAddMediumLine = (props) => /* @__PURE__ */ jsx198("svg", { stroke: "black", width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx198("path", { d: "M12 5V19M5 12H19", stroke: "inherit", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }) });
var add_medium_line_default = SvgAddMediumLine;

// assets/newIcons/AI-large-line.svg
import * as React194 from "react";
import { jsx as jsx199, jsxs as jsxs60 } from "react/jsx-runtime";
var SvgAiLargeLine = (props) => /* @__PURE__ */ jsxs60("svg", { stroke: "black", width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: [
  /* @__PURE__ */ jsx199("path", { d: "M17 14C13.134 14 10 10.866 10 7C10 10.866 6.866 14 3 14C6.866 14 10 17.134 10 21C10 17.134 13.134 14 17 14Z", stroke: "inherit", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }),
  /* @__PURE__ */ jsx199("path", { d: "M16 9C17.3807 9 18.5 7.88071 18.5 6.5C18.5 7.88071 19.6193 9 21 9C19.6193 9 18.5 10.1193 18.5 11.5C18.5 10.1193 17.3807 9 16 9Z", stroke: "inherit", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }),
  /* @__PURE__ */ jsx199("path", { d: "M12.5 4.25C13.1904 4.25 13.75 3.69036 13.75 3C13.75 3.69036 14.3096 4.25 15 4.25C14.3096 4.25 13.75 4.80964 13.75 5.5C13.75 4.80964 13.1904 4.25 12.5 4.25Z", stroke: "inherit", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" })
] });
var AI_large_line_default = SvgAiLargeLine;

// assets/newIcons/alarm-large-line.svg
import * as React195 from "react";
import { jsx as jsx200 } from "react/jsx-runtime";
var SvgAlarmLargeLine = (props) => /* @__PURE__ */ jsx200("svg", { stroke: "black", width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx200("path", { d: "M6.5 17.5H17.5M5.5 6.5L4 5M18.5 6.5L20 5M12 5V3M6.3125 17.5L5.53295 19.8003C5.37909 20.4015 5.78342 21 6.34346 21H17.6565C18.2166 21 18.6209 20.4015 18.4671 19.8003L17.6875 17.5V13.7647C17.6875 10.5809 15.1411 8 12 8C8.85888 8 6.3125 10.5809 6.3125 13.7647V17.5Z", stroke: "inherit", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }) });
var alarm_large_line_default = SvgAlarmLargeLine;

// assets/newIcons/analytics-large-fill.svg
import * as React196 from "react";
import { jsx as jsx201, jsxs as jsxs61 } from "react/jsx-runtime";
var SvgAnalyticsLargeFill = (props) => /* @__PURE__ */ jsxs61("svg", { width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "black", xmlns: "http://www.w3.org/2000/svg", ...props, children: [
  /* @__PURE__ */ jsx201("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M13.5856 3.25C13.0678 3.66871 12.75 4.3065 12.75 5C12.75 5.96847 13.3697 6.82828 14.2885 7.13454L16.2212 7.77878L16.8655 9.71151C17.1717 10.6303 18.0315 11.25 19 11.25C19.6935 11.25 20.3313 10.9322 20.75 10.4144V18C20.75 19.5188 19.5188 20.75 18 20.75H6C4.48122 20.75 3.25 19.5188 3.25 18V6C3.25 4.48122 4.48122 3.25 6 3.25H13.5856ZM8.75 12.5C8.75 12.0858 8.41421 11.75 8 11.75C7.58579 11.75 7.25 12.0858 7.25 12.5V16C7.25 16.4142 7.58579 16.75 8 16.75C8.41421 16.75 8.75 16.4142 8.75 16V12.5ZM16.75 14C16.75 13.5858 16.4142 13.25 16 13.25C15.5858 13.25 15.25 13.5858 15.25 14V16C15.25 16.4142 15.5858 16.75 16 16.75C16.4142 16.75 16.75 16.4142 16.75 16V14ZM12.75 10C12.75 9.58579 12.4142 9.25 12 9.25C11.5858 9.25 11.25 9.58579 11.25 10V16C11.25 16.4142 11.5858 16.75 12 16.75C12.4142 16.75 12.75 16.4142 12.75 16V10Z", fill: "inherit" }),
  /* @__PURE__ */ jsx201("path", { d: "M19.7115 0.762829C19.6094 0.456573 19.3228 0.25 19 0.25C18.6772 0.25 18.3906 0.456573 18.2885 0.762829L17.4071 3.40707L14.7628 4.28849C14.4566 4.39057 14.25 4.67718 14.25 5C14.25 5.32282 14.4566 5.60943 14.7628 5.71151L17.4071 6.59293L18.2885 9.23717C18.3906 9.54343 18.6772 9.75 19 9.75C19.3228 9.75 19.6094 9.54343 19.7115 9.23717L20.5929 6.59293L23.2372 5.71151C23.5434 5.60943 23.75 5.32282 23.75 5C23.75 4.67718 23.5434 4.39057 23.2372 4.28849L20.5929 3.40707L19.7115 0.762829Z", fill: "inherit" })
] });
var analytics_large_fill_default = SvgAnalyticsLargeFill;

// assets/newIcons/analytics-large-line.svg
import * as React197 from "react";
import { jsx as jsx202 } from "react/jsx-runtime";
var SvgAnalyticsLargeLine = (props) => /* @__PURE__ */ jsx202("svg", { stroke: "black", width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx202("path", { d: "M12 16V10M8 16V12.5M16 16V14M12.15 4H6C4.89543 4 4 4.89543 4 6V18C4 19.1046 4.89543 20 6 20H18C19.1046 20 20 19.1046 20 18V11.85M19 1L20 4L23 5L20 6L19 9L18 6L15 5L18 4L19 1Z", stroke: "inherit", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }) });
var analytics_large_line_default = SvgAnalyticsLargeLine;

// assets/newIcons/apps-large-line.svg
import * as React198 from "react";
import { jsx as jsx203 } from "react/jsx-runtime";
var SvgAppsLargeLine = (props) => /* @__PURE__ */ jsx203("svg", { stroke: "black", width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx203("path", { d: "M5.65 5.62988H5.66M18.35 5.62988H18.36M12 5.62988H12.01M12 12H12.01M5.65 12H5.66M18.35 12H18.36M12 18.3701H12.01M5.65 18.3701H5.66M18.35 18.3701H18.36M6.3125 5.65625C6.3125 6.01869 6.01869 6.3125 5.65625 6.3125C5.29381 6.3125 5 6.01869 5 5.65625C5 5.29381 5.29381 5 5.65625 5C6.01869 5 6.3125 5.29381 6.3125 5.65625ZM12.6562 5.65625C12.6562 6.01869 12.3624 6.3125 12 6.3125C11.6376 6.3125 11.3438 6.01869 11.3438 5.65625C11.3438 5.29381 11.6376 5 12 5C12.3624 5 12.6562 5.29381 12.6562 5.65625ZM19 5.65625C19 6.01869 18.7062 6.3125 18.3438 6.3125C17.9813 6.3125 17.6875 6.01869 17.6875 5.65625C17.6875 5.29381 17.9813 5 18.3438 5C18.7062 5 19 5.29381 19 5.65625ZM6.3125 12C6.3125 12.3624 6.01869 12.6562 5.65625 12.6562C5.29381 12.6562 5 12.3624 5 12C5 11.6376 5.29381 11.3438 5.65625 11.3438C6.01869 11.3438 6.3125 11.6376 6.3125 12ZM12.6562 12C12.6562 12.3624 12.3624 12.6562 12 12.6562C11.6376 12.6562 11.3438 12.3624 11.3438 12C11.3438 11.6376 11.6376 11.3438 12 11.3438C12.3624 11.3438 12.6562 11.6376 12.6562 12ZM19 12C19 12.3624 18.7062 12.6562 18.3438 12.6562C17.9813 12.6562 17.6875 12.3624 17.6875 12C17.6875 11.6376 17.9813 11.3438 18.3438 11.3438C18.7062 11.3438 19 11.6376 19 12ZM6.3125 18.3438C6.3125 18.7062 6.01869 19 5.65625 19C5.29381 19 5 18.7062 5 18.3438C5 17.9813 5.29381 17.6875 5.65625 17.6875C6.01869 17.6875 6.3125 17.9813 6.3125 18.3438ZM12.6562 18.3438C12.6562 18.7062 12.3624 19 12 19C11.6376 19 11.3438 18.7062 11.3438 18.3438C11.3438 17.9813 11.6376 17.6875 12 17.6875C12.3624 17.6875 12.6562 17.9813 12.6562 18.3438ZM19 18.3438C19 18.7062 18.7062 19 18.3438 19C17.9813 19 17.6875 18.7062 17.6875 18.3438C17.6875 17.9813 17.9813 17.6875 18.3438 17.6875C18.7062 17.6875 19 17.9813 19 18.3438Z", stroke: "inherit", strokeWidth: 1.5, strokeLinecap: "round" }) });
var apps_large_line_default = SvgAppsLargeLine;

// assets/newIcons/area-large-line.svg
import * as React199 from "react";
import { jsx as jsx204 } from "react/jsx-runtime";
var SvgAreaLargeLine = (props) => /* @__PURE__ */ jsx204("svg", { stroke: "black", width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx204("path", { d: "M5 7C3.89543 7 3 6.10457 3 5C3 3.89543 3.89543 3 5 3C6.10457 3 7 3.89543 7 5M5 7C6.10457 7 7 6.10457 7 5M5 7V17M7 5H17M17 19C17 20.1046 17.8954 21 19 21C20.1046 21 21 20.1046 21 19C21 17.8954 20.1046 17 19 17M17 19C17 17.8954 17.8954 17 19 17M17 19H7M19 17V7M19 7C17.8954 7 17 6.10457 17 5M19 7C20.1046 7 21 6.10457 21 5C21 3.89543 20.1046 3 19 3C17.8954 3 17 3.89543 17 5M7 19C7 20.1046 6.10457 21 5 21C3.89543 21 3 20.1046 3 19C3 17.8954 3.89543 17 5 17M7 19C7 17.8954 6.10457 17 5 17", stroke: "inherit", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }) });
var area_large_line_default = SvgAreaLargeLine;

// assets/newIcons/arrow_chevron_down-large-line.svg
import * as React200 from "react";
import { jsx as jsx205 } from "react/jsx-runtime";
var SvgArrowChevronDownLargeLine = (props) => /* @__PURE__ */ jsx205("svg", { stroke: "black", width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx205("path", { d: "M21.5 8L12.5 17L3.5 8", stroke: "inherit", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }) });
var arrow_chevron_down_large_line_default = SvgArrowChevronDownLargeLine;

// assets/newIcons/arrow_chevron_down-medium-line.svg
import * as React201 from "react";
import { jsx as jsx206 } from "react/jsx-runtime";
var SvgArrowChevronDownMediumLine = (props) => /* @__PURE__ */ jsx206("svg", { stroke: "black", width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx206("path", { d: "M19 9L12 16L5 9", stroke: "inherit", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }) });
var arrow_chevron_down_medium_line_default = SvgArrowChevronDownMediumLine;

// assets/newIcons/arrow_chevron_down-small-fill.svg
import * as React202 from "react";
import { jsx as jsx207 } from "react/jsx-runtime";
var SvgArrowChevronDownSmallFill = (props) => /* @__PURE__ */ jsx207("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "black", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx207("path", { d: "M6.55802 9.44194L9.55802 12.4419C9.80209 12.686 10.1978 12.686 10.4419 12.4419L13.4419 9.44194C13.6206 9.26319 13.6741 8.99437 13.5774 8.76082C13.4806 8.52728 13.2527 8.375 13 8.375H6.99996C6.74717 8.375 6.51927 8.52728 6.42253 8.76082C6.32579 8.99437 6.37927 9.26319 6.55802 9.44194Z", fill: "inherit" }) });
var arrow_chevron_down_small_fill_default = SvgArrowChevronDownSmallFill;

// assets/newIcons/arrow_chevron_down-small-line.svg
import * as React203 from "react";
import { jsx as jsx208 } from "react/jsx-runtime";
var SvgArrowChevronDownSmallLine = (props) => /* @__PURE__ */ jsx208("svg", { stroke: "black", width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx208("path", { d: "M17 9L12 14L7 9", stroke: "inherit", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }) });
var arrow_chevron_down_small_line_default = SvgArrowChevronDownSmallLine;

// assets/newIcons/arrow_chevron_left-large-line.svg
import * as React204 from "react";
import { jsx as jsx209 } from "react/jsx-runtime";
var SvgArrowChevronLeftLargeLine = (props) => /* @__PURE__ */ jsx209("svg", { stroke: "black", width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx209("path", { d: "M16 21L7 12L16 3", stroke: "inherit", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }) });
var arrow_chevron_left_large_line_default = SvgArrowChevronLeftLargeLine;

// assets/newIcons/arrow_chevron_left-medium-line.svg
import * as React205 from "react";
import { jsx as jsx210 } from "react/jsx-runtime";
var SvgArrowChevronLeftMediumLine = (props) => /* @__PURE__ */ jsx210("svg", { stroke: "black", width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx210("path", { d: "M15 19L8 12L15 5", stroke: "inherit", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }) });
var arrow_chevron_left_medium_line_default = SvgArrowChevronLeftMediumLine;

// assets/newIcons/arrow_chevron_left-small-line.svg
import * as React206 from "react";
import { jsx as jsx211 } from "react/jsx-runtime";
var SvgArrowChevronLeftSmallLine = (props) => /* @__PURE__ */ jsx211("svg", { stroke: "black", width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx211("path", { d: "M14 17L9 12L14 7", stroke: "inherit", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }) });
var arrow_chevron_left_small_line_default = SvgArrowChevronLeftSmallLine;

// assets/newIcons/arrow_chevron_right-large-line.svg
import * as React207 from "react";
import { jsx as jsx212 } from "react/jsx-runtime";
var SvgArrowChevronRightLargeLine = (props) => /* @__PURE__ */ jsx212("svg", { stroke: "black", width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx212("path", { d: "M8 3L17 12L8 21", stroke: "inherit", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }) });
var arrow_chevron_right_large_line_default = SvgArrowChevronRightLargeLine;

// assets/newIcons/arrow_chevron_right-medium-line.svg
import * as React208 from "react";
import { jsx as jsx213 } from "react/jsx-runtime";
var SvgArrowChevronRightMediumLine = (props) => /* @__PURE__ */ jsx213("svg", { stroke: "black", width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx213("path", { d: "M9 5L16 12L9 19", stroke: "inherit", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }) });
var arrow_chevron_right_medium_line_default = SvgArrowChevronRightMediumLine;

// assets/newIcons/arrow_chevron_right-small-line.svg
import * as React209 from "react";
import { jsx as jsx214 } from "react/jsx-runtime";
var SvgArrowChevronRightSmallLine = (props) => /* @__PURE__ */ jsx214("svg", { stroke: "black", width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx214("path", { d: "M10 7L15 12L10 17", stroke: "inherit", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }) });
var arrow_chevron_right_small_line_default = SvgArrowChevronRightSmallLine;

// assets/newIcons/arrow_chevron_up-large-line.svg
import * as React210 from "react";
import { jsx as jsx215 } from "react/jsx-runtime";
var SvgArrowChevronUpLargeLine = (props) => /* @__PURE__ */ jsx215("svg", { stroke: "black", width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx215("path", { d: "M3 16L12 7L21 16", stroke: "inherit", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }) });
var arrow_chevron_up_large_line_default = SvgArrowChevronUpLargeLine;

// assets/newIcons/arrow_chevron_up-medium-line.svg
import * as React211 from "react";
import { jsx as jsx216 } from "react/jsx-runtime";
var SvgArrowChevronUpMediumLine = (props) => /* @__PURE__ */ jsx216("svg", { stroke: "black", width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx216("path", { d: "M5 15L12 8L19 15", stroke: "inherit", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }) });
var arrow_chevron_up_medium_line_default = SvgArrowChevronUpMediumLine;

// assets/newIcons/arrow_chevron_up-small-fill.svg
import * as React212 from "react";
import { jsx as jsx217 } from "react/jsx-runtime";
var SvgArrowChevronUpSmallFill = (props) => /* @__PURE__ */ jsx217("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "black", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx217("path", { d: "M9.18308 7.18306C9.42715 6.93898 9.82288 6.93898 10.067 7.18306L13.067 10.1831C13.2457 10.3618 13.2992 10.6306 13.2024 10.8642C13.1057 11.0977 12.8778 11.25 12.625 11.25H6.62502C6.37223 11.25 6.14433 11.0977 6.04759 10.8642C5.95086 10.6306 6.00433 10.3618 6.18308 10.1831L9.18308 7.18306Z", fill: "inherit" }) });
var arrow_chevron_up_small_fill_default = SvgArrowChevronUpSmallFill;

// assets/newIcons/arrow_chevron_up-small-line.svg
import * as React213 from "react";
import { jsx as jsx218 } from "react/jsx-runtime";
var SvgArrowChevronUpSmallLine = (props) => /* @__PURE__ */ jsx218("svg", { stroke: "black", width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx218("path", { d: "M7 14L12 9L17 14", stroke: "inherit", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }) });
var arrow_chevron_up_small_line_default = SvgArrowChevronUpSmallLine;

// assets/newIcons/arrow_down-large-fill.svg
import * as React214 from "react";
import { jsx as jsx219 } from "react/jsx-runtime";
var SvgArrowDownLargeFill = (props) => /* @__PURE__ */ jsx219("svg", { width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "black", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx219("path", { d: "M3.53724 8.28066L11.0425 17.3016C11.5399 17.8995 12.4601 17.8995 12.9575 17.3016L20.4627 8.28066C21.1432 7.46284 20.5454 6.25 19.5053 6.25H4.49472C3.4546 6.25 2.85682 7.46284 3.53724 8.28066Z", fill: "inherit" }) });
var arrow_down_large_fill_default = SvgArrowDownLargeFill;

// assets/newIcons/arrow_down-large-line.svg
import * as React215 from "react";
import { jsx as jsx220 } from "react/jsx-runtime";
var SvgArrowDownLargeLine = (props) => /* @__PURE__ */ jsx220("svg", { stroke: "black", width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx220("path", { d: "M11.6191 16.822C11.8166 17.0593 12.1834 17.0593 12.3809 16.822L19.8862 7.80099C20.1518 7.4817 19.9228 7 19.5053 7H4.49473C4.07725 7 3.84816 7.48171 4.11379 7.80099L11.6191 16.822Z", stroke: "inherit", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }) });
var arrow_down_large_line_default = SvgArrowDownLargeLine;

// assets/newIcons/arrow_down-medium-line.svg
import * as React216 from "react";
import { jsx as jsx221 } from "react/jsx-runtime";
var SvgArrowDownMediumLine = (props) => /* @__PURE__ */ jsx221("svg", { stroke: "black", width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx221("path", { d: "M12 19L12 5M12 19L17 14M12 19L7 14", stroke: "inherit", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }) });
var arrow_down_medium_line_default = SvgArrowDownMediumLine;

// assets/newIcons/arrow_elbow-large-line.svg
import * as React217 from "react";
import { jsx as jsx222 } from "react/jsx-runtime";
var SvgArrowElbowLargeLine = (props) => /* @__PURE__ */ jsx222("svg", { stroke: "black", width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx222("path", { d: "M8 7V15C8 15.5523 8.44772 16 9 16H17", stroke: "inherit", strokeWidth: 1.5, strokeLinecap: "round" }) });
var arrow_elbow_large_line_default = SvgArrowElbowLargeLine;

// assets/newIcons/arrow_left-large-line.svg
import * as React218 from "react";
import { jsx as jsx223 } from "react/jsx-runtime";
var SvgArrowLeftLargeLine = (props) => /* @__PURE__ */ jsx223("svg", { stroke: "black", width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx223("path", { d: "M3 12L21 12M3 12L10 19M3 12L10 5", stroke: "inherit", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }) });
var arrow_left_large_line_default = SvgArrowLeftLargeLine;

// assets/newIcons/arrow_left-medium-line.svg
import * as React219 from "react";
import { jsx as jsx224 } from "react/jsx-runtime";
var SvgArrowLeftMediumLine = (props) => /* @__PURE__ */ jsx224("svg", { stroke: "black", width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx224("path", { d: "M5 12L19 12M5 12L10 17M5 12L10 7", stroke: "inherit", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }) });
var arrow_left_medium_line_default = SvgArrowLeftMediumLine;

// assets/newIcons/arrow_right-large-line.svg
import * as React220 from "react";
import { jsx as jsx225 } from "react/jsx-runtime";
var SvgArrowRightLargeLine = (props) => /* @__PURE__ */ jsx225("svg", { stroke: "black", width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx225("path", { d: "M21 12L3 12M21 12L14 5M21 12L14 19", stroke: "inherit", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }) });
var arrow_right_large_line_default = SvgArrowRightLargeLine;

// assets/newIcons/arrow_right-medium-line.svg
import * as React221 from "react";
import { jsx as jsx226 } from "react/jsx-runtime";
var SvgArrowRightMediumLine = (props) => /* @__PURE__ */ jsx226("svg", { stroke: "black", width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx226("path", { d: "M19 12L5 12M19 12L14 7M19 12L14 17", stroke: "inherit", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }) });
var arrow_right_medium_line_default = SvgArrowRightMediumLine;

// assets/newIcons/arrow_up_down-large-line.svg
import * as React222 from "react";
import { jsx as jsx227 } from "react/jsx-runtime";
var SvgArrowUpDownLargeLine = (props) => /* @__PURE__ */ jsx227("svg", { stroke: "black", width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx227("path", { d: "M17 21V3M17 3L13 7M17 3L21 7M7 3V21M7 21L11 17M7 21L3 17", stroke: "inherit", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }) });
var arrow_up_down_large_line_default = SvgArrowUpDownLargeLine;

// assets/newIcons/arrow_up_down-medium-line.svg
import * as React223 from "react";
import { jsx as jsx228 } from "react/jsx-runtime";
var SvgArrowUpDownMediumLine = (props) => /* @__PURE__ */ jsx228("svg", { stroke: "black", width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx228("path", { d: "M16 19V5M16 5L13 8.11111M16 5L19 8.11111M8 5V19M8 19L11 15.8889M8 19L5 15.8889", stroke: "inherit", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }) });
var arrow_up_down_medium_line_default = SvgArrowUpDownMediumLine;

// assets/newIcons/arrow_up_down-small-line.svg
import * as React224 from "react";
import { jsx as jsx229 } from "react/jsx-runtime";
var SvgArrowUpDownSmallLine = (props) => /* @__PURE__ */ jsx229("svg", { stroke: "black", width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx229("path", { d: "M15 17V7M15 7L13 9.22222M15 7L17 9.22222M9 7V17M9 17L11 14.7778M9 17L7 14.7778", stroke: "inherit", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }) });
var arrow_up_down_small_line_default = SvgArrowUpDownSmallLine;

// assets/newIcons/arrow_up-large-fill.svg
import * as React225 from "react";
import { jsx as jsx230 } from "react/jsx-runtime";
var SvgArrowUpLargeFill = (props) => /* @__PURE__ */ jsx230("svg", { width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "black", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx230("path", { d: "M12.9575 6.69837C12.4601 6.10054 11.5399 6.10054 11.0425 6.69837L3.53724 15.7193C2.85682 16.5372 3.4546 17.75 4.49472 17.75H19.5053C20.5454 17.75 21.1432 16.5372 20.4627 15.7193L12.9575 6.69837Z", fill: "inherit" }) });
var arrow_up_large_fill_default = SvgArrowUpLargeFill;

// assets/newIcons/arrow_up-large-line.svg
import * as React226 from "react";
import { jsx as jsx231 } from "react/jsx-runtime";
var SvgArrowUpLargeLine = (props) => /* @__PURE__ */ jsx231("svg", { stroke: "black", width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx231("path", { d: "M11.6191 7.17804C11.8166 6.94065 12.1834 6.94065 12.3809 7.17804L19.8862 16.199C20.1518 16.5183 19.9228 17 19.5053 17H4.49473C4.07725 17 3.84816 16.5183 4.11379 16.199L11.6191 7.17804Z", stroke: "inherit", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }) });
var arrow_up_large_line_default = SvgArrowUpLargeLine;

// assets/newIcons/arrow_up-medium-line.svg
import * as React227 from "react";
import { jsx as jsx232 } from "react/jsx-runtime";
var SvgArrowUpMediumLine = (props) => /* @__PURE__ */ jsx232("svg", { stroke: "black", width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx232("path", { d: "M12 5V19M12 5L7 10M12 5L17 10", stroke: "inherit", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }) });
var arrow_up_medium_line_default = SvgArrowUpMediumLine;

// assets/newIcons/auto_focus-large-line.svg
import * as React228 from "react";
import { jsx as jsx233 } from "react/jsx-runtime";
var SvgAutoFocusLargeLine = (props) => /* @__PURE__ */ jsx233("svg", { stroke: "black", width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx233("path", { d: "M21 7.5V5C21 3.89543 20.1046 3 19 3H16.5M21 16.5V19C21 20.1046 20.1046 21 19 21H16.5M3 16.5V19C3 20.1046 3.89543 21 5 21H7.5M3 7.5V5C3 3.89543 3.89543 3 5 3H7.5M6 15L8.57143 9L11.1429 15M6.91835 12.8572H10.2245M17.4999 9H13.7143V11.8333M13.7143 11.8333V15M13.7143 11.8333H16.898", stroke: "inherit", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }) });
var auto_focus_large_line_default = SvgAutoFocusLargeLine;

// assets/newIcons/bookmark-large-fill.svg
import * as React229 from "react";
import { jsx as jsx234 } from "react/jsx-runtime";
var SvgBookmarkLargeFill = (props) => /* @__PURE__ */ jsx234("svg", { width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "black", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx234("path", { d: "M7 2.25C5.48122 2.25 4.25 3.48122 4.25 5V21C4.25 21.2744 4.3998 21.5268 4.64061 21.6583C4.88141 21.7898 5.17478 21.7792 5.40556 21.6309L11.3241 17.8261C11.7358 17.5614 12.2642 17.5615 12.6759 17.8262L18.5944 21.6309C18.8252 21.7792 19.1186 21.7898 19.3594 21.6583C19.6002 21.5268 19.75 21.2744 19.75 21V5C19.75 3.48122 18.5188 2.25 17 2.25H7Z", fill: "inherit" }) });
var bookmark_large_fill_default = SvgBookmarkLargeFill;

// assets/newIcons/bookmark-large-line.svg
import * as React230 from "react";
import { jsx as jsx235 } from "react/jsx-runtime";
var SvgBookmarkLargeLine = (props) => /* @__PURE__ */ jsx235("svg", { stroke: "black", width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx235("path", { d: "M5 21V13V5C5 3.89543 5.89543 3 7 3H17C18.1046 3 19 3.89543 19 5V13V21L13.0815 17.1953C12.4227 16.7717 11.5773 16.7717 10.9185 17.1953L5 21Z", stroke: "inherit", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }) });
var bookmark_large_line_default = SvgBookmarkLargeLine;

// assets/newIcons/building_office1-large-fill.svg
import * as React231 from "react";
import { jsx as jsx236 } from "react/jsx-runtime";
var SvgBuildingOffice1LargeFill = (props) => /* @__PURE__ */ jsx236("svg", { width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "black", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx236("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M17 2.25C18.5188 2.25 19.75 3.48122 19.75 5V20.25H21L21.0771 20.2539C21.4551 20.2925 21.75 20.6118 21.75 21C21.75 21.3882 21.4551 21.7075 21.0771 21.7461L21 21.75H3C2.5858 21.75 2.25001 21.4142 2.25 21C2.25001 20.5858 2.58579 20.25 3 20.25H4.25V5C4.25 3.48122 5.48122 2.25 7 2.25H17ZM11 15C10.4477 15 10 15.4477 10 16V20.25H14V16C14 15.4477 13.5523 15 13 15H11ZM9 10.25C8.58579 10.25 8.25 10.5858 8.25 11C8.25002 11.4142 8.5858 11.75 9 11.75H10L10.0771 11.7461C10.4551 11.7075 10.75 11.3882 10.75 11C10.75 10.6118 10.4551 10.2925 10.0771 10.2539L10 10.25H9ZM14 10.25C13.5858 10.25 13.25 10.5858 13.25 11C13.25 11.4142 13.5858 11.75 14 11.75H15L15.0771 11.7461C15.4551 11.7075 15.75 11.3882 15.75 11C15.75 10.6118 15.4551 10.2925 15.0771 10.2539L15 10.25H14ZM9 6.25C8.58579 6.25 8.25 6.58579 8.25 7C8.25002 7.4142 8.5858 7.75 9 7.75H10C10.4142 7.75 10.75 7.4142 10.75 7C10.75 6.58579 10.4142 6.25 10 6.25H9ZM14 6.25C13.5858 6.25 13.25 6.58579 13.25 7C13.25 7.4142 13.5858 7.75 14 7.75H15C15.4142 7.75 15.75 7.4142 15.75 7C15.75 6.58579 15.4142 6.25 15 6.25H14Z", fill: "inherit" }) });
var building_office1_large_fill_default = SvgBuildingOffice1LargeFill;

// assets/newIcons/building_office1-large-line.svg
import * as React232 from "react";
import { jsx as jsx237 } from "react/jsx-runtime";
var SvgBuildingOffice1LargeLine = (props) => /* @__PURE__ */ jsx237("svg", { stroke: "black", width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx237("path", { d: "M19 21V5C19 3.89543 18.1046 3 17 3H7C5.89543 3 5 3.89543 5 5V21M19 21L21 21M19 21H14M5 21L3 21M5 21H10M9 6.99998H10M9 11H10M14 6.99998H15M14 11H15M10 21V16C10 15.4477 10.4477 15 11 15H13C13.5523 15 14 15.4477 14 16V21M10 21H14", stroke: "inherit", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }) });
var building_office1_large_line_default = SvgBuildingOffice1LargeLine;

// assets/newIcons/building_office2-large-line.svg
import * as React233 from "react";
import { jsx as jsx238 } from "react/jsx-runtime";
var SvgBuildingOffice2LargeLine = (props) => /* @__PURE__ */ jsx238("svg", { stroke: "black", width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx238("path", { d: "M3 20H21M5 20V6C5 4.89543 5.89543 4 7 4H15C16.1046 4 17 4.89543 17 6V11M17 11H14C12.8954 11 12 11.8954 12 13V20H19V13C19 11.8954 18.1046 11 17 11ZM8 8H9M8 12H9M8 16H9M15.5 20V16", stroke: "inherit", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }) });
var building_office2_large_line_default = SvgBuildingOffice2LargeLine;

// assets/newIcons/building_office3-large-line.svg
import * as React234 from "react";
import { jsx as jsx239 } from "react/jsx-runtime";
var SvgBuildingOffice3LargeLine = (props) => /* @__PURE__ */ jsx239("svg", { stroke: "black", width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx239("path", { d: "M17 11H18C19.1 11 20 11.9 20 13V21H21H13.5M3 21H4M4 21V13C4 11.9 4.9 11 6 11H7M4 21H7M7 11C7 14.8682 7 17.1095 7 21M7 11C7 10.114 7 6.77371 7 6M7 11V21M7 21H10.5M7 6C7 4.9 7.9 4 9 4H15C16.1 4 17 4.9 17 6V21H13.5M7 6C7 5.06559 7 7.07623 7 6ZM13.5 21V16C13.5 15.45 13.05 15 12.5 15H11.5C10.95 15 10.5 15.45 10.5 16V21M13.5 21H10.5M10 8H10.5M10 11H10.5M13.5 8H14M13.5 11H14", stroke: "inherit", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }) });
var building_office3_large_line_default = SvgBuildingOffice3LargeLine;

// assets/newIcons/calendar-large-line.svg
import * as React235 from "react";
import { jsx as jsx240 } from "react/jsx-runtime";
var SvgCalendarLargeLine = (props) => /* @__PURE__ */ jsx240("svg", { stroke: "black", width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx240("path", { d: "M8 5H5C3.89543 5 3 5.89543 3 7V9.5M8 5V3M8 5H16M16 5H19C20.1046 5 21 5.89543 21 7V9.5M16 5V3M3 9.5V17C3 18.1046 3.89543 19 5 19H19C20.1046 19 21 18.1046 21 17V9.5M3 9.5H21", stroke: "inherit", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }) });
var calendar_large_line_default = SvgCalendarLargeLine;

// assets/newIcons/camera_dome_cloud-large-line.svg
import * as React236 from "react";
import { jsx as jsx241 } from "react/jsx-runtime";
var SvgCameraDomeCloudLargeLine = (props) => /* @__PURE__ */ jsx241("svg", { stroke: "black", width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx241("path", { d: "M20 9L20.9594 6.45682C21.1488 5.72675 20.6512 5 19.9619 5H4.03811C3.34883 5 2.85119 5.72675 3.04055 6.45683L4 9M20 9H4M20 9V11.381C20 11.4351 19.9994 11.4961 19.9982 11.55M4 9V11.381C4 14.9311 6.54955 17.9142 10 18.76C10.0994 18.7843 10.1995 18.8069 10.3004 18.8277M10.7012 15.5178C10.2726 15.1503 10 14.6054 10 14C10 12.9 10.9 12 12 12C12.5697 12 13.0858 12.2414 13.451 12.627M15.025 20C13.9066 20 13 19.1366 13 18.0714C13 17.1299 13.7084 16.346 14.6452 16.1767C14.7568 16.1566 14.848 16.0729 14.876 15.963C15.163 14.8365 16.2289 14 17.5 14C18.7711 14 19.837 14.8365 20.124 15.963C20.152 16.0729 20.2432 16.1566 20.3548 16.1767C21.2916 16.346 22 17.1299 22 18.0714C22 19.1366 21.0934 20 19.975 20C17.9996 20 16.7545 20 15.025 20Z", stroke: "inherit", strokeWidth: 1.5, strokeLinecap: "round" }) });
var camera_dome_cloud_large_line_default = SvgCameraDomeCloudLargeLine;

// assets/newIcons/camera_dome-large-line.svg
import * as React237 from "react";
import { jsx as jsx242 } from "react/jsx-runtime";
var SvgCameraDomeLargeLine = (props) => /* @__PURE__ */ jsx242("svg", { stroke: "black", width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx242("path", { d: "M20 9L20.9594 6.45682C21.1488 5.72675 20.6512 5 19.9619 5H4.03811C3.34883 5 2.85119 5.72675 3.04055 6.45683L4 9M20 9H4M20 9V11.381C20 15.5888 16.4183 19 12 19C7.58172 19 4 15.5888 4 11.381V9M14 14C14 15.1 13.1 16 12 16C10.9 16 10 15.1 10 14C10 12.9 10.9 12 12 12C13.1 12 14 12.9 14 14Z", stroke: "inherit", strokeWidth: 1.5, strokeLinecap: "round" }) });
var camera_dome_large_line_default = SvgCameraDomeLargeLine;

// assets/newIcons/camera_external-large-line.svg
import * as React238 from "react";
import { jsx as jsx243 } from "react/jsx-runtime";
var SvgCameraExternalLargeLine = (props) => /* @__PURE__ */ jsx243("svg", { stroke: "black", width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx243("path", { d: "M20 9L20.9594 6.45682C21.1488 5.72675 20.6512 5 19.9619 5H4.03811C3.34883 5 2.85119 5.72675 3.04055 6.45683L4 9M20 9H4M20 9V11.381C20 12.1277 19.8872 12.8494 19.6769 13.5314M4 9V11.381C4 14.854 6.43992 17.7842 9.77631 18.7018M10.8032 15.5997C10.3163 15.234 10 14.6522 10 14C10 12.9 10.9 12 12 12C12.7364 12 13.3831 12.4033 13.7303 13C13.7671 13.0634 13.8006 13.129 13.8305 13.1964M14.5 16L13 17.5L14.5 19M20.5 16L22 17.5L20.5 19M18.5 15.5L16.5 19.5", stroke: "inherit", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }) });
var camera_external_large_line_default = SvgCameraExternalLargeLine;

// assets/newIcons/camera_fisheye-large-line.svg
import * as React239 from "react";
import { jsx as jsx244 } from "react/jsx-runtime";
var SvgCameraFisheyeLargeLine = (props) => /* @__PURE__ */ jsx244("svg", { stroke: "black", width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx244("path", { d: "M20 9L20.9594 6.45682C21.1488 5.72675 20.6512 5 19.9619 5H4.03811C3.34883 5 2.85119 5.72675 3.04055 6.45683L4 9M20 9H4M20 9V11.381C20 12.1277 19.8872 12.8494 19.6769 13.5314M4 9V11.381C4 14.854 6.43992 17.7842 9.77631 18.7018M10.8032 15.5997C10.3163 15.234 10 14.6522 10 14C10 12.9 10.9 12 12 12C12.7364 12 13.3831 12.4033 13.7303 13C13.7671 13.0634 13.8006 13.129 13.8305 13.1964M12.5 17.9971L12.5 17.9985M12.5 17.9985C12.5026 18.1551 13.4994 20.494 16.0212 20.494C16.0212 20.494 18.5968 20.6883 20.3862 17.9985M12.5 17.9985L12.5 18M12.5 17.9985C12.5026 17.842 13.4994 15.5031 16.0212 15.5031C16.0212 15.5031 18.5968 15.3087 20.3862 17.9985M20.3862 17.9985C20.8186 17.3486 21.2051 16.5303 21.4982 15.5002M20.3862 17.9985C20.8186 18.6485 21.2051 19.4668 21.4982 20.4969", stroke: "inherit", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }) });
var camera_fisheye_large_line_default = SvgCameraFisheyeLargeLine;

// assets/newIcons/camera_MDC-large-line.svg
import * as React240 from "react";
import { jsx as jsx245 } from "react/jsx-runtime";
var SvgCameraMdcLargeLine = (props) => /* @__PURE__ */ jsx245("svg", { stroke: "black", width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx245("path", { d: "M21 10L21.9594 7.45682C22.1488 6.72675 21.6512 6 20.9619 6H3.03811C2.34883 6 1.85119 6.72675 2.04055 7.45683L3 10M21 10H3M21 10V14C21 16.2091 19.2091 18 17 18H7C4.79086 18 3 16.2091 3 14V10M7.75 13.75C7.75 14.3 7.4125 14.75 7 14.75C6.5875 14.75 6.25 14.3 6.25 13.75C6.25 13.2 6.5875 12.75 7 12.75C7.4125 12.75 7.75 13.2 7.75 13.75ZM12.75 13.75C12.75 14.3 12.4125 14.75 12 14.75C11.5875 14.75 11.25 14.3 11.25 13.75C11.25 13.2 11.5875 12.75 12 12.75C12.4125 12.75 12.75 13.2 12.75 13.75ZM17.75 13.75C17.75 14.3 17.4125 14.75 17 14.75C16.5875 14.75 16.25 14.3 16.25 13.75C16.25 13.2 16.5875 12.75 17 12.75C17.4125 12.75 17.75 13.2 17.75 13.75Z", stroke: "inherit", strokeWidth: 1.5, strokeLinecap: "round" }) });
var camera_MDC_large_line_default = SvgCameraMdcLargeLine;

// assets/newIcons/camera_PTZ-large-line.svg
import * as React241 from "react";
import { jsx as jsx246 } from "react/jsx-runtime";
var SvgCameraPtzLargeLine = (props) => /* @__PURE__ */ jsx246("svg", { stroke: "black", width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx246("path", { d: "M20 9L20.9594 6.45682C21.1488 5.72675 20.6512 5 19.9619 5H4.03811C3.34883 5 2.85119 5.72675 3.04055 6.45683L4 9M20 9H4M20 9V10.75M4 9V11.381C4 14.8449 6.4272 17.7689 9.7502 18.6946M10.483 15.2997C10.1823 14.9495 10 14.495 10 14C10 12.9 10.9 12 12 12C12.5322 12 13.0176 12.2107 13.3769 12.5527M14.5 16.5L13 18L14.5 19.5M21.5 19.5L23 18L21.5 16.5M19.5 14.5L18 13L16.5 14.5M16.5 21.5L18 23L19.5 21.5M18 18.75C18.4142 18.75 18.75 18.4142 18.75 18C18.75 17.5858 18.4142 17.25 18 17.25C17.5858 17.25 17.25 17.5858 17.25 18C17.25 18.4142 17.5858 18.75 18 18.75Z", stroke: "inherit", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }) });
var camera_PTZ_large_line_default = SvgCameraPtzLargeLine;

// assets/newIcons/camera_tamp-large-line.svg
import * as React242 from "react";
import { jsx as jsx247 } from "react/jsx-runtime";
var SvgCameraTampLargeLine = (props) => /* @__PURE__ */ jsx247("svg", { stroke: "black", width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx247("path", { d: "M20 14H22M20 14C20 13.1716 19.3284 12.5 18.5 12.5C17.6716 12.5 17 13.1716 17 14V18.0029C16.3936 18.4591 16 19.1828 16 20C16 21.3807 17.1193 22.5 18.5 22.5C19.8807 22.5 21 21.3807 21 20C21 19.1828 20.6064 18.4591 20 18.0029V14ZM20 16.5H22M20 9L20.9594 6.45682C21.1488 5.72675 20.6512 5 19.9619 5H4.03811C3.34883 5 2.85119 5.72675 3.04055 6.45683L4 9M20 9H4M20 9V10.3M4 9V11.381C4 15.5888 7.58172 19 12 19C12.5631 19 13.1126 18.9446 13.6428 18.8392M18.5 20H18.5085V20.0085H18.5V20ZM14 14C14 15.1 13.1 16 12 16C10.9 16 10 15.1 10 14C10 12.9 10.9 12 12 12C13.1 12 14 12.9 14 14Z", stroke: "inherit", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }) });
var camera_tamp_large_line_default = SvgCameraTampLargeLine;

// assets/newIcons/certification-large-line.svg
import * as React243 from "react";
import { jsx as jsx248 } from "react/jsx-runtime";
var SvgCertificationLargeLine = (props) => /* @__PURE__ */ jsx248("svg", { stroke: "black", width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx248("path", { d: "M7.5 14.5V21L12 19L16.5 21V14.5M18.5 9.5C18.5 13.0899 15.5899 16 12 16C8.41015 16 5.5 13.0899 5.5 9.5C5.5 5.91015 8.41015 3 12 3C15.5899 3 18.5 5.91015 18.5 9.5ZM14 9.5C14 10.6046 13.1046 11.5 12 11.5C10.8954 11.5 10 10.6046 10 9.5C10 8.39543 10.8954 7.5 12 7.5C13.1046 7.5 14 8.39543 14 9.5Z", stroke: "inherit", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }) });
var certification_large_line_default = SvgCertificationLargeLine;

// assets/newIcons/cgi_sender-large-line.svg
import * as React244 from "react";
import { jsx as jsx249 } from "react/jsx-runtime";
var SvgCgiSenderLargeLine = (props) => /* @__PURE__ */ jsx249("svg", { stroke: "black", width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx249("path", { d: "M15.5 14.5L18 12L15.5 9.5M8.5 9.5L6 12L8.5 14.5M13 7.5L11 16.5M7.8 21H16.2C17.8802 21 18.7202 21 19.362 20.673C19.9265 20.3854 20.3854 19.9265 20.673 19.362C21 18.7202 21 17.8802 21 16.2V7.8C21 6.11984 21 5.27976 20.673 4.63803C20.3854 4.07354 19.9265 3.6146 19.362 3.32698C18.7202 3 17.8802 3 16.2 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V16.2C3 17.8802 3 18.7202 3.32698 19.362C3.6146 19.9265 4.07354 20.3854 4.63803 20.673C5.27976 21 6.11984 21 7.8 21Z", stroke: "inherit", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }) });
var cgi_sender_large_line_default = SvgCgiSenderLargeLine;

// assets/newIcons/chat_support-large-line.svg
import * as React245 from "react";
import { jsx as jsx250 } from "react/jsx-runtime";
var SvgChatSupportLargeLine = (props) => /* @__PURE__ */ jsx250("svg", { stroke: "black", width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx250("path", { d: "M7 8.5H12M7 12H15M3 5C3 3.89543 3.89543 3 5 3H19C20.1046 3 21 3.89543 21 5V16C21 17.1046 20.1046 18 19 18H12.1429L7.80697 21.3724C7.47854 21.6278 7 21.3938 7 20.9777V18H5C3.89543 18 3 17.1046 3 16V5Z", stroke: "inherit", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }) });
var chat_support_large_line_default = SvgChatSupportLargeLine;

// assets/newIcons/check-large-line.svg
import * as React246 from "react";
import { jsx as jsx251 } from "react/jsx-runtime";
var SvgCheckLargeLine = (props) => /* @__PURE__ */ jsx251("svg", { stroke: "black", width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx251("path", { d: "M20 6L9 17L4 12", stroke: "inherit", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }) });
var check_large_line_default = SvgCheckLargeLine;

// assets/newIcons/close-large-line.svg
import * as React247 from "react";
import { jsx as jsx252 } from "react/jsx-runtime";
var SvgCloseLargeLine = (props) => /* @__PURE__ */ jsx252("svg", { stroke: "black", width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx252("path", { d: "M3 3L21 21M21 3L3 21", stroke: "inherit", strokeWidth: 1.5, strokeLinecap: "round" }) });
var close_large_line_default = SvgCloseLargeLine;

// assets/newIcons/cloud_upload-large-line.svg
import * as React248 from "react";
import { jsx as jsx253 } from "react/jsx-runtime";
var SvgCloudUploadLargeLine = (props) => /* @__PURE__ */ jsx253("svg", { stroke: "black", width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx253("path", { d: "M4 16.2422C2.79401 15.435 2 14.0602 2 12.5C2 10.1564 3.79151 8.23129 6.07974 8.01937C6.54781 5.17213 9.02024 3 12 3C14.9798 3 17.4522 5.17213 17.9203 8.01937C20.2085 8.23129 22 10.1564 22 12.5C22 14.0602 21.206 15.435 20 16.2422M8 16L12 12M12 12L16 16M12 12V21", stroke: "inherit", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }) });
var cloud_upload_large_line_default = SvgCloudUploadLargeLine;

// assets/newIcons/copy-large-line.svg
import * as React249 from "react";
import { jsx as jsx254 } from "react/jsx-runtime";
var SvgCopyLargeLine = (props) => /* @__PURE__ */ jsx254("svg", { stroke: "black", width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx254("path", { d: "M8 7V5C8 3.89543 8.89543 3 10 3H18C19.1046 3 20 3.89543 20 5V15C20 16.1046 19.1046 17 18 17H16M14 7H6C4.89543 7 4 7.89543 4 9V19C4 20.1046 4.89543 21 6 21H14C15.1046 21 16 20.1046 16 19V9C16 7.89543 15.1046 7 14 7Z", stroke: "inherit", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }) });
var copy_large_line_default = SvgCopyLargeLine;

// assets/newIcons/cpu-large-line.svg
import * as React250 from "react";
import { jsx as jsx255 } from "react/jsx-runtime";
var SvgCpuLargeLine = (props) => /* @__PURE__ */ jsx255("svg", { stroke: "black", width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx255("path", { d: "M9 5V3M15 5V3M9 19V21M15 19V21M19 14H21M19 9H21M5 9H3M5 14H3M10 15H14C14.5523 15 15 14.5523 15 14V10C15 9.44772 14.5523 9 14 9H10C9.44772 9 9 9.44772 9 10V14C9 14.5523 9.44772 15 10 15ZM7 19H17C18.1046 19 19 18.1046 19 17V7C19 5.89543 18.1046 5 17 5H7C5.89543 5 5 5.89543 5 7V17C5 18.1046 5.89543 19 7 19Z", stroke: "inherit", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }) });
var cpu_large_line_default = SvgCpuLargeLine;

// assets/newIcons/crowd_counting-large-line.svg
import * as React251 from "react";
import { jsx as jsx256 } from "react/jsx-runtime";
var SvgCrowdCountingLargeLine = (props) => /* @__PURE__ */ jsx256("svg", { stroke: "black", width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx256("path", { d: "M6 20.5V19C6 16.7909 7.79086 15 10 15H14M1.5 20.5V19.3636C1.5 16.9537 3.5 15 4.5 15M8.5 4C7.64183 4.22741 6.88119 4.74395 6.33801 5.46819C5.79483 6.19243 5.5 7.08318 5.5 8C5.5 8.91682 5.79483 9.80757 6.33801 10.5318C6.88119 11.256 7.64183 11.7726 8.5 12M18 15H22M22 15V19M22 15L17.5 19.5L15.5 17.5L12.5 20.5M10 8C10 10.2091 11.7909 12 14 12C16.2091 12 18 10.2091 18 8C18 5.79086 16.2091 4 14 4C11.7909 4 10 5.79086 10 8Z", stroke: "inherit", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }) });
var crowd_counting_large_line_default = SvgCrowdCountingLargeLine;

// assets/newIcons/dashboard-large-line.svg
import * as React252 from "react";
import { jsx as jsx257 } from "react/jsx-runtime";
var SvgDashboardLargeLine = (props) => /* @__PURE__ */ jsx257("svg", { stroke: "black", width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx257("path", { d: "M9 5L9 19M9 10L21 10M5 19H19C20.1046 19 21 18.1046 21 17V7C21 5.89543 20.1046 5 19 5H5C3.89543 5 3 5.89543 3 7V17C3 18.1046 3.89543 19 5 19Z", stroke: "inherit", strokeWidth: 1.5 }) });
var dashboard_large_line_default = SvgDashboardLargeLine;

// assets/newIcons/dashboards-large-line.svg
import * as React253 from "react";
import { jsx as jsx258, jsxs as jsxs62 } from "react/jsx-runtime";
var SvgDashboardsLargeLine = (props) => /* @__PURE__ */ jsxs62("svg", { stroke: "black", width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: [
  /* @__PURE__ */ jsx258("path", { d: "M4 6C4 4.89543 4.89543 4 6 4H8.5C9.60457 4 10.5 4.89543 10.5 6V8.5C10.5 9.60457 9.60457 10.5 8.5 10.5H6C4.89543 10.5 4 9.60457 4 8.5V6Z", stroke: "inherit", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }),
  /* @__PURE__ */ jsx258("path", { d: "M4 15.5C4 14.3954 4.89543 13.5 6 13.5H8.5C9.60457 13.5 10.5 14.3954 10.5 15.5V18C10.5 19.1046 9.60457 20 8.5 20H6C4.89543 20 4 19.1046 4 18V15.5Z", stroke: "inherit", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }),
  /* @__PURE__ */ jsx258("path", { d: "M13.5 6C13.5 4.89543 14.3954 4 15.5 4H18C19.1046 4 20 4.89543 20 6V8.5C20 9.60457 19.1046 10.5 18 10.5H15.5C14.3954 10.5 13.5 9.60457 13.5 8.5V6Z", stroke: "inherit", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }),
  /* @__PURE__ */ jsx258("path", { d: "M13.5 15.5C13.5 14.3954 14.3954 13.5 15.5 13.5H18C19.1046 13.5 20 14.3954 20 15.5V18C20 19.1046 19.1046 20 18 20H15.5C14.3954 20 13.5 19.1046 13.5 18V15.5Z", stroke: "inherit", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" })
] });
var dashboards_large_line_default = SvgDashboardsLargeLine;

// assets/newIcons/defocus-large-line.svg
import * as React254 from "react";
import { jsx as jsx259, jsxs as jsxs63 } from "react/jsx-runtime";
var SvgDefocusLargeLine = (props) => /* @__PURE__ */ jsxs63("svg", { stroke: "black", width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: [
  /* @__PURE__ */ jsx259("path", { d: "M13.25 9.99974C13.25 9.58552 13.5858 9.24974 14 9.24974C14.4142 9.24974 14.75 9.58552 14.75 9.99974C14.75 10.4139 14.4142 10.7497 14 10.7497C13.5858 10.7497 13.25 10.4139 13.25 9.99974Z", fill: "inherit" }),
  /* @__PURE__ */ jsx259("path", { d: "M13.25 13.9997C13.25 13.5855 13.5858 13.2497 14 13.2497C14.4142 13.2497 14.75 13.5855 14.75 13.9997C14.75 14.4139 14.4142 14.7497 14 14.7497C13.5858 14.7497 13.25 14.4139 13.25 13.9997Z", fill: "inherit" }),
  /* @__PURE__ */ jsx259("path", { d: "M9.25 13.9997C9.25 13.5855 9.58579 13.2497 10 13.2497C10.4142 13.2497 10.75 13.5855 10.75 13.9997C10.75 14.4139 10.4142 14.7497 10 14.7497C9.58579 14.7497 9.25 14.4139 9.25 13.9997Z", fill: "inherit" }),
  /* @__PURE__ */ jsx259("path", { d: "M9.25 9.99974C9.25 9.58552 9.58579 9.24974 10 9.24974C10.4142 9.24974 10.75 9.58552 10.75 9.99974C10.75 10.4139 10.4142 10.7497 10 10.7497C9.58579 10.7497 9.25 10.4139 9.25 9.99974Z", fill: "inherit" }),
  /* @__PURE__ */ jsx259("path", { d: "M10 5.99974H10.005M18 9.99974V10.0047M10 17.9997H10.005M6 9.99974V10.0047M14 5.99974H14.005M18 13.9997V14.0047M14 17.9997H14.005M6 13.9997V14.0047M10 6.24974C9.86193 6.24974 9.75 6.13781 9.75 5.99974C9.75 5.86166 9.86193 5.74974 10 5.74974C10.1381 5.74974 10.25 5.86166 10.25 5.99974C10.25 6.13781 10.1381 6.24974 10 6.24974ZM17.75 9.99974C17.75 9.86166 17.8619 9.74974 18 9.74974C18.1381 9.74974 18.25 9.86166 18.25 9.99974C18.25 10.1378 18.1381 10.2497 18 10.2497C17.8619 10.2497 17.75 10.1378 17.75 9.99974ZM10 18.2497C9.86193 18.2497 9.75 18.1378 9.75 17.9997C9.75 17.8617 9.86193 17.7497 10 17.7497C10.1381 17.7497 10.25 17.8617 10.25 17.9997C10.25 18.1378 10.1381 18.2497 10 18.2497ZM5.75 9.99974C5.75 9.86166 5.86193 9.74974 6 9.74974C6.13807 9.74974 6.25 9.86166 6.25 9.99974C6.25 10.1378 6.13807 10.2497 6 10.2497C5.86193 10.2497 5.75 10.1378 5.75 9.99974ZM14 6.24974C13.8619 6.24974 13.75 6.13781 13.75 5.99974C13.75 5.86166 13.8619 5.74974 14 5.74974C14.1381 5.74974 14.25 5.86166 14.25 5.99974C14.25 6.13781 14.1381 6.24974 14 6.24974ZM17.75 13.9997C17.75 13.8617 17.8619 13.7497 18 13.7497C18.1381 13.7497 18.25 13.8617 18.25 13.9997C18.25 14.1378 18.1381 14.2497 18 14.2497C17.8619 14.2497 17.75 14.1378 17.75 13.9997ZM14 18.2497C13.8619 18.2497 13.75 18.1378 13.75 17.9997C13.75 17.8617 13.8619 17.7497 14 17.7497C14.1381 17.7497 14.25 17.8617 14.25 17.9997C14.25 18.1378 14.1381 18.2497 14 18.2497ZM5.75 13.9997C5.75 13.8617 5.86193 13.7497 6 13.7497C6.13807 13.7497 6.25 13.8617 6.25 13.9997C6.25 14.1378 6.13807 14.2497 6 14.2497C5.86193 14.2497 5.75 14.1378 5.75 13.9997ZM10 2.99974V2.99121H10.0085V2.99974H10ZM21 9.99095H21.0085V9.99947H21V9.99095ZM10 20.9997V20.9912H10.0085V20.9997H10ZM3 9.99095H3.00852V9.99947H3L3 9.99095ZM14 2.99974V2.99121H14.0085V2.99974H14ZM21 13.9909H21.0085V13.9995H21V13.9909ZM14 20.9997V20.9912H14.0085V20.9997H14ZM3 13.9909H3.00852V13.9995H3L3 13.9909ZM6 5.99095H6.00852V5.99947H6V5.99095ZM18 5.99095H18.0085V5.99947H18V5.99095ZM18 17.9997H18.0085V18.0083H18V17.9997ZM6 17.9997H6.00852V18.0083H6V17.9997ZM14 10.7497C13.5858 10.7497 13.25 10.4139 13.25 9.99974C13.25 9.58552 13.5858 9.24974 14 9.24974C14.4142 9.24974 14.75 9.58552 14.75 9.99974C14.75 10.4139 14.4142 10.7497 14 10.7497ZM14 14.7497C13.5858 14.7497 13.25 14.4139 13.25 13.9997C13.25 13.5855 13.5858 13.2497 14 13.2497C14.4142 13.2497 14.75 13.5855 14.75 13.9997C14.75 14.4139 14.4142 14.7497 14 14.7497ZM10 14.7497C9.58579 14.7497 9.25 14.4139 9.25 13.9997C9.25 13.5855 9.58579 13.2497 10 13.2497C10.4142 13.2497 10.75 13.5855 10.75 13.9997C10.75 14.4139 10.4142 14.7497 10 14.7497ZM10 10.7497C9.58579 10.7497 9.25 10.4139 9.25 9.99974C9.25 9.58552 9.58579 9.24974 10 9.24974C10.4142 9.24974 10.75 9.58552 10.75 9.99974C10.75 10.4139 10.4142 10.7497 10 10.7497Z", stroke: "inherit", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" })
] });
var defocus_large_line_default = SvgDefocusLargeLine;

// assets/newIcons/device-large-line.svg
import * as React255 from "react";
import { jsx as jsx260 } from "react/jsx-runtime";
var SvgDeviceLargeLine = (props) => /* @__PURE__ */ jsx260("svg", { stroke: "black", width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx260("path", { d: "M7.49997 11L3.31235 7.64993C2.98497 7.38803 2.5 7.62111 2.5 8.04037V15.9597C2.5 16.379 2.98497 16.6121 3.31235 16.3502L7.49997 13M19.5 18H9.49997C8.3954 18 7.49997 17.1046 7.49997 16V8C7.49997 6.89543 8.3954 6 9.49997 6H19.5C20.6045 6 21.5 6.89543 21.5 8V16C21.5 17.1046 20.6045 18 19.5 18Z", stroke: "inherit", strokeWidth: 1.5 }) });
var device_large_line_default = SvgDeviceLargeLine;

// assets/newIcons/direction-large-line.svg
import * as React256 from "react";
import { jsx as jsx261 } from "react/jsx-runtime";
var SvgDirectionLargeLine = (props) => /* @__PURE__ */ jsx261("svg", { stroke: "black", width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx261("path", { d: "M21 19.4516L20.4375 16.7097M21 19.4516L18.1875 20M21 19.4516L14.25 14.495M3 19.4516L5.8125 20M3 19.4516L3.5625 16.7097M3 19.4516L9.75 14.495M12 3L9.75 5.19355M12 3L14.25 5.19355M12 3V10.3821", stroke: "inherit", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }) });
var direction_large_line_default = SvgDirectionLargeLine;

// assets/newIcons/document-large-line.svg
import * as React257 from "react";
import { jsx as jsx262 } from "react/jsx-runtime";
var SvgDocumentLargeLine = (props) => /* @__PURE__ */ jsx262("svg", { stroke: "black", width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx262("path", { d: "M19 9H13.8974C13.4018 9 13 8.6269 13 8.16667V3M7 21H17C18.1046 21 19 20.1046 19 19V8.82843C19 8.29799 18.7893 7.78929 18.4142 7.41421L14.5858 3.58579C14.2107 3.21071 13.702 3 13.1716 3H7C5.89543 3 5 3.89543 5 5V19C5 20.1046 5.89543 21 7 21Z", stroke: "inherit", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }) });
var document_large_line_default = SvgDocumentLargeLine;

// assets/newIcons/download_import-large-line.svg
import * as React258 from "react";
import { jsx as jsx263 } from "react/jsx-runtime";
var SvgDownloadImportLargeLine = (props) => /* @__PURE__ */ jsx263("svg", { stroke: "black", width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx263("path", { d: "M17 11L12 16M12 16L7 11M12 16V4M20 16V18C20 19.1046 19.1046 20 18 20H6C4.89543 20 4 19.1046 4 18V16", stroke: "inherit", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }) });
var download_import_large_line_default = SvgDownloadImportLargeLine;

// assets/newIcons/drag-large-line.svg
import * as React259 from "react";
import { jsx as jsx264, jsxs as jsxs64 } from "react/jsx-runtime";
var SvgDragLargeLine = (props) => /* @__PURE__ */ jsxs64("svg", { stroke: "black", width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: [
  /* @__PURE__ */ jsx264("path", { d: "M9.5 5.75C9.5 6.16421 9.16421 6.5 8.75 6.5C8.33579 6.5 8 6.16421 8 5.75C8 5.33579 8.33579 5 8.75 5C9.16421 5 9.5 5.33579 9.5 5.75Z", stroke: "inherit", strokeWidth: 1.5 }),
  /* @__PURE__ */ jsx264("path", { d: "M9.5 18.25C9.5 18.6642 9.16421 19 8.75 19C8.33579 19 8 18.6642 8 18.25C8 17.8358 8.33579 17.5 8.75 17.5C9.16421 17.5 9.5 17.8358 9.5 18.25Z", stroke: "inherit", strokeWidth: 1.5 }),
  /* @__PURE__ */ jsx264("path", { d: "M9.5 12C9.5 12.4142 9.16421 12.75 8.75 12.75C8.33579 12.75 8 12.4142 8 12C8 11.5858 8.33579 11.25 8.75 11.25C9.16421 11.25 9.5 11.5858 9.5 12Z", stroke: "inherit", strokeWidth: 1.5 }),
  /* @__PURE__ */ jsx264("path", { d: "M16 5.75C16 6.16421 15.6642 6.5 15.25 6.5C14.8358 6.5 14.5 6.16421 14.5 5.75C14.5 5.33579 14.8358 5 15.25 5C15.6642 5 16 5.33579 16 5.75Z", stroke: "inherit", strokeWidth: 1.5 }),
  /* @__PURE__ */ jsx264("path", { d: "M16 18.25C16 18.6642 15.6642 19 15.25 19C14.8358 19 14.5 18.6642 14.5 18.25C14.5 17.8358 14.8358 17.5 15.25 17.5C15.6642 17.5 16 17.8358 16 18.25Z", stroke: "inherit", strokeWidth: 1.5 }),
  /* @__PURE__ */ jsx264("path", { d: "M16 12C16 12.4142 15.6642 12.75 15.25 12.75C14.8358 12.75 14.5 12.4142 14.5 12C14.5 11.5858 14.8358 11.25 15.25 11.25C15.6642 11.25 16 11.5858 16 12Z", stroke: "inherit", strokeWidth: 1.5 })
] });
var drag_large_line_default = SvgDragLargeLine;

// assets/newIcons/edit-large-line.svg
import * as React260 from "react";
import { jsx as jsx265 } from "react/jsx-runtime";
var SvgEditLargeLine = (props) => /* @__PURE__ */ jsx265("svg", { stroke: "black", width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx265("path", { d: "M14.2513 5.74302L18.5 10M19.6061 4.8684C18.3992 3.72495 16.4417 3.70589 15.2145 4.83981L4.56274 14.8282C4.4851 14.901 4.43272 14.9967 4.41322 15.1013L3.6329 19.2871C3.56873 19.6313 3.86905 19.9331 4.21355 19.8707L8.72022 19.0544C8.81494 19.0372 8.90269 18.9931 8.97294 18.9273L19.5757 8.99433C20.7928 7.86041 20.813 6.02137 19.6061 4.8684Z", stroke: "inherit", strokeWidth: 1.5, strokeMiterlimit: 10, strokeLinejoin: "round" }) });
var edit_large_line_default = SvgEditLargeLine;

// assets/newIcons/email-large-line.svg
import * as React261 from "react";
import { jsx as jsx266 } from "react/jsx-runtime";
var SvgEmailLargeLine = (props) => /* @__PURE__ */ jsx266("svg", { stroke: "black", width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx266("path", { d: "M3 7L10.7721 13.045C11.4943 13.6067 12.5057 13.6067 13.2279 13.045L21 7M5 19H19C20.1046 19 21 18.1046 21 17V7C21 5.89543 20.1046 5 19 5H5C3.89543 5 3 5.89543 3 7V17C3 18.1046 3.89543 19 5 19Z", stroke: "inherit", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }) });
var email_large_line_default = SvgEmailLargeLine;

// assets/newIcons/empty-large-line.svg
import * as React262 from "react";
import { jsx as jsx267 } from "react/jsx-runtime";
var SvgEmptyLargeLine = (props) => /* @__PURE__ */ jsx267("svg", { stroke: "black", width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx267("circle", { cx: 12, cy: 12, r: 9, stroke: "inherit", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", strokeDasharray: "0.1 2 0.1 2" }) });
var empty_large_line_default = SvgEmptyLargeLine;

// assets/newIcons/encoder-large-line.svg
import * as React263 from "react";
import { jsx as jsx268 } from "react/jsx-runtime";
var SvgEncoderLargeLine = (props) => /* @__PURE__ */ jsx268("svg", { stroke: "black", width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx268("path", { d: "M7 12H10M14 12H14.01M17 12H17.01M21 17V9C21 7.89543 20.1046 7 19 7H5C3.89543 7 3 7.89543 3 9V17M21 17H3M21 17H23M3 17H1", stroke: "inherit", strokeWidth: 1.5, strokeLinecap: "round" }) });
var encoder_large_line_default = SvgEncoderLargeLine;

// assets/newIcons/error-large-fill.svg
import * as React264 from "react";
import { jsx as jsx269 } from "react/jsx-runtime";
var SvgErrorLargeFill = (props) => /* @__PURE__ */ jsx269("svg", { width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "black", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx269("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2.25 12C2.25 6.61522 6.61522 2.25 12 2.25C17.3848 2.25 21.75 6.61522 21.75 12C21.75 17.3848 17.3848 21.75 12 21.75C6.61522 21.75 2.25 17.3848 2.25 12ZM12.75 8C12.75 7.58579 12.4142 7.25 12 7.25C11.5858 7.25 11.25 7.58579 11.25 8L11.25 12C11.25 12.4142 11.5858 12.75 12 12.75C12.4142 12.75 12.75 12.4142 12.75 12L12.75 8ZM12 14.25C11.3096 14.25 10.75 14.8096 10.75 15.5C10.75 16.1904 11.3096 16.75 12 16.75C12.6904 16.75 13.25 16.1904 13.25 15.5C13.25 14.8096 12.6904 14.25 12 14.25Z", fill: "inherit" }) });
var error_large_fill_default = SvgErrorLargeFill;

// assets/newIcons/error-large-line.svg
import * as React265 from "react";
import { jsx as jsx270 } from "react/jsx-runtime";
var SvgErrorLargeLine = (props) => /* @__PURE__ */ jsx270("svg", { stroke: "black", width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx270("path", { d: "M12 15.5H11.99M12 8L12 12M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12ZM11.5 15.5C11.5 15.2239 11.7239 15 12 15C12.2761 15 12.5 15.2239 12.5 15.5C12.5 15.7761 12.2761 16 12 16C11.7239 16 11.5 15.7761 11.5 15.5Z", stroke: "inherit", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }) });
var error_large_line_default = SvgErrorLargeLine;

// assets/newIcons/event-large-line.svg
import * as React266 from "react";
import { jsx as jsx271 } from "react/jsx-runtime";
var SvgEventLargeLine = (props) => /* @__PURE__ */ jsx271("svg", { stroke: "black", width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx271("path", { d: "M5 14L12.5 1.5V10H19L11.5 22.5V14H5Z", stroke: "inherit", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }) });
var event_large_line_default = SvgEventLargeLine;

// assets/newIcons/external_link-large-line.svg
import * as React267 from "react";
import { jsx as jsx272 } from "react/jsx-runtime";
var SvgExternalLinkLargeLine = (props) => /* @__PURE__ */ jsx272("svg", { stroke: "black", width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx272("path", { d: "M12 12L19.5 4.5M20 13V18C20 19.1046 19.1046 20 18 20H6C4.89543 20 4 19.1046 4 18V6C4 4.89543 4.89543 4 6 4H11M15 4H19C19.5523 4 20 4.44772 20 5V9", stroke: "inherit", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }) });
var external_link_large_line_default = SvgExternalLinkLargeLine;

// assets/newIcons/face-large-line.svg
import * as React268 from "react";
import { jsx as jsx273 } from "react/jsx-runtime";
var SvgFaceLargeLine = (props) => /* @__PURE__ */ jsx273("svg", { stroke: "black", width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx273("path", { d: "M4.15331 14.0489C4.50819 13.8439 4.92761 13.8655 5.26098 14.0705C8.89588 14.3294 13.5417 11.8373 14.8429 8.37419C16.8002 8.37419 18.5854 11.5999 18.5854 14.0705C18.9187 13.8655 19.3382 13.8439 19.693 14.0489C20.3168 14.3941 20.5856 15.2356 20.2845 15.9369L19.9296 16.7892C19.6393 17.5012 18.8972 17.8033 18.2627 17.4689C18.2197 17.4473 18.166 17.4149 18.166 17.4149H18.209C17.0905 20.166 13.9611 22 11.9178 22C9.87451 22 6.82033 20.1012 5.64813 17.4365V17.4149H5.6804C5.64813 17.4257 5.62663 17.4473 5.58361 17.4689C4.94911 17.8033 4.21783 17.5012 3.91672 16.7892L3.56183 15.9369C3.26071 15.2356 3.52957 14.3834 4.15331 14.0489ZM4.15331 14.0489C0.948572 7.17667 5.15344 3.01233 7.89575 2.30029C11.0897 1.53431 13.617 2.30029 14.8537 3.84304C15.2838 3.5086 15.757 3.14179 17.1443 3.28204C19.3704 3.62727 21.0266 6.27044 20.747 8.90282C20.7039 10.1327 20.0587 12.7867 19.5102 13.9734", stroke: "inherit", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }) });
var face_large_line_default = SvgFaceLargeLine;

// assets/newIcons/fail-large-fill.svg
import * as React269 from "react";
import { jsx as jsx274 } from "react/jsx-runtime";
var SvgFailLargeFill = (props) => /* @__PURE__ */ jsx274("svg", { width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "black", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx274("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2.25 12C2.25 6.61522 6.61522 2.25 12 2.25C17.3848 2.25 21.75 6.61522 21.75 12C21.75 17.3848 17.3848 21.75 12 21.75C6.61522 21.75 2.25 17.3848 2.25 12ZM15.5303 8.46967C15.8232 8.76256 15.8232 9.23744 15.5303 9.53033L13.0607 12L15.5303 14.4697C15.8232 14.7626 15.8232 15.2374 15.5303 15.5303C15.2374 15.8232 14.7626 15.8232 14.4697 15.5303L12 13.0607L9.53033 15.5303C9.23744 15.8232 8.76256 15.8232 8.46967 15.5303C8.17678 15.2374 8.17678 14.7626 8.46967 14.4697L10.9393 12L8.46967 9.53033C8.17678 9.23744 8.17678 8.76256 8.46967 8.46967C8.76256 8.17678 9.23744 8.17678 9.53033 8.46967L12 10.9393L14.4697 8.46967C14.7626 8.17678 15.2374 8.17678 15.5303 8.46967Z", fill: "inherit" }) });
var fail_large_fill_default = SvgFailLargeFill;

// assets/newIcons/fail-large-line.svg
import * as React270 from "react";
import { jsx as jsx275 } from "react/jsx-runtime";
var SvgFailLargeLine = (props) => /* @__PURE__ */ jsx275("svg", { stroke: "black", width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx275("path", { d: "M15 9L9 15M9 9L15 15M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z", stroke: "inherit", strokeWidth: 1.5, strokeMiterlimit: 10, strokeLinecap: "round" }) });
var fail_large_line_default = SvgFailLargeLine;

// assets/newIcons/favorite-large-line.svg
import * as React271 from "react";
import { jsx as jsx276 } from "react/jsx-runtime";
var SvgFavoriteLargeLine = (props) => /* @__PURE__ */ jsx276("svg", { stroke: "black", width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx276("path", { d: "M11.1335 4.03197C11.4879 3.32268 12.5121 3.32268 12.8665 4.03197L14.8991 8.09923C15.0398 8.38089 15.3119 8.57612 15.6267 8.62128L20.1716 9.2735C20.9642 9.38724 21.2807 10.3492 20.7071 10.9013L17.4184 14.0672C17.1906 14.2864 17.0867 14.6023 17.1405 14.9119L17.9168 19.3822C18.0522 20.1618 17.2237 20.7563 16.5148 20.3883L12.4497 18.2776C12.1682 18.1315 11.8318 18.1315 11.5503 18.2776L7.48523 20.3883C6.77631 20.7563 5.94776 20.1618 6.08315 19.3822L6.85952 14.9119C6.91329 14.6023 6.80936 14.2864 6.58161 14.0672L3.29287 10.9013C2.71935 10.3492 3.03582 9.38724 3.82841 9.2735L8.37334 8.62128C8.68808 8.57612 8.96016 8.38089 9.10092 8.09923L11.1335 4.03197Z", stroke: "inherit", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }) });
var favorite_large_line_default = SvgFavoriteLargeLine;

// assets/newIcons/filter-large-line.svg
import * as React272 from "react";
import { jsx as jsx277 } from "react/jsx-runtime";
var SvgFilterLargeLine = (props) => /* @__PURE__ */ jsx277("svg", { stroke: "black", width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx277("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10 12.3059L4.30304 5.48017C3.55659 4.4548 4.27436 3 5.52671 3H18.4733C19.7256 3 20.4434 4.4548 19.697 5.48017L14 12.3059V20.5C14 21.118 13.2944 21.4708 12.8 21.1L10.3 19.225C10.1111 19.0834 10 18.8611 10 18.625V12.3059Z", stroke: "inherit", strokeWidth: 1.5, strokeLinejoin: "round" }) });
var filter_large_line_default = SvgFilterLargeLine;

// assets/newIcons/firmware-large-line.svg
import * as React273 from "react";
import { jsx as jsx278 } from "react/jsx-runtime";
var SvgFirmwareLargeLine = (props) => /* @__PURE__ */ jsx278("svg", { stroke: "black", width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx278("path", { d: "M19 9V8.82843C19 8.29799 18.7893 7.78929 18.4142 7.41421L14.5858 3.58579C14.2107 3.21071 13.702 3 13.1716 3H7C5.89543 3 5 3.89543 5 5V19C5 20.1046 5.89543 21 7 21H9M15.5 12V13.5M22 15.5H20.5M13.5 15.5H12M15.5 20.5V22M18.5 12V13.5M22 18.5H20.5M13.5 18.5H12M18.5 20.5V22M15 20.5H19C19.8284 20.5 20.5 19.8284 20.5 19V15C20.5 14.1716 19.8284 13.5 19 13.5H15C14.1716 13.5 13.5 14.1716 13.5 15V19C13.5 19.8284 14.1716 20.5 15 20.5ZM16.5 16.5H17.5V17.5H16.5V16.5Z", stroke: "inherit", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }) });
var firmware_large_line_default = SvgFirmwareLargeLine;

// assets/newIcons/focus_far-large-line.svg
import * as React274 from "react";
import { jsx as jsx279 } from "react/jsx-runtime";
var SvgFocusFarLargeLine = (props) => /* @__PURE__ */ jsx279("svg", { stroke: "black", width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx279("path", { d: "M11.5 17.9844H20.2768C21.0446 17.9844 21.526 17.155 21.1451 16.4883L14.8682 5.50386C14.4844 4.83205 13.5157 4.83205 13.1318 5.50386L9.4049 12.0259M3.78306 17.9844H11.2169C11.9979 17.9844 12.4774 17.1293 12.0702 16.463L8.35329 10.3807C7.96336 9.74265 7.03665 9.74265 6.64672 10.3807L2.92978 16.463C2.52257 17.1293 3.00213 17.9844 3.78306 17.9844Z", stroke: "inherit", strokeWidth: 1.5, strokeLinecap: "round" }) });
var focus_far_large_line_default = SvgFocusFarLargeLine;

// assets/newIcons/focus_near-large-line.svg
import * as React275 from "react";
import { jsx as jsx280 } from "react/jsx-runtime";
var SvgFocusNearLargeLine = (props) => /* @__PURE__ */ jsx280("svg", { stroke: "black", width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx280("path", { d: "M11.9999 17.5051V21.0051M6.52894 17.5051H17.4709C18.1921 17.5051 18.6761 16.765 18.3871 16.1043L12.9161 3.59918C12.5666 2.80027 11.4333 2.80027 11.0838 3.59918L5.61278 16.1043C5.32373 16.765 5.80779 17.5051 6.52894 17.5051Z", stroke: "inherit", strokeWidth: 1.5, strokeLinecap: "round" }) });
var focus_near_large_line_default = SvgFocusNearLargeLine;

// assets/newIcons/fog_detection-large-line.svg
import * as React276 from "react";
import { jsx as jsx281 } from "react/jsx-runtime";
var SvgFogDetectionLargeLine = (props) => /* @__PURE__ */ jsx281("svg", { stroke: "black", width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx281("path", { d: "M10.5 20H4.22222M12.5 16.571H5.5M3 16.571H2M15 20H13M15 16.571H18C20.2092 16.571 22 14.762 22 12.5303C22 10.426 20.4076 8.69735 18.3736 8.50708C17.9575 5.95042 15.7598 4 13.1111 4C10.4624 4 8.26472 5.95042 7.84866 8.50708C5.81468 8.69735 4.22222 10.426 4.22222 12.5303C4.22222 12.7385 4.2378 12.9429 4.26784 13.1426", stroke: "inherit", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }) });
var fog_detection_large_line_default = SvgFogDetectionLargeLine;

// assets/newIcons/folder_close-large-fill.svg
import * as React277 from "react";
import { jsx as jsx282 } from "react/jsx-runtime";
var SvgFolderCloseLargeFill = (props) => /* @__PURE__ */ jsx282("svg", { width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "black", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx282("path", { d: "M4.8 3.75C3.30246 3.75 2.25 5.09961 2.25 6.55172V17.4483C2.25 18.9004 3.30246 20.25 4.8 20.25H19.2C20.6975 20.25 21.75 18.9004 21.75 17.4483V8.55172C21.75 7.09961 20.6975 5.75 19.2 5.75L11.5992 5.75L10.2934 4.5711C9.82725 4.05833 9.18282 3.75 8.48824 3.75H4.8Z", fill: "inherit" }) });
var folder_close_large_fill_default = SvgFolderCloseLargeFill;

// assets/newIcons/folder_close-large-line.svg
import * as React278 from "react";
import { jsx as jsx283 } from "react/jsx-runtime";
var SvgFolderCloseLargeLine = (props) => /* @__PURE__ */ jsx283("svg", { stroke: "black", width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx283("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M21 8.55172C21 7.41859 20.1941 6.5 19.2 6.5L11.3975 6.5C11.3293 6.5 11.2639 6.46912 11.2156 6.41415L9.76103 5.10094C9.42346 4.71616 8.96563 4.5 8.48824 4.5H4.8C3.80589 4.5 3 5.41859 3 6.55172V17.4483C3 18.5814 3.80589 19.5 4.8 19.5H19.2C20.1941 19.5 21 18.5814 21 17.4483V8.55172Z", stroke: "inherit", strokeWidth: 1.5, strokeMiterlimit: 10 }) });
var folder_close_large_line_default = SvgFolderCloseLargeLine;

// assets/newIcons/folder_open-large-fill.svg
import * as React279 from "react";
import { jsx as jsx284, jsxs as jsxs65 } from "react/jsx-runtime";
var SvgFolderOpenLargeFill = (props) => /* @__PURE__ */ jsxs65("svg", { width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "black", xmlns: "http://www.w3.org/2000/svg", ...props, children: [
  /* @__PURE__ */ jsx284("path", { d: "M2.25 6.55172C2.25 5.09961 3.30246 3.75 4.8 3.75H8.48824C9.18282 3.75 9.82725 4.05833 10.2934 4.5711L11.5992 5.75L18.25 5.75C19.7361 5.75 20.7347 7.07909 20.7498 8.51849C20.6299 8.50628 20.5079 8.5 20.3838 8.5H7.01417C5.58532 8.5 4.29995 9.36854 3.76687 10.6942L2.25 14.4664V6.55172Z", fill: "inherit" }),
  /* @__PURE__ */ jsx284("path", { d: "M5.50691 11.782C5.80398 11.0097 6.54605 10.5 7.3736 10.5H20.8459C22.2609 10.5 23.2284 11.9291 22.7029 13.2428L20.4029 18.9928C20.0992 19.7521 19.3637 20.25 18.5459 20.25H5.16206C3.7585 20.25 2.79152 18.842 3.29537 17.532L5.50691 11.782Z", fill: "inherit" })
] });
var folder_open_large_fill_default = SvgFolderOpenLargeFill;

// assets/newIcons/folder_open-large-line.svg
import * as React280 from "react";
import { jsx as jsx285 } from "react/jsx-runtime";
var SvgFolderOpenLargeLine = (props) => /* @__PURE__ */ jsx285("svg", { stroke: "black", width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx285("path", { d: "M20 10V8.55172C20 7.41859 19.1941 6.5 18.2 6.5L11.3975 6.5C11.3293 6.5 11.2639 6.46912 11.2156 6.41415L9.76103 5.10094C9.42346 4.71616 8.96563 4.5 8.48824 4.5H4.8C3.80589 4.5 3 5.41859 3 6.55172V17.4483C3 18.5814 3.80589 19.5 4.8 19.5H12M5.95987 19.5H18.0295C18.846 19.5 19.5805 19.0037 19.8851 18.2462L21.8957 13.2462C22.4242 11.932 21.4566 10.5 20.0401 10.5H7.97046C7.15398 10.5 6.41947 10.9963 6.11486 11.7538L4.10428 16.7538C3.57581 18.068 4.54338 19.5 5.95987 19.5Z", stroke: "inherit", strokeWidth: 1.5, strokeMiterlimit: 10 }) });
var folder_open_large_line_default = SvgFolderOpenLargeLine;

// assets/newIcons/folklift-large-line.svg
import * as React281 from "react";
import { jsx as jsx286 } from "react/jsx-runtime";
var SvgFolkliftLargeLine = (props) => /* @__PURE__ */ jsx286("svg", { stroke: "black", width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx286("path", { d: "M4.5 9.88883V5C4.5 3.89543 5.39543 3 6.5 3H11.083C11.8643 3 12.5741 3.45503 12.9003 4.16504L16.5 12M18 3V16C18 16.5523 18.4477 17 19 17H22M18 17V14C18 12.8954 17.1046 12 16 12H12L9 10H5C3.89543 10 3 10.8954 3 12V17M13 17H8M8 17.5C8 18.8807 6.88071 20 5.5 20C4.11929 20 3 18.8807 3 17.5C3 16.1193 4.11929 15 5.5 15C6.88071 15 8 16.1193 8 17.5ZM18 17.5C18 18.8807 16.8807 20 15.5 20C14.1193 20 13 18.8807 13 17.5C13 16.1193 14.1193 15 15.5 15C16.8807 15 18 16.1193 18 17.5Z", stroke: "inherit", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }) });
var folklift_large_line_default = SvgFolkliftLargeLine;

// assets/newIcons/forklift_counting-large-line.svg
import * as React282 from "react";
import { jsx as jsx287 } from "react/jsx-runtime";
var SvgForkliftCountingLargeLine = (props) => /* @__PURE__ */ jsx287("svg", { stroke: "black", width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx287("path", { d: "M4.5 9.88883V5C4.5 3.89543 5.39543 3 6.5 3H11.083C11.8643 3 12.5741 3.45503 12.9003 4.16504L16.5 12M3 17V12C3 10.8954 3.89543 10 5 10H9L12 12H18V3M8 17H11.5M17.5 15H21M21 15V18.5M21 15L17 19L15.2342 17.2727L12.6001 20M8 17.5C8 18.8807 6.88071 20 5.5 20C4.11929 20 3 18.8807 3 17.5C3 16.1193 4.11929 15 5.5 15C6.88071 15 8 16.1193 8 17.5Z", stroke: "inherit", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }) });
var forklift_counting_large_line_default = SvgForkliftCountingLargeLine;

// assets/newIcons/forklift_heatmap-large-line.svg
import * as React283 from "react";
import { jsx as jsx288 } from "react/jsx-runtime";
var SvgForkliftHeatmapLargeLine = (props) => /* @__PURE__ */ jsx288("svg", { stroke: "black", width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx288("path", { d: "M4.5 9.88883V5C4.5 3.89543 5.39543 3 6.5 3H11.083C11.8643 3 12.5741 3.45503 12.9003 4.16504L15.6001 10.0413M18 3V10.0413M3 17V12C3 10.8954 3.89543 10 5 10H9L11.5609 11.7072M8 17H10M8 17.5C8 18.8807 6.88071 20 5.5 20C4.11929 20 3 18.8807 3 17.5C3 16.1193 4.11929 15 5.5 15C6.88071 15 8 16.1193 8 17.5ZM16 15.75H15.75V16H16V15.75ZM16.5 18.5H15.75V19.25H16.5V18.5ZM19.25 19H19V19.25H19.25V19ZM20 22H15C13.8954 22 13 21.1046 13 20V15C13 13.8954 13.8954 13 15 13H20C21.1046 13 22 13.8954 22 15V20C22 21.1046 21.1046 22 20 22Z", stroke: "inherit", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }) });
var forklift_heatmap_large_line_default = SvgForkliftHeatmapLargeLine;

// assets/newIcons/forklift_queue_management-large-line.svg
import * as React284 from "react";
import { jsx as jsx289 } from "react/jsx-runtime";
var SvgForkliftQueueManagementLargeLine = (props) => /* @__PURE__ */ jsx289("svg", { stroke: "black", width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx289("path", { d: "M3.75 19.09C3.75 20.15 4.57 21 5.58 21C6.59 21 7.41 20.14 7.41 19.09C7.41 18.04 6.59 17.18 5.58 17.18C4.57 17.18 3.75 18.04 3.75 19.09ZM3.75 19.09V14.88C3.75 14.04 4.41 13.35 5.22 13.35H8.15L10.35 14.88H14.28C15.09 14.88 15.75 15.56 15.75 16.41V19.09M15.75 19.09C15.75 20.15 14.93 21 13.92 21C12.91 21 12.09 20.14 12.09 19.09C12.09 18.04 12.91 17.18 13.92 17.18C14.93 17.18 15.75 18.04 15.75 19.09ZM4.85 13.27V9.53C4.85 8.69 5.51 8 6.32 8H9.68C10.25 8 10.77 8.35 11.01 8.89L13.65 14.88M12.08 18.71H7.41M18.25 8V18.21M18.25 18.21C18.25 18.64 18.59 19 19 19H21M18.25 18.21V16.64M7.01001 5.5H11.26C11.88 5.5 12.44 5.87 12.69 6.46L15.21 12.24M8.25 3H12.87C13.49 3 14.05 3.37 14.3 3.96L15.273 6", stroke: "inherit", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }) });
var forklift_queue_management_large_line_default = SvgForkliftQueueManagementLargeLine;

// assets/newIcons/grouping-large-line.svg
import * as React285 from "react";
import { jsx as jsx290 } from "react/jsx-runtime";
var SvgGroupingLargeLine = (props) => /* @__PURE__ */ jsx290("svg", { stroke: "black", width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx290("path", { d: "M21 15.4048L13.0429 20.2674C12.4027 20.6587 11.5973 20.6587 10.9571 20.2674L3 15.4048M3 11.9048L10.9571 16.7674C11.5973 17.1587 12.4027 17.1587 13.0429 16.7674L21 11.9048M17.0212 10.8362L13.0426 13.2675C12.4024 13.6587 11.597 13.6587 10.9568 13.2675L6.97827 10.8362M17.0214 5.97477L13.0429 3.54344C12.4026 3.15219 11.5973 3.15219 10.9571 3.54344L6.97852 5.97477M16.2812 11.2883L20.3017 8.83133C20.6208 8.63637 20.6208 8.17302 20.3017 7.97805L16.2812 5.52104M7.71858 11.2883L3.69802 8.83133C3.37898 8.63637 3.37898 8.17302 3.69802 7.97805L7.71858 5.52104", stroke: "inherit", strokeWidth: 1.5, strokeMiterlimit: 10, strokeLinecap: "round", strokeLinejoin: "round" }) });
var grouping_large_line_default = SvgGroupingLargeLine;

// assets/newIcons/dry_heater-large-line.svg
import * as React286 from "react";
import { jsx as jsx291 } from "react/jsx-runtime";
var SvgDryHeaterLargeLine = (props) => /* @__PURE__ */ jsx291("svg", { stroke: "black", width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx291("path", { d: "M6 5.5C6 5.5 3.75 8 6 10.5C8.25 13 6 15.5 6 15.5M18 5.5C18 5.5 15.75 8 18 10.5C20.25 13 18 15.5 18 15.5M12 4.5C12 4.5 10.8124 5.81956 11.0256 7.5M8.51849 17.3333C8.80863 14 12 11.5 12 11.5C12 11.5 15.1915 14 15.4816 17.3333C15.6759 19.5651 14.3211 21.5 12 21.5C9.679 21.5 8.32378 19.5704 8.51849 17.3333ZM4 6.25C4.58579 5.17606 5.5 3.5 5.5 3.5L7 6.25H4ZM16 6.25C16.5858 5.17606 17.5 3.5 17.5 3.5L19 6.25H16ZM10 5.25C10.5858 4.17606 11.5 2.5 11.5 2.5L13 5.25H10Z", stroke: "inherit", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }) });
var dry_heater_large_line_default = SvgDryHeaterLargeLine;

// assets/newIcons/dry_spin-large-line.svg
import * as React287 from "react";
import { jsx as jsx292 } from "react/jsx-runtime";
var SvgDrySpinLargeLine = (props) => /* @__PURE__ */ jsx292("svg", { stroke: "black", width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx292("path", { d: "M12 19C6.47715 19 2 16.5376 2 13.5C2 11.9614 3.14864 10.5704 5 9.57222M18 9.09961C20.4289 10.103 22 11.7006 22 13.5C22 15.3326 20.3705 16.9558 17.8649 17.9553C17.2868 18.1859 16.6621 18.3833 16 18.5424M8.51849 10.8333C8.80863 7.5 12 5 12 5C12 5 15.1915 7.5 15.4816 10.8333C15.6759 13.0651 14.3211 15 12 15C9.679 15 8.32378 13.0704 8.51849 10.8333ZM2.86596 9.2496C4.00434 9.22901 5.78096 9.19688 5.78096 9.19688L4.45572 11.7937L2.86596 9.2496ZM18.2559 19.3246C17.156 19.0306 15.4393 18.5718 15.4393 18.5718L17.429 16.4408L18.2559 19.3246Z", stroke: "inherit", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }) });
var dry_spin_large_line_default = SvgDrySpinLargeLine;

// assets/newIcons/heatmap-large-line.svg
import * as React288 from "react";
import { jsx as jsx293, jsxs as jsxs66 } from "react/jsx-runtime";
var SvgHeatmapLargeLine = (props) => /* @__PURE__ */ jsxs66("svg", { stroke: "black", width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: [
  /* @__PURE__ */ jsx293("path", { d: "M21 5C21 3.89543 20.1046 3 19 3H5C3.89543 3 3 3.89543 3 5V19C3 20.1046 3.89543 21 5 21H19C20.1046 21 21 20.1046 21 19V5Z", stroke: "inherit", strokeWidth: 1.5, strokeLinejoin: "round" }),
  /* @__PURE__ */ jsx293("path", { d: "M17 16H16.25V16.75H17V16Z", stroke: "inherit", strokeWidth: 1.5, strokeLinejoin: "round" }),
  /* @__PURE__ */ jsx293("path", { d: "M13 15.5H11.5V17H13V15.5Z", stroke: "inherit", strokeWidth: 1.5, strokeLinejoin: "round" }),
  /* @__PURE__ */ jsx293("path", { d: "M8 7H7.25V7.75H8V7Z", stroke: "inherit", strokeWidth: 1.5, strokeLinejoin: "round" }),
  /* @__PURE__ */ jsx293("path", { d: "M12.5 7.5H12.49V7.51H12.5V7.5Z", stroke: "inherit", strokeWidth: 1.5, strokeLinejoin: "round" }),
  /* @__PURE__ */ jsx293("path", { d: "M16.5 12H16.49V12.01H16.5V12Z", stroke: "inherit", strokeWidth: 1.5, strokeLinejoin: "round" }),
  /* @__PURE__ */ jsx293("path", { d: "M16.5 7.5H16.49V7.51H16.5V7.5Z", stroke: "inherit", strokeWidth: 1.5, strokeLinejoin: "round" }),
  /* @__PURE__ */ jsx293("path", { d: "M12.75 11.5H12V12.25H12.75V11.5Z", stroke: "inherit", strokeWidth: 1.5, strokeLinejoin: "round" }),
  /* @__PURE__ */ jsx293("path", { d: "M8.5 11H7V12.5H8.5V11Z", stroke: "inherit", strokeWidth: 1.5, strokeLinejoin: "round" }),
  /* @__PURE__ */ jsx293("path", { d: "M8.5 15.5H7V17H8.5V15.5Z", stroke: "inherit", strokeWidth: 1.5, strokeLinejoin: "round" })
] });
var heatmap_large_line_default = SvgHeatmapLargeLine;

// assets/newIcons/help-large-fill.svg
import * as React289 from "react";
import { jsx as jsx294 } from "react/jsx-runtime";
var SvgHelpLargeFill = (props) => /* @__PURE__ */ jsx294("svg", { width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "black", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx294("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 2.25C6.61522 2.25 2.25 6.61522 2.25 12C2.25 17.3848 6.61522 21.75 12 21.75C17.3848 21.75 21.75 17.3848 21.75 12C21.75 6.61522 17.3848 2.25 12 2.25ZM10.6077 8.24814C10.26 8.55722 10 9.03702 10 9.75023C10 10.1644 9.66421 10.5002 9.25 10.5002C8.83579 10.5002 8.5 10.1644 8.5 9.75023C8.5 8.63001 8.92752 7.73473 9.61108 7.12707C10.2808 6.53167 11.1527 6.25003 12 6.25C12.8473 6.24997 13.7191 6.53154 14.3889 7.1269C15.0725 7.73454 15.5 8.62981 15.5 9.75002C15.5 10.5716 15.2908 11.1994 14.9073 11.6816C14.5403 12.1432 14.067 12.3988 13.7104 12.577C13.6404 12.612 13.5762 12.6437 13.517 12.6729C13.2317 12.8136 13.0631 12.8967 12.9295 13.0162C12.8333 13.1022 12.75 13.2102 12.75 13.5C12.75 13.9142 12.4142 14.25 12 14.25C11.5858 14.25 11.25 13.9142 11.25 13.5C11.25 12.7898 11.5104 12.2728 11.9298 11.8979C12.2324 11.6274 12.6231 11.438 12.9052 11.3012C12.9535 11.2777 12.9986 11.2559 13.0396 11.2354C13.3705 11.0699 13.5847 10.9349 13.7333 10.748C13.8655 10.5818 14 10.3033 14 9.75002C14 9.03682 13.74 8.55705 13.3924 8.24802C13.0309 7.92671 12.5277 7.74998 12 7.75C11.4723 7.75002 10.9692 7.92679 10.6077 8.24814ZM10.75 16.5C10.75 15.8096 11.3096 15.25 12 15.25C12.6904 15.25 13.25 15.8096 13.25 16.5C13.25 17.1904 12.6904 17.75 12 17.75C11.3096 17.75 10.75 17.1904 10.75 16.5Z", fill: "inherit" }) });
var help_large_fill_default = SvgHelpLargeFill;

// assets/newIcons/help-large-line.svg
import * as React290 from "react";
import { jsx as jsx295 } from "react/jsx-runtime";
var SvgHelpLargeLine = (props) => /* @__PURE__ */ jsx295("svg", { stroke: "black", width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx295("path", { d: "M9.25 9.75023C9.25 6.08339 14.75 6.08319 14.75 9.75002C14.75 12.4999 12 11.5 12 13.5M12 16.5H12.01M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12ZM12.5 16.5C12.5 16.7761 12.2761 17 12 17C11.7239 17 11.5 16.7761 11.5 16.5C11.5 16.2239 11.7239 16 12 16C12.2761 16 12.5 16.2239 12.5 16.5Z", stroke: "inherit", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }) });
var help_large_line_default = SvgHelpLargeLine;

// assets/newIcons/identities-large-fill.svg
import * as React291 from "react";
import { jsx as jsx296 } from "react/jsx-runtime";
var SvgIdentitiesLargeFill = (props) => /* @__PURE__ */ jsx296("svg", { width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "black", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx296("path", { d: "M19 4.25C20.5188 4.25 21.75 5.48122 21.75 7V17C21.75 18.5188 20.5188 19.75 19 19.75H5C3.48122 19.75 2.25 18.5188 2.25 17V7C2.25 5.48122 3.48122 4.25 5 4.25H19ZM7.75 12.75C6.36929 12.75 5.25 13.8693 5.25 15.25V16C5.25 16.4142 5.58579 16.75 6 16.75C6.41421 16.75 6.75 16.4142 6.75 16V15.25C6.75 14.6977 7.19772 14.25 7.75 14.25H10.25C10.8023 14.25 11.25 14.6977 11.25 15.25V16C11.25 16.4142 11.5858 16.75 12 16.75C12.4142 16.75 12.75 16.4142 12.75 16V15.25C12.75 13.8693 11.6307 12.75 10.25 12.75H7.75ZM9 7.25C7.61929 7.25 6.5 8.36929 6.5 9.75C6.5 11.1307 7.61929 12.25 9 12.25C10.3807 12.25 11.5 11.1307 11.5 9.75C11.5 8.36929 10.3807 7.25 9 7.25ZM14 10.75C13.5858 10.75 13.25 11.0858 13.25 11.5C13.25 11.9142 13.5858 12.25 14 12.25H17.5C17.9142 12.25 18.25 11.9142 18.25 11.5C18.25 11.0858 17.9142 10.75 17.5 10.75H14ZM9 8.75C9.55228 8.75 10 9.19772 10 9.75C10 10.3023 9.55228 10.75 9 10.75C8.44772 10.75 8 10.3023 8 9.75C8 9.19772 8.44772 8.75 9 8.75ZM14 7.75C13.5858 7.75 13.25 8.08579 13.25 8.5C13.25 8.91421 13.5858 9.25 14 9.25H17.5C17.9142 9.25 18.25 8.91421 18.25 8.5C18.25 8.08579 17.9142 7.75 17.5 7.75H14Z", fill: "inherit" }) });
var identities_large_fill_default = SvgIdentitiesLargeFill;

// assets/newIcons/identities-large-line.svg
import * as React292 from "react";
import { jsx as jsx297 } from "react/jsx-runtime";
var SvgIdentitiesLargeLine = (props) => /* @__PURE__ */ jsx297("svg", { stroke: "black", width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx297("path", { d: "M12 16V15.25C12 14.2835 11.2165 13.5 10.25 13.5H7.75C6.7835 13.5 6 14.2835 6 15.25V16M14 8.5H17.5M14 11.5H17.5M5 19H19C20.1046 19 21 18.1046 21 17V7C21 5.89543 20.1046 5 19 5H5C3.89543 5 3 5.89543 3 7V17C3 18.1046 3.89543 19 5 19ZM10.75 9.75C10.75 10.7165 9.9665 11.5 9 11.5C8.0335 11.5 7.25 10.7165 7.25 9.75C7.25 8.7835 8.0335 8 9 8C9.9665 8 10.75 8.7835 10.75 9.75Z", stroke: "inherit", strokeWidth: 1.5, strokeLinecap: "round" }) });
var identities_large_line_default = SvgIdentitiesLargeLine;

// assets/newIcons/image_gallery-large-line.svg
import * as React293 from "react";
import { jsx as jsx298 } from "react/jsx-runtime";
var SvgImageGalleryLargeLine = (props) => /* @__PURE__ */ jsx298("svg", { stroke: "black", width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx298("path", { d: "M4 15.6569L8.24264 11.4142C9.02369 10.6332 10.29 10.6332 11.0711 11.4142L15.5789 15.922M20.0104 15.2071L17.8891 13.0858C17.108 12.3047 15.8417 12.3047 15.0607 13.0858L13.9016 14.2448M15.5 8.5V8.51M6 20H18C19.1046 20 20 19.1046 20 18V6C20 4.89543 19.1046 4 18 4H6C4.89543 4 4 4.89543 4 6V18C4 19.1046 4.89543 20 6 20ZM16 8.5C16 8.77614 15.7761 9 15.5 9C15.2239 9 15 8.77614 15 8.5C15 8.22386 15.2239 8 15.5 8C15.7761 8 16 8.22386 16 8.5Z", stroke: "inherit", strokeWidth: 1.5, strokeLinecap: "round" }) });
var image_gallery_large_line_default = SvgImageGalleryLargeLine;

// assets/newIcons/information-large-line.svg
import * as React294 from "react";
import { jsx as jsx299 } from "react/jsx-runtime";
var SvgInformationLargeLine = (props) => /* @__PURE__ */ jsx299("svg", { stroke: "black", width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx299("path", { d: "M12 8.5H12.01M12 16V12M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12ZM12.5 8.5C12.5 8.77614 12.2761 9 12 9C11.7239 9 11.5 8.77614 11.5 8.5C11.5 8.22386 11.7239 8 12 8C12.2761 8 12.5 8.22386 12.5 8.5Z", stroke: "inherit", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }) });
var information_large_line_default = SvgInformationLargeLine;

// assets/newIcons/key-large-line.svg
import * as React295 from "react";
import { jsx as jsx300 } from "react/jsx-runtime";
var SvgKeyLargeLine = (props) => /* @__PURE__ */ jsx300("svg", { stroke: "black", width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx300("path", { d: "M10.1784 10.3286C10.0621 9.90555 10 9.46003 10 9C10 6.23858 12.2386 4 15 4C17.7614 4 20 6.23858 20 9C20 11.7614 17.7614 14 15 14C14.2177 14 13.4773 13.8203 12.8179 13.5M10.1761 10.3239L4 16.5V20L8 20V17H11V13.5H12.82M16 8H16.005M16.5 8C16.5 8.27614 16.2761 8.5 16 8.5C15.7239 8.5 15.5 8.27614 15.5 8C15.5 7.72386 15.7239 7.5 16 7.5C16.2761 7.5 16.5 7.72386 16.5 8Z", stroke: "inherit", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }) });
var key_large_line_default = SvgKeyLargeLine;

// assets/newIcons/language-large-line.svg
import * as React296 from "react";
import { jsx as jsx301 } from "react/jsx-runtime";
var SvgLanguageLargeLine = (props) => /* @__PURE__ */ jsx301("svg", { stroke: "black", width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx301("path", { d: "M12 3C14.2512 5.46451 15.5305 8.66283 15.6 12C15.5305 15.3372 14.2512 18.5354 12 21M12 3C9.74885 5.46451 8.46952 8.66283 8.4 12C8.46952 15.3372 9.74885 18.5354 12 21M12 3C7.02944 3 3 7.02944 3 12C3 16.9705 7.02944 21 12 21M12 3C16.9705 3 21 7.02944 21 12C21 16.9705 16.9705 21 12 21M3.45002 9.3H20.55M3.45 14.7H20.55", stroke: "inherit", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }) });
var language_large_line_default = SvgLanguageLargeLine;

// assets/newIcons/license_plate-large-line.svg
import * as React297 from "react";
import { jsx as jsx302 } from "react/jsx-runtime";
var SvgLicensePlateLargeLine = (props) => /* @__PURE__ */ jsx302("svg", { stroke: "black", width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx302("path", { d: "M4.5 7.5H4.51M4.5 16.5H4.51M19.5 7.5H19.51M19.5 16.5H19.51M11.2499 10.9285L12.6784 9.5V14.4998M15.464 10.7501C15.464 10.7501 15.6426 9.5 16.8925 9.5C18.1425 9.5 18.771 10.569 18.1425 11.4642C18.0128 11.6489 17.7853 11.8213 16.7139 12.5356C15.6426 13.2499 15.464 14.5 15.464 14.5H18.6782M5.25 14.4998L7.39278 9.5L9.53556 14.4998M5.67849 13.5H9.10707M4 19H20C21.1046 19 22 18.1046 22 17V7C22 5.89543 21.1046 5 20 5H4C2.89543 5 2 5.89543 2 7V17C2 18.1046 2.89543 19 4 19Z", stroke: "inherit", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }) });
var license_plate_large_line_default = SvgLicensePlateLargeLine;

// assets/newIcons/license-large-line.svg
import * as React298 from "react";
import { jsx as jsx303 } from "react/jsx-runtime";
var SvgLicenseLargeLine = (props) => /* @__PURE__ */ jsx303("svg", { stroke: "black", width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx303("path", { d: "M7 9H11M7 12H11M17 14.75V20L19 18.5L21 20V14.75M21 7C21 5.89543 20.1046 5 19 5H5C3.89543 5 3 5.89543 3 7V17C3 18.1046 3.89543 19 5 19H14M22 12.5C22 14.1569 20.6569 15.5 19 15.5C17.3431 15.5 16 14.1569 16 12.5C16 10.8431 17.3431 9.5 19 9.5C20.6569 9.5 22 10.8431 22 12.5Z", stroke: "inherit", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }) });
var license_large_line_default = SvgLicenseLargeLine;

// assets/newIcons/line_crossing-large-line.svg
import * as React299 from "react";
import { jsx as jsx304 } from "react/jsx-runtime";
var SvgLineCrossingLargeLine = (props) => /* @__PURE__ */ jsx304("svg", { stroke: "black", width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx304("path", { d: "M17.25 20V4M17.25 4L20.25 7M17.25 4L14.25 7M6.75 4V20M6.75 20L9.75 17M6.75 20L3.75 17M13.5 12H14.5M9.5 12H10.5M3 12H4M20 12H21", stroke: "inherit", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }) });
var line_crossing_large_line_default = SvgLineCrossingLargeLine;

// assets/newIcons/link_clip-large-line.svg
import * as React300 from "react";
import { jsx as jsx305 } from "react/jsx-runtime";
var SvgLinkClipLargeLine = (props) => /* @__PURE__ */ jsx305("svg", { stroke: "black", width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx305("path", { d: "M10.7272 6.90849L12 5.6357C13.7573 3.87836 16.6066 3.87834 18.3639 5.6357C20.1213 7.39304 20.1213 10.2423 18.3639 11.9997L17.0912 13.2725M6.90881 10.7269L5.63602 11.9997C3.87866 13.757 3.87866 16.6063 5.63602 18.3636C7.39337 20.121 10.2426 20.121 12 18.3636L13.2728 17.0908M9.17155 14.8281L14.8284 9.17123", stroke: "inherit", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }) });
var link_clip_large_line_default = SvgLinkClipLargeLine;

// assets/newIcons/link-large-line.svg
import * as React301 from "react";
import { jsx as jsx306 } from "react/jsx-runtime";
var SvgLinkLargeLine = (props) => /* @__PURE__ */ jsx306("svg", { stroke: "black", width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx306("path", { d: "M6.4359 5H19M19 5V17.5641M19 5L5 19", stroke: "inherit", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }) });
var link_large_line_default = SvgLinkLargeLine;

// assets/newIcons/list-large-line.svg
import * as React302 from "react";
import { jsx as jsx307 } from "react/jsx-runtime";
var SvgListLargeLine = (props) => /* @__PURE__ */ jsx307("svg", { stroke: "black", width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx307("path", { d: "M9 6H21M9 12H21M9 18H21M4.5 6C4.5 6.41421 4.16421 6.75 3.75 6.75C3.33579 6.75 3 6.41421 3 6C3 5.58579 3.33579 5.25 3.75 5.25C4.16421 5.25 4.5 5.58579 4.5 6ZM4.5 18C4.5 18.4142 4.16421 18.75 3.75 18.75C3.33579 18.75 3 18.4142 3 18C3 17.5858 3.33579 17.25 3.75 17.25C4.16421 17.25 4.5 17.5858 4.5 18ZM4.5 12C4.5 12.4142 4.16421 12.75 3.75 12.75C3.33579 12.75 3 12.4142 3 12C3 11.5858 3.33579 11.25 3.75 11.25C4.16421 11.25 4.5 11.5858 4.5 12Z", stroke: "inherit", strokeWidth: 1.5, strokeLinecap: "round" }) });
var list_large_line_default = SvgListLargeLine;

// assets/newIcons/live-large-line.svg
import * as React303 from "react";
import { jsx as jsx308 } from "react/jsx-runtime";
var SvgLiveLargeLine = (props) => /* @__PURE__ */ jsx308("svg", { stroke: "black", width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx308("path", { d: "M8 20H16M4.8 4H19.2C20.1941 4 21 4.83147 21 5.85714V15.1429C21 16.1685 20.1941 17 19.2 17H4.8C3.80589 17 3 16.1685 3 15.1429V5.85714C3 4.83147 3.80589 4 4.8 4Z", stroke: "inherit", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }) });
var live_large_line_default = SvgLiveLargeLine;

// assets/newIcons/location-large-line.svg
import * as React304 from "react";
import { jsx as jsx309, jsxs as jsxs67 } from "react/jsx-runtime";
var SvgLocationLargeLine = (props) => /* @__PURE__ */ jsxs67("svg", { stroke: "black", width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: [
  /* @__PURE__ */ jsx309("path", { d: "M6.40538 15.4552L10.8937 20.5033C11.4825 21.1656 12.5175 21.1656 13.1063 20.5033L17.5946 15.4552C21.8856 10.6291 18.4587 3 12 3C5.54127 3 2.11441 10.6291 6.40538 15.4552Z", stroke: "inherit", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }),
  /* @__PURE__ */ jsx309("path", { d: "M14.5 10C14.5 11.3808 13.3807 12.5 12 12.5C10.6193 12.5 9.5 11.3808 9.5 10C9.5 8.61929 10.6193 7.5 12 7.5C13.3807 7.5 14.5 8.61929 14.5 10Z", stroke: "inherit", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" })
] });
var location_large_line_default = SvgLocationLargeLine;

// assets/newIcons/lock_open-large-line.svg
import * as React305 from "react";
import { jsx as jsx310 } from "react/jsx-runtime";
var SvgLockOpenLargeLine = (props) => /* @__PURE__ */ jsx310("svg", { stroke: "black", width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx310("path", { d: "M8 10V7C8 4.79086 9.79086 3 12 3C13.1947 3 14.2671 3.52375 15 4.35418M12 14V16M7 21H17C18.1046 21 19 20.1046 19 19V12C19 10.8954 18.1046 10 17 10H7C5.89543 10 5 10.8954 5 12V19C5 20.1046 5.89543 21 7 21Z", stroke: "inherit", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }) });
var lock_open_large_line_default = SvgLockOpenLargeLine;

// assets/newIcons/lock-large-line.svg
import * as React306 from "react";
import { jsx as jsx311 } from "react/jsx-runtime";
var SvgLockLargeLine = (props) => /* @__PURE__ */ jsx311("svg", { stroke: "black", width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx311("path", { d: "M16 10V7C16 4.79086 14.2091 3 12 3C9.79086 3 8 4.79086 8 7V10M12 14V16M7 21H17C18.1046 21 19 20.1046 19 19V12C19 10.8954 18.1046 10 17 10H7C5.89543 10 5 10.8954 5 12V19C5 20.1046 5.89543 21 7 21Z", stroke: "inherit", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }) });
var lock_large_line_default = SvgLockLargeLine;

// assets/newIcons/log_out-large-line.svg
import * as React307 from "react";
import { jsx as jsx312 } from "react/jsx-runtime";
var SvgLogOutLargeLine = (props) => /* @__PURE__ */ jsx312("svg", { stroke: "black", width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx312("path", { d: "M8 20H6C4.89543 20 4 19.1046 4 18V6C4 4.89543 4.89543 4 6 4H8M15 17L20 12M20 12L15 7M20 12H8", stroke: "inherit", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }) });
var log_out_large_line_default = SvgLogOutLargeLine;

// assets/newIcons/log-large-line.svg
import * as React308 from "react";
import { jsx as jsx313 } from "react/jsx-runtime";
var SvgLogLargeLine = (props) => /* @__PURE__ */ jsx313("svg", { stroke: "black", width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx313("path", { d: "M9 10H15M9 13.5H12M8 4.5C8 5.32843 8.67157 6 9.5 6H14.5C15.3284 6 16 5.32843 16 4.5M8 4.5C8 3.67157 8.67157 3 9.5 3H14.5C15.3284 3 16 3.67157 16 4.5M8 4.5H7C5.89543 4.5 5 5.39543 5 6.5V18C5 19.1046 5.89543 20 7 20H17C18.1046 20 19 19.1046 19 18V6.5C19 5.39543 18.1046 4.5 17 4.5H16", stroke: "inherit", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }) });
var log_large_line_default = SvgLogLargeLine;

// assets/newIcons/map-large-line.svg
import * as React309 from "react";
import { jsx as jsx314 } from "react/jsx-runtime";
var SvgMapLargeLine = (props) => /* @__PURE__ */ jsx314("svg", { stroke: "black", width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx314("path", { d: "M7 7H7.5M21 16V6C21 4.89543 20.1046 4 19 4H18M21 16V19C21 20.1046 20.1046 21 19 21H11M21 16L14 13.7143M18 4H14.5M18 4L14 13.7143M11 21H6C4.89543 21 4 20.1046 4 19V14.5M11 21L14 13.7143M8.01386 12.6019C7.80878 12.8038 7.53496 12.9167 7.25002 12.9167C6.96509 12.9167 6.69126 12.8038 6.48619 12.6019C4.61121 10.7465 2.09868 8.67539 3.32398 5.66727C3.6512 4.87959 4.1975 4.20711 4.89531 3.73303C5.59311 3.25896 6.41178 3.00411 7.25002 3C8.92342 3 10.5142 4.04113 11.1761 5.66727C12.4001 8.67167 9.8937 10.7539 8.01386 12.6019ZM7.25 8C7.8023 8 8.25 7.5523 8.25 7C8.25 6.44772 7.8023 6 7.25 6C6.6977 6 6.25 6.44772 6.25 7C6.25 7.5523 6.6977 8 7.25 8Z", stroke: "inherit", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }) });
var map_large_line_default = SvgMapLargeLine;

// assets/newIcons/menu-large-line.svg
import * as React310 from "react";
import { jsx as jsx315 } from "react/jsx-runtime";
var SvgMenuLargeLine = (props) => /* @__PURE__ */ jsx315("svg", { stroke: "black", width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx315("path", { d: "M4 6H20M4 12H20M4 18H20", stroke: "inherit", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }) });
var menu_large_line_default = SvgMenuLargeLine;

// assets/newIcons/minus-large-line.svg
import * as React311 from "react";
import { jsx as jsx316 } from "react/jsx-runtime";
var SvgMinusLargeLine = (props) => /* @__PURE__ */ jsx316("svg", { stroke: "black", width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx316("path", { d: "M3 12H21", stroke: "inherit", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }) });
var minus_large_line_default = SvgMinusLargeLine;

// assets/newIcons/more-large-line.svg
import * as React312 from "react";
import { jsx as jsx317, jsxs as jsxs68 } from "react/jsx-runtime";
var SvgMoreLargeLine = (props) => /* @__PURE__ */ jsxs68("svg", { stroke: "black", width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: [
  /* @__PURE__ */ jsx317("path", { d: "M12 12.75C11.5858 12.75 11.25 12.4142 11.25 12C11.25 11.5858 11.5858 11.25 12 11.25C12.4142 11.25 12.75 11.5858 12.75 12C12.75 12.4142 12.4142 12.75 12 12.75Z", stroke: "inherit", strokeWidth: 1.5 }),
  /* @__PURE__ */ jsx317("path", { d: "M18.25 12.75C17.8358 12.75 17.5 12.4142 17.5 12C17.5 11.5858 17.8358 11.25 18.25 11.25C18.6642 11.25 19 11.5858 19 12C19 12.4142 18.6642 12.75 18.25 12.75Z", stroke: "inherit", strokeWidth: 1.5 }),
  /* @__PURE__ */ jsx317("path", { d: "M5.75 12.75C5.33579 12.75 5 12.4142 5 12C5 11.5858 5.33579 11.25 5.75 11.25C6.16421 11.25 6.5 11.5858 6.5 12C6.5 12.4142 6.16421 12.75 5.75 12.75Z", stroke: "inherit", strokeWidth: 1.5 })
] });
var more_large_line_default = SvgMoreLargeLine;

// assets/newIcons/motion_detection-large-line.svg
import * as React313 from "react";
import { jsx as jsx318 } from "react/jsx-runtime";
var SvgMotionDetectionLargeLine = (props) => /* @__PURE__ */ jsx318("svg", { stroke: "black", width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx318("path", { d: "M8.24851 12.6518L7.86851 13.1718L7.81851 13.2318C7.77851 13.2818 7.73851 13.3218 7.69851 13.3618C7.14851 13.9018 6.26851 13.9818 5.62851 13.5218C5.21851 13.2218 5.03851 12.7718 5.00851 12.3718C4.96851 11.9718 5.06851 11.5318 5.32851 11.1818L7.11851 8.8918C7.19851 8.8018 7.50851 8.5318 7.61851 8.4818L9.95851 6.9118C10.2339 6.71154 10.8831 6.51482 11.2094 6.44479M8.24851 12.6518C8.17851 13.0618 8.22851 13.4918 8.37851 13.8818C8.52851 14.2918 8.78851 14.6418 9.12851 14.9118L11.8485 17.1718L13.0685 20.5218L13.2085 20.9118C13.5085 21.7418 14.4285 22.1618 15.2585 21.8618C15.7185 21.6918 16.0285 21.3118 16.1885 20.9718C16.3485 20.6418 16.4485 20.2018 16.3485 19.7718V19.5218C16.3485 19.4218 16.3285 19.3118 16.2985 19.2118L15.7185 17.4118C15.7185 17.4118 15.7085 17.3818 15.6985 17.3618L14.9985 15.6318C14.9485 15.5118 14.8785 15.4018 14.7885 15.3018L12.9285 13.4118L13.25 12.0501C13.5815 12.4501 13.7899 12.6518 14.4885 13.1918C15.1085 13.4818 16.1485 13.7618 16.7985 13.8518C17.7785 13.9918 18.4985 13.1818 18.4985 12.3318C18.4985 11.4218 17.7785 10.8218 17.0685 10.6718C16.7985 10.6218 15.7685 10.2918 15.7685 10.2918C15.2785 10.0518 14.92 9.7018 14.6 9.2718C14.55 9.2118 14.3785 8.94013 14.2185 8.45013C14.094 8.06334 13.7624 7.43319 13.5 7.15019M8.24851 12.6518L8.71852 11.4423M9.06855 14.8626L5.87911 18.8733L5.78911 18.9733C5.21911 19.6533 5.30911 20.6533 5.98911 21.2233C6.65911 21.7833 7.66911 21.6933 8.23911 21.0233L8.37911 20.8633L11.6417 17M15.5 4.7002C15.5 6.08091 14.3807 7.2002 13 7.2002C11.6193 7.2002 10.5 6.08091 10.5 4.7002C10.5 3.31948 11.6193 2.2002 13 2.2002C14.3807 2.2002 15.5 3.31948 15.5 4.7002Z", stroke: "inherit", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }) });
var motion_detection_large_line_default = SvgMotionDetectionLargeLine;

// assets/newIcons/network-large-line.svg
import * as React314 from "react";
import { jsx as jsx319 } from "react/jsx-runtime";
var SvgNetworkLargeLine = (props) => /* @__PURE__ */ jsx319("svg", { stroke: "black", width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx319("path", { d: "M17 16V14C17 12.8954 16.1046 12 15 12H9C7.89543 12 7 12.8954 7 14V16M12 8V12M10 8H14C14.5523 8 15 7.55228 15 7V4C15 3.44772 14.5523 3 14 3H10C9.44772 3 9 3.44772 9 4V7C9 7.55228 9.44772 8 10 8ZM15 21H19C19.5523 21 20 20.5523 20 20V17C20 16.4477 19.5523 16 19 16H15C14.4477 16 14 16.4477 14 17V20C14 20.5523 14.4477 21 15 21ZM5 21H9C9.55228 21 10 20.5523 10 20V17C10 16.4477 9.55228 16 9 16H5C4.44772 16 4 16.4477 4 17V20C4 20.5523 4.44772 21 5 21Z", stroke: "inherit", strokeWidth: 1.5 }) });
var network_large_line_default = SvgNetworkLargeLine;

// assets/newIcons/note-large-line.svg
import * as React315 from "react";
import { jsx as jsx320 } from "react/jsx-runtime";
var SvgNoteLargeLine = (props) => /* @__PURE__ */ jsx320("svg", { stroke: "black", width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx320("path", { d: "M9 7H15M9 10L15 10M9 13H11M7 21H17C18.1046 21 19 20.1046 19 19V5C19 3.89543 18.1046 3 17 3H7C5.89543 3 5 3.89543 5 5V19C5 20.1046 5.89543 21 7 21Z", stroke: "inherit", strokeWidth: 1.5, strokeLinecap: "round" }) });
var note_large_line_default = SvgNoteLargeLine;

// assets/newIcons/notification-large-fill.svg
import * as React316 from "react";
import { jsx as jsx321, jsxs as jsxs69 } from "react/jsx-runtime";
var SvgNotificationLargeFill = (props) => /* @__PURE__ */ jsxs69("svg", { width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "black", xmlns: "http://www.w3.org/2000/svg", ...props, children: [
  /* @__PURE__ */ jsx321("path", { d: "M12 2.25C7.71979 2.25 4.25 5.71979 4.25 10V17.25H4C3.58579 17.25 3.25 17.5858 3.25 18C3.25 18.4142 3.58579 18.75 4 18.75H20C20.4142 18.75 20.75 18.4142 20.75 18C20.75 17.5858 20.4142 17.25 20 17.25H19.75V10C19.75 5.71979 16.2802 2.25 12 2.25Z", fill: "inherit" }),
  /* @__PURE__ */ jsx321("path", { d: "M10 20.25C9.58579 20.25 9.25 20.5858 9.25 21C9.25 21.4142 9.58579 21.75 10 21.75H14C14.4142 21.75 14.75 21.4142 14.75 21C14.75 20.5858 14.4142 20.25 14 20.25H10Z", fill: "inherit" })
] });
var notification_large_fill_default = SvgNotificationLargeFill;

// assets/newIcons/notification-large-line.svg
import * as React317 from "react";
import { jsx as jsx322 } from "react/jsx-runtime";
var SvgNotificationLargeLine = (props) => /* @__PURE__ */ jsx322("svg", { stroke: "black", width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx322("path", { d: "M4 18H20M10 21H14M19 18V10C19 6.13401 15.866 3 12 3C8.13401 3 5 6.13401 5 10V18H19Z", stroke: "inherit", strokeWidth: 1.5, strokeLinecap: "round" }) });
var notification_large_line_default = SvgNotificationLargeLine;

// assets/newIcons/object_detection-large-line.svg
import * as React318 from "react";
import { jsx as jsx323 } from "react/jsx-runtime";
var SvgObjectDetectionLargeLine = (props) => /* @__PURE__ */ jsx323("svg", { stroke: "black", width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx323("path", { d: "M21 7.5V5C21 3.89543 20.1046 3 19 3H16.5M21 16.5V19C21 20.1046 20.1046 21 19 21H16.5M3 16.5V19C3 20.1046 3.89543 21 5 21H7.5M3 7.5V5C3 3.89543 3.89543 3 5 3H7.5M16 12C16 9.79086 14.2091 8 12 8C9.79086 8 8 9.79086 8 12C8 14.2091 9.79086 16 12 16C14.2091 16 16 14.2091 16 12Z", stroke: "inherit", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }) });
var object_detection_large_line_default = SvgObjectDetectionLargeLine;

// assets/newIcons/online_success-large-fill.svg
import * as React319 from "react";
import { jsx as jsx324 } from "react/jsx-runtime";
var SvgOnlineSuccessLargeFill = (props) => /* @__PURE__ */ jsx324("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "black", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx324("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10 1.875C5.51268 1.875 1.875 5.51268 1.875 10C1.875 14.4873 5.51268 18.125 10 18.125C14.4873 18.125 18.125 14.4873 18.125 10C18.125 5.51268 14.4873 1.875 10 1.875ZM13.7598 7.04309C14.0121 7.27861 14.0258 7.6741 13.7903 7.92645L9.1236 12.9264C9.00539 13.0531 8.83993 13.125 8.66669 13.125C8.49345 13.125 8.32798 13.0531 8.20978 12.9264L6.20978 10.7836C5.97426 10.5312 5.98789 10.1358 6.24024 9.90023C6.49258 9.66471 6.88808 9.67835 7.1236 9.93069L8.66669 11.584L12.8764 7.07355C13.112 6.82121 13.5075 6.80757 13.7598 7.04309Z", fill: "inherit" }) });
var online_success_large_fill_default = SvgOnlineSuccessLargeFill;

// assets/newIcons/online_success-large-line.svg
import * as React320 from "react";
import { jsx as jsx325 } from "react/jsx-runtime";
var SvgOnlineSuccessLargeLine = (props) => /* @__PURE__ */ jsx325("svg", { stroke: "black", width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx325("path", { d: "M8 12.4286L10.4 15L16 9M12 21C16.9705 21 21 16.9705 21 12C21 7.02944 16.9705 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9705 7.02944 21 12 21Z", stroke: "inherit", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }) });
var online_success_large_line_default = SvgOnlineSuccessLargeLine;

// assets/newIcons/panel_collapse-large-line.svg
import * as React321 from "react";
import { jsx as jsx326 } from "react/jsx-runtime";
var SvgPanelCollapseLargeLine = (props) => /* @__PURE__ */ jsx326("svg", { stroke: "black", width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx326("path", { d: "M5.99841 7.00167V17.0017M9.49841 12.001L13.9984 7.00098M9.49841 12.001H18.9984M9.49841 12.001L13.9984 17.001", stroke: "inherit", strokeWidth: 1.5, strokeMiterlimit: 10, strokeLinecap: "round", strokeLinejoin: "round" }) });
var panel_collapse_large_line_default = SvgPanelCollapseLargeLine;

// assets/newIcons/panel_expansion-large-line.svg
import * as React322 from "react";
import { jsx as jsx327 } from "react/jsx-runtime";
var SvgPanelExpansionLargeLine = (props) => /* @__PURE__ */ jsx327("svg", { stroke: "black", width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx327("path", { d: "M17.9984 7.00167V17.0017M14.4984 12.001L9.99841 7.00098M14.4984 12.001H4.99841M14.4984 12.001L9.99841 17.001", stroke: "inherit", strokeWidth: 1.5, strokeMiterlimit: 10, strokeLinecap: "round", strokeLinejoin: "round" }) });
var panel_expansion_large_line_default = SvgPanelExpansionLargeLine;

// assets/newIcons/people_counting-large-fill.svg
import * as React323 from "react";
import { jsx as jsx328, jsxs as jsxs70 } from "react/jsx-runtime";
var SvgPeopleCountingLargeFill = (props) => /* @__PURE__ */ jsxs70("svg", { width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "black", xmlns: "http://www.w3.org/2000/svg", ...props, children: [
  /* @__PURE__ */ jsx328("path", { d: "M12.0153 0.500035C10.5125 0.492367 9.23477 1.76038 9.25014 3.26649C9.26025 4.26296 9.80141 5.13583 10.6028 5.61352C7.494 6.1395 5.5 8.45262 5.5 11.6978V14.75C5.5 15.4404 6.05964 16 6.75 16C7.39175 16 7.92055 15.5164 7.99183 14.8937L8 14.8929V12C8 11.7239 8.22388 11.5 8.5 11.5C8.77612 11.5 9 11.7239 9 12V22.25C9 22.9404 9.55969 23.5 10.25 23.5C10.9403 23.5 11.5 22.9404 11.5 22.25V21.9634C11.3351 21.8708 11.1793 21.7559 11.037 21.6184C10.1432 20.7551 10.1184 19.3307 10.9817 18.4369L11.5 17.9003V16C11.5 15.7239 11.7239 15.5 12 15.5C12.2761 15.5 12.5 15.7239 12.5 16V16.8649L13.6159 15.7096C13.9852 15.3272 14.4761 15.0898 15 15.0349V12C15 11.7239 15.2239 11.5 15.5 11.5C15.7761 11.5 16 11.7239 16 12V13.3229C16.3981 12.9666 16.9237 12.75 17.5 12.75H18.5V11.6978C18.5 8.4579 16.5051 6.14703 13.4033 5.6161C14.2083 5.13699 14.75 4.2578 14.75 3.25698C14.75 1.74862 13.5257 0.507702 12.0153 0.500035Z", fill: "inherit" }),
  /* @__PURE__ */ jsx328("path", { d: "M15 20.754L14.2185 21.5631C13.7521 22.046 13.1218 22.2753 12.5 22.2478V22.25C12.5 22.9404 13.0597 23.5 13.75 23.5C14.4403 23.5 15 22.9404 15 22.25V20.754Z", fill: "inherit" }),
  /* @__PURE__ */ jsx328("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M16.75 15C16.75 14.5858 17.0858 14.25 17.5 14.25H21C21.4142 14.25 21.75 14.5858 21.75 15V18.5C21.75 18.9142 21.4142 19.25 21 19.25C20.5858 19.25 20.25 18.9142 20.25 18.5V16.8367L17.526 19.6159C17.3842 19.7605 17.1901 19.8416 16.9876 19.8409C16.7851 19.8402 16.5915 19.7576 16.4509 19.6119L15.2342 18.3523L13.1396 20.521C12.8518 20.819 12.377 20.8272 12.0791 20.5395C11.7811 20.2517 11.7729 19.7769 12.0606 19.479L14.6948 16.7517C14.8361 16.6054 15.0308 16.5227 15.2342 16.5227C15.4377 16.5227 15.6324 16.6054 15.7737 16.7517L16.9943 18.0154L19.2147 15.75H17.5C17.0858 15.75 16.75 15.4142 16.75 15Z", fill: "inherit" })
] });
var people_counting_large_fill_default = SvgPeopleCountingLargeFill;

// assets/newIcons/people_counting-large-line.svg
import * as React324 from "react";
import { jsx as jsx329 } from "react/jsx-runtime";
var SvgPeopleCountingLargeLine = (props) => /* @__PURE__ */ jsx329("svg", { stroke: "black", width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx329("path", { d: "M17.5 15H21M21 15V18.5M21 15L16.9903 19.0909L15.2342 17.2727L12.6001 20M6 11.62C6 7.96 8.68205 6 11.9998 6C15.3176 6 17.9997 7.96 17.9997 11.62M8.99969 10.5V14.0572M8.99969 14.0572C8.99969 14.8272 8.38381 15.4472 7.61893 15.4472H7.39046C6.62558 15.4472 6.0097 14.8272 6.0097 14.0572V11.6172M8.99969 14.0572L9.00916 21.61C9.00916 22.38 9.62504 23 10.3899 23H10.6184C11.0213 23 11.372 22.8009 11.6137 22.5M11.9601 15V17M15.01 14.0572V10.5M18 11.6172V12M14.5 3.50698C14.5 4.87884 13.3789 6 12.007 6C10.6352 6 9.51405 4.8858 9.50012 3.51394C9.4862 2.14905 10.6491 0.993068 12.014 1.00003C13.3858 1.007 14.5 2.13512 14.5 3.50698Z", stroke: "inherit", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }) });
var people_counting_large_line_default = SvgPeopleCountingLargeLine;

// assets/newIcons/people_heatmap-large-line.svg
import * as React325 from "react";
import { jsx as jsx330 } from "react/jsx-runtime";
var SvgPeopleHeatmapLargeLine = (props) => /* @__PURE__ */ jsx330("svg", { stroke: "black", width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx330("path", { d: "M6 11.62C6 7.96 8.68205 6 11.9998 6C14.7886 6 17.1282 7.3848 17.8034 10M8.99969 10.5V14.0572M8.99969 14.0572C8.99969 14.8272 8.38381 15.4472 7.61893 15.4472H7.39046C6.62558 15.4472 6.0097 14.8272 6.0097 14.0572V11.6172M8.99969 14.0572L9.00916 21.61C9.00916 22.38 9.62504 23 10.3899 23H10.6184C10.752 23 10.8799 22.9781 11 22.9378M14.5 3.50698C14.5 4.87884 13.3789 6 12.007 6C10.6352 6 9.51405 4.8858 9.50012 3.51394C9.4862 2.14905 10.6491 0.993068 12.014 1.00003C13.3858 1.007 14.5 2.13512 14.5 3.50698ZM16 15.75H15.75V16H16V15.75ZM16.5 18.5H15.75V19.25H16.5V18.5ZM19.25 19H19V19.25H19.25V19ZM20 22H15C13.8954 22 13 21.1046 13 20V15C13 13.8954 13.8954 13 15 13H20C21.1046 13 22 13.8954 22 15V20C22 21.1046 21.1046 22 20 22Z", stroke: "inherit", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }) });
var people_heatmap_large_line_default = SvgPeopleHeatmapLargeLine;

// assets/newIcons/people-large-line.svg
import * as React326 from "react";
import { jsx as jsx331 } from "react/jsx-runtime";
var SvgPeopleLargeLine = (props) => /* @__PURE__ */ jsx331("svg", { stroke: "black", width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx331("path", { d: "M6 11.62C6 7.96 8.68205 6 11.9998 6C15.3176 6 17.9997 7.96 17.9997 11.62M8.99969 10.5V14.0572M8.99969 14.0572C8.99969 14.8272 8.38381 15.4472 7.61893 15.4472H7.39046C6.62558 15.4472 6.0097 14.8272 6.0097 14.0572V11.6172M8.99969 14.0572L9.00916 21.61C9.00916 22.38 9.62504 23 10.3899 23H10.6184C11.3833 23 11.9601 22.2825 11.9601 21.5125M11.9601 15V21.5125M11.9601 21.5125C11.9601 22.2825 12.6264 23 13.3913 23H13.6198C14.3847 23 15.0005 22.38 15.0005 21.61L15.01 14.0572M15.01 14.0572C15.01 14.8272 15.6259 15.4472 16.3908 15.4472H16.6192C17.3841 15.4472 18 14.8272 18 14.0572V11.6172M15.01 14.0572V10.5M14.5 3.50698C14.5 4.87884 13.3789 6 12.007 6C10.6352 6 9.51405 4.8858 9.50012 3.51394C9.4862 2.14905 10.6491 0.993068 12.014 1.00003C13.3858 1.007 14.5 2.13512 14.5 3.50698Z", stroke: "inherit", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }) });
var people_large_line_default = SvgPeopleLargeLine;

// assets/newIcons/pin-large-fill.svg
import * as React327 from "react";
import { jsx as jsx332 } from "react/jsx-runtime";
var SvgPinLargeFill = (props) => /* @__PURE__ */ jsx332("svg", { width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "black", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx332("path", { d: "M11.25 21L11.25 15.75H6C5.58579 15.75 5.25 15.4142 5.25 15V12.5C5.25 12.3519 5.29383 12.2072 5.37596 12.084L7.25 9.27292V5C7.25 3.48122 8.48122 2.25 10 2.25H14C15.5188 2.25 16.75 3.48122 16.75 5V9.27292L18.624 12.084C18.7062 12.2072 18.75 12.3519 18.75 12.5V15C18.75 15.4142 18.4142 15.75 18 15.75H12.75L12.75 21C12.75 21.4142 12.4142 21.75 12 21.75C11.5858 21.75 11.25 21.4142 11.25 21Z", fill: "inherit" }) });
var pin_large_fill_default = SvgPinLargeFill;

// assets/newIcons/pin-large-line.svg
import * as React328 from "react";
import { jsx as jsx333 } from "react/jsx-runtime";
var SvgPinLargeLine = (props) => /* @__PURE__ */ jsx333("svg", { stroke: "black", width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx333("path", { d: "M12 21L12 15M8 5C8 3.89543 8.89543 3 10 3H14C15.1046 3 16 3.89543 16 5V9.5L18 12.5V15H6V12.5L8 9.5V5Z", stroke: "inherit", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }) });
var pin_large_line_default = SvgPinLargeLine;

// assets/newIcons/pin2-large-fill.svg
import * as React329 from "react";
import { jsx as jsx334 } from "react/jsx-runtime";
var SvgPin2LargeFill = (props) => /* @__PURE__ */ jsx334("svg", { width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "black", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx334("path", { d: "M5.10572 17.8333L8.81803 14.121L5.10572 10.4087C4.81282 10.1158 4.81282 9.64095 5.10572 9.34805L6.87348 7.58029C6.97818 7.47559 7.11153 7.40422 7.25673 7.37518L10.5696 6.71261L13.591 3.6912C14.6649 2.61726 16.4061 2.61726 17.4801 3.6912L20.3085 6.51963C21.3825 7.59357 21.3825 9.33477 20.3085 10.4087L17.2871 13.4301L16.6245 16.743C16.5955 16.8882 16.5241 17.0215 16.4194 17.1262L14.6517 18.894C14.3588 19.1869 13.8839 19.1869 13.591 18.894L9.87869 15.1817L6.16638 18.894C5.87348 19.1869 5.39861 19.1869 5.10572 18.894C4.81282 18.6011 4.81282 18.1262 5.10572 17.8333Z", fill: "inherit" }) });
var pin2_large_fill_default = SvgPin2LargeFill;

// assets/newIcons/pin2-large-line.svg
import * as React330 from "react";
import { jsx as jsx335 } from "react/jsx-runtime";
var SvgPin2LargeLine = (props) => /* @__PURE__ */ jsx335("svg", { stroke: "black", width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx335("path", { d: "M5.63606 18.3639L9.8787 14.1212M14.1213 4.22174C14.9024 3.44069 16.1687 3.44069 16.9498 4.22174L19.7782 7.05016C20.5592 7.83121 20.5592 9.09754 19.7782 9.87859L16.5962 13.0606L15.8891 16.5961L14.1213 18.3639L5.63606 9.87859L7.40382 8.11082L10.9394 7.40372L14.1213 4.22174Z", stroke: "inherit", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }) });
var pin2_large_line_default = SvgPin2LargeLine;

// assets/newIcons/playback-large-line.svg
import * as React331 from "react";
import { jsx as jsx336, jsxs as jsxs71 } from "react/jsx-runtime";
var SvgPlaybackLargeLine = (props) => /* @__PURE__ */ jsxs71("svg", { stroke: "black", width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: [
  /* @__PURE__ */ jsx336("path", { d: "M9.5 9.40116C9.5 8.80214 10.1676 8.44485 10.666 8.77713L14.5639 11.3757C15.0092 11.6726 15.0092 12.3269 14.5639 12.6238L10.666 15.2224C10.1676 15.5547 9.5 15.1974 9.5 14.5984V9.40116Z", stroke: "inherit", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }),
  /* @__PURE__ */ jsx336("path", { d: "M3 5C3 3.89543 3.89543 3 5 3H19C20.1046 3 21 3.89543 21 5V19C21 20.1046 20.1046 21 19 21H5C3.89543 21 3 20.1046 3 19V5Z", stroke: "inherit", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" })
] });
var playback_large_line_default = SvgPlaybackLargeLine;

// assets/newIcons/PoE-large-line.svg
import * as React332 from "react";
import { jsx as jsx337 } from "react/jsx-runtime";
var SvgPoELargeLine = (props) => /* @__PURE__ */ jsx337("svg", { stroke: "black", width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx337("path", { d: "M12 14V17M12 17C13.1046 17 14 17.8954 14 19M12 17C10.8954 17 10 17.8954 10 19M14 19C14 20.1046 13.1046 21 12 21C10.8954 21 10 20.1046 10 19M14 19H21M10 19H3M10.375 10H10.38M13.625 10H13.63M7.125 10H7.13M16.875 10H16.88M5 14H19C20.1046 14 21 13.1046 21 12V8C21 6.89543 20.1046 6 19 6H5C3.89543 6 3 6.89543 3 8V12C3 13.1046 3.89543 14 5 14ZM10.625 10C10.625 10.1381 10.5131 10.25 10.375 10.25C10.2369 10.25 10.125 10.1381 10.125 10C10.125 9.86193 10.2369 9.75 10.375 9.75C10.5131 9.75 10.625 9.86193 10.625 10ZM13.875 10C13.875 10.1381 13.7631 10.25 13.625 10.25C13.4869 10.25 13.375 10.1381 13.375 10C13.375 9.86193 13.4869 9.75 13.625 9.75C13.7631 9.75 13.875 9.86193 13.875 10ZM7.375 10C7.375 10.1381 7.26307 10.25 7.125 10.25C6.98693 10.25 6.875 10.1381 6.875 10C6.875 9.86193 6.98693 9.75 7.125 9.75C7.26307 9.75 7.375 9.86193 7.375 10ZM17.125 10C17.125 10.1381 17.0131 10.25 16.875 10.25C16.7369 10.25 16.625 10.1381 16.625 10C16.625 9.86193 16.7369 9.75 16.875 9.75C17.0131 9.75 17.125 9.86193 17.125 10Z", stroke: "inherit", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }) });
var PoE_large_line_default = SvgPoELargeLine;

// assets/newIcons/PTZ-large-line.svg
import * as React333 from "react";
import { jsx as jsx338 } from "react/jsx-runtime";
var SvgPtzLargeLine = (props) => /* @__PURE__ */ jsx338("svg", { stroke: "black", width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx338("path", { d: "M17 12H22M22 12L19 15M22 12L19 9M7 12H2M2 12L5 9M2 12L5 15M12 22L9 19M12 22L15 19M12 22V17M12 2L15 5M12 2L9 5M12 2V7M14 12C14 13.1046 13.1046 14 12 14C10.8954 14 10 13.1046 10 12C10 10.8954 10.8954 10 12 10C13.1046 10 14 10.8954 14 12Z", stroke: "inherit", strokeWidth: 1.5, strokeMiterlimit: 10, strokeLinecap: "round", strokeLinejoin: "round" }) });
var PTZ_large_line_default = SvgPtzLargeLine;

// assets/newIcons/queue_management-large-line.svg
import * as React334 from "react";
import { jsx as jsx339 } from "react/jsx-runtime";
var SvgQueueManagementLargeLine = (props) => /* @__PURE__ */ jsx339("svg", { stroke: "black", width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx339("path", { d: "M3 12.7722C3 9.8076 5.17246 8.22 7.85987 8.22C10.5473 8.22 12.7197 9.8076 12.7197 12.7722M5.42975 11.865V14.7463M5.42975 14.7463C5.42975 15.37 4.93089 15.8722 4.31133 15.8722H4.12627C3.50672 15.8722 3.00786 15.37 3.00786 14.7463V12.7699M5.42975 14.7463L5.43742 20.8641C5.43742 21.4878 5.93628 21.99 6.55583 21.99H6.74089C7.36045 21.99 7.82769 21.4088 7.82769 20.7851M7.82769 15.51V20.7851M7.82769 20.7851C7.82769 21.4088 8.36741 21.99 8.98696 21.99H9.17202C9.79158 21.99 10.2904 21.4878 10.2904 20.8641L10.2981 14.7463M10.2981 14.7463C10.2981 15.37 10.797 15.8722 11.4165 15.8722H11.6016C12.2211 15.8722 12.72 15.37 12.72 14.7463V12.7699M10.2981 14.7463V11.865M11.26 3.67008C11.62 3.31008 12.13 3.08008 12.68 3.08008C13.8 3.08008 14.7 4.00008 14.7 5.12008C14.7 6.12008 14.15 6.96008 13.19 7.11008C14.74 7.47008 16.94 9.40008 16.94 12.5101V13.6001C16.94 14.6701 15.85 15.3901 15.12 15.3901V19.4501M15.83 2.3C16.14 2.1 16.5 2 16.88 2C18 2 18.9 2.92 18.9 4.04C18.9 5.04 18.35 5.98 17.39 6.14C18.94 6.5 21.14 8.33 21.14 11.43V12.52C21.14 13.6 20.05 14.31 19.32 14.31V18.32M15.13 19.4399C15.13 20.2299 14.5 20.8599 13.72 20.8599H13.48C13.19 20.8599 12.9 20.7599 12.67 20.5799M19.33 18.3C19.33 19.09 18.7 19.72 17.92 19.72H17.68C17.63 19.72 17.57 19.72 17.51 19.71M9.88502 6.20067C9.88502 7.31187 8.9769 8.22001 7.86571 8.22001C6.75453 8.22001 5.8464 7.31751 5.83512 6.20631C5.82384 5.10074 6.76581 4.1644 7.87135 4.17004C8.98254 4.17568 9.88502 5.08946 9.88502 6.20067Z", stroke: "inherit", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }) });
var queue_management_large_line_default = SvgQueueManagementLargeLine;

// assets/newIcons/ram-large-line.svg
import * as React335 from "react";
import { jsx as jsx340 } from "react/jsx-runtime";
var SvgRamLargeLine = (props) => /* @__PURE__ */ jsx340("svg", { stroke: "black", width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx340("path", { d: "M7 12H10M6 17V19M12 17V19M18 17V19M6 5V7M12 5V7M18 5V7M5 17H19C20.1046 17 21 16.1046 21 15V9C21 7.89543 20.1046 7 19 7H5C3.89543 7 3 7.89543 3 9V15C3 16.1046 3.89543 17 5 17Z", stroke: "inherit", strokeWidth: 1.5, strokeMiterlimit: 10, strokeLinecap: "round" }) });
var ram_large_line_default = SvgRamLargeLine;

// assets/newIcons/refresh-large-line.svg
import * as React336 from "react";
import { jsx as jsx341 } from "react/jsx-runtime";
var SvgRefreshLargeLine = (props) => /* @__PURE__ */ jsx341("svg", { stroke: "black", width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx341("path", { d: "M20.0781 16C18.6054 18.9634 15.5474 21 12.0136 21C7.21086 21 3.28674 17.238 3.0273 12.5M20.0781 16H15.5137M20.0781 16H20.5137V21M3.94917 8C5.42188 5.03656 8.47993 3 12.0137 3C16.8164 3 20.7406 6.76201 21 11.5M3.94917 8H8.51367M3.94917 8H3.51367V3", stroke: "inherit", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }) });
var refresh_large_line_default = SvgRefreshLargeLine;

// assets/newIcons/remove-large-fill.svg
import * as React337 from "react";
import { jsx as jsx342 } from "react/jsx-runtime";
var SvgRemoveLargeFill = (props) => /* @__PURE__ */ jsx342("svg", { width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "black", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx342("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10 2.25C8.48122 2.25 7.25 3.48122 7.25 5V5.25H3C2.58579 5.25 2.25 5.58579 2.25 6C2.25 6.41421 2.58579 6.75 3 6.75H4.25V19C4.25 20.5188 5.48122 21.75 7 21.75H17C18.5188 21.75 19.75 20.5188 19.75 19V6.75H21C21.4142 6.75 21.75 6.41421 21.75 6C21.75 5.58579 21.4142 5.25 21 5.25H16.75V5C16.75 3.48122 15.5188 2.25 14 2.25H10ZM15.25 5.25H8.75V5C8.75 4.30964 9.30964 3.75 10 3.75H14C14.6904 3.75 15.25 4.30964 15.25 5V5.25ZM10.75 11C10.75 10.5858 10.4142 10.25 10 10.25C9.58579 10.25 9.25 10.5858 9.25 11V16C9.25 16.4142 9.58579 16.75 10 16.75C10.4142 16.75 10.75 16.4142 10.75 16V11ZM14 10.25C14.4142 10.25 14.75 10.5858 14.75 11V16C14.75 16.4142 14.4142 16.75 14 16.75C13.5858 16.75 13.25 16.4142 13.25 16V11C13.25 10.5858 13.5858 10.25 14 10.25Z", fill: "inherit" }) });
var remove_large_fill_default = SvgRemoveLargeFill;

// assets/newIcons/remove-large-line.svg
import * as React338 from "react";
import { jsx as jsx343 } from "react/jsx-runtime";
var SvgRemoveLargeLine = (props) => /* @__PURE__ */ jsx343("svg", { stroke: "black", width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx343("path", { d: "M3 6H21M10 11V16M14 11V16M5 6H19V19C19 20.1046 18.1046 21 17 21H7C5.89543 21 5 20.1046 5 19V6ZM16 6V5C16 3.89543 15.1046 3 14 3H10C8.89543 3 8 3.89543 8 5V6H16Z", stroke: "inherit", strokeWidth: 1.5, strokeLinecap: "round" }) });
var remove_large_line_default = SvgRemoveLargeLine;

// assets/newIcons/reports-large-fill.svg
import * as React339 from "react";
import { jsx as jsx344 } from "react/jsx-runtime";
var SvgReportsLargeFill = (props) => /* @__PURE__ */ jsx344("svg", { width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "black", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx344("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M14.5 2.25C15.4793 2.25 16.31 2.87657 16.6191 3.75H17.5C19.0188 3.75 20.25 4.98122 20.25 6.5V19C20.25 20.5188 19.0188 21.75 17.5 21.75H6.5C4.98122 21.75 3.75 20.5188 3.75 19V6.5C3.75 4.98122 4.98122 3.75 6.5 3.75H7.38086C7.68999 2.87657 8.52067 2.25 9.5 2.25H14.5ZM16.5303 10.4697C16.2374 10.1768 15.7626 10.1769 15.4697 10.4697L13 12.9395L11.5303 11.4697C11.2557 11.1951 10.8209 11.1777 10.5264 11.418L10.4697 11.4697L7.46973 14.4697C7.17683 14.7626 7.17683 15.2374 7.46973 15.5303C7.76262 15.8231 8.23739 15.8232 8.53027 15.5303L11 13.0605L12.4697 14.5303C12.7626 14.8231 13.2374 14.8232 13.5303 14.5303L16.5303 11.5303C16.8231 11.2374 16.8231 10.7626 16.5303 10.4697ZM9.5 3.75C9.08579 3.75 8.75 4.08579 8.75 4.5C8.75 4.91421 9.08579 5.25 9.5 5.25H14.5C14.9142 5.25 15.25 4.91421 15.25 4.5C15.25 4.08579 14.9142 3.75 14.5 3.75H9.5Z", fill: "inherit" }) });
var reports_large_fill_default = SvgReportsLargeFill;

// assets/newIcons/reports-large-line.svg
import * as React340 from "react";
import { jsx as jsx345 } from "react/jsx-runtime";
var SvgReportsLargeLine = (props) => /* @__PURE__ */ jsx345("svg", { stroke: "black", width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx345("path", { d: "M8 4.5C8 5.32843 8.67157 6 9.5 6H14.5C15.3284 6 16 5.32843 16 4.5M8 4.5C8 3.67157 8.67157 3 9.5 3H14.5C15.3284 3 16 3.67157 16 4.5M8 4.5H6.5C5.39543 4.5 4.5 5.39543 4.5 6.5V19C4.5 20.1046 5.39543 21 6.5 21H17.5C18.6046 21 19.5 20.1046 19.5 19V6.5C19.5 5.39543 18.6046 4.5 17.5 4.5H16M8 15L11 12L13 14L16 11", stroke: "inherit", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }) });
var reports_large_line_default = SvgReportsLargeLine;

// assets/newIcons/reset-large-line.svg
import * as React341 from "react";
import { jsx as jsx346 } from "react/jsx-runtime";
var SvgResetLargeLine = (props) => /* @__PURE__ */ jsx346("svg", { stroke: "black", width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx346("path", { d: "M21 4H16M16 4V9M16 4C18.7298 5.54563 21 8.63909 21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3", stroke: "inherit", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }) });
var reset_large_line_default = SvgResetLargeLine;

// assets/newIcons/rule_setup-large-line.svg
import * as React342 from "react";
import { jsx as jsx347 } from "react/jsx-runtime";
var SvgRuleSetupLargeLine = (props) => /* @__PURE__ */ jsx347("svg", { stroke: "black", width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx347("path", { d: "M8 7H12M15.5 7H12M16 17H14C12.8954 17 12 16.1046 12 15V7M16 14L22 17.5L16 21V14ZM2 4H8V10H2V4ZM21.5 7C21.5 7.59334 21.3241 8.17336 20.9944 8.66671C20.6648 9.16006 20.1962 9.54458 19.6481 9.77164C19.0999 9.9987 18.4967 10.0581 17.9147 9.94236C17.3328 9.8266 16.7982 9.54088 16.3787 9.12132C15.9591 8.70176 15.6734 8.16721 15.5576 7.58527C15.4419 7.00333 15.5013 6.40013 15.7284 5.85195C15.9554 5.30377 16.3399 4.83524 16.8333 4.50559C17.3266 4.17595 17.9067 4 18.5 4C19.2957 4 20.0587 4.31607 20.6213 4.87868C21.1839 5.44129 21.5 6.20435 21.5 7Z", stroke: "inherit", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }) });
var rule_setup_large_line_default = SvgRuleSetupLargeLine;

// assets/newIcons/search-large-line.svg
import * as React343 from "react";
import { jsx as jsx348 } from "react/jsx-runtime";
var SvgSearchLargeLine = (props) => /* @__PURE__ */ jsx348("svg", { stroke: "black", width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx348("path", { d: "M15.8283 15.7782C17.1708 14.423 18 12.5583 18 10.5C18 6.35786 14.6421 3 10.5 3C6.35786 3 3 6.35786 3 10.5C3 14.6421 6.35786 18 10.5 18C12.5838 18 14.4691 17.1502 15.8283 15.7782ZM15.8283 15.7782L21 21", stroke: "inherit", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }) });
var search_large_line_default = SvgSearchLargeLine;

// assets/newIcons/server_gateway-large-line.svg
import * as React344 from "react";
import { jsx as jsx349 } from "react/jsx-runtime";
var SvgServerGatewayLargeLine = (props) => /* @__PURE__ */ jsx349("svg", { stroke: "black", width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx349("path", { d: "M12 15V18M12 18C13.1046 18 14 18.8954 14 20M12 18C10.8954 18 10 18.8954 10 20M14 20C14 21.1046 13.1046 22 12 22C10.8954 22 10 21.1046 10 20M14 20H21M10 20H3M8 6H11M8 12H11M6 9H18M6 9C4.89543 9 4 8.10457 4 7V5C4 3.89543 4.89543 3 6 3H18C19.1046 3 20 3.89543 20 5V7C20 8.10457 19.1046 9 18 9M6 9C4.89543 9 4 9.89543 4 11V13C4 14.1046 4.89543 15 6 15H18C19.1046 15 20 14.1046 20 13V11C20 9.89543 19.1046 9 18 9", stroke: "inherit", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }) });
var server_gateway_large_line_default = SvgServerGatewayLargeLine;

// assets/newIcons/server-large-line.svg
import * as React345 from "react";
import { jsx as jsx350 } from "react/jsx-runtime";
var SvgServerLargeLine = (props) => /* @__PURE__ */ jsx350("svg", { stroke: "black", width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx350("path", { d: "M7 8H10M7 16H10M5 12H19M5 12C3.89543 12 3 11.1046 3 10V6C3 4.89543 3.89543 4 5 4H19C20.1046 4 21 4.89543 21 6V10C21 11.1046 20.1046 12 19 12M5 12C3.89543 12 3 12.8954 3 14V18C3 19.1046 3.89543 20 5 20H19C20.1046 20 21 19.1046 21 18V14C21 12.8954 20.1046 12 19 12", stroke: "inherit", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }) });
var server_large_line_default = SvgServerLargeLine;

// assets/newIcons/setting-large-fill.svg
import * as React346 from "react";
import { jsx as jsx351 } from "react/jsx-runtime";
var SvgSettingLargeFill = (props) => /* @__PURE__ */ jsx351("svg", { width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "black", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx351("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10.2277 2.4038C10.8053 2.30185 11.3977 2.25 12 2.25C12.6006 2.25 13.1886 2.30493 13.7594 2.40576C14.3413 2.50856 14.7187 2.89217 14.9437 3.26873C15.1643 3.63803 15.2783 4.05965 15.3363 4.41021C15.3937 4.75667 15.6053 5.08368 15.9588 5.28497C16.3247 5.49328 16.7497 5.50571 17.117 5.35341C17.4446 5.21753 17.8537 5.10359 18.2735 5.10801C18.7028 5.11253 19.202 5.24554 19.5753 5.67088C20.3508 6.55446 20.9668 7.57406 21.3813 8.69038C21.5838 9.23564 21.4513 9.74907 21.2363 10.1328C21.0264 10.5074 20.7135 10.8113 20.4214 11.03C20.1128 11.2611 19.9254 11.6098 19.9254 12C19.9254 12.3892 20.1116 12.7393 20.4157 12.97C20.7056 13.1901 21.0192 13.4955 21.2302 13.8709C21.4461 14.2552 21.5818 14.7716 21.3772 15.3207C20.9627 16.4327 20.3482 17.4485 19.5753 18.3291C19.2019 18.7545 18.7026 18.8873 18.2738 18.8922C17.8544 18.897 17.4455 18.7839 17.1183 18.6497C16.7511 18.499 16.3228 18.5118 15.9534 18.7181C15.6032 18.9136 15.3905 19.2422 15.3349 19.5956C15.28 19.9454 15.1693 20.3659 14.9511 20.7345C14.7284 21.111 14.3528 21.4937 13.7723 21.5962C13.1947 21.6982 12.6024 21.75 12 21.75C11.3995 21.75 10.8115 21.6951 10.2407 21.5942C9.65897 21.4915 9.28133 21.1081 9.05621 20.7314C8.83539 20.3618 8.72138 19.9398 8.66392 19.5883C8.60662 19.2376 8.39443 18.9123 8.04667 18.7181L8.04123 18.715C7.67537 18.5067 7.25032 18.4943 6.8831 18.6466C6.55548 18.7825 6.14634 18.8964 5.72653 18.892C5.29727 18.8875 4.7981 18.7545 4.42479 18.3291C3.64927 17.4455 3.03327 16.4259 2.61875 15.3096C2.41628 14.7644 2.54878 14.2509 2.76379 13.8672C2.97366 13.4926 3.28659 13.1887 3.57869 12.97C3.8873 12.7389 4.07463 12.3902 4.07463 12C4.07463 11.6108 3.88845 11.2607 3.58438 11.03C3.29446 10.8099 2.98082 10.5045 2.76988 10.1291C2.55394 9.74479 2.41821 9.22841 2.62287 8.6793C3.03735 7.56731 3.65184 6.55154 4.42479 5.67088C4.79818 5.24545 5.29742 5.11266 5.72622 5.10778C6.14567 5.103 6.55458 5.21607 6.88175 5.35031C7.24893 5.50096 7.67729 5.48818 8.04667 5.28191C8.39682 5.08638 8.60959 4.75782 8.6651 4.40438C8.72003 4.05465 8.83078 3.63415 9.0489 3.26549C9.27169 2.88896 9.64724 2.50625 10.2277 2.4038ZM12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z", fill: "inherit" }) });
var setting_large_fill_default = SvgSettingLargeFill;

// assets/newIcons/setting-large-line.svg
import * as React347 from "react";
import { jsx as jsx352, jsxs as jsxs72 } from "react/jsx-runtime";
var SvgSettingLargeLine = (props) => /* @__PURE__ */ jsxs72("svg", { stroke: "black", width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: [
  /* @__PURE__ */ jsx352("path", { d: "M19.1908 12C19.1908 11.3571 19.5036 10.7923 19.9889 10.4297C20.4675 10.0721 20.9049 9.51069 20.6968 8.95145C20.3141 7.92296 19.7448 6.98217 19.0266 6.16561C18.6414 5.72768 17.9552 5.82297 17.4159 6.04619C16.8456 6.28219 16.1751 6.26607 15.5954 5.93674C15.0423 5.62252 14.696 5.09994 14.602 4.53264C14.5026 3.93331 14.2319 3.25 13.6324 3.14433C13.1014 3.05073 12.5559 3 12 3C11.4395 3 10.8897 3.04813 10.3545 3.14238C9.75919 3.24724 9.49423 3.9248 9.40042 4.52076C9.30993 5.09568 8.96243 5.62591 8.4046 5.93674C7.82536 6.25949 7.1554 6.27753 6.58544 6.04418C6.04521 5.823 5.35858 5.72768 4.97339 6.16561C4.25755 6.97946 3.68967 7.91674 3.30699 8.94124C3.09685 9.50383 3.54139 10.0696 4.02068 10.4325C4.5005 10.7959 4.8092 11.3614 4.8092 12C4.8092 12.6429 4.49638 13.2077 4.01106 13.5703C3.53252 13.9279 3.09508 14.4893 3.30318 15.0485C3.6859 16.077 4.25517 17.0178 4.97339 17.8344C5.35858 18.2723 6.04476 18.177 6.58414 17.9538C7.15439 17.7178 7.82492 17.7339 8.4046 18.0633C8.95856 18.3719 9.30509 18.897 9.3985 19.4673C9.4967 20.0668 9.76811 20.75 10.3676 20.8557C10.8986 20.9493 11.4441 21 12 21C12.5605 21 13.1103 20.9519 13.6455 20.8576C14.2408 20.7528 14.5058 20.0752 14.5996 19.4792C14.6901 18.9043 15.0376 18.3741 15.5954 18.0633C16.1746 17.7405 16.8446 17.7225 17.4146 17.9558C17.9548 18.177 18.6414 18.2723 19.0266 17.8344C19.7425 17.0205 20.3103 16.0833 20.693 15.0588C20.9032 14.4962 20.4586 13.9304 19.9793 13.5675C19.4995 13.2041 19.1908 12.6386 19.1908 12Z", stroke: "inherit", strokeWidth: 1.5 }),
  /* @__PURE__ */ jsx352("path", { d: "M15.0064 12C15.0064 13.6569 13.6604 15 12 15C10.3396 15 8.99356 13.6569 8.99356 12C8.99356 10.3431 10.3396 9 12 9C13.6604 9 15.0064 10.3431 15.0064 12Z", stroke: "inherit", strokeWidth: 1.5 })
] });
var setting_large_line_default = SvgSettingLargeLine;

// assets/newIcons/share-large-line.svg
import * as React348 from "react";
import { jsx as jsx353 } from "react/jsx-runtime";
var SvgShareLargeLine = (props) => /* @__PURE__ */ jsx353("svg", { stroke: "black", width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx353("path", { d: "M15 6.5L9 10M9 14L15 17.5M18 8C16.3431 8 15 6.65685 15 5C15 3.34315 16.3431 2 18 2C19.6569 2 21 3.34315 21 5C21 6.65685 19.6569 8 18 8ZM18 22C16.3431 22 15 20.6569 15 19C15 17.3431 16.3431 16 18 16C19.6569 16 21 17.3431 21 19C21 20.6569 19.6569 22 18 22ZM6 15C4.34315 15 3 13.6569 3 12C3 10.3431 4.34315 9 6 9C7.65685 9 9 10.3431 9 12C9 13.6569 7.65685 15 6 15Z", stroke: "inherit", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }) });
var share_large_line_default = SvgShareLargeLine;

// assets/newIcons/shock_detection-large-line.svg
import * as React349 from "react";
import { jsx as jsx354 } from "react/jsx-runtime";
var SvgShockDetectionLargeLine = (props) => /* @__PURE__ */ jsx354("svg", { stroke: "black", width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx354("path", { d: "M17.3333 10.5714L17.973 8.93653C18.0992 8.4672 17.7674 8 17.3079 8H6.69207C6.23255 8 5.90079 8.4672 6.02703 8.93653L6.66667 10.5714M17.3333 10.5714V12.102C17.3333 14.8071 14.9455 17 12 17C9.05448 17 6.66667 14.8071 6.66667 12.102V10.5714M17.3333 10.5714H6.66667M12 13.75H12.005M3.83579 6L2.54289 7.29289C2.15237 7.68342 2.15237 8.31658 2.54289 8.70711L3.12868 9.29289C3.5192 9.68342 3.5192 10.3166 3.12868 10.7071L2.54289 11.2929C2.15237 11.6834 2.15237 12.3166 2.54289 12.7071L3.12868 13.2929C3.5192 13.6834 3.5192 14.3166 3.12868 14.7071L2.54289 15.2929C2.15237 15.6834 2.15237 16.3166 2.54289 16.7071L3.83579 18M20.16 6L21.4529 7.29289C21.8434 7.68342 21.8434 8.31658 21.4529 8.70711L20.8671 9.29289C20.4766 9.68342 20.4766 10.3166 20.8671 10.7071L21.4529 11.2929C21.8434 11.6834 21.8434 12.3166 21.4529 12.7071L20.8671 13.2929C20.4766 13.6834 20.4766 14.3166 20.8671 14.7071L21.4529 15.2929C21.8434 15.6834 21.8434 16.3166 21.4529 16.7071L20.16 18M12.5 13.75C12.5 14.0261 12.2761 14.25 12 14.25C11.7239 14.25 11.5 14.0261 11.5 13.75C11.5 13.4739 11.7239 13.25 12 13.25C12.2761 13.25 12.5 13.4739 12.5 13.75Z", stroke: "inherit", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }) });
var shock_detection_large_line_default = SvgShockDetectionLargeLine;

// assets/newIcons/shopping_cart_counting-large-line.svg
import * as React350 from "react";
import { jsx as jsx355 } from "react/jsx-runtime";
var SvgShoppingCartCountingLargeLine = (props) => /* @__PURE__ */ jsx355("svg", { stroke: "black", width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx355("path", { d: "M17.5 15H21M21 15V18.5M21 15L17 19L15.2342 17.2727L12.6001 20M19.219 12.2486L20 6.00049H5L5.78101 12.2486C5.90612 13.2494 6.75692 14.0005 7.76556 14.0005H15.25M2 3H4.5L6.37503 17.0005M7 17.0005H12.25M8 18.5005C8 19.3289 7.32843 20.0005 6.5 20.0005C5.67157 20.0005 5 19.3289 5 18.5005C5 17.6721 5.67157 17.0005 6.5 17.0005C7.32843 17.0005 8 17.6721 8 18.5005Z", stroke: "inherit", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }) });
var shopping_cart_counting_large_line_default = SvgShoppingCartCountingLargeLine;

// assets/newIcons/shopping_cart_heatmap-large-line.svg
import * as React351 from "react";
import { jsx as jsx356 } from "react/jsx-runtime";
var SvgShoppingCartHeatmapLargeLine = (props) => /* @__PURE__ */ jsx356("svg", { stroke: "black", width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx356("path", { d: "M2 3H4.5L6.37503 17.0005M7 17.0005L10 17M10 14.0005H7.76556C6.75692 14.0005 5.90612 13.2494 5.78101 12.2486L5 6.00049H20L19.5001 10M8 18.5005C8 19.3289 7.32843 20.0005 6.5 20.0005C5.67157 20.0005 5 19.3289 5 18.5005C5 17.6721 5.67157 17.0005 6.5 17.0005C7.32843 17.0005 8 17.6721 8 18.5005ZM16 15.75H15.75V16H16V15.75ZM16.5 18.5H15.75V19.25H16.5V18.5ZM19.25 19H19V19.25H19.25V19ZM20 22H15C13.8954 22 13 21.1046 13 20V15C13 13.8954 13.8954 13 15 13H20C21.1046 13 22 13.8954 22 15V20C22 21.1046 21.1046 22 20 22Z", stroke: "inherit", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }) });
var shopping_cart_heatmap_large_line_default = SvgShoppingCartHeatmapLargeLine;

// assets/newIcons/shopping_cart_queue_management-large-line.svg
import * as React352 from "react";
import { jsx as jsx357 } from "react/jsx-runtime";
var SvgShoppingCartQueueManagementLargeLine = (props) => /* @__PURE__ */ jsx357("svg", { stroke: "black", width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx357("path", { d: "M2 8.29947H3.86802L5.26904 18.7665M5.36041 18.7665C4.74112 18.7665 4.24366 19.264 4.24366 19.8832C4.24366 20.5025 4.74112 21 5.36041 21C5.9797 21 6.47716 20.5025 6.47716 19.8832C6.47716 19.264 5.9797 18.7665 5.36041 18.7665ZM5.36041 18.7665H14.0559M4.53808 5.62954H6.4061L6.78173 7.87319H18L17.2081 13.7311C17.1472 14.1879 16.8934 14.5737 16.5381 14.8072M7.40109 3H9.26912L9.64475 5.24366H21.1067L20.193 11.6802C20.1422 12.0762 19.9392 12.4213 19.6549 12.6548M14.066 18.7665C13.4467 18.7665 12.9493 19.264 12.9493 19.8832C12.9493 20.5025 13.4467 21 14.066 21C14.6853 21 15.1828 20.5025 15.1828 19.8832C15.1828 19.264 14.6853 18.7665 14.066 18.7665ZM4.24366 10.5431H14.934L14.3452 15.2132C14.2538 15.9645 13.6142 16.5228 12.863 16.5228H6.31473C5.56346 16.5228 4.92386 15.9645 4.83249 15.2132L4.24366 10.5431Z", stroke: "inherit", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }) });
var shopping_cart_queue_management_large_line_default = SvgShoppingCartQueueManagementLargeLine;

// assets/newIcons/shopping_cart-large-line.svg
import * as React353 from "react";
import { jsx as jsx358 } from "react/jsx-runtime";
var SvgShoppingCartLargeLine = (props) => /* @__PURE__ */ jsx358("svg", { stroke: "black", width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx358("path", { d: "M2 3H4.5L6.37503 17.0005M17.5 17.0005C16.6716 17.0005 16 17.6721 16 18.5005C16 19.3289 16.6716 20.0005 17.5 20.0005C18.3284 20.0005 19 19.3289 19 18.5005C19 17.6721 18.3284 17.0005 17.5 17.0005ZM17.5 17.0005H7M5 6.00049H20L19.219 12.2486C19.0939 13.2494 18.2431 14.0005 17.2344 14.0005H7.76556C6.75692 14.0005 5.90612 13.2494 5.78101 12.2486L5 6.00049ZM8 18.5005C8 19.3289 7.32843 20.0005 6.5 20.0005C5.67157 20.0005 5 19.3289 5 18.5005C5 17.6721 5.67157 17.0005 6.5 17.0005C7.32843 17.0005 8 17.6721 8 18.5005Z", stroke: "inherit", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }) });
var shopping_cart_large_line_default = SvgShoppingCartLargeLine;

// assets/newIcons/slip_fall-large-line.svg
import * as React354 from "react";
import { jsx as jsx359 } from "react/jsx-runtime";
var SvgSlipFallLargeLine = (props) => /* @__PURE__ */ jsx359("svg", { stroke: "black", width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx359("path", { d: "M5.32567 12.0197L2 12.7502L4.76614 15.003L3.42947 18.7292L6.75565 17.998L7.42896 21L9.05604 17.6353M21.0293 16.7503L18.545 13.4941C18.545 13.4941 18.5208 13.4664 18.5136 13.4538C18.4749 13.401 18.4238 13.3554 18.3826 13.3125C18.3485 13.2821 18.3144 13.2517 18.2876 13.2339C18.2535 13.2035 18.2096 13.1705 18.163 13.1473C18.1191 13.1143 18.0726 13.0911 18.0162 13.0654C17.9769 13.0548 17.95 13.0369 17.9133 13.0164C17.8543 13.0005 17.7881 12.9721 17.7291 12.9562C17.6996 12.9482 17.6701 12.9403 17.6504 12.935C17.5816 12.9164 17.5003 12.9051 17.4262 12.9063C17.4065 12.901 17.3967 12.8984 17.3744 12.903C17.2806 12.8989 17.194 12.9074 17.1048 12.9257C17.1048 12.9257 17.1048 12.9257 17.095 12.9231L16.9959 12.9388C16.9959 12.9388 16.9638 12.9407 16.9513 12.948L16.5873 13.0089L17.5532 11.9546L20.1365 12.5448C20.9607 12.7351 21.7745 12.2124 21.9611 11.3933C22.1503 10.5644 21.6305 9.74586 20.8162 9.5582L17.3793 8.76977C17.0423 8.68955 16.7032 8.73597 16.4144 8.87019C16.3895 8.88467 16.3672 8.88926 16.3423 8.90374C16.2826 8.93006 16.2327 8.95902 16.1802 8.99788C16.1303 9.02684 16.0902 9.05845 16.0476 9.09996C16.02 9.12433 15.9924 9.1487 15.9648 9.17308C15.9373 9.19745 15.9123 9.21193 15.8946 9.23895L13.9751 11.3402L12.2012 9.01749L14.6793 5.41299C15.1602 4.71568 14.9836 3.75638 14.2903 3.2727C13.597 2.78902 12.6432 2.96663 12.1623 3.66393L8.12792 9.50994C7.78367 10.0108 7.78292 10.6467 8.06105 11.1457C8.06105 11.1457 8.06825 11.1583 8.07545 11.1708C8.08985 11.1959 8.09705 11.2084 8.11144 11.2335C8.14744 11.2962 8.18344 11.3589 8.22927 11.4243L11.8497 16.1529C12.2871 16.7266 13.0326 16.8957 13.6645 16.6208L16.6911 16.1007L18.6123 18.6221C19.1296 19.2916 20.0857 19.422 20.7513 18.9017C21.4169 18.3814 21.5466 17.4198 21.0293 16.7503ZM9 6.5C9 7.88071 7.88071 9 6.5 9C5.11929 9 4 7.88071 4 6.5C4 5.11929 5.11929 4 6.5 4C7.88071 4 9 5.11929 9 6.5Z", stroke: "inherit", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }) });
var slip_fall_large_line_default = SvgSlipFallLargeLine;

// assets/newIcons/software_update-large-line.svg
import * as React355 from "react";
import { jsx as jsx360 } from "react/jsx-runtime";
var SvgSoftwareUpdateLargeLine = (props) => /* @__PURE__ */ jsx360("svg", { stroke: "black", width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx360("path", { d: "M9 2V4M15 2V4M2 9H4M2 15H4M9 20V22M15 20V22M20 15H22M20 9H22M8.18599 13.8889C8.88249 15.2883 10.3288 16.25 12 16.25C14.2714 16.25 16.1273 14.4735 16.25 12.2361M8.18599 13.8889H10.3447M8.18599 13.8889H8V16.25M15.814 10.1111C15.1175 8.71171 13.6712 7.75 12 7.75C9.72857 7.75 7.8727 9.5265 7.75 11.7639M15.814 10.1111H13.6553M15.814 10.1111H16.02V7.75M6 20H18C19.1046 20 20 19.1046 20 18V6C20 4.89543 19.1046 4 18 4H6C4.89543 4 4 4.89543 4 6V18C4 19.1046 4.89543 20 6 20Z", stroke: "inherit", strokeWidth: 1.25, strokeLinecap: "round", strokeLinejoin: "round" }) });
var software_update_large_line_default = SvgSoftwareUpdateLargeLine;

// assets/newIcons/sort_arrow_down-large-line.svg
import * as React356 from "react";
import { jsx as jsx361 } from "react/jsx-runtime";
var SvgSortArrowDownLargeLine = (props) => /* @__PURE__ */ jsx361("svg", { stroke: "black", width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx361("path", { d: "M16 17L12 21M12 21L8 17M12 21L12 3", stroke: "inherit", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }) });
var sort_arrow_down_large_line_default = SvgSortArrowDownLargeLine;

// assets/newIcons/sort_arrow_down-medium-line.svg
import * as React357 from "react";
import { jsx as jsx362 } from "react/jsx-runtime";
var SvgSortArrowDownMediumLine = (props) => /* @__PURE__ */ jsx362("svg", { stroke: "black", width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx362("path", { d: "M15 16L12 19M12 19L9 16M12 19L12 5", stroke: "inherit", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }) });
var sort_arrow_down_medium_line_default = SvgSortArrowDownMediumLine;

// assets/newIcons/sort_arrow_up_down-large-line.svg
import * as React358 from "react";
import { jsx as jsx363 } from "react/jsx-runtime";
var SvgSortArrowUpDownLargeLine = (props) => /* @__PURE__ */ jsx363("svg", { stroke: "black", width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx363("path", { d: "M16 17L12 21L8 17M16 7L12 3L8 7", stroke: "inherit", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }) });
var sort_arrow_up_down_large_line_default = SvgSortArrowUpDownLargeLine;

// assets/newIcons/sort_arrow_up_down-medium-line.svg
import * as React359 from "react";
import { jsx as jsx364 } from "react/jsx-runtime";
var SvgSortArrowUpDownMediumLine = (props) => /* @__PURE__ */ jsx364("svg", { stroke: "black", width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx364("path", { d: "M15 16L12 19L9 16M15 8L12 5L9 8", stroke: "inherit", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }) });
var sort_arrow_up_down_medium_line_default = SvgSortArrowUpDownMediumLine;

// assets/newIcons/sort_arrow_up-large-line.svg
import * as React360 from "react";
import { jsx as jsx365 } from "react/jsx-runtime";
var SvgSortArrowUpLargeLine = (props) => /* @__PURE__ */ jsx365("svg", { stroke: "black", width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx365("path", { d: "M16 7L12 3M12 3L8 7M12 3L12 21", stroke: "inherit", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }) });
var sort_arrow_up_large_line_default = SvgSortArrowUpLargeLine;

// assets/newIcons/sort_arrow_up-medium-line.svg
import * as React361 from "react";
import { jsx as jsx366 } from "react/jsx-runtime";
var SvgSortArrowUpMediumLine = (props) => /* @__PURE__ */ jsx366("svg", { stroke: "black", width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx366("path", { d: "M15 8L12 5M12 5L9 8M12 5L12 19", stroke: "inherit", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }) });
var sort_arrow_up_medium_line_default = SvgSortArrowUpMediumLine;

// assets/newIcons/speaker_sound_volume_mute-large-line.svg
import * as React362 from "react";
import { jsx as jsx367 } from "react/jsx-runtime";
var SvgSpeakerSoundVolumeMuteLargeLine = (props) => /* @__PURE__ */ jsx367("svg", { stroke: "black", width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx367("path", { d: "M17 14L19 12M19 12L21 10M19 12L17 10M19 12L21 14M4 15C3.44772 15 3 14.5523 3 14V10C3 9.44772 3.44772 9 4 9L7.5 9L12.177 4.28135C12.8565 3.67426 14 4.11449 14 4.98318V19.0168C14 19.8855 12.8565 20.3257 12.177 19.7187L7.5 15L4 15Z", stroke: "inherit", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }) });
var speaker_sound_volume_mute_large_line_default = SvgSpeakerSoundVolumeMuteLargeLine;

// assets/newIcons/speaker_sound_volume-large-line.svg
import * as React363 from "react";
import { jsx as jsx368 } from "react/jsx-runtime";
var SvgSpeakerSoundVolumeLargeLine = (props) => /* @__PURE__ */ jsx368("svg", { stroke: "black", width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx368("path", { d: "M19.6621 7C20.513 8.47087 20.9999 10.1786 20.9999 12C20.9999 13.8214 20.513 15.5291 19.6621 17M17.1973 9C17.7078 9.88252 18 10.9071 18 12C18 13.0929 17.7078 14.1175 17.1973 15M4 15C3.44772 15 3 14.5523 3 14V10C3 9.44772 3.44772 9 4 9L7.5 9L12.177 4.28135C12.8565 3.67426 14 4.11449 14 4.98318V19.0168C14 19.8855 12.8565 20.3257 12.177 19.7187L7.5 15L4 15Z", stroke: "inherit", strokeWidth: 1.5, strokeLinecap: "round" }) });
var speaker_sound_volume_large_line_default = SvgSpeakerSoundVolumeLargeLine;

// assets/newIcons/stopped_vehicle-large-line.svg
import * as React364 from "react";
import { jsx as jsx369 } from "react/jsx-runtime";
var SvgStoppedVehicleLargeLine = (props) => /* @__PURE__ */ jsx369("svg", { stroke: "black", width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx369("path", { d: "M5.69998 5.69998L7 7M18.3 18.3L16.05 16.05M10 12.7368V8H13.4211C14.8453 8 16 9.06038 16 10.3684C16 11.6764 14.8453 12.7368 13.4211 12.7368H10ZM10 12.7368V17M12 21C7.02944 21 3 16.9705 3 12C3 7.02944 7.02944 3 12 3C16.9705 3 21 7.02944 21 12C21 16.9705 16.9705 21 12 21Z", stroke: "inherit", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }) });
var stopped_vehicle_large_line_default = SvgStoppedVehicleLargeLine;

// assets/newIcons/storage-large-line.svg
import * as React365 from "react";
import { jsx as jsx370 } from "react/jsx-runtime";
var SvgStorageLargeLine = (props) => /* @__PURE__ */ jsx370("svg", { stroke: "black", width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx370("path", { d: "M7 12H10M5 17H19C20.1046 17 21 16.1046 21 15V9C21 7.89543 20.1046 7 19 7H5C3.89543 7 3 7.89543 3 9V15C3 16.1046 3.89543 17 5 17Z", stroke: "inherit", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }) });
var storage_large_line_default = SvgStorageLargeLine;

// assets/newIcons/tampering_detection-large-line.svg
import * as React366 from "react";
import { jsx as jsx371 } from "react/jsx-runtime";
var SvgTamperingDetectionLargeLine = (props) => /* @__PURE__ */ jsx371("svg", { stroke: "black", width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx371("path", { d: "M20 9L20.9594 6.45682C21.1488 5.72675 20.6512 5 19.9619 5H4.03811C3.34883 5 2.85119 5.72675 3.04055 6.45683L4 9M20 9H4M20 9V11.381C20 15.5888 16.4183 19 12 19C7.58172 19 4 15.5888 4 11.381V9M20.2297 9.5L11 18.7297M15.0029 9L7 17.0029M9.27542 9L4.27542 14", stroke: "inherit", strokeWidth: 1.5, strokeMiterlimit: 10 }) });
var tampering_detection_large_line_default = SvgTamperingDetectionLargeLine;

// assets/newIcons/temperature-large-line.svg
import * as React367 from "react";
import { jsx as jsx372 } from "react/jsx-runtime";
var SvgTemperatureLargeLine = (props) => /* @__PURE__ */ jsx372("svg", { stroke: "black", width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx372("path", { d: "M14.75 5H18M12 17L12 12.5V8M14.75 8H18M14.75 11H18M13.5 17C13.5 17.8284 12.8284 18.5 12 18.5C11.1716 18.5 10.5 17.8284 10.5 17C10.5 16.1716 11.1716 15.5 12 15.5C12.8284 15.5 13.5 16.1716 13.5 17ZM12.75 17C12.75 17.4142 12.4142 17.75 12 17.75C11.5858 17.75 11.25 17.4142 11.25 17C11.25 16.5858 11.5858 16.25 12 16.25C12.4142 16.25 12.75 16.5858 12.75 17ZM9.27273 4.72727C9.27273 3.22104 10.4938 2 12 2C13.5062 2 14.7273 3.22104 14.7273 4.72727V12.8086C16.0956 13.7007 17 15.2447 17 17C17 19.7614 14.7614 22 12 22C9.23858 22 7 19.7614 7 17C7 15.2447 7.90445 13.7007 9.27273 12.8086V4.72727Z", stroke: "inherit", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }) });
var temperature_large_line_default = SvgTemperatureLargeLine;

// assets/newIcons/time-large-line.svg
import * as React368 from "react";
import { jsx as jsx373 } from "react/jsx-runtime";
var SvgTimeLargeLine = (props) => /* @__PURE__ */ jsx373("svg", { stroke: "black", width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx373("path", { d: "M12 7V12H17M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z", stroke: "inherit", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }) });
var time_large_line_default = SvgTimeLargeLine;

// assets/newIcons/top_rank-large-line.svg
import * as React369 from "react";
import { jsx as jsx374 } from "react/jsx-runtime";
var SvgTopRankLargeLine = (props) => /* @__PURE__ */ jsx374("svg", { stroke: "black", width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx374("path", { d: "M12 16C8.68629 16 6 13.3137 6 10V5H18V10C18 13.3137 15.3137 16 12 16ZM12 16V21M9 21H15M3 7H6V11C4.34315 11 3 9.65685 3 8V7ZM21 7H18V11C19.6569 11 21 9.65685 21 8V7Z", stroke: "inherit", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }) });
var top_rank_large_line_default = SvgTopRankLargeLine;

// assets/newIcons/traffic_jam-large-line.svg
import * as React370 from "react";
import { jsx as jsx375 } from "react/jsx-runtime";
var SvgTrafficJamLargeLine = (props) => /* @__PURE__ */ jsx375("svg", { stroke: "black", width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx375("path", { d: "M15.2184 6.42857L14.3032 3.98952C14.04 3.38922 13.4362 3 12.768 3H6.10562C5.43749 3 4.83363 3.38922 4.57043 3.98952L3 6.42857M15.2184 6.42857H10.5746C9.90644 6.42857 9.30258 6.81779 9.03939 7.41809L8 9.5M15.2184 6.42857H17.3933C18.0615 6.42857 18.6653 6.81779 18.9285 7.41809L21 11M4.77781 13H17.2223M4.77781 13C3.79597 13 3.00003 13.7675 3.00003 14.7143L3 16.9366C3 17.997 3.95513 18.8566 5.13333 18.8566H16.8667C18.0449 18.8566 19 17.997 19 16.9366L19 14.7143C19 13.7675 18.2041 13 17.2223 13M4.77781 13C4.77781 12.8583 4.80656 12.8875 4.86296 12.753L6.01688 10.4017C6.24272 9.8632 6.87679 9.5 7.59099 9.5H14C14.6698 9.5 15.274 9.82009 15.5316 10.3115L17.0946 12.7126C17.1789 12.8733 17.2223 12.8259 17.2223 13M5.13337 15.8571V16.7143M9 16H13M16.8667 15.8571V16.7143M4.33333 19.1423L4.33337 20.5714C4.33337 20.8081 4.53235 21 4.77781 21H6.11114C6.3566 21 6.55559 20.8081 6.55559 20.5714L6.55556 19.1423M15.4444 19.1423L15.4445 20.5714C15.4445 20.8081 15.6435 21 15.8889 21H17.2223C17.4677 21 17.6667 20.8081 17.6667 20.5714L17.6667 19.1423", stroke: "inherit", strokeWidth: 1.5, strokeLinecap: "round" }) });
var traffic_jam_large_line_default = SvgTrafficJamLargeLine;

// assets/newIcons/unlink_clip-large-line.svg
import * as React371 from "react";
import { jsx as jsx376, jsxs as jsxs73 } from "react/jsx-runtime";
var SvgUnlinkClipLargeLine = (props) => /* @__PURE__ */ jsxs73("svg", { stroke: "black", width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: [
  /* @__PURE__ */ jsx376("g", { clipPath: "url(#clip0_10672_946)", children: /* @__PURE__ */ jsx376("path", { d: "M7.54523 11.3636L5.63604 13.2728C4.23015 14.6787 4.23015 16.9581 5.63604 18.3639C7.0419 19.7698 9.32132 19.7698 10.7272 18.3639L12.6364 16.4548M11.3636 7.54521L13.2728 5.63602C14.6787 4.23016 16.9581 4.23014 18.364 5.63602C19.7698 7.04189 19.7698 9.32133 18.364 10.7272L16.4548 12.6364M5.63606 5.63604L6.90892 6.9089M17.0912 17.0912L18.364 18.364M14.5457 18.3641L14.5457 20.2733M9.45458 3.727L9.45458 5.63619M18.3641 14.5457L20.2733 14.5457M3.727 9.45455L5.63619 9.45455M9.17157 14.8284L14.8284 9.17156", stroke: "inherit", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }) }),
  /* @__PURE__ */ jsx376("defs", { children: /* @__PURE__ */ jsx376("clipPath", { id: "clip0_10672_946", children: /* @__PURE__ */ jsx376("rect", { width: 24, height: 24, fill: "white" }) }) })
] });
var unlink_clip_large_line_default = SvgUnlinkClipLargeLine;

// assets/newIcons/upload_export-large-line.svg
import * as React372 from "react";
import { jsx as jsx377 } from "react/jsx-runtime";
var SvgUploadExportLargeLine = (props) => /* @__PURE__ */ jsx377("svg", { stroke: "black", width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx377("path", { d: "M20 16V18C20 19.1046 19.1046 20 18 20H6C4.89543 20 4 19.1046 4 18V16M17 9L12 4M12 4L7 9M12 4V16", stroke: "inherit", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }) });
var upload_export_large_line_default = SvgUploadExportLargeLine;

// assets/newIcons/user_group-large-line.svg
import * as React373 from "react";
import { jsx as jsx378 } from "react/jsx-runtime";
var SvgUserGroupLargeLine = (props) => /* @__PURE__ */ jsx378("svg", { stroke: "black", width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx378("path", { d: "M16.5 21V19.5C16.5 18.3954 15.6046 17.5 14.5 17.5H9.5C8.39543 17.5 7.5 18.3954 7.5 19.5V21M21 15.5V13.5C21 12.3954 20.1046 11.5 19 11.5H17.5M3 15.5V13.5C3 12.3954 3.89543 11.5 5 11.5H6.5M14.5 12.5C14.5 13.8807 13.3807 15 12 15C10.6193 15 9.5 13.8807 9.5 12.5C9.5 11.1193 10.6193 10 12 10C13.3807 10 14.5 11.1193 14.5 12.5ZM20 6.5C20 7.88071 18.8807 9 17.5 9C16.1193 9 15 7.88071 15 6.5C15 5.11929 16.1193 4 17.5 4C18.8807 4 20 5.11929 20 6.5ZM9 6.5C9 7.88071 7.88071 9 6.5 9C5.11929 9 4 7.88071 4 6.5C4 5.11929 5.11929 4 6.5 4C7.88071 4 9 5.11929 9 6.5Z", stroke: "inherit", strokeWidth: 1.5, strokeLinecap: "round" }) });
var user_group_large_line_default = SvgUserGroupLargeLine;

// assets/newIcons/user_guide-large-line.svg
import * as React374 from "react";
import { jsx as jsx379 } from "react/jsx-runtime";
var SvgUserGuideLargeLine = (props) => /* @__PURE__ */ jsx379("svg", { stroke: "black", width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx379("path", { d: "M12 20C12 18.8954 12.8954 18 14 18H20C20.5523 18 21 17.5523 21 17V7C21 6.44772 20.5523 6 20 6H15C13.3431 6 12 7.34315 12 9M12 20C12 18.8954 11.1046 18 10 18H4C3.44772 18 3 17.5523 3 17V7C3 6.44772 3.44772 6 4 6H9C10.6569 6 12 7.34315 12 9M12 20V9", stroke: "inherit", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }) });
var user_guide_large_line_default = SvgUserGuideLargeLine;

// assets/newIcons/user_profile-large-fill.svg
import * as React375 from "react";
import { jsx as jsx380, jsxs as jsxs74 } from "react/jsx-runtime";
var SvgUserProfileLargeFill = (props) => /* @__PURE__ */ jsxs74("svg", { width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "black", xmlns: "http://www.w3.org/2000/svg", ...props, children: [
  /* @__PURE__ */ jsx380("path", { d: "M9.75 10C9.75 8.75736 10.7574 7.75 12 7.75C13.2426 7.75 14.25 8.75736 14.25 10C14.25 11.2426 13.2426 12.25 12 12.25C10.7574 12.25 9.75 11.2426 9.75 10Z", fill: "inherit" }),
  /* @__PURE__ */ jsx380("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2.25 12C2.25 6.61522 6.61522 2.25 12 2.25C17.3848 2.25 21.75 6.61522 21.75 12C21.75 14.7701 20.5948 17.2704 18.7398 19.0454C18.7398 19.0433 18.7397 19.0412 18.7397 19.039C18.7363 18.6924 18.7321 18.344 18.727 18.0733C18.7245 17.9383 18.7217 17.8197 18.7186 17.7291C18.717 17.6843 18.7153 17.6424 18.7132 17.6071L18.7131 17.6042C18.712 17.5857 18.7082 17.5154 18.6946 17.4489C18.439 16.1943 17.3306 15.25 16 15.25H8C6.59595 15.25 5.43865 16.3016 5.27084 17.6604C5.26497 17.7079 5.26385 17.764 5.26363 17.7752L5.2636 17.7768C5.2629 17.8043 5.26229 17.8395 5.26172 17.8798C5.26059 17.9608 5.25955 18.0706 5.2586 18.1985C5.25686 18.4336 5.25538 18.7342 5.25416 19.0396C3.40272 17.265 2.25 14.7671 2.25 12ZM12 6.25C9.92893 6.25 8.25 7.92893 8.25 10C8.25 12.0711 9.92893 13.75 12 13.75C14.071 13.75 15.75 12.0711 15.75 10C15.75 7.92893 14.071 6.25 12 6.25Z", fill: "inherit" }),
  /* @__PURE__ */ jsx380("path", { d: "M6.75055 20.2176C8.26589 21.1876 10.0673 21.75 12 21.75C13.9324 21.75 15.7335 21.1878 17.2487 20.2181C17.2471 19.9404 17.2441 19.4973 17.2398 19.0537C17.2364 18.7084 17.2322 18.3653 17.2273 18.1014C17.2248 17.969 17.2222 17.8595 17.2195 17.7806C17.2185 17.7513 17.2175 17.7284 17.2167 17.7113C17.0867 17.1601 16.5904 16.75 16 16.75H8C7.37164 16.75 6.85062 17.2143 6.76303 17.8182C6.76257 17.8373 6.76208 17.8648 6.76158 17.9008C6.76051 17.9768 6.7595 18.0827 6.75856 18.2097C6.75668 18.4631 6.7551 18.7951 6.75383 19.128C6.75225 19.5411 6.75116 19.954 6.75055 20.2176Z", fill: "inherit" }),
  /* @__PURE__ */ jsx380("path", { d: "M17.2146 17.6783C17.2146 17.6783 17.2148 17.6804 17.2152 17.6858L17.2146 17.6783Z", fill: "inherit" })
] });
var user_profile_large_fill_default = SvgUserProfileLargeFill;

// assets/newIcons/user_profile-large-line.svg
import * as React376 from "react";
import { jsx as jsx381 } from "react/jsx-runtime";
var SvgUserProfileLargeLine = (props) => /* @__PURE__ */ jsx381("svg", { stroke: "black", width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx381("path", { d: "M6 18.5C6 18.4161 6.00516 17.8335 6.01518 17.7524C6.13716 16.7646 6.97928 16 8 16H16C16.9671 16 17.7739 16.6864 17.9597 17.5986C17.9861 17.7283 18 18.3625 18 18.5M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12ZM15 10C15 11.6569 13.6568 13 12 13C10.3431 13 9 11.6569 9 10C9 8.34314 10.3431 7 12 7C13.6568 7 15 8.34314 15 10Z", stroke: "inherit", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }) });
var user_profile_large_line_default = SvgUserProfileLargeLine;

// assets/newIcons/user-large-fill.svg
import * as React377 from "react";
import { jsx as jsx382, jsxs as jsxs75 } from "react/jsx-runtime";
var SvgUserLargeFill = (props) => /* @__PURE__ */ jsxs75("svg", { width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "black", xmlns: "http://www.w3.org/2000/svg", ...props, children: [
  /* @__PURE__ */ jsx382("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3.86126 16.0444C4.5422 14.9379 5.83741 14.25 8 14.25H16C18.1626 14.25 19.4578 14.9379 20.1387 16.0444C20.7512 17.0397 20.7505 18.223 20.75 18.943C20.75 18.9624 20.75 18.9814 20.75 19V19C20.75 19.9665 19.9665 20.75 19 20.75H5C4.03351 20.75 3.25 19.9665 3.25 19V19C3.25 18.9814 3.24999 18.9624 3.24998 18.943C3.24952 18.223 3.24877 17.0397 3.86126 16.0444Z", fill: "inherit" }),
  /* @__PURE__ */ jsx382("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.25 8C7.25 5.37665 9.37665 3.25 12 3.25C14.6233 3.25 16.75 5.37664 16.75 8C16.75 10.6234 14.6233 12.75 12 12.75C9.37665 12.75 7.25 10.6234 7.25 8Z", fill: "inherit" })
] });
var user_large_fill_default = SvgUserLargeFill;

// assets/newIcons/user-large-line.svg
import * as React378 from "react";
import { jsx as jsx383 } from "react/jsx-runtime";
var SvgUserLargeLine = (props) => /* @__PURE__ */ jsx383("svg", { stroke: "black", width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx383("path", { d: "M20 20V19C20 16.7909 18.2091 15 16 15H8C5.79086 15 4 16.7909 4 19V20M16 8C16 10.2091 14.2091 12 12 12C9.79086 12 8 10.2091 8 8C8 5.79086 9.79086 4 12 4C14.2091 4 16 5.79086 16 8Z", stroke: "inherit", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }) });
var user_large_line_default = SvgUserLargeLine;

// assets/newIcons/vehicle_bicycle-large-line.svg
import * as React379 from "react";
import { jsx as jsx384 } from "react/jsx-runtime";
var SvgVehicleBicycleLargeLine = (props) => /* @__PURE__ */ jsx384("svg", { stroke: "black", width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx384("path", { d: "M5.5 16.5L9.525 11.7501M9.525 11.7501H15.6794M9.525 11.7501L7.95 8.6001H5.7M9.525 11.7501L12 16.7001M18.5 16.5L14.25 8.6001H17.85L18.75 9.9501M8 16.5001C8 17.8808 6.88071 19.0001 5.5 19.0001C4.11929 19.0001 3 17.8808 3 16.5001C3 15.1194 4.11929 14.0001 5.5 14.0001C6.88071 14.0001 8 15.1194 8 16.5001ZM21 16.5C21 17.8807 19.8807 19 18.5 19C17.1193 19 16 17.8807 16 16.5C16 15.1193 17.1193 14 18.5 14C19.8807 14 21 15.1193 21 16.5Z", stroke: "inherit", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }) });
var vehicle_bicycle_large_line_default = SvgVehicleBicycleLargeLine;

// assets/newIcons/vehicle_bus-large-line.svg
import * as React380 from "react";
import { jsx as jsx385 } from "react/jsx-runtime";
var SvgVehicleBusLargeLine = (props) => /* @__PURE__ */ jsx385("svg", { stroke: "black", width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx385("path", { d: "M19.2727 16.9646H21.1158C21.6 16.9646 22 16.5751 22 16.0909V12.0105C22 11.5789 21.9684 11.1474 21.8947 10.7263C21.5368 8.57895 19.6526 7 17.4526 7H3.69474C2.75789 7 2 7.74737 2 8.67368V16.0909L4.72727 17M9 17H15M9 17C9 18.1046 8.10457 19 7 19C5.89543 19 5 18.1046 5 17C5 15.8954 5.89543 15 7 15C8.10457 15 9 15.8954 9 17ZM15 17C15 18.1046 15.8954 19 17 19C18.1046 19 19 18.1046 19 17C19 15.8954 18.1046 15 17 15C15.8954 15 15 15.8954 15 17ZM22 12.3462H18C16.8954 12.3462 16 11.5196 16 10.5V7M12 7V11M2 11L16 11M7 7V11", stroke: "inherit", strokeWidth: 1.5, strokeMiterlimit: 10, strokeLinecap: "round", strokeLinejoin: "round" }) });
var vehicle_bus_large_line_default = SvgVehicleBusLargeLine;

// assets/newIcons/vehicle_counting-large-line.svg
import * as React381 from "react";
import { jsx as jsx386 } from "react/jsx-runtime";
var SvgVehicleCountingLargeLine = (props) => /* @__PURE__ */ jsx386("svg", { stroke: "black", width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx386("path", { d: "M7 17H5.4C4.07452 17 3 15.9971 3 14.76V11.9999C3 10.8954 3.89543 9.99993 5 9.99993M7 17H11.5M7 17V18.5C7 18.7761 6.77614 19 6.5 19H5C4.72386 19 4.5 18.7761 4.5 18.5V17M21 12.5V11.9999C21 10.8954 20.1046 9.99993 19 9.99993M5 9.99993H19M5 9.99993C5 9.83458 5.03235 9.53541 5.09579 9.37854L6.44121 6.05196C6.69529 5.42374 7.40861 5 8.21208 5H15.4222C16.1758 5 16.8555 5.37344 17.1453 5.94675L18.8564 9.33136C18.9512 9.51885 19 9.79682 19 9.99993M5.4 13V14M9.6 13.08H14.4M17.5 15H21M21 15V18.5M21 15L17 19L15.2342 17.2727L12.6001 20", stroke: "inherit", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }) });
var vehicle_counting_large_line_default = SvgVehicleCountingLargeLine;

// assets/newIcons/vehicle_heatmap-large-line.svg
import * as React382 from "react";
import { jsx as jsx387 } from "react/jsx-runtime";
var SvgVehicleHeatmapLargeLine = (props) => /* @__PURE__ */ jsx387("svg", { stroke: "black", width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx387("path", { d: "M5 9.99993H19M5 9.99993C3.89543 9.99993 3 10.8954 3 11.9999V14.76C3 15.9971 4.07452 17 5.4 17H7M5 9.99993C5 9.83458 5.03235 9.53541 5.09579 9.37854L6.44121 6.05196C6.69529 5.42374 7.40861 5 8.21208 5H15.4222C16.1758 5 16.8555 5.37344 17.1453 5.94675L18.8564 9.33136C18.9512 9.51885 19 9.79682 19 9.99993M19 9.99993C19.3643 9.99993 19.7058 10.0973 20 10.2675M5.4 13V14M4.5 17V18.5C4.5 18.7761 4.72386 19 5 19H6.5C6.77614 19 7 18.7761 7 18.5V17M7 17H10M16 15.75H15.75V16H16V15.75ZM16.5 18.5H15.75V19.25H16.5V18.5ZM19.25 19H19V19.25H19.25V19ZM20 22H15C13.8954 22 13 21.1046 13 20V15C13 13.8954 13.8954 13 15 13H20C21.1046 13 22 13.8954 22 15V20C22 21.1046 21.1046 22 20 22Z", stroke: "inherit", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }) });
var vehicle_heatmap_large_line_default = SvgVehicleHeatmapLargeLine;

// assets/newIcons/vehicle_motorcycle-large-line.svg
import * as React383 from "react";
import { jsx as jsx388 } from "react/jsx-runtime";
var SvgVehicleMotorcycleLargeLine = (props) => /* @__PURE__ */ jsx388("svg", { stroke: "black", width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx388("path", { d: "M18.5 16.5L16.46 11.83M15.5 6V9H11.71L6.7 14.31M3 12C4.7 10.73 7.22 10.67 9 11.83M5.5 16.5H13.13C13.8 11.95 16.4 11.55 19 11.58V9.33C19 8.22 18.41 6 16.06 6H13M5.5 19C6.88 19 8 17.88 8 16.5C8 15.12 6.88 14 5.5 14C4.12 14 3 15.12 3 16.5C3 17.88 4.12 19 5.5 19ZM18.5 19C19.88 19 21 17.88 21 16.5C21 15.12 19.88 14 18.5 14C17.12 14 16 15.12 16 16.5C16 17.88 17.12 19 18.5 19Z", stroke: "inherit", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }) });
var vehicle_motorcycle_large_line_default = SvgVehicleMotorcycleLargeLine;

// assets/newIcons/vehicle_queue_management-large-line.svg
import * as React384 from "react";
import { jsx as jsx389 } from "react/jsx-runtime";
var SvgVehicleQueueManagementLargeLine = (props) => /* @__PURE__ */ jsx389("svg", { stroke: "black", width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx389("path", { d: "M3.66669 13H15.3333M3.66669 13C2.74622 13 2.00003 13.7195 2.00003 14.6071L2 16.6906C2 17.6847 2.89543 18.4906 4 18.4906H15C16.1045 18.4906 17 17.6847 17 16.6906L17 14.6071C17 13.7195 16.2538 13 15.3333 13M3.66669 13C3.66669 12.8671 3.69365 12.8945 3.74652 12.7685L4.8677 10.0953C5.07943 9.5905 5.67387 9.25 6.34342 9.25H12.3519C12.9798 9.25 13.5462 9.55009 13.7878 10.0108L15.2137 12.7306C15.2927 12.8812 15.3333 12.8368 15.3333 13M4.00003 15.6786V16.4821M7.62499 15.8125H11.375M15 15.6786V16.4821M3.25 18.7584L3.25003 20.0982C3.25003 20.3201 3.43658 20.5 3.66669 20.5H4.91669C5.14681 20.5 5.33336 20.3201 5.33336 20.0982L5.33333 18.7584M13.6666 18.7584L13.6667 20.0982C13.6667 20.3201 13.8532 20.5 14.0833 20.5H15.3333C15.5635 20.5 15.75 20.3201 15.75 20.0982L15.75 18.7584M19.617 13.4366L19.617 12.2143C19.617 11.3736 18.9894 10.6742 18.1613 10.5281C17.9853 10.497 17.7946 10.3709 17.7116 10.2126L16.1906 7.3115C15.933 6.82009 15.3289 6.5 14.659 6.5H8.25M21.997 10.4366L21.997 9.21428C21.997 8.37356 21.3694 7.6742 20.5413 7.52806C20.3654 7.49701 20.1746 7.37088 20.0916 7.21259L18.5706 4.3115C18.313 3.82009 17.7089 3.5 17.039 3.5H10.63", stroke: "inherit", strokeWidth: 1.5, strokeLinecap: "round" }) });
var vehicle_queue_management_large_line_default = SvgVehicleQueueManagementLargeLine;

// assets/newIcons/vehicle_sedan-large-line.svg
import * as React385 from "react";
import { jsx as jsx390 } from "react/jsx-runtime";
var SvgVehicleSedanLargeLine = (props) => /* @__PURE__ */ jsx390("svg", { stroke: "black", width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx390("path", { d: "M9.00001 17H15M9.00001 17C9.00001 18.1045 8.10457 19 7 19C5.89543 19 5 18.1046 5 17M9.00001 17C9.00001 15.8954 8.10457 15 7 15C5.89543 15 5 15.8954 5 17M15 17C15 18.1045 15.8954 19 17 19C18.1046 19 19 18.1046 19 17M15 17C15 15.8954 15.8954 15 17 15C18.1046 15 19 15.8954 19 17M5 17L3.72085 16.6281C3.29376 16.504 3 16.1127 3 15.6679V13.421C3 12.975 3.29535 12.5829 3.72402 12.4598L4.71318 12.1758C5.00489 12.092 5.24277 11.8803 5.35983 11.6003L6.39903 9.11432C6.55457 8.74224 6.91838 8.5 7.32166 8.5H13.0822C13.3495 8.5 13.6057 8.60705 13.7936 8.79725L17 12.0433M19 17L20.1818 17C20.6337 17 21 16.6337 21 16.1818V13.6823C21 12.7785 20.2674 12.0459 19.3636 12.0459H15.6818M5.04545 12.0433L19 12.0433M11 8.5V12.0433", stroke: "inherit", strokeWidth: 1.5, strokeMiterlimit: 10, strokeLinecap: "round", strokeLinejoin: "round" }) });
var vehicle_sedan_large_line_default = SvgVehicleSedanLargeLine;

// assets/newIcons/vehicle_suv-large-line.svg
import * as React386 from "react";
import { jsx as jsx391 } from "react/jsx-runtime";
var SvgVehicleSuvLargeLine = (props) => /* @__PURE__ */ jsx391("svg", { stroke: "black", width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx391("path", { d: "M9 17L15 17M9 17C9 18.1046 8.10457 19 7 19C5.89543 19 5 18.1046 5 17M9 17C9 15.8954 8.10457 15 7 15C5.89543 15 5 15.8954 5 17M15 17C15 18.1046 15.8954 19 17 19C18.1046 19 19 18.1046 19 17M15 17C15 15.8954 15.8954 15 17 15C18.1046 15 19 15.8954 19 17M5 17L3.55279 16.2764C3.214 16.107 3 15.7607 3 15.382V11.283C3 11.098 3.05135 10.9166 3.14834 10.7589L4.41427 8.7018C4.77827 8.11031 5.42307 7.75 6.11759 7.75H12.723C13.0402 7.75 13.3385 7.90045 13.5271 8.15547L15.7002 11.0945C15.8888 11.3495 16.1871 11.5 16.5043 11.5H19.5C20.4037 11.5 21 12.5063 21 13.41V16C21 16.5523 20.5523 17 20 17H19M3 11.5L17.5 11.5M9.54544 7.75V11.5", stroke: "inherit", strokeWidth: 1.5, strokeMiterlimit: 10, strokeLinecap: "round", strokeLinejoin: "round" }) });
var vehicle_suv_large_line_default = SvgVehicleSuvLargeLine;

// assets/newIcons/vehicle_truck-large-line.svg
import * as React387 from "react";
import { jsx as jsx392 } from "react/jsx-runtime";
var SvgVehicleTruckLargeLine = (props) => /* @__PURE__ */ jsx392("svg", { stroke: "black", width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx392("path", { d: "M15 8.5H17.4983C18.0086 8.5 18.4949 8.72059 18.8363 9.1069L20.5379 11.0326C20.8354 11.3693 21 11.8062 21 12.2591V14M15 8.5V6.91667C15 6.41041 14.5971 6 14.1 6H5C3.89543 6 3 6.89543 3 8V16.0833C3 16.5896 3.40294 17 3.9 17H4.8M15 8.5V10.5C15 11.3284 15.6716 12 16.5 12H21M15 17H9M15 17C15 18.1046 15.8954 19 17 19C18.1046 19 19 18.1046 19 17M15 17C15 15.8954 15.8954 15 17 15C18.1046 15 19 15.8954 19 17M9 17C9 18.1046 8.10457 19 7 19C5.89543 19 5 18.1046 5 17C5 15.8954 5.89543 15 7 15C8.10457 15 9 15.8954 9 17ZM21 13V16C21 16.5523 20.5523 17 20 17H19", stroke: "inherit", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }) });
var vehicle_truck_large_line_default = SvgVehicleTruckLargeLine;

// assets/newIcons/vehicle_van-large-line.svg
import * as React388 from "react";
import { jsx as jsx393 } from "react/jsx-runtime";
var SvgVehicleVanLargeLine = (props) => /* @__PURE__ */ jsx393("svg", { stroke: "black", width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx393("path", { d: "M9 17C9 18.1046 8.10457 19 7 19C5.89543 19 5 18.1046 5 17M9 17C9 15.8954 8.10457 15 7 15C5.89543 15 5 15.8954 5 17M9 17H15M5 17C3.89543 17 3 16.1046 3 15V9C3 7.89543 3.89543 7 5 7H15.0617C15.7076 7 16.3137 7.31193 16.6891 7.83752L18.685 10.6318C18.7735 10.7556 18.8758 10.869 18.9901 10.9695C19.4435 11.3684 19.9318 11.7956 20.3137 12.129C20.7496 12.5096 21 13.0595 21 13.6383V15C21 16.1046 20.1046 17 19 17M19 17C19 18.1046 18.1046 19 17 19C15.8954 19 15 18.1046 15 17M19 17C19 15.8954 18.1046 15 17 15C15.8954 15 15 15.8954 15 17M11.8182 7L13.2031 10.4623C13.355 10.842 13.7227 11.0909 14.1316 11.0909H19", stroke: "inherit", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }) });
var vehicle_van_large_line_default = SvgVehicleVanLargeLine;

// assets/newIcons/vehicle-large-line.svg
import * as React389 from "react";
import { jsx as jsx394 } from "react/jsx-runtime";
var SvgVehicleLargeLine = (props) => /* @__PURE__ */ jsx394("svg", { stroke: "black", width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx394("path", { d: "M5 9.99993H19M5 9.99993C3.89543 9.99993 3 10.8954 3 11.9999L3 14.76C3 15.9971 4.07452 17 5.4 17H18.6C19.9255 17 21 15.9971 21 14.76V11.9999C21 10.8954 20.1046 9.99993 19 9.99993M5 9.99993C5 9.83458 5.03235 9.53541 5.09579 9.37854L6.44121 6.05196C6.69529 5.42374 7.40861 5 8.21208 5H15.4222C16.1758 5 16.8555 5.37344 17.1453 5.94675L18.8564 9.33136C18.9512 9.51885 19 9.79682 19 9.99993M5.4 13V14M9.6 13.08H14.4M18.6 13V14M4.5 17V18.5C4.5 18.7761 4.72386 19 5 19H6.5C6.77614 19 7 18.7761 7 18.5V17M17 17V18.5C17 18.7761 17.2239 19 17.5 19H19C19.2761 19 19.5 18.7761 19.5 18.5V17", stroke: "inherit", strokeWidth: 1.5, strokeLinecap: "round" }) });
var vehicle_large_line_default = SvgVehicleLargeLine;

// assets/newIcons/video_loss-large-line.svg
import * as React390 from "react";
import { jsx as jsx395 } from "react/jsx-runtime";
var SvgVideoLossLargeLine = (props) => /* @__PURE__ */ jsx395("svg", { stroke: "black", width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx395("path", { d: "M5.69998 5.69998L18.3 18.3M12 21C7.02943 21 3 16.9705 3 12C3 7.02943 7.02943 3 12 3C16.9705 3 21 7.02943 21 12C21 16.9705 16.9705 21 12 21Z", stroke: "inherit", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }) });
var video_loss_large_line_default = SvgVideoLossLargeLine;

// assets/newIcons/view_hide-large-line.svg
import * as React391 from "react";
import { jsx as jsx396 } from "react/jsx-runtime";
var SvgViewHideLargeLine = (props) => /* @__PURE__ */ jsx396("svg", { stroke: "black", width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx396("path", { d: "M19.5 16L17.0248 12.6038M12 17.5V14M4.5 16L6.96895 12.6124M3 8C6.6 16 17.4 16 21 8", stroke: "inherit", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }) });
var view_hide_large_line_default = SvgViewHideLargeLine;

// assets/newIcons/view_show-large-line.svg
import * as React392 from "react";
import { jsx as jsx397 } from "react/jsx-runtime";
var SvgViewShowLargeLine = (props) => /* @__PURE__ */ jsx397("svg", { stroke: "black", width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx397("path", { d: "M3 13C6.6 5 17.4 5 21 13M12 17C10.3431 17 9 15.6569 9 14C9 12.3431 10.3431 11 12 11C13.6569 11 15 12.3431 15 14C15 15.6569 13.6569 17 12 17Z", stroke: "inherit", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }) });
var view_show_large_line_default = SvgViewShowLargeLine;

// assets/newIcons/warning_error-large-fill.svg
import * as React393 from "react";
import { jsx as jsx398 } from "react/jsx-runtime";
var SvgWarningErrorLargeFill = (props) => /* @__PURE__ */ jsx398("svg", { width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "black", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx398("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M14.4906 3.62553C13.3765 1.79149 10.6235 1.79149 9.50936 3.62553L1.64833 16.5658C0.48755 18.4766 1.9789 20.75 4.13898 20.75H19.861C22.0211 20.75 23.5124 18.4766 22.3517 16.5658L14.4906 3.62553ZM12 8.25C12.4142 8.25 12.75 8.58579 12.75 9V13C12.75 13.4142 12.4142 13.75 12 13.75C11.5858 13.75 11.25 13.4142 11.25 13V9C11.25 8.58579 11.5858 8.25 12 8.25ZM10.75 16C10.75 15.3096 11.3096 14.75 12 14.75C12.6904 14.75 13.25 15.3096 13.25 16C13.25 16.6904 12.6904 17.25 12 17.25C11.3096 17.25 10.75 16.6904 10.75 16Z", fill: "inherit" }) });
var warning_error_large_fill_default = SvgWarningErrorLargeFill;

// assets/newIcons/warning_error-large-line.svg
import * as React394 from "react";
import { jsx as jsx399 } from "react/jsx-runtime";
var SvgWarningErrorLargeLine = (props) => /* @__PURE__ */ jsx399("svg", { stroke: "black", width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx399("path", { d: "M12 9V13M12 16H12.01M4.13898 20H19.861C21.5052 20 22.5327 18.3085 21.7107 16.9552L13.8497 4.01493C13.0276 2.66169 10.9724 2.66169 10.1503 4.01493L2.28933 16.9552C1.46726 18.3085 2.49485 20 4.13898 20ZM12.5 16C12.5 16.2761 12.2761 16.5 12 16.5C11.7239 16.5 11.5 16.2761 11.5 16C11.5 15.7239 11.7239 15.5 12 15.5C12.2761 15.5 12.5 15.7239 12.5 16Z", stroke: "inherit", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }) });
var warning_error_large_line_default = SvgWarningErrorLargeLine;

// assets/newIcons/warranty_expiration-large-line.svg
import * as React395 from "react";
import { jsx as jsx400 } from "react/jsx-runtime";
var SvgWarrantyExpirationLargeLine = (props) => /* @__PURE__ */ jsx400("svg", { stroke: "black", width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx400("path", { d: "M9.99988 21H5.99988C4.89531 21 3.99988 20.1046 3.99988 19V5C3.99988 3.89543 4.89531 3 5.99988 3H15.9999C17.1044 3 17.9999 3.89543 17.9999 5V9M14.5001 12.5001H20.5M14.5001 12.5001V13.3621C14.4972 14.2778 14.7863 15.171 15.326 15.9141C15.8657 16.6572 16.6284 17.2123 17.5052 17.5001M14.5001 12.5001H13M20.5 12.5001V13.3621C20.5035 14.2765 20.216 15.1687 19.6783 15.9117C19.1406 16.6547 18.3801 17.2105 17.5052 17.5001M20.5 12.5001L22 12.5001M17.5052 17.5001C18.3801 17.7896 19.1406 18.3454 19.6783 19.0884C20.216 19.8314 20.5035 20.7236 20.5 21.638V22.5001M17.5052 17.5001C16.6284 17.7878 15.8657 18.3429 15.326 19.086C14.7863 19.8291 14.4972 20.7223 14.5001 21.638V22.5001M14.5001 22.5001H20.5M14.5001 22.5001H13M20.5 22.5001H22M9.00003 6.00005L9.61783 7.2566L11 7.45555L10.0053 8.42937L10.2356 9.81157L9.00003 9.16236L7.76443 9.81157L7.9948 8.42937L7.00003 7.45555L8.38223 7.2566L9.00003 6.00005Z", stroke: "inherit", strokeWidth: 1.5, strokeMiterlimit: 10, strokeLinecap: "round", strokeLinejoin: "round" }) });
var warranty_expiration_large_line_default = SvgWarrantyExpirationLargeLine;

// assets/newIcons/warranty-large-line.svg
import * as React396 from "react";
import { jsx as jsx401 } from "react/jsx-runtime";
var SvgWarrantyLargeLine = (props) => /* @__PURE__ */ jsx401("svg", { stroke: "black", width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx401("path", { d: "M8 14H16M8 17H16M7 21H17C18.1046 21 19 20.1046 19 19V5C19 3.89543 18.1046 3 17 3H7C5.89543 3 5 3.89543 5 5V19C5 20.1046 5.89543 21 7 21ZM10 6L10.6178 7.25654L12 7.4555L11.0052 8.42932L11.2356 9.81152L10 9.1623L8.7644 9.81152L8.99476 8.42932L8 7.4555L9.3822 7.25654L10 6Z", stroke: "inherit", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }) });
var warranty_large_line_default = SvgWarrantyLargeLine;

// assets/newIcons/log-large-fill.svg
import * as React397 from "react";
import { jsx as jsx402 } from "react/jsx-runtime";
var SvgLogLargeFill = (props) => /* @__PURE__ */ jsx402("svg", { width: "inherit", height: "inherit", viewBox: "0 0 24 24", fill: "black", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx402("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M14.5 2.25C15.4793 2.25 16.31 2.87657 16.6191 3.75H17.5C19.0188 3.75 20.25 4.98122 20.25 6.5V19C20.25 20.5188 19.0188 21.75 17.5 21.75H6.5C4.98122 21.75 3.75 20.5188 3.75 19V6.5C3.75 4.98122 4.98122 3.75 6.5 3.75H7.38086C7.68999 2.87657 8.52067 2.25 9.5 2.25H14.5ZM9 12.75C8.58579 12.75 8.25 13.0858 8.25 13.5C8.25 13.9142 8.58579 14.25 9 14.25H12C12.4142 14.25 12.75 13.9142 12.75 13.5C12.75 13.0858 12.4142 12.75 12 12.75H9ZM9 9.25C8.58579 9.25 8.25 9.58579 8.25 10C8.25 10.4142 8.58579 10.75 9 10.75H15C15.4142 10.75 15.75 10.4142 15.75 10C15.75 9.58579 15.4142 9.25 15 9.25H9ZM9.5 3.75C9.08579 3.75 8.75 4.08579 8.75 4.5C8.75 4.91421 9.08579 5.25 9.5 5.25H14.5C14.9142 5.25 15.25 4.91421 15.25 4.5C15.25 4.08579 14.9142 3.75 14.5 3.75H9.5Z", fill: "inherit", fillOpacity: 0.77 }) });
var log_large_fill_default = SvgLogLargeFill;

// components/HVIcon/iconList.ts
var oldIconList = {
  add: add_default,
  "arrow-up": arrow_up_side_default,
  "arrow-right": arrow_right_side_default,
  "arrow-down": arrow_down_side_default,
  "arrow-left": arrow_left_side_default,
  "arrow-chevron-up": arrow_chevron_up_default,
  "arrow-chevron-right": arrow_chevron_right_default,
  "arrow-chevron-left": arrow_chevron_left_default,
  "arrow-chevron-down": arrow_chevron_down_default,
  "arrow-up-down": arrow_up_down_default,
  alarm: alarm_default,
  apps: apps_default,
  area: area_default,
  analytics: analytics_default,
  AI: AI_default,
  bookmark: bookmark_default,
  "building-office1": building_office1_default,
  "building-office2": building_office2_default,
  "building-office3": building_office3_default,
  check: check_default,
  calendar: calendar_default,
  close: closeSign_default,
  copy: copy_default,
  certification: certification_default,
  "camera-dome": camera_dome_default,
  "camera-dome-cloud": camera_dome_cloud_default,
  "camera-fisheye": camera_fisheye_default,
  "camera-external": camera_external_default,
  "camera-MDC": camera_MDC_default,
  crowd: crowd_default,
  cpu: cpu_default,
  "cgi-sender": cgi_sender_default,
  "camera-PTZ": camera_PTZ_default,
  "camera-tamp": camera_tamp_default,
  "cloud-upload": cloud_upload_default,
  device: device_default,
  dashboard: dashboardSign_default,
  document: document_default,
  drag: drag_default,
  dashboards: dashboards_default,
  direction: direction_default,
  defocus: defocus_default,
  "external-link": external_link_default,
  export: export_default,
  edit: edit_default,
  email: email_default,
  empty: empty_default,
  event: event_default,
  fail: fail_no_fill_default,
  "fail-snackbar": fail_default,
  favorite: favorite_default,
  filter: filter_default,
  "folder-close": folder_close_default,
  "Folder-open": folder_open_default,
  folklift: folklift_default,
  firmware: firmware_default,
  "forklift-counting": forklift_counting_default,
  "forklift-queue-management": forklift_queue_management_default,
  "forklift-heatmap": forklift_heatmap_default,
  face: face_default,
  "fog-detection": fog_detection_default,
  "focus-near": focus_near_default,
  "focus-far": focus_far_default,
  help: help_default,
  heatmap: heatmap_default,
  "heater-heat": heater_heat_default,
  "heater-heat-1": heater_heat_1_default,
  information: information_plain_default,
  "image-gallery": image_gallery_default,
  "information-filled": information_default,
  location: location_default,
  live: live_default,
  lock: lock_default,
  "lock-open": lock_open_default,
  "link-clip": link_clip_default,
  list: list_default,
  link: link1_default,
  "log-out": log_out1_default,
  license: license_default,
  log: log1_default,
  "license-plate": license_plate_default,
  "line-crossing": line_crossing_default,
  more: more_default,
  "motion-detection": motion_detection_default,
  map: map_default,
  menu: menu_default,
  notification: notification_default,
  note: note_default,
  network: network_default,
  "online-success": online_success_plain_default,
  "online-success-filled": online_success_default,
  "object-detection": object_detection_default,
  playback: playback_default,
  PoE: PoE_default,
  people: people_default,
  "people-vector": people_vector_default,
  "people-heatmap": people_heatmap_default,
  PTZ: PTZ_default,
  "queue-management": queue_management_default,
  refresh: refresh_default,
  reset: reset_default,
  remove: remove_default,
  "reports-old": reports_old_default,
  ram: ram_default,
  reports: reports_default,
  "rule-setup": rule_setup_default,
  search: search_default,
  setting: setting_default,
  share: share_default,
  server: server_default,
  "server-gateway": server_gateway_default,
  storage: storage_default,
  "speaker-sound-volume": speaker_sound_volume_default,
  "speaker-sound-volume-mute": speaker_sound_volume_mute_default,
  "software-update": software_update_default,
  "sort-arrow-down": sort_arrow_down_default,
  "sort-arrow-up": sort_arrow_up_default,
  "sort-arrow-up-down": sort_arrow_up_down_default,
  "slip-fall": slip_fall_default,
  "shopping-cart": shopping_cart_default,
  "shopping-cart-counting": shopping_cart_counting_default,
  "shopping-cart-queue-management": shopping_cart_queue_management_default,
  "shopping-cart-heatmap": shopping_cart_heatmap_default,
  "stopped-vehicle": stopped_vehicle_default,
  "shock-detection": shock_detection_default,
  time: time_default,
  "top-rank": top_rank_default,
  "traffic-jam": traffic_jam_default,
  temperature: temperature_default,
  "tooltip-help": tooltipHelp_default,
  "tooltip-info": tooltipInfo_default,
  "tampering-detection": tampering_detection_default,
  user: user_single_default,
  "user-profile": user_profile_default,
  "user-group": user_group_default,
  "unlink-clip": unlink_clip_default,
  "view-show": view_show_default,
  "view-hide": view_hide_default,
  "video-loss": video_loss_default,
  vehicle: vehicle_default,
  "vehicle-motorcycle": vehicle_motorcycle_default,
  vehicle_bicycle: vehicle_bicycle_default,
  "vehicle-truck": vehicle_truck_default,
  "vehicle-bus": vehicle_bus_default,
  "vehicle-van": vehicle_van_default,
  "vehicle-sedan": vehicle_sedan_default,
  "vehicle-suv": vehicle_suv_default,
  "vehicle-counting": vehicle_counting_default,
  "vehicle-queue-management": vehicle_queue_management_default,
  "vehicle-heatmap": vehicle_heatmap_default,
  warning: warning_default,
  "warning-error": warning_error_default,
  warranty: warranty_default,
  "warranty-expiration": warranty_expiration_default,
  leaf: IconLeaf_default,
  "empty-state-large": largeIconEmptyState_default,
  "empty-state-medium": mediumIconEmptyState_default,
  "icon-arrow-right": IconArrowRight_default
};
var iconList = {
  "add-large-line": add_large_line_default,
  "add-medium-line": add_medium_line_default,
  "AI-large-line": AI_large_line_default,
  "alarm-large-line": alarm_large_line_default,
  "analytics-large-fill": analytics_large_fill_default,
  "analytics-large-line": analytics_large_line_default,
  "apps-large-line": apps_large_line_default,
  "area-large-line": area_large_line_default,
  "arrow_chevron_down-large-line": arrow_chevron_down_large_line_default,
  "arrow_chevron_down-medium-line": arrow_chevron_down_medium_line_default,
  "arrow_chevron_down-small-fill": arrow_chevron_down_small_fill_default,
  "arrow_chevron_down-small-line": arrow_chevron_down_small_line_default,
  "arrow_chevron_left-large-line": arrow_chevron_left_large_line_default,
  "arrow_chevron_left-medium-line": arrow_chevron_left_medium_line_default,
  "arrow_chevron_left-small-line": arrow_chevron_left_small_line_default,
  "arrow_chevron_right-large-line": arrow_chevron_right_large_line_default,
  "arrow_chevron_right-medium-line": arrow_chevron_right_medium_line_default,
  "arrow_chevron_right-small-line": arrow_chevron_right_small_line_default,
  "arrow_chevron_up-large-line": arrow_chevron_up_large_line_default,
  "arrow_chevron_up-medium-line": arrow_chevron_up_medium_line_default,
  "arrow_chevron_up-small-fill": arrow_chevron_up_small_fill_default,
  "arrow_chevron_up-small-line": arrow_chevron_up_small_line_default,
  "arrow_down-large-fill": arrow_down_large_fill_default,
  "arrow_down-large-line": arrow_down_large_line_default,
  "arrow_down-medium-line": arrow_down_medium_line_default,
  "arrow_elbow-large-line": arrow_elbow_large_line_default,
  "arrow_left-large-line": arrow_left_large_line_default,
  "arrow_left-medium-line": arrow_left_medium_line_default,
  "arrow_none-large-line": arrow_none_large_line_default,
  "arrow_right-large-line": arrow_right_large_line_default,
  "arrow_right-medium-line": arrow_right_medium_line_default,
  "arrow_up_down-large-line": arrow_up_down_large_line_default,
  "arrow_up_down-medium-line": arrow_up_down_medium_line_default,
  "arrow_up_down-small-line": arrow_up_down_small_line_default,
  "arrow_up-large-fill": arrow_up_large_fill_default,
  "arrow_up-large-line": arrow_up_large_line_default,
  "arrow_up-medium-line": arrow_up_medium_line_default,
  "auto_focus-large-line": auto_focus_large_line_default,
  "bookmark-large-fill": bookmark_large_fill_default,
  "bookmark-large-line": bookmark_large_line_default,
  "building_office1-large-fill": building_office1_large_fill_default,
  "building_office1-large-line": building_office1_large_line_default,
  "building_office2-large-line": building_office2_large_line_default,
  "building_office3-large-line": building_office3_large_line_default,
  "calendar-large-line": calendar_large_line_default,
  "camera_dome_cloud-large-line": camera_dome_cloud_large_line_default,
  "camera_dome-large-line": camera_dome_large_line_default,
  "camera_external-large-line": camera_external_large_line_default,
  "camera_fisheye-large-line": camera_fisheye_large_line_default,
  "camera_MDC-large-line": camera_MDC_large_line_default,
  "camera_PTZ-large-line": camera_PTZ_large_line_default,
  "camera_tamp-large-line": camera_tamp_large_line_default,
  "certification-large-line": certification_large_line_default,
  "cgi_sender-large-line": cgi_sender_large_line_default,
  "chat_support-large-line": chat_support_large_line_default,
  "check-large-line": check_large_line_default,
  "close-large-line": close_large_line_default,
  "cloud_upload-large-line": cloud_upload_large_line_default,
  "copy-large-line": copy_large_line_default,
  "cpu-large-line": cpu_large_line_default,
  "crowd_counting-large-line": crowd_counting_large_line_default,
  "dashboard-large-line": dashboard_large_line_default,
  "dashboards-large-line": dashboards_large_line_default,
  "defocus-large-line": defocus_large_line_default,
  "device-large-line": device_large_line_default,
  "direction-large-line": direction_large_line_default,
  "document-large-line": document_large_line_default,
  "download_import-large-line": download_import_large_line_default,
  "drag-large-line": drag_large_line_default,
  "edit-large-line": edit_large_line_default,
  "email-large-line": email_large_line_default,
  "empty-large-line": empty_large_line_default,
  "encoder-large-line": encoder_large_line_default,
  "error-large-fill": error_large_fill_default,
  "error-large-line": error_large_line_default,
  "event-large-line": event_large_line_default,
  "external_link-large-line": external_link_large_line_default,
  "face-large-line": face_large_line_default,
  "fail-large-fill": fail_large_fill_default,
  "fail-large-line": fail_large_line_default,
  "favorite-large-line": favorite_large_line_default,
  "filter-large-line": filter_large_line_default,
  "firmware-large-line": firmware_large_line_default,
  "focus_far-large-line": focus_far_large_line_default,
  "focus_near-large-line": focus_near_large_line_default,
  "fog_detection-large-line": fog_detection_large_line_default,
  "folder_close-large-fill": folder_close_large_fill_default,
  "folder_close-large-line": folder_close_large_line_default,
  "folder_open-large-fill": folder_open_large_fill_default,
  "folder_open-large-line": folder_open_large_line_default,
  "folklift-large-line": folklift_large_line_default,
  "forklift_counting-large-line": forklift_counting_large_line_default,
  "forklift_heatmap-large-line": forklift_heatmap_large_line_default,
  "forklift_queue_management-large-line": forklift_queue_management_large_line_default,
  "grouping-large-line": grouping_large_line_default,
  "dry_heater-large-line": dry_heater_large_line_default,
  "dry_spin-large-line": dry_spin_large_line_default,
  "heatmap-large-line": heatmap_large_line_default,
  "help-large-fill": help_large_fill_default,
  "help-large-line": help_large_line_default,
  "identities-large-fill": identities_large_fill_default,
  "identities-large-line": identities_large_line_default,
  "image_gallery-large-line": image_gallery_large_line_default,
  "information-large-line": information_large_line_default,
  "key-large-line": key_large_line_default,
  "language-large-line": language_large_line_default,
  "license_plate-large-line": license_plate_large_line_default,
  "license-large-line": license_large_line_default,
  "line_crossing-large-line": line_crossing_large_line_default,
  "link_clip-large-line": link_clip_large_line_default,
  "link-large-line": link_large_line_default,
  "list-large-line": list_large_line_default,
  "live-large-line": live_large_line_default,
  "location-large-line": location_large_line_default,
  "lock_open-large-line": lock_open_large_line_default,
  "lock-large-line": lock_large_line_default,
  "log_out-large-line": log_out_large_line_default,
  "log-large-line": log_large_line_default,
  "map-large-line": map_large_line_default,
  "menu-large-line": menu_large_line_default,
  "minus-large-line": minus_large_line_default,
  "more-large-line": more_large_line_default,
  "motion_detection-large-line": motion_detection_large_line_default,
  "network-large-line": network_large_line_default,
  "note-large-line": note_large_line_default,
  "notification-large-fill": notification_large_fill_default,
  "notification-large-line": notification_large_line_default,
  "object_detection-large-line": object_detection_large_line_default,
  "online_success-large-fill": online_success_large_fill_default,
  "online_success-large-line": online_success_large_line_default,
  "panel_collapse-large-line": panel_collapse_large_line_default,
  "panel_expansion-large-line": panel_expansion_large_line_default,
  "people_counting-large-fill": people_counting_large_fill_default,
  "people_counting-large-line": people_counting_large_line_default,
  "people_heatmap-large-line": people_heatmap_large_line_default,
  "people-large-line": people_large_line_default,
  "pin-large-fill": pin_large_fill_default,
  "pin-large-line": pin_large_line_default,
  "pin2-large-fill": pin2_large_fill_default,
  "pin2-large-line": pin2_large_line_default,
  "playback-large-line": playback_large_line_default,
  "PoE-large-line": PoE_large_line_default,
  "PTZ-large-line": PTZ_large_line_default,
  "queue_management-large-line": queue_management_large_line_default,
  "ram-large-line": ram_large_line_default,
  "refresh-large-line": refresh_large_line_default,
  "remove-large-fill": remove_large_fill_default,
  "remove-large-line": remove_large_line_default,
  "reports-large-fill": reports_large_fill_default,
  "reports-large-line": reports_large_line_default,
  "reset-large-line": reset_large_line_default,
  "rule_setup-large-line": rule_setup_large_line_default,
  "search-large-line": search_large_line_default,
  "server_gateway-large-line": server_gateway_large_line_default,
  "server-large-line": server_large_line_default,
  "setting-large-fill": setting_large_fill_default,
  "setting-large-line": setting_large_line_default,
  "share-large-line": share_large_line_default,
  "shock_detection-large-line": shock_detection_large_line_default,
  "shopping_cart_counting-large-line": shopping_cart_counting_large_line_default,
  "shopping_cart_heatmap-large-line": shopping_cart_heatmap_large_line_default,
  "shopping_cart_queue_management-large-line": shopping_cart_queue_management_large_line_default,
  "shopping_cart-large-line": shopping_cart_large_line_default,
  "slip_fall-large-line": slip_fall_large_line_default,
  "software_update-large-line": software_update_large_line_default,
  "sort_arrow_down-large-line": sort_arrow_down_large_line_default,
  "sort_arrow_down-medium-line": sort_arrow_down_medium_line_default,
  "sort_arrow_up_down-large-line": sort_arrow_up_down_large_line_default,
  "sort_arrow_up_down-medium-line": sort_arrow_up_down_medium_line_default,
  "sort_arrow_up-large-line": sort_arrow_up_large_line_default,
  "sort_arrow_up-medium-line": sort_arrow_up_medium_line_default,
  "speaker_sound_volume_mute-large-line": speaker_sound_volume_mute_large_line_default,
  "speaker_sound_volume-large-line": speaker_sound_volume_large_line_default,
  "stopped_vehicle-large-line": stopped_vehicle_large_line_default,
  "storage-large-line": storage_large_line_default,
  "tampering_detection-large-line": tampering_detection_large_line_default,
  "temperature-large-line": temperature_large_line_default,
  "time-large-line": time_large_line_default,
  "top_rank-large-line": top_rank_large_line_default,
  "traffic_jam-large-line": traffic_jam_large_line_default,
  "unlink_clip-large-line": unlink_clip_large_line_default,
  "upload_export-large-line": upload_export_large_line_default,
  "user_group-large-line": user_group_large_line_default,
  "user_guide-large-line": user_guide_large_line_default,
  "user_profile-large-fill": user_profile_large_fill_default,
  "user_profile-large-line": user_profile_large_line_default,
  "user-large-fill": user_large_fill_default,
  "user-large-line": user_large_line_default,
  "vehicle_bicycle-large-line": vehicle_bicycle_large_line_default,
  "vehicle_bus-large-line": vehicle_bus_large_line_default,
  "vehicle_counting-large-line": vehicle_counting_large_line_default,
  "vehicle_heatmap-large-line": vehicle_heatmap_large_line_default,
  "vehicle_motorcycle-large-line": vehicle_motorcycle_large_line_default,
  "vehicle_queue_management-large-line": vehicle_queue_management_large_line_default,
  "vehicle_sedan-large-line": vehicle_sedan_large_line_default,
  "vehicle_suv-large-line": vehicle_suv_large_line_default,
  "vehicle_truck-large-line": vehicle_truck_large_line_default,
  "vehicle_van-large-line": vehicle_van_large_line_default,
  "vehicle-large-line": vehicle_large_line_default,
  "video_loss-large-line": video_loss_large_line_default,
  "view_hide-large-line": view_hide_large_line_default,
  "view_show-large-line": view_show_large_line_default,
  "warning_error-large-fill": warning_error_large_fill_default,
  "warning_error-large-line": warning_error_large_line_default,
  "warranty_expiration-large-line": warranty_expiration_large_line_default,
  "warranty-large-line": warranty_large_line_default,
  "log-large-fill": log_large_fill_default
};
var iconList_default = iconList;

// components/HVIcon/HVIcon.tsx
import { createElement as createElement2 } from "react";
import { Fragment, jsx as jsx403 } from "react/jsx-runtime";
var svgDefaultProperties = {
  width: 24,
  height: 24,
  strokeWidth: 1.5
};
var HVIcon = ({
  name,
  scale = "medium",
  theme: theme2 = "line",
  svgProps: svgProps2 = svgDefaultProperties,
  styleClass,
  size = 24
}) => {
  const iconKey = `${name}-${scale}-${theme2}`;
  let selectedIcon;
  if (iconList_default[iconKey]) {
    selectedIcon = iconList_default[iconKey];
  } else {
    const oldIconName = name;
    selectedIcon = oldIconList[oldIconName];
  }
  if (theme2 === "fill") {
    svgDefaultProperties["fill"] = "var(--hv-icon-normal-primary)";
    svgDefaultProperties["stroke"] = "none";
  } else {
    svgDefaultProperties["fill"] = "none";
    svgDefaultProperties["stroke"] = "var(--hv-icon-normal-primary)";
  }
  svgDefaultProperties["height"] = size;
  svgDefaultProperties["width"] = size;
  return /* @__PURE__ */ jsx403(Fragment, { children: createElement2(selectedIcon, {
    className: styleClass,
    ...svgDefaultProperties,
    ...svgProps2
  }) });
};
var HVIcon_default = HVIcon;

// utils/Utils.ts
var svgProps = (size, fillColor, strokeColor) => {
  return {
    height: size,
    width: size,
    fill: fillColor ? fillColor : "var(--hv-alert-text-default)",
    stroke: strokeColor ? strokeColor : ""
  };
};

// components/HVBreadcrumbs/HVBreadcrumbs.tsx
import { Fragment as Fragment2, jsx as jsx404, jsxs as jsxs76 } from "react/jsx-runtime";
var HVBreadcrumbItem = ({
  item,
  type
}) => {
  return /* @__PURE__ */ jsx404(
    HVFlex_default,
    {
      direction: "row",
      align: "center",
      gap: "var(--mantine-spacing-1)",
      className: styles4.flex,
      onClick: item?.onClick,
      ...item.breadcrumbItemContainerProps,
      children: item.variant === "More" ? /* @__PURE__ */ jsx404(
        HVText_default,
        {
          type: type === "md" ? "Body-md" : "Body-xs",
          className: `${styles4.text} ${item.isActive && styles4.textActive}`,
          ...item.moreTextProps,
          children: "..."
        }
      ) : /* @__PURE__ */ jsxs76(Fragment2, { children: [
        item.icon,
        /* @__PURE__ */ jsx404(
          HVText_default,
          {
            type: type === "md" ? "Body-md" : "Body-xs",
            className: `${styles4.text} ${item.isActive && styles4.textActive}`,
            ...item.shortTextProps,
            children: item.label
          }
        )
      ] })
    }
  );
};
var itemList = ({ type, items }) => {
  return items?.map((item, index) => /* @__PURE__ */ jsx404(HVBreadcrumbItem, { item, type }, index.toString()));
};
function HVBreadcrumbs({
  type = "sm",
  breadcrumbsProps,
  items,
  children
}) {
  return /* @__PURE__ */ jsx404(
    Breadcrumbs,
    {
      separator: /* @__PURE__ */ jsx404(
        HVIcon_default,
        {
          name: "arrow-chevron-right",
          svgProps: svgProps(
            type === "md" ? 20 : 16,
            "",
            "var(--hv-text-normal-secondary)"
          )
        }
      ),
      ...breadcrumbsProps,
      className: `${breadcrumbsProps?.className}`,
      children: children ? children : itemList({ type, items })
    }
  );
}
var HVBreadcrumbs_default = HVBreadcrumbs;

// components/HVButton/HVButton.tsx
import { forwardRef as forwardRef2 } from "react";
import { Button, createPolymorphicComponent as createPolymorphicComponent2, Menu } from "@mantine/core";
import style2 from "./HVButton.module-XFFHZOZ4.module.css";
import clsx from "clsx";
import { jsx as jsx405, jsxs as jsxs77 } from "react/jsx-runtime";
var HVButton = createPolymorphicComponent2(
  forwardRef2(
    ({
      variant = "Primary",
      children,
      text,
      textProps,
      buttonsGroup,
      activeKey,
      dropdownItems,
      isSplitButton,
      isSplitButtonIconVisible = true,
      onClick,
      buttonContainerProps,
      buttonMenuContainerProps,
      menuContainerProps,
      menuTargetContainerProps,
      menuDropdownContainerProps,
      menuItemContainerProps,
      leftSection,
      rightSection,
      ...rest
    }, ref) => {
      if (isSplitButton && dropdownItems?.length) {
        return /* @__PURE__ */ jsx405("div", { className: style2["div-container-split-button"], children: /* @__PURE__ */ jsxs77(Menu, { withinPortal: false, ...menuContainerProps, children: [
          /* @__PURE__ */ jsxs77("div", { className: style2["div-menu-container"], children: [
            /* @__PURE__ */ jsx405(
              Button,
              {
                variant,
                onClick: (e) => {
                  onClick?.(e);
                },
                className: clsx(
                  style2.root,
                  style2[variant],
                  style2["first-button"]
                ),
                ...buttonContainerProps,
                leftSection,
                rightSection,
                ...rest,
                children: /* @__PURE__ */ jsx405(HVText_default, { type: "Body-sm", c: "inherit", ...textProps, children: text })
              }
            ),
            isSplitButtonIconVisible && /* @__PURE__ */ jsx405(Menu.Target, { ...menuTargetContainerProps, children: /* @__PURE__ */ jsx405(
              Button,
              {
                variant: "default",
                className: clsx(
                  style2.root,
                  style2[variant],
                  style2["last-button"]
                ),
                ...buttonMenuContainerProps,
                ...rest,
                children: /* @__PURE__ */ jsx405(
                  HVIcon_default,
                  {
                    name: "arrow-chevron-down",
                    svgProps: { width: 20, height: 20 }
                  }
                )
              }
            ) })
          ] }),
          /* @__PURE__ */ jsx405(
            Menu.Dropdown,
            {
              className: style2["button-dropdown"],
              ...menuDropdownContainerProps,
              children: dropdownItems.map((item, idx) => /* @__PURE__ */ jsx405(
                Menu.Item,
                {
                  className: style2["button-dropdown-item"],
                  onClick: item.onClick,
                  ...menuItemContainerProps,
                  children: item.label
                },
                idx
              ))
            }
          )
        ] }) });
      }
      if (buttonsGroup && buttonsGroup.length > 0) {
        return /* @__PURE__ */ jsx405("div", { style: { display: "flex" }, children: buttonsGroup.map((btn, index) => {
          const isFirst = index === 0;
          const isLast = index === buttonsGroup.length - 1;
          const isActive = activeKey === btn.key;
          return /* @__PURE__ */ jsx405(
            Button,
            {
              component: "button",
              ref,
              onClick: btn.onClick,
              disabled: btn.disabled,
              className: clsx(
                style2.root,
                style2["ButtonGroup"],
                isFirst && style2.first,
                isLast && style2.last,
                isActive && style2.active
              ),
              ...buttonContainerProps,
              leftSection,
              rightSection,
              ...rest,
              children: /* @__PURE__ */ jsx405(HVText_default, { type: "Body-sm", c: "inherit", ...textProps, children: btn.text })
            },
            btn.key
          );
        }) });
      }
      return /* @__PURE__ */ jsxs77(
        Button,
        {
          component: "button",
          ref,
          variant,
          styles: {
            section: {
              marginInlineStart: "var(--hv-spacing-1)"
            }
          },
          className: clsx(style2.root, style2[variant]),
          ...buttonContainerProps,
          leftSection,
          rightSection,
          onClick: (e) => {
            onClick?.(e);
          },
          ...rest,
          children: [
            text && /* @__PURE__ */ jsx405(HVText_default, { type: "Body-sm", c: "inherit", ...textProps, children: text }),
            children
          ]
        }
      );
    }
  )
);
var HVButton_default = HVButton;

// components/HVCheckbox/HVCheckbox.tsx
import { Checkbox } from "@mantine/core";
import styles5 from "./HVCheckbox.module-K4ZWX45T.module.css";
import { jsx as jsx406 } from "react/jsx-runtime";
var HVCheckbox = ({
  checked,
  label,
  disabled,
  onChange,
  defaultChecked,
  labelProps,
  size = "16",
  indeterminate,
  hvCheckboxProps
}) => {
  return /* @__PURE__ */ jsx406(
    Checkbox,
    {
      size,
      label: label ? /* @__PURE__ */ jsx406(
        HVText_default,
        {
          style: { lineHeight: `${size}px` },
          c: disabled ? "var(--hv-text-normal-disabled)" : "var(--hv-text-normal-primary)",
          type: "Body-sm",
          ...labelProps,
          children: `${label}`
        }
      ) : null,
      checked,
      onChange,
      disabled,
      indeterminate,
      defaultChecked,
      classNames: styles5,
      ...hvCheckboxProps
    }
  );
};
var HVCheckbox_default = HVCheckbox;

// components/HVClickOutSide/HVClickOutSide.tsx
import { Box } from "@mantine/core";
import { useEffect, useRef } from "react";
import { jsx as jsx407 } from "react/jsx-runtime";
var HVClickOutSide = ({ onClickOutside, children }) => {
  const ref = useRef(null);
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (ref.current && !ref.current.contains(event.target)) {
        onClickOutside();
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("touchstart", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("touchstart", handleClickOutside);
    };
  }, [onClickOutside]);
  return /* @__PURE__ */ jsx407(Box, { ref, children });
};
var HVClickOutSide_default = HVClickOutSide;

// components/HVDropdown/HVDropdown.tsx
import { useEffect as useEffect2, useRef as useRef2, useState } from "react";
import {
  Combobox,
  Group,
  Input,
  InputBase,
  Select,
  useCombobox
} from "@mantine/core";
import style3 from "./HVDropdown.module-E7ZXO6WS.module.css";
import scrollBarStyle from "./HVDropdpwnScroll.module-JLWYPEBZ.module.css";
import { Fragment as Fragment3, jsx as jsx408, jsxs as jsxs78 } from "react/jsx-runtime";
var renderSelectOption = ({
  option,
  checked
}) => {
  const item = option;
  return /* @__PURE__ */ jsxs78(
    Group,
    {
      justify: "space-between",
      className: `${style3.optionContainer} ${checked ? style3.selected : ""}`,
      w: "100%",
      children: [
        /* @__PURE__ */ jsx408("span", { children: item.label }),
        item.count && /* @__PURE__ */ jsx408("span", { className: style3.count, children: item.count })
      ]
    }
  );
};
var renderSelectOptionWithArrow = ({
  option,
  checked
}) => {
  const item = option;
  return /* @__PURE__ */ jsxs78(Group, { justify: "space-between", className: style3.optionContainer, w: "100%", children: [
    /* @__PURE__ */ jsxs78("div", { className: style3.groupItemWithArrow, children: [
      /* @__PURE__ */ jsx408("span", { className: style3.groupItemWithArrowemptySpace, children: checked ? /* @__PURE__ */ jsx408(HVIcon_default, { name: "check", scale: "large", theme: "line", size: "20" }) : null }),
      /* @__PURE__ */ jsx408("span", { children: item.label })
    ] }),
    item.count !== void 0 && /* @__PURE__ */ jsx408("span", { className: style3.count, children: item.count })
  ] });
};
var HVDropdown = ({
  type,
  selectedItem = null,
  options,
  selectWithArrow,
  selectWithSearch,
  selectWithCount,
  getSelectedValue,
  dropdownIconProps,
  dropdownOpenIconProps,
  dropdownCloseIconProps,
  ...dropdownContainerProps
}) => {
  const [opened, setOpened] = useState(false);
  const [rightSectionIcon, setRightSideIcon] = useState(
    /* @__PURE__ */ jsx408(
      HVIcon_default,
      {
        ...dropdownIconProps,
        name: "arrow_chevron_down",
        scale: "small",
        theme: "line",
        size: "20",
        svgProps: { stroke: "var(--hv-icon-normal-secondary)" }
      }
    )
  );
  const [search, setSearch] = useState("");
  const [value, setValue] = useState(null);
  const [searchFocused, setSearchFocused] = useState(false);
  const [selectedComboItem, setSelectedComboItem] = useState();
  const searchRef = useRef2(null);
  const combobox = useCombobox({
    onDropdownClose: () => {
      combobox.resetSelectedOption();
      combobox.focusTarget();
      setSearch("");
    },
    onDropdownOpen: () => {
      combobox.focusSearchInput();
    }
  });
  useEffect2(() => {
    if (combobox.dropdownOpened) {
      setTimeout(() => {
        searchRef.current?.blur();
      }, 0);
    }
  }, [combobox.dropdownOpened]);
  useEffect2(() => {
    setOptionToDropdown(selectedItem);
  }, []);
  const normalizedOptions = options.map(
    (item) => typeof item === "string" ? { label: item, value: item } : item
  );
  const setOptionToDropdown = (dropDownSelectedItem) => {
    if (!dropDownSelectedItem) return;
    const selectedItem2 = normalizedOptions.find(
      (item) => item.value === dropDownSelectedItem
    );
    if (selectedItem2) {
      setSelectedComboItem(selectedItem2);
    }
  };
  const optionsForCombobox = normalizedOptions.filter((item) => {
    const optionItem = item;
    return optionItem.label.toLowerCase().includes(search.toLowerCase().trim());
  }).map((item) => {
    const optionItem = item;
    return /* @__PURE__ */ jsx408(
      Combobox.Option,
      {
        value: optionItem.value,
        className: `${style3.dropdownOptionItem} ${selectedItem === optionItem.value && !selectWithArrow && style3.selected}`,
        w: "100%",
        children: /* @__PURE__ */ jsxs78("div", { className: style3.dropdownOptionContainer, children: [
          /* @__PURE__ */ jsxs78(
            "div",
            {
              className: style3.dropdownOptionItemWithCheckAndLabel,
              style: {
                gap: selectWithArrow ? "8px" : void 0
              },
              children: [
                /* @__PURE__ */ jsx408(
                  "span",
                  {
                    className: style3.dropdownOptionCheckItem,
                    style: {
                      width: selectWithArrow ? "20px" : void 0
                    },
                    children: selectWithArrow && selectedItem === optionItem.value ? /* @__PURE__ */ jsx408(HVIcon_default, { name: "check", scale: "large", theme: "line", size: "20" }) : null
                  }
                ),
                /* @__PURE__ */ jsx408("span", { children: optionItem.label })
              ]
            }
          ),
          optionItem.count !== void 0 && /* @__PURE__ */ jsx408("span", { className: style3.count, children: optionItem.count })
        ] })
      },
      optionItem.value
    );
  });
  return /* @__PURE__ */ jsx408(Fragment3, { children: selectWithSearch || selectWithCount ? /* @__PURE__ */ jsx408("div", { className: style3.comboboxWrapper, children: /* @__PURE__ */ jsxs78(
    Combobox,
    {
      store: combobox,
      withinPortal: false,
      onOptionSubmit: (val) => {
        setValue(val);
        getSelectedValue(val);
        setOptionToDropdown(val);
        combobox.closeDropdown();
      },
      children: [
        /* @__PURE__ */ jsx408(Combobox.Target, { children: /* @__PURE__ */ jsx408(
          InputBase,
          {
            component: "button",
            type: "button",
            pointer: true,
            rightSection: combobox.dropdownOpened ? /* @__PURE__ */ jsx408(
              HVIcon_default,
              {
                name: "arrow_chevron_up",
                scale: "small",
                theme: "line"
              }
            ) : /* @__PURE__ */ jsx408(
              HVIcon_default,
              {
                name: "arrow_chevron_down",
                scale: "small",
                theme: "line",
                svgProps: { stroke: "var(--hv-icon-normal-secondary)" }
              }
            ),
            onClick: () => combobox.toggleDropdown(),
            rightSectionPointerEvents: "none",
            className: style3.dropdownItemContainer,
            styles: {
              input: combobox.dropdownOpened ? { border: "1px solid var(--hv-input-outline-active)" } : void 0
            },
            children: selectedItem !== null ? /* @__PURE__ */ jsxs78(Group, { justify: "space-between", w: "100%", children: [
              /* @__PURE__ */ jsx408("span", { children: selectedComboItem?.label }),
              selectedComboItem?.count && /* @__PURE__ */ jsx408("span", { className: style3.count, children: selectedComboItem?.count })
            ] }) : value || /* @__PURE__ */ jsx408(
              Input.Placeholder,
              {
                style: { color: "var(--hv-text-normal-secondary)" },
                children: "Choose an option"
              }
            )
          }
        ) }),
        /* @__PURE__ */ jsxs78(Combobox.Dropdown, { className: style3.comboboxOptionsContainer, children: [
          selectWithSearch && /* @__PURE__ */ jsx408(
            Combobox.Search,
            {
              ref: searchRef,
              value: search,
              onChange: (event) => setSearch(event.currentTarget.value),
              onFocus: () => setSearchFocused(true),
              onBlur: () => setSearchFocused(false),
              placeholder: "Search input field",
              className: style3.search,
              leftSection: /* @__PURE__ */ jsx408("span", { className: style3.leftIconWrapper, children: /* @__PURE__ */ jsx408(
                HVIcon_default,
                {
                  name: "search",
                  scale: "large",
                  theme: "line",
                  size: "20",
                  svgProps: { stroke: "var(--hv-icon-normal-secondary)" }
                }
              ) }),
              rightSection: searchFocused ? /* @__PURE__ */ jsx408(
                "span",
                {
                  className: style3.rightIconWrapper,
                  onMouseDown: (e) => {
                    e.preventDefault();
                    setSearch("");
                  },
                  children: /* @__PURE__ */ jsx408(
                    HVIcon_default,
                    {
                      name: "fail",
                      scale: "large",
                      theme: "fill",
                      size: "20",
                      svgProps: { fill: "var(--hv-icon-normal-primary)" },
                      className: style3.clearSearch,
                      onMouseDown: (e) => {
                        e.preventDefault();
                        setSearch("");
                      }
                    }
                  )
                }
              ) : null,
              rightSectionPointerEvents: "auto"
            }
          ),
          /* @__PURE__ */ jsx408(Combobox.Options, { className: style3.dropdownOptions, children: optionsForCombobox.length > 0 ? optionsForCombobox : /* @__PURE__ */ jsx408(Combobox.Empty, { className: style3.empty, children: "No data found" }) })
        ] })
      ]
    }
  ) }) : /* @__PURE__ */ jsx408(
    Select,
    {
      data: options,
      value: selectedItem,
      withCheckIcon: false,
      classNames: {
        root: type === "medium" ? style3.rootWrapperMedium : style3.rootWrapperLarge,
        input: style3.dropdownContainer,
        section: style3.sectionContainer,
        dropdown: style3.optionsContainer,
        option: style3.option
      },
      size: type === "medium" ? "xs" : "sm",
      styles: {
        input: {
          height: type === "medium" ? "24px" : "32px",
          backgroundColor: opened ? "var(--hv-input-foreground-default)" : "",
          color: opened ? "var(--hv-text-normal-primary)" : "",
          border: opened ? "1px solid var(--hv-input-outline-active)" : "",
          fontSize: type === "medium" ? "var(--hv-fontsize-body-xs)" : "var(--hv-fontsize-body-sm)"
        }
      },
      onDropdownOpen: () => {
        setOpened(true);
        setRightSideIcon(
          /* @__PURE__ */ jsx408(
            HVIcon_default,
            {
              ...dropdownOpenIconProps,
              name: "arrow_chevron_up",
              scale: "small",
              theme: "line",
              size: "20",
              svgProps: { stroke: "var(--hv-icon-normal-secondary)" }
            }
          )
        );
      },
      onDropdownClose: () => {
        setOpened(false);
        setRightSideIcon(
          /* @__PURE__ */ jsx408(
            HVIcon_default,
            {
              ...dropdownCloseIconProps,
              name: "arrow_chevron_down",
              scale: "small",
              theme: "line",
              size: "20",
              svgProps: { stroke: "var(--hv-icon-normal-secondary)" }
            }
          )
        );
      },
      comboboxProps: { offset: 4 },
      renderOption: selectWithArrow ? renderSelectOptionWithArrow : renderSelectOption,
      scrollAreaProps: { classNames: scrollBarStyle },
      rightSection: rightSectionIcon,
      onChange: (option) => getSelectedValue && getSelectedValue(option),
      ...dropdownContainerProps
    }
  ) });
};
var HVDropdown_default = HVDropdown;

// components/HVElevation/HVElevation.tsx
import { Paper } from "@mantine/core";
import styles6 from "./HVElevation.module-HS3QS2SG.module.css";
import { jsx as jsx409 } from "react/jsx-runtime";
var HVElevation = ({
  children,
  shadow,
  radius,
  paperContainerProps
}) => {
  return /* @__PURE__ */ jsx409(Paper, { shadow, radius: "lg", classNames: styles6, ...paperContainerProps, children });
};
var HVElevation_default = HVElevation;

// components/HVEmpty/HVEmpty.tsx
import style4 from "./HVEmpty.module-IJ5C3M4F.module.css";
import { jsx as jsx410, jsxs as jsxs79 } from "react/jsx-runtime";
var HVEmpty = ({
  iconSize,
  title,
  titleDescription,
  detail,
  detailDescription,
  key,
  appContainerProps,
  titleTextProps,
  detailTextProps
}) => {
  return /* @__PURE__ */ jsxs79(HVFlex_default, { className: style4.outerBox, ...appContainerProps, children: [
    iconSize === "medium" ? /* @__PURE__ */ jsx410(mediumIconEmptyState_default, { stroke: "var(--hv-icon-normal-primary)" }) : /* @__PURE__ */ jsx410(largeIconEmptyState_default, { stroke: "var(--hv-icon-normal-primary)" }),
    title && /* @__PURE__ */ jsx410(
      HVText_default,
      {
        ...titleTextProps,
        weight: "Bold",
        type: "Body-sm",
        "aria-label": titleDescription ? titleDescription : "",
        children: title
      }
    ),
    detail && /* @__PURE__ */ jsx410(
      HVText_default,
      {
        ...detailTextProps,
        c: "var(--hv-text-normal-tertiary)",
        type: "Body-sm",
        "aria-label": detailDescription ? detailDescription : "",
        children: detail
      }
    )
  ] }, key);
};
var HVEmpty_default = HVEmpty;

// components/HVInput/HVInput.tsx
import {
  Autocomplete,
  NumberInput,
  PasswordInput,
  TextInput
} from "@mantine/core";
import styles7 from "./HVInput.module-KGCLFNBE.module.css";
import { useState as useState2 } from "react";
import "@mantine/dates/styles.css";
import "@mantine/core/styles.css";
import { jsx as jsx411, jsxs as jsxs80 } from "react/jsx-runtime";
var HVInput = ({
  id,
  placeholder,
  leftSection,
  value: initialValue = "",
  error,
  success,
  guide,
  description,
  inputWrapperProps,
  type = "text",
  disabled = false,
  defaultValue,
  number,
  label = "",
  data = [],
  inputProps,
  passwordProps,
  numberInputProps,
  autocompleteProps
}) => {
  const showError = !!error;
  const showSuccess = !!success && !showError;
  const showGuide = !!guide && !showError && !showSuccess;
  const [value, setValue] = useState2(initialValue || defaultValue || "");
  const [search, setSearch] = useState2("");
  const VisibilityToggleIcon = ({ reveal }) => reveal ? /* @__PURE__ */ jsx411(
    HVIcon_default,
    {
      name: "view-show",
      scale: "large",
      theme: "line",
      svgProps: {
        width: "20px",
        height: "20px",
        stroke: "var(--hv-icon-normal-secondary)"
      }
    }
  ) : /* @__PURE__ */ jsx411(
    HVIcon_default,
    {
      name: "view-hide",
      scale: "large",
      theme: "line",
      svgProps: {
        width: "20px",
        height: "20px",
        stroke: "var(--hv-icon-normal-secondary)"
      }
    }
  );
  const iconSearch = /* @__PURE__ */ jsx411(
    HVIcon_default,
    {
      name: "search",
      scale: "large",
      theme: "line",
      svgProps: {
        width: "20px",
        height: "20px",
        stroke: "var(--hv-icon-normal-primary)"
      }
    }
  );
  return /* @__PURE__ */ jsxs80("div", { children: [
    type === "password" ? /* @__PURE__ */ jsx411(
      PasswordInput,
      {
        error: showError,
        description,
        wrapperProps: inputWrapperProps,
        id,
        placeholder,
        value,
        onChange: (event) => setValue(event.currentTarget.value),
        type,
        visibilityToggleIcon: VisibilityToggleIcon,
        visibilityToggleButtonProps: disabled ? {
          disabled: false,
          tabIndex: -1,
          style: {
            pointerEvents: "none",
            opacity: 0.6
          }
        } : {},
        disabled,
        defaultValue,
        ...passwordProps,
        styles: {
          input: {
            border: `1px solid ${showError ? "var(--hv-data-red)" : "var(--hv-input-outline-default)"}`,
            minHeight: "32px",
            height: "32px",
            borderRadius: "4px",
            backgroundColor: disabled ? "var(--hv-input-foreground-disabled)" : ""
          }
        },
        classNames: {
          root: styles7.passwordInputContainer
        }
      }
    ) : type === "spinner" ? /* @__PURE__ */ jsx411(
      NumberInput,
      {
        id,
        placeholder,
        value: number,
        error: showError,
        description,
        wrapperProps: inputWrapperProps,
        disabled,
        defaultValue,
        ...numberInputProps,
        styles: {
          input: {
            border: "1px solid var(--hv-input-outline-default)",
            minHeight: "32px",
            height: "32px",
            minWidth: "80px"
          },
          control: {
            borderLeft: "none",
            "--ni-control-border": "none",
            border: "none",
            height: "30px"
          }
        },
        classNames: {
          root: styles7.passwordInputContainer
        }
      }
    ) : type === "search" ? /* @__PURE__ */ jsx411(
      Autocomplete,
      {
        label,
        placeholder,
        data: data || [],
        value,
        onChange: (val) => {
          setValue(val);
          setSearch(val);
        },
        error: showError,
        description,
        id,
        disabled,
        rightSection: !disabled && value && /* @__PURE__ */ jsx411(
          "div",
          {
            onClick: () => setValue(""),
            style: {
              cursor: "pointer",
              display: "flex",
              alignItems: "center"
            },
            children: /* @__PURE__ */ jsx411(
              HVIcon_default,
              {
                name: "fail",
                theme: "fill",
                scale: "large",
                svgProps: {
                  width: 20,
                  height: 20
                }
              }
            )
          }
        ),
        leftSection: iconSearch,
        classNames: {
          root: styles7.searchInputContainer,
          input: styles7.input,
          dropdown: styles7.dropdown,
          option: styles7.option
        },
        ...autocompleteProps,
        renderOption: ({ option }) => {
          const label2 = option.value;
          const lowerLabel = label2.toLowerCase();
          const lowerSearch = search.toLowerCase();
          if (lowerLabel.startsWith(lowerSearch)) {
            const match = label2.slice(0, search.length);
            const rest = label2.slice(search.length);
            return /* @__PURE__ */ jsxs80("div", { children: [
              /* @__PURE__ */ jsx411(
                "span",
                {
                  style: {
                    color: "var(--hv-brand-primary)",
                    fontWeight: "600"
                  },
                  children: match
                }
              ),
              /* @__PURE__ */ jsx411("span", { style: { color: "var(--hv-text-normal-primary)" }, children: rest })
            ] });
          }
          return /* @__PURE__ */ jsx411("div", { style: { color: "var(--hv-text-normal-primary)" }, children: label2 });
        }
      }
    ) : /* @__PURE__ */ jsx411(
      TextInput,
      {
        id,
        placeholder,
        leftSection,
        label,
        value,
        error: showError,
        description,
        wrapperProps: inputWrapperProps,
        type,
        ...inputProps,
        disabled,
        defaultValue,
        rightSection: !disabled && value && /* @__PURE__ */ jsx411(
          "div",
          {
            onClick: () => setValue(""),
            style: {
              cursor: "pointer",
              display: "flex",
              alignItems: "center"
            },
            children: /* @__PURE__ */ jsx411(
              HVIcon_default,
              {
                name: "fail",
                theme: "fill",
                scale: "large",
                svgProps: {
                  width: 20,
                  height: 20
                }
              }
            )
          }
        ),
        onChange: (event) => setValue(event.currentTarget.value),
        styles: {
          input: {
            border: `1px solid ${showError ? "var(--hv-data-red)" : "var(--hv-input-outline-default)"}`,
            minHeight: "32px",
            height: "32px",
            minWidth: "80px",
            maxWidth: "600"
          }
        },
        classNames: {
          root: styles7.inputContainer
        }
      }
    ),
    showError && /* @__PURE__ */ jsxs80("div", { className: styles7.errorText, children: [
      /* @__PURE__ */ jsx411(
        HVIcon_default,
        {
          name: "information",
          svgProps: {
            width: "16px",
            height: "16px",
            stroke: "var(--hv-data-red)"
          }
        }
      ),
      /* @__PURE__ */ jsx411("span", { children: error })
    ] }),
    showSuccess && /* @__PURE__ */ jsxs80("div", { className: styles7.successText, children: [
      /* @__PURE__ */ jsx411(
        HVIcon_default,
        {
          name: "online-success",
          svgProps: {
            width: "16px",
            height: "16px",
            stroke: "var(--hv-data-emerald)"
          }
        }
      ),
      /* @__PURE__ */ jsx411("span", { children: success })
    ] }),
    showGuide && /* @__PURE__ */ jsxs80("div", { className: styles7.guideText, children: [
      /* @__PURE__ */ jsx411(
        HVIcon_default,
        {
          name: "information",
          svgProps: {
            width: "16px",
            height: "16px",
            stroke: "var(--hv-icon-normal-secondary)"
          }
        }
      ),
      /* @__PURE__ */ jsx411("span", { children: guide })
    ] })
  ] });
};
var HVInput_default = HVInput;

// components/HVLoader/LoaderSVG.tsx
import styles8 from "./LoaderSVG.module-IOC7ASKO.module.css";
import { jsx as jsx412, jsxs as jsxs81 } from "react/jsx-runtime";
var LoaderSVG = ({
  primaryStroke,
  secondaryStroke,
  strokeWidth,
  size
}) => {
  return /* @__PURE__ */ jsxs81(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "25 25 50 50",
      className: styles8.circular,
      width: size,
      height: size,
      children: [
        /* @__PURE__ */ jsx412(
          "circle",
          {
            className: styles8.pathOutline,
            cx: "50",
            cy: "50",
            r: "20",
            fill: "none",
            strokeWidth: strokeWidth ?? "2",
            strokeMiterlimit: "10",
            style: { stroke: secondaryStroke }
          }
        ),
        /* @__PURE__ */ jsx412(
          "circle",
          {
            className: styles8.path,
            cx: "50",
            cy: "50",
            r: "20",
            fill: "none",
            strokeWidth: strokeWidth ?? "2",
            strokeMiterlimit: "10",
            style: { stroke: primaryStroke }
          }
        )
      ]
    }
  );
};
var LoaderSVG_default = LoaderSVG;

// components/HVLoader/HVLoader.tsx
import { jsx as jsx413, jsxs as jsxs82 } from "react/jsx-runtime";
var sizeMap = {
  xs: 20,
  sm: 24,
  md: 32,
  lg: 40,
  xl: 48,
  Huge: 60
};
var getColors = (variant, primaryStroke, secondaryStroke) => {
  switch (variant) {
    case "Primary":
      return {
        primaryStroke: "var(--hv-brand-primary)",
        secondaryStroke: "var(--hv-loading-circuit-ring-default)"
      };
    case "Secondary":
      return {
        primaryStroke: "var(--hv-loading-spinner-secondary)",
        secondaryStroke: "var(--hv-loading-circuit-ring-default)"
      };
    default:
      return {
        primaryStroke: primaryStroke ?? "var(--hv-brand-primary)",
        secondaryStroke: secondaryStroke ?? "var(--hv-loading-circuit-ring-default)"
      };
  }
};
var HVLoader = ({
  containerProps,
  variant,
  size = "Huge",
  primaryStroke,
  secondaryStroke,
  strokeWidth,
  label,
  subContainerProps,
  labelTextProps
}) => {
  const loaderSize = sizeMap[size] ?? size;
  const colors = getColors(variant, primaryStroke, secondaryStroke);
  return /* @__PURE__ */ jsx413(HVFlex_default, { ...containerProps, children: /* @__PURE__ */ jsxs82(HVFlex_default, { ...subContainerProps, align: "center", children: [
    /* @__PURE__ */ jsx413(
      LoaderSVG_default,
      {
        size: loaderSize,
        primaryStroke: colors.primaryStroke,
        secondaryStroke: colors.secondaryStroke,
        strokeWidth
      }
    ),
    label && /* @__PURE__ */ jsx413(HVText_default, { ...labelTextProps, type: "Body-sm", children: label })
  ] }) });
};
var HVLoader_default = HVLoader;

// components/HVLogo/HVLogo.tsx
import { Image, Box as Box2 } from "@mantine/core";
import style5 from "./HVLogo.module-NX2CDPYF.module.css";
import { jsx as jsx414, jsxs as jsxs83 } from "react/jsx-runtime";
var HVLogo = ({
  imageSrc,
  altText = "",
  text,
  url,
  key,
  appContainerProps,
  imageSize,
  imageProps,
  textProps
}) => {
  return /* @__PURE__ */ jsxs83(
    Box2,
    {
      className: style5.outerBox,
      component: "a",
      href: url,
      ...appContainerProps,
      children: [
        /* @__PURE__ */ jsx414(
          Image,
          {
            src: imageSrc,
            alt: altText,
            h: imageSize?.height || imageSize?.width || "80px",
            w: imageSize?.width || imageSize?.width || "80px",
            ...imageProps
          }
        ),
        /* @__PURE__ */ jsx414(HVText_default, { className: style5.textStyle, type: "Body-sm", ...textProps, children: text })
      ]
    },
    key
  );
};
var HVLogo_default = HVLogo;

// components/HVMenu/HVMenu.tsx
import { Accordion, NavLink } from "@mantine/core";
import hvLinkClass from "./HVNavigationLink.module-YUZT4IDF.module.css";
import hvMenuClass from "./HVMenu.module-4W6FFEVC.module.css";
import { isValidElement } from "react";
import { Fragment as Fragment4, jsx as jsx415, jsxs as jsxs84 } from "react/jsx-runtime";
var HVMenu = ({
  menuArr,
  menuContainerProps,
  accordionItemContainerProps,
  accordionControlContainerProps,
  accordionPanelContainerProps,
  navLinkContainerProps
}) => {
  return /* @__PURE__ */ jsx415(
    Accordion,
    {
      variant: "separated",
      classNames: hvMenuClass,
      ...menuContainerProps,
      children: menuArr.map((item) => {
        return /* @__PURE__ */ jsxs84(
          Accordion.Item,
          {
            value: item.id,
            ...item.itemProps,
            bg: item?.itemProps?.isActive ? "var(--hv-orange-6)" : void 0,
            ...accordionItemContainerProps,
            children: [
              /* @__PURE__ */ jsx415(
                Accordion.Control,
                {
                  icon: item.icon,
                  chevron: item.content ? /* @__PURE__ */ jsx415(HVIcon_default, { name: "arrow-chevron-down" }) : /* @__PURE__ */ jsx415(Fragment4, {}),
                  "data-selected": item.selected,
                  ...accordionControlContainerProps,
                  children: item.label
                }
              ),
              item.content && /* @__PURE__ */ jsx415(Accordion.Panel, { ...accordionPanelContainerProps, children: item.content.map((contentItem) => {
                if (isValidElement(contentItem)) {
                  return contentItem;
                } else {
                  return /* @__PURE__ */ jsx415(
                    NavLink,
                    {
                      component: "a",
                      href: contentItem.link,
                      active: contentItem.isActive,
                      label: contentItem.label,
                      "data-selected": contentItem.selected ? "true" : "",
                      classNames: hvLinkClass,
                      mb: "4px",
                      ...navLinkContainerProps
                    },
                    contentItem.label
                  );
                }
              }) })
            ]
          },
          item.id
        );
      })
    }
  );
};
var HVMenu_default = HVMenu;

// components/HVModal/HVModal.tsx
import { useDisclosure } from "@mantine/hooks";
import { Modal, Box as Box3 } from "@mantine/core";
import styled from "./HVModal.module-BCTQIYL3.module.css";
import { Fragment as Fragment5, jsx as jsx416, jsxs as jsxs85 } from "react/jsx-runtime";
var HVModal = ({
  children,
  buttonTitle,
  buttonVariant = "Primary",
  modalTitle = "Sample",
  type = "Normal",
  leftButtonContent,
  rightButtonContent,
  titleButtonProps,
  leftButtonProps,
  rightButtonProps,
  modalProps,
  boxProps
}) => {
  const [opened, { open, close }] = useDisclosure(false);
  return /* @__PURE__ */ jsxs85(Fragment5, { children: [
    /* @__PURE__ */ jsxs85(
      Modal,
      {
        ...modalProps,
        opened,
        size: type === "Normal" ? "400px" : "800px",
        onClose: close,
        title: modalTitle,
        classNames: styled,
        children: [
          children,
          /* @__PURE__ */ jsxs85(Box3, { ...boxProps, className: styled.buttonSection, children: [
            /* @__PURE__ */ jsx416(
              HVButton_default,
              {
                ...leftButtonProps,
                onClick: (e) => {
                  leftButtonProps?.onClick?.(e);
                  close();
                },
                variant: "Primary",
                children: leftButtonContent
              }
            ),
            rightButtonContent && /* @__PURE__ */ jsx416(
              HVButton_default,
              {
                ...rightButtonProps,
                onClick: (e) => {
                  rightButtonProps?.onClick?.(e);
                  close();
                },
                variant: "Secondary",
                children: rightButtonContent
              }
            )
          ] })
        ]
      }
    ),
    /* @__PURE__ */ jsx416(
      HVButton_default,
      {
        ...titleButtonProps,
        variant: buttonVariant,
        onClick: open,
        children: buttonTitle
      }
    )
  ] });
};
var HVModal_default = HVModal;

// components/HVNavigationBar/HVNavigationBar.tsx
import { Box as Box5 } from "@mantine/core";
import { Image as Image2 } from "@mantine/core";
import style6 from "./HVNavigationBar.module-37N3U4ZJ.module.css";

// components/HVTooltip/HVTooltip.tsx
import { Tooltip, Box as Box4 } from "@mantine/core";
import styles9 from "./HVTooltip.module-ZL66BGUY.module.css";
import { jsx as jsx417 } from "react/jsx-runtime";
function HVTooltip({
  label,
  tooltipProps,
  children,
  isHoverEffectNeeded = true,
  position = "top",
  variant = "Help"
}) {
  return /* @__PURE__ */ jsx417(
    Tooltip,
    {
      label: /* @__PURE__ */ jsx417(HVText_default, { type: "Body-xs", c: "var(--hv-text-on-brand-primary)", children: label }),
      multiline: true,
      className: styles9.tooltip,
      position,
      ...tooltipProps,
      children: /* @__PURE__ */ jsx417(
        Box4,
        {
          className: `${styles9.box} ${isHoverEffectNeeded && styles9.boxHover}`,
          children: !children ? variant === "Help" ? /* @__PURE__ */ jsx417(HVIcon_default, { name: "tooltip-help", styleClass: styles9.svg }) : /* @__PURE__ */ jsx417(HVIcon_default, { name: "tooltip-info", styleClass: styles9.svg }) : children
        }
      )
    }
  );
}
var HVTooltip_default = HVTooltip;

// components/HVNavigationBar/HVNavigationBar.tsx
import { jsx as jsx418, jsxs as jsxs86 } from "react/jsx-runtime";
var HVNavigationBar = ({
  menus,
  logoSrc,
  activeMenuId,
  title,
  onSelect,
  containerProps,
  logoContainerProps,
  logoImageProps,
  logoTextProps,
  onLogoClick
}) => {
  return /* @__PURE__ */ jsxs86(Box5, { component: "div", className: style6.mainNavigation, ...containerProps, children: [
    /* @__PURE__ */ jsxs86(
      Box5,
      {
        component: "button",
        className: style6.logoHeader,
        ...logoContainerProps,
        onClick: onLogoClick,
        children: [
          /* @__PURE__ */ jsx418(Image2, { src: logoSrc, alt: "logo", ...logoImageProps }),
          title && /* @__PURE__ */ jsx418(HVText_default, { ...logoTextProps, children: title })
        ]
      }
    ),
    menus.map((item) => {
      return /* @__PURE__ */ jsx418(
        HVTooltip_default,
        {
          label: item.title,
          isHoverEffectNeeded: false,
          position: "right",
          ...item.tooltipProps,
          children: /* @__PURE__ */ jsx418(
            Box5,
            {
              component: "a",
              onClick: () => {
                onSelect(item.id);
              },
              href: item.link,
              className: style6.menuItem,
              "aria-label": item.menuContainerAriaLabel || item.title,
              ...item.containerProps,
              children: /* @__PURE__ */ jsx418(
                Box5,
                {
                  component: "div",
                  className: style6.menuIcon,
                  ...item.iconContainerProps,
                  "aria-label": item.iconContainerAriaLabel,
                  children: item.id === activeMenuId ? item.selectedIcon ?? item.icon : item.icon
                }
              )
            }
          )
        },
        item.id
      );
    })
  ] });
};
var HVNavigationBar_default = HVNavigationBar;

// components/HVPagination/HVPagination.tsx
import { Group as Group2, NumberInput as NumberInput2, Pagination } from "@mantine/core";
import styles10 from "./HVPagination.module-T3FVQVLY.module.css";
import { useState as useState3 } from "react";
import { jsx as jsx419, jsxs as jsxs87 } from "react/jsx-runtime";
function HVPagination({
  containerProps,
  showTotalRows = true,
  totalRowsPrefix = "Total",
  totalRows,
  totalTextProps,
  defaultItemsPerPage,
  paginationProps,
  currentPage,
  onPageChange,
  goToPageContainerProps,
  goToPagePrefix = "Go to page",
  goToPagePrefixTextProps,
  goToPageInputProps
}) {
  const [inputValue, setInputValue] = useState3("");
  const totalPages = Math.ceil(totalRows / (defaultItemsPerPage ?? 10));
  const handleInputKeyDown = (event) => {
    if (event.key === "Enter") {
      const page = parseInt(inputValue, 10);
      if (page >= 1 && page <= totalPages) {
        onPageChange?.(page);
      } else {
        alert(`Please enter a page number between 1 and ${totalPages}`);
      }
      setInputValue("");
    }
  };
  return /* @__PURE__ */ jsxs87(
    HVFlex_default,
    {
      w: "100%",
      direction: "row",
      align: "center",
      justify: "end",
      gap: "var(--mantine-spacing-5)",
      h: "var(--mantine-spacing-8)",
      px: 0,
      my: "var(--mantine-spacing-5)",
      ...containerProps,
      children: [
        showTotalRows && /* @__PURE__ */ jsxs87(HVText_default, { type: "Body-sm", ...totalTextProps, children: [
          totalRowsPrefix,
          " ",
          totalRows
        ] }),
        /* @__PURE__ */ jsx419(
          Pagination,
          {
            total: totalPages,
            value: currentPage,
            onChange: onPageChange,
            classNames: styles10,
            ...paginationProps
          }
        ),
        /* @__PURE__ */ jsxs87(Group2, { gap: "var(--mantine-spacing-2)", ...goToPageContainerProps, children: [
          /* @__PURE__ */ jsx419(HVText_default, { type: "Body-sm", ...goToPagePrefixTextProps, children: goToPagePrefix }),
          /* @__PURE__ */ jsx419(
            NumberInput2,
            {
              hideControls: true,
              w: "50px",
              size: "xs",
              value: inputValue,
              onChange: (value) => setInputValue(value.toString()),
              onKeyDown: handleInputKeyDown,
              ...goToPageInputProps
            }
          )
        ] })
      ]
    }
  );
}
var HVPagination_default = HVPagination;

// components/HVRadio/HVRadio.tsx
import { Radio } from "@mantine/core";
import styles11 from "./HVRadio.module-SPCH6U2J.module.css";
import { jsx as jsx420 } from "react/jsx-runtime";
var HVRadio = ({
  checked,
  onChange,
  label,
  disabled = false,
  ...rest
}) => {
  return /* @__PURE__ */ jsx420(
    Radio,
    {
      disabled,
      variant: "outline",
      checked,
      onChange,
      label,
      classNames: styles11,
      ...rest
    }
  );
};
var HVRadio_default = HVRadio;

// components/HVRoleSelector/HVRoleSelector.tsx
import { Box as Box6, Stack } from "@mantine/core";
import classes from "./HVRoleSelector.module-AKLIUCQR.module.css";
import { jsx as jsx421, jsxs as jsxs88 } from "react/jsx-runtime";
var HVRoleSelector = ({
  roles,
  currentRole,
  setCurrentRole,
  containerProps,
  colorBarProps,
  labelContainerProps,
  titleProps,
  valueProps,
  stackProps
}) => {
  return /* @__PURE__ */ jsx421(Stack, { className: classes.bodyWrapper, ...stackProps, children: roles.map((role) => /* @__PURE__ */ jsxs88(
    Box6,
    {
      className: `${classes.unStyledButton} ${currentRole?.name === role.name ? classes.unStyledButtonActive : ""}`,
      onClick: () => setCurrentRole?.(role),
      ...containerProps,
      children: [
        /* @__PURE__ */ jsx421(
          Box6,
          {
            className: classes.colorBar,
            bg: `${role.color}`,
            ...colorBarProps
          }
        ),
        /* @__PURE__ */ jsxs88(Box6, { className: classes.labelWrapper, ...labelContainerProps, children: [
          /* @__PURE__ */ jsx421(HVText_default, { type: "Body-md", fw: 500, ...titleProps, children: role.name }),
          /* @__PURE__ */ jsx421(
            HVText_default,
            {
              type: "Body-md",
              fw: 400,
              c: "var(--hv-text-secondary-2)",
              ...valueProps,
              children: role.value
            }
          )
        ] })
      ]
    },
    role.roleId
  )) });
};
var HVRoleSelector_default = HVRoleSelector;

// components/HVScrollBar/HVScrollBar.tsx
import { ScrollArea } from "@mantine/core";
import scrollbarNormal from "./HVScrollBar.module-6FFHAGLA.module.css";
import scrollbarLines from "./HVScrollBarLine.module-MRWA34DV.module.css";
import { jsx as jsx422 } from "react/jsx-runtime";
function HVScrollBar({
  scrollBarProps,
  children,
  variant = "Normal"
}) {
  return /* @__PURE__ */ jsx422(
    ScrollArea,
    {
      p: "var(--mantine-spacing-3)",
      classNames: variant === "Normal" ? scrollbarNormal : scrollbarLines,
      ...scrollBarProps,
      children
    }
  );
}
var HVScrollBar_default = HVScrollBar;

// components/HVSnackbar/useHVSnackbar.tsx
import { useCallback } from "react";
import { notifications } from "@mantine/notifications";
import styles12 from "./HVSnackBar.module-XVM2YES5.module.css";
import { jsx as jsx423 } from "react/jsx-runtime";
var getIconByVariant = (variant) => {
  switch (variant) {
    case "online-success":
      return /* @__PURE__ */ jsx423(
        HVIcon_default,
        {
          name: "online-success-filled",
          svgProps: {
            width: 21,
            height: 20,
            stroke: "Inherit",
            fill: "Inherit"
          }
        }
      );
    case "warning-error":
      return /* @__PURE__ */ jsx423(
        HVIcon_default,
        {
          name: "warning-error",
          svgProps: {
            width: 21,
            height: 20,
            stroke: "Inherit",
            fill: "Inherit"
          }
        }
      );
    case "information":
      return /* @__PURE__ */ jsx423(
        HVIcon_default,
        {
          name: "information-filled",
          svgProps: {
            width: 21,
            height: 20,
            stroke: "Inherit",
            fill: "Inherit"
          }
        }
      );
    case "fail":
      return /* @__PURE__ */ jsx423(
        HVIcon_default,
        {
          name: "fail-snackbar",
          svgProps: {
            width: 21,
            height: 20,
            stroke: "Inherit",
            fill: "Inherit"
          }
        }
      );
    default:
      return null;
  }
};
var useHVSnackbar = () => {
  const showSnackbar = useCallback(
    ({
      id,
      title,
      message,
      type = "Toast",
      variant,
      customAction,
      closeButtonProps,
      ...rest
    }) => {
      notifications.show({
        id,
        title: title && /* @__PURE__ */ jsx423(HVText_default, { weight: "Bold", c: "var(--hv-snack-bar-text-default)", children: title }),
        message: /* @__PURE__ */ jsx423(HVText_default, { type: "Body-sm", c: "var(--hv-snack-bar-text-default)", children: message }),
        withCloseButton: type !== "Toast",
        icon: variant && getIconByVariant(variant),
        closeButtonProps: {
          className: styles12.closeButton,
          children: customAction?.actionLabel && /* @__PURE__ */ jsx423(HVFlex_default, { onClick: customAction?.action, children: /* @__PURE__ */ jsx423(
            HVText_default,
            {
              type: "Body-sm",
              weight: "Bold",
              c: "var(--hv-snack-bar-text-default)",
              children: customAction.actionLabel
            }
          ) }),
          ...closeButtonProps
        },
        position: "top-right",
        classNames: styles12,
        ...rest
      });
    },
    []
  );
  const hideSnackbar = useCallback(({ id }) => {
    notifications.hide(id);
  }, []);
  return { showSnackbar, hideSnackbar };
};
var useHVSnackbar_default = useHVSnackbar;

// components/HVTab/HVTab.tsx
import { Tabs } from "@mantine/core";
import styles13 from "./HVTab.module-6JJKCHYR.module.css";
import { jsx as jsx424, jsxs as jsxs89 } from "react/jsx-runtime";
var HVTab = ({
  tabList,
  tabListProps,
  tabProps,
  tabPanelProps,
  variant = "Primary",
  ...rest
}) => {
  return /* @__PURE__ */ jsxs89(Tabs, { defaultValue: tabList[0].value, className: styles13.tabs, ...rest, children: [
    /* @__PURE__ */ jsx424(
      Tabs.List,
      {
        ...tabListProps,
        className: `
      ${variant === "twoDepthTab" ? styles13.twoDepthTabList : styles13.tabList}
  `,
        children: tabList.map((tab, index) => {
          return /* @__PURE__ */ jsx424(
            Tabs.Tab,
            {
              value: tab.value,
              className: `
      ${variant === "twoDepthTab" ? styles13.twoDepthtab : styles13.tab}
  `,
              ...tabProps,
              ...tab.tabProps,
              children: tab.children ? tab.children : /* @__PURE__ */ jsxs89(
                HVText_default,
                {
                  type: "Body-md",
                  className: `
      ${variant === "twoDepthTab" ? styles13.twoDepthtabText : styles13.tabText}
  `,
                  ...tab.labelProps,
                  children: [
                    /* @__PURE__ */ jsxs89("span", { className: `
      ${tab.icon ? styles13.twoDepthIcon : ""}
  `, children: [
                      " ",
                      tab.icon
                    ] }),
                    tab.label,
                    tab.count !== void 0 && tab.count > 0 && /* @__PURE__ */ jsx424("span", { className: styles13.countBadge, children: tab.count.toLocaleString() })
                  ]
                }
              )
            },
            `${tab.label}${index}`
          );
        })
      }
    ),
    tabList.map((tab, index) => {
      return /* @__PURE__ */ jsx424(
        Tabs.Panel,
        {
          value: tab.value,
          ...tabPanelProps,
          children: tab.panel
        },
        `${tab.label}${index}`
      );
    })
  ] });
};
var HVTab_default = HVTab;

// components/HVTable/HVTable.tsx
import { forwardRef as forwardRef3, useImperativeHandle, useState as useState4 } from "react";
import {
  MantineReactTable,
  useMantineReactTable
} from "mantine-react-table";
import "mantine-react-table/styles.css";
import classes2 from "./HVTable.module-DOC4KRLM.module.css";
import _ from "lodash";
import checkBoxStyle from "./HVCheckbox.module-K4ZWX45T.module.css";
import { jsx as jsx425, jsxs as jsxs90 } from "react/jsx-runtime";
var HVTable = ({
  tableContainerProps,
  data,
  columns,
  onRowClick,
  tableOptions,
  hideSelectionColumn,
  hideExpandCollapseColumn,
  enablePagination = false,
  paginationProps = {
    defaultItemsPerPage: 10
  }
}, ref) => {
  const [currentPage, setCurrentPage] = useState4(1);
  const [selectedRow, setSelectedRow] = useState4(null);
  const defaultTableOptions = {
    columns,
    data,
    //must be memoized or stable (useState, useMemo, defined outside of this component, etc.)
    initialState: { density: "xs", ...tableOptions?.initialState },
    enableMultiRowSelection: true,
    enableStickyHeader: true,
    enableTopToolbar: false,
    enableTableFooter: false,
    enableStickyFooter: true,
    enableRowSelection: (row) => {
      return !row.original.disabled;
    },
    enableColumnActions: false,
    sortingFns: {
      "case-insensitive-string-sort": (rowA, rowB, columnId) => {
        const a = rowA.getValue(columnId);
        const b = rowB.getValue(columnId);
        if (a == null) return b == null ? 0 : -1;
        if (b == null) return 1;
        if (typeof a === "number" && typeof b === "number") {
          return a - b;
        }
        if (typeof a === "string" && typeof b === "string") {
          return a.toLowerCase().trim().localeCompare(b.toLowerCase().trim());
        }
        return String(a).toLowerCase().trim().localeCompare(String(b).toLowerCase().trim());
      }
    },
    defaultColumn: {
      sortingFn: "case-insensitive-string-sort"
    },
    icons: {
      IconArrowsSort: () => /* @__PURE__ */ jsx425(
        HVIcon_default,
        {
          name: "sort-arrow-up-down",
          svgProps: svgProps(20, "", "var(--hv-icon-normal-secondary)")
        }
      ),
      IconSortAscending: () => /* @__PURE__ */ jsx425(
        HVIcon_default,
        {
          name: "sort-arrow-up",
          svgProps: svgProps(20, "", "var(--hv-icon-normal-secondary)")
        }
      ),
      IconSortDescending: () => /* @__PURE__ */ jsx425(
        HVIcon_default,
        {
          name: "sort-arrow-down",
          svgProps: svgProps(20, "", "var(--hv-icon-normal-secondary)")
        }
      )
    },
    displayColumnDefOptions: {
      "mrt-row-select": {
        mantineTableHeadCellProps: {
          display: hideSelectionColumn ? "none" : "grid",
          kind: "mrt-row-select"
        },
        mantineTableBodyCellProps: {
          display: hideSelectionColumn ? "none" : "flex",
          kind: "mrt-row-select"
        }
      },
      "mrt-row-expand": {
        mantineTableHeadCellProps: {
          display: hideExpandCollapseColumn ? "none" : "grid",
          kind: "mrt-row-expand"
        },
        mantineTableBodyCellProps: {
          display: hideExpandCollapseColumn ? "none" : "flex",
          kind: "mrt-row-expand"
        }
      }
    },
    //MainContainer Style and Props
    mantinePaperProps: (props) => {
      const paperProps = typeof tableOptions?.mantinePaperProps === "function" ? tableOptions?.mantinePaperProps?.(props) : tableOptions?.mantinePaperProps;
      return {
        ...paperProps,
        className: `${classes2.mantinePaper}  ${paperProps?.className}`
      };
    },
    //TableContainer Style and Props
    mantineTableContainerProps: (props) => {
      const containerProps = typeof tableOptions?.mantineTableContainerProps === "function" ? tableOptions?.mantineTableContainerProps?.(props) : tableOptions?.mantineTableContainerProps;
      return {
        ...containerProps,
        className: `${classes2.tableContainer} ${containerProps?.className}`
      };
    },
    //Header Row & Column Style and Props
    mantineTableHeadRowProps: (props) => {
      const headRowProps = typeof tableOptions?.mantineTableHeadRowProps === "function" ? tableOptions?.mantineTableHeadRowProps?.(props) : tableOptions?.mantineTableHeadRowProps;
      return {
        ...headRowProps,
        className: `${classes2.headRow} ${headRowProps?.className}`
      };
    },
    mantineTableHeadCellProps: (props) => {
      const headCellProps = typeof tableOptions?.mantineTableHeadCellProps === "function" ? tableOptions?.mantineTableHeadCellProps?.(props) : tableOptions?.mantineTableHeadCellProps;
      return {
        ...headCellProps,
        className: `${classes2.headCell} ${headCellProps?.className}`,
        style: {
          justifyContent: props.column.columnDef.id === "mrt-row-select" ? "center" : (props?.column.columnDef).justifyContent || "center",
          ...headCellProps?.style
        }
      };
    },
    //Body Row & Column Style and Props
    mantineTableBodyProps: (props) => {
      const bodyProps = typeof tableOptions?.mantineTableBodyProps === "function" ? tableOptions?.mantineTableBodyProps?.(props) : tableOptions?.mantineTableBodyProps;
      return {
        ...bodyProps,
        style: { borderBottomWidth: 4, ...bodyProps?.style }
      };
    },
    mantineTableBodyRowProps: (props) => {
      const tableBodyRowProps = typeof tableOptions?.mantineTableBodyRowProps === "function" ? tableOptions?.mantineTableBodyRowProps?.(props) : tableOptions?.mantineTableBodyRowProps;
      const isClickable = !!onRowClick;
      const isSelected = props.table.getState().rowSelection.hasOwnProperty(props.row.original.id);
      const isExpanded = props.table.getState().rowSelection.hasOwnProperty(props.row.original.id);
      return {
        ...tableBodyRowProps,
        className: props.isDetailPanel ? `${classes2.detailPanel} ${isSelected && classes2.detailPanelSelected}` : `${classes2.bodyRow}  ${selectedRow === props.row && classes2.bodyRowSelected} ${isExpanded && classes2.bodyRowExpanded} ${tableBodyRowProps?.className}`,
        onClick: (e) => {
          if (isClickable) {
            setSelectedRow((prev) => props.row === prev ? null : props.row);
          }
          tableBodyRowProps?.onClick ? tableBodyRowProps?.onClick(e) : onRowClick?.(props.row, props.table);
        },
        style: [
          isClickable ? { cursor: "pointer" } : {},
          tableBodyRowProps?.style
        ]
      };
    },
    mantineTableBodyCellProps: (props) => {
      const columnDef = typeof props?.column?.columnDef?.mantineTableBodyCellProps === "function" ? props?.column?.columnDef?.mantineTableBodyCellProps?.(props) : props?.column?.columnDef?.mantineTableBodyCellProps;
      const tableBodyCellProps = typeof tableOptions?.mantineTableBodyCellProps === "function" ? tableOptions?.mantineTableBodyCellProps?.(props) : tableOptions?.mantineTableBodyCellProps;
      const justify = (props?.column.columnDef).justifyContent;
      const textAlign = justify === "flex-start" ? "start" : justify === "flex-end" ? "end" : "center";
      return {
        ...tableBodyCellProps,
        className: `${classes2.bodyCell} ${tableBodyCellProps?.className}`,
        display: columnDef?.display,
        style: {
          textAlign,
          alignSelf: "center",
          placeItems: textAlign,
          ...tableBodyCellProps?.style
        }
      };
    },
    mantineSelectCheckboxProps: (props) => {
      const selectCheckboxProps = typeof tableOptions?.mantineSelectCheckboxProps === "function" ? tableOptions?.mantineSelectCheckboxProps?.(props) : tableOptions?.mantineSelectCheckboxProps;
      return {
        classNames: checkBoxStyle,
        size: "xs",
        ...selectCheckboxProps
      };
    },
    mantineSelectAllCheckboxProps: (props) => {
      const selectAllCheckboxProps = typeof tableOptions?.mantineSelectAllCheckboxProps === "function" ? tableOptions?.mantineSelectAllCheckboxProps?.(props) : tableOptions?.mantineSelectAllCheckboxProps;
      return {
        classNames: checkBoxStyle,
        size: "xs",
        ...selectAllCheckboxProps
      };
    },
    mantineExpandButtonProps: (props) => {
      const expandButtonProps = typeof tableOptions?.mantineExpandButtonProps === "function" ? tableOptions?.mantineExpandButtonProps?.(props) : tableOptions?.mantineExpandButtonProps;
      return {
        ...expandButtonProps
      };
    },
    //Virtualization for smooth rendering
    enableRowVirtualization: true,
    enableColumnVirtualization: true,
    //Bottom Toolbar and Pagination
    enableBottomToolbar: false,
    enablePagination: false
  };
  const omittedTableOptions = _.omit(tableOptions, [
    "initialState",
    "mantinePaperProps",
    "mantineTableContainerProps",
    "mantineTableHeadRowProps",
    "mantineTableHeadCellProps",
    "mantineTableBodyProps",
    "mantineTableBodyRowProps",
    "mantineTableBodyCellProps",
    "mantinePaginationProps",
    "mantineSelectCheckboxProps",
    "mantineSelectAllCheckboxProps"
  ]);
  const paginatedData = enablePagination ? data.slice(
    (currentPage - 1) * (paginationProps.defaultItemsPerPage ?? 10),
    currentPage * (paginationProps.defaultItemsPerPage ?? 10)
  ) : data;
  const table = useMantineReactTable({
    ...defaultTableOptions,
    ...omittedTableOptions,
    data: paginatedData
  });
  useImperativeHandle(ref, () => table, [table]);
  return /* @__PURE__ */ jsxs90(
    HVFlex_default,
    {
      ...tableContainerProps,
      style: { overflow: "auto", ...tableContainerProps?.style },
      children: [
        /* @__PURE__ */ jsx425(MantineReactTable, { table }),
        enablePagination && /* @__PURE__ */ jsx425(
          HVPagination_default,
          {
            totalRows: data.length,
            currentPage,
            onPageChange: setCurrentPage,
            ...paginationProps
          }
        )
      ]
    }
  );
};
var HVTable_default = forwardRef3(HVTable);

// components/HVTableV2/HVTable.tsx
import { useMemo, useRef as useRef3 } from "react";
import "mantine-react-table/styles.css";
import classes3 from "./HVTable.module-3JBKBLL3.module.css";
import {
  flexRender,
  getCoreRowModel,
  useReactTable
} from "@tanstack/react-table";
import { useVirtualizer } from "@tanstack/react-virtual";
import { jsx as jsx426, jsxs as jsxs91 } from "react/jsx-runtime";
var HVTable2 = ({
  data,
  columns,
  enableCheckboxSelection,
  manualSorting,
  selectedRowId,
  checkedRowIdSet,
  sortState,
  pageInfo,
  getSelectableRow,
  getRowId,
  onSortStateChange,
  onRowClick,
  onRowCheckChange,
  onPageChange,
  renderEmptyRowsFallback
}) => {
  const tableContainerRef = useRef3(null);
  const emptyBodyRef = useRef3(null);
  const checkedRowIdMap = useMemo(() => {
    const map = {};
    checkedRowIdSet?.forEach((id) => {
      map[id] = true;
    });
    return map;
  }, [checkedRowIdSet]);
  const defaultColumns = useMemo(() => {
    return [
      ...columns.map((column) => {
        const meta = {
          align: column.align || "left"
        };
        const columnDef = {
          id: column.id,
          size: column.size,
          enableSorting: column.enableSorting,
          meta,
          accessorFn: column.accessorFn,
          header: ({ column: headerColumn }) => {
            headerColumn.getAutoSortDir = () => "asc";
            return column.header;
          }
        };
        if (column.sortingFn) {
          columnDef["sortingFn"] = ({ original: rowA }, { original: rowB }) => column.sortingFn(rowA, rowB);
        }
        if (column.renderCell) {
          columnDef["cell"] = ({ row }) => column.renderCell({ row: row.original });
        }
        return columnDef;
      })
    ];
  }, [columns]);
  const table = useReactTable({
    data,
    columns: defaultColumns,
    manualSorting,
    enableMultiRowSelection: true,
    state: {
      rowSelection: checkedRowIdMap,
      sorting: sortState ? [{ id: sortState.id, desc: sortState.desc }] : []
    },
    getCoreRowModel: getCoreRowModel(),
    onRowSelectionChange: (updater) => {
      if (typeof updater === "function") {
        const newCheckedRowIdMap = updater(checkedRowIdMap);
        const newCheckedRowIdSet = /* @__PURE__ */ new Set();
        Object.keys(newCheckedRowIdMap).forEach((rowId) => {
          if (newCheckedRowIdMap[rowId]) {
            newCheckedRowIdSet.add(rowId);
          }
        });
        onRowCheckChange?.(newCheckedRowIdSet);
      }
    },
    onSortingChange: (updater) => {
      if (typeof updater === "function") {
        const updatedSort = updater(
          sortState ? [{ id: sortState.id, desc: sortState.desc }] : []
        );
        if (updatedSort[0]) {
          onSortStateChange?.({
            id: updatedSort[0].id,
            desc: updatedSort[0].desc
          });
        } else {
          onSortStateChange?.(null);
        }
      }
    },
    getRowId,
    enableRowSelection: (() => {
      if (enableCheckboxSelection) {
        if (getSelectableRow) {
          return (row) => getSelectableRow(row.original);
        }
        return true;
      }
      return false;
    })()
  });
  const { rows } = table.getRowModel();
  const rowVirtualizer = useVirtualizer({
    count: rows.length,
    estimateSize: () => 48,
    getScrollElement: () => tableContainerRef.current,
    measureElement: typeof window !== "undefined" && navigator.userAgent.indexOf("Firefox") === -1 ? (element) => element?.getBoundingClientRect().height : void 0,
    overscan: 5
  });
  return /* @__PURE__ */ jsxs91("div", { className: classes3.container, children: [
    /* @__PURE__ */ jsxs91(
      "div",
      {
        className: classes3.tableContainer,
        ref: tableContainerRef,
        style: {
          overflow: "auto",
          position: "relative"
        },
        onScroll: (e) => {
          if (emptyBodyRef.current) {
            emptyBodyRef.current.style.transform = `translateX(${e.currentTarget.scrollLeft}px)`;
          }
        },
        children: [
          /* @__PURE__ */ jsxs91("table", { className: classes3.table, children: [
            /* @__PURE__ */ jsx426("thead", { className: classes3.thead, children: table.getHeaderGroups().map((headerGroup) => /* @__PURE__ */ jsxs91("tr", { className: classes3.theadTr, children: [
              enableCheckboxSelection && /* @__PURE__ */ jsx426("th", { className: classes3.checkBoxTh, children: /* @__PURE__ */ jsx426(
                HVCheckbox_default,
                {
                  checked: table.getIsAllRowsSelected(),
                  indeterminate: table.getIsSomeRowsSelected(),
                  onChange: table.getToggleAllRowsSelectedHandler()
                }
              ) }),
              headerGroup.headers.map((header) => {
                return /* @__PURE__ */ jsx426(
                  "th",
                  {
                    className: classes3.th,
                    style: { width: header.getSize() },
                    children: /* @__PURE__ */ jsxs91(
                      "div",
                      {
                        className: classes3.thDiv,
                        onClick: header.column.getToggleSortingHandler(),
                        style: {
                          justifyContent: (() => {
                            const meta = header.column.columnDef.meta;
                            if (meta.align === "center") {
                              return "center";
                            }
                            if (meta.align === "right") {
                              return "right";
                            }
                            return "left";
                          })()
                        },
                        children: [
                          flexRender(
                            header.column.columnDef.header,
                            header.getContext()
                          ),
                          (() => {
                            if (header.column.getCanSort() === false) {
                              return null;
                            }
                            const sort = header.column.getIsSorted();
                            if (sort === "asc") {
                              return /* @__PURE__ */ jsx426(
                                HVIcon_default,
                                {
                                  name: "sort-arrow-up",
                                  svgProps: svgProps(
                                    20,
                                    "",
                                    "var(--hv-icon-normal-secondary)"
                                  )
                                }
                              );
                            }
                            if (sort === "desc") {
                              return /* @__PURE__ */ jsx426(
                                HVIcon_default,
                                {
                                  name: "sort-arrow-down",
                                  svgProps: svgProps(
                                    20,
                                    "",
                                    "var(--hv-icon-normal-secondary)"
                                  )
                                }
                              );
                            }
                            return /* @__PURE__ */ jsx426(
                              HVIcon_default,
                              {
                                name: "sort-arrow-up-down",
                                size: 20,
                                svgProps: svgProps(
                                  20,
                                  "",
                                  "var(--hv-icon-normal-secondary)"
                                )
                              }
                            );
                          })()
                        ]
                      }
                    )
                  },
                  header.id
                );
              })
            ] }, headerGroup.id)) }),
            rows.length > 0 && /* @__PURE__ */ jsx426(
              "tbody",
              {
                className: classes3.tbody,
                style: {
                  height: `${rowVirtualizer.getTotalSize()}px`
                  //tells scrollbar how big the table is
                },
                children: rowVirtualizer.getVirtualItems().map((virtualRow) => {
                  const row = rows[virtualRow.index];
                  const isSelected = selectedRowId === row.id;
                  const isChecked = checkedRowIdSet?.has(row.id);
                  return /* @__PURE__ */ jsxs91(
                    "tr",
                    {
                      "data-index": virtualRow.index,
                      ref: (node) => rowVirtualizer.measureElement(node),
                      className: `${classes3.tbodyTr} ${isSelected ? classes3.tbodyTrSelected : ""} ${isChecked ? classes3.tobdyTrChecked : ""}`,
                      style: {
                        transform: `translateY(${virtualRow.start}px)`
                        //this should always be a `style` as it changes on scroll
                      },
                      onClick: onRowClick ? () => onRowClick(row.original) : void 0,
                      children: [
                        enableCheckboxSelection && /* @__PURE__ */ jsx426(
                          "td",
                          {
                            className: classes3.checkBoxTd,
                            onClick: (e) => e.stopPropagation(),
                            children: /* @__PURE__ */ jsx426(
                              HVCheckbox_default,
                              {
                                checked: row.getIsSelected(),
                                disabled: !row.getCanSelect(),
                                indeterminate: row.getIsSomeSelected(),
                                onChange: row.getToggleSelectedHandler()
                              }
                            )
                          }
                        ),
                        row.getVisibleCells().map((cell) => {
                          return /* @__PURE__ */ jsx426(
                            "td",
                            {
                              title: cell.getValue(),
                              className: classes3.td,
                              style: {
                                width: cell.column.getSize(),
                                textAlign: (() => {
                                  const meta = cell.column.columnDef.meta;
                                  if (meta.align === "center") {
                                    return "center";
                                  }
                                  if (meta.align === "right") {
                                    return "right";
                                  }
                                  return "left";
                                })()
                              },
                              children: flexRender(
                                cell.column.columnDef.cell,
                                cell.getContext()
                              )
                            },
                            cell.id
                          );
                        })
                      ]
                    },
                    row.id
                  );
                })
              }
            )
          ] }),
          rows.length === 0 && /* @__PURE__ */ jsx426("div", { ref: emptyBodyRef, className: classes3.emptyBody, children: renderEmptyRowsFallback?.() })
        ]
      }
    ),
    pageInfo && /* @__PURE__ */ jsx426(
      HVPagination_default,
      {
        totalRows: pageInfo.totalRows,
        currentPage: pageInfo.currentPage,
        defaultItemsPerPage: pageInfo.defaultItemsPerPage,
        onPageChange
      }
    )
  ] });
};
var HVTable_default2 = HVTable2;

// components/HVToggle/HVToggle.tsx
import { Switch } from "@mantine/core";
import styles14 from "./HVToggle.module-CSNOUHCY.module.css";
import { jsx as jsx427 } from "react/jsx-runtime";
var HVSwitch = ({
  checked,
  onChange,
  onLabel,
  offLabel,
  defaultChecked,
  label,
  disabled,
  variant = "filled",
  onLabelProps,
  offLabelProps,
  ...rest
}) => {
  return /* @__PURE__ */ jsx427(
    Switch,
    {
      checked,
      onChange,
      onLabel: /* @__PURE__ */ jsx427(HVText_default, { type: "Body-xs", c: "inherit", ...onLabelProps, children: onLabel }),
      offLabel: /* @__PURE__ */ jsx427(HVText_default, { type: "Body-xs", c: "inherit", ...offLabelProps, children: offLabel }),
      defaultChecked,
      label,
      disabled,
      variant,
      classNames: styles14,
      color: "var(--hv-toggle-selected-orange)",
      ...rest
    }
  );
};
var HVToggle_default = HVSwitch;

// components/HVTopBar/HVTopBar.tsx
import { Box as Box7 } from "@mantine/core";
import styles15 from "./HVTopBar.module-E2YKG5UZ.module.css";
import { jsx as jsx428, jsxs as jsxs92 } from "react/jsx-runtime";
import { createElement as createElement3 } from "react";
var TopBarLeft = ({ type, breadCrumbsProps, leftTobBarProps, subLeftTobBarProps }) => {
  return /* @__PURE__ */ jsxs92(HVFlex_default, { className: styles15.leftComponent, ...leftTobBarProps, children: [
    type === "SightMind" ? /* @__PURE__ */ jsx428(sightMindLogo_default, {}) : /* @__PURE__ */ jsx428(HanwhaVisionLogo_default, {}),
    /* @__PURE__ */ jsx428(HVFlex_default, { ...subLeftTobBarProps, className: styles15.leftComponentDivider }),
    type === "SightMind" ? /* @__PURE__ */ jsx428(
      HVBreadcrumbs_default,
      {
        items: breadCrumbsProps?.items ?? [],
        breadcrumbsProps: {
          children: null,
          className: styles15.leftComponentBredCrumbs
        },
        ...breadCrumbsProps
      }
    ) : /* @__PURE__ */ jsx428(cloudPortal_default, {})
  ] });
};
var MenuItem = (item) => {
  return /* @__PURE__ */ jsx428(
    Box7,
    {
      onClick: item?.onClick,
      ...item?.containerProps,
      className: `${styles15.rightComponentItem} ${item?.containerProps?.className}`,
      children: item?.children
    }
  );
};
var TopBarRight = ({
  type,
  userProfileProps,
  showUserProfile,
  rightMenuItems,
  rightTopBarProps,
  rightTopBarMenuProps
}) => {
  return /* @__PURE__ */ jsxs92(HVFlex_default, { className: styles15.rightComponent, ...rightTopBarProps, children: [
    /* @__PURE__ */ jsx428(HVFlex_default, { ...rightTopBarMenuProps, className: styles15.rightComponentMenu, children: rightMenuItems?.map((item, index) => {
      return /* @__PURE__ */ createElement3(MenuItem, { ...item, key: index.toString() });
    }) }),
    showUserProfile && /* @__PURE__ */ jsx428(
      HVUserProfile_default,
      {
        profileImageProps: {
          type: "text",
          text: type === "SightMind" ? "SM" : "CP"
        },
        title: "",
        email: "",
        permissions: [],
        menuItems: [],
        logoutMenuItem: { label: "Log out" },
        ...userProfileProps
      }
    )
  ] });
};
var HVTopBar = ({
  type = "SightMind",
  breadCrumbsProps,
  userProfileProps,
  leftComponent,
  rightComponent,
  rightMenuItems,
  showUserProfile = true,
  rootContainerProps,
  rightTopBarMenuProps,
  rightTopBarProps,
  leftTobBarProps,
  subLeftTobBarProps
}) => {
  return /* @__PURE__ */ jsxs92(HVFlex_default, { className: styles15.topBar, ...rootContainerProps, children: [
    leftComponent ? leftComponent : /* @__PURE__ */ jsx428(TopBarLeft, { type, breadCrumbsProps, subLeftTobBarProps, leftTobBarProps }),
    rightComponent ? rightComponent : /* @__PURE__ */ jsx428(
      TopBarRight,
      {
        type,
        userProfileProps,
        showUserProfile,
        rightMenuItems,
        rightTopBarMenuProps,
        rightTopBarProps
      }
    )
  ] });
};
var HVTopBar_default = HVTopBar;

// components/HVUserProfile/HVUserProfile.tsx
import { Menu as Menu2, Box as Box9 } from "@mantine/core";
import styled2 from "./HVUserProfile.module-V76A5SOH.module.css";

// components/HVUserProfile/HVPermission/HVPermission.tsx
import { Box as Box8, useMantineColorScheme } from "@mantine/core";
import styles16 from "./HVPermission.module-OUD764SQ.module.css";

// assets/images/Apps/AppSightMind.svg
import * as React398 from "react";
import { jsx as jsx429, jsxs as jsxs93 } from "react/jsx-runtime";
var SvgAppSightMind = (props) => /* @__PURE__ */ jsxs93("svg", { viewBox: "0 0 72 72", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: [
  /* @__PURE__ */ jsx429("path", { d: "M57.2204 18.5142H65.2832C65.6572 18.5142 65.9802 18.6513 66.2523 18.9256C66.5243 19.1999 66.6603 19.5256 66.6603 19.9027V52.6113C66.6603 52.9884 66.5243 53.3142 66.2523 53.5884C65.9802 53.8627 65.6572 53.9999 65.2832 53.9999H56.691C56.3169 53.9999 55.9939 53.8627 55.7219 53.5884C55.4499 53.3142 55.3139 52.9884 55.3139 52.6113V36.977L50.5434 46.2421C50.3671 46.5846 50.0143 46.7999 49.6291 46.7999C49.32 46.7999 48.9726 46.7999 48.7772 46.7999H48.2161C47.8194 46.7999 47.2338 46.7999 46.7916 46.7999C46.4124 46.7999 46.0642 46.5913 45.8852 46.257L40.9139 36.977V52.6113C40.9139 52.9884 40.7779 53.3142 40.5058 53.5884C40.2338 53.8627 39.9108 53.9999 39.5368 53.9999H31.0088C30.6348 53.9999 30.3118 53.8627 30.0397 53.5884C29.7677 53.3142 29.6317 52.9884 29.6317 52.6113V19.9027C29.6317 19.5256 29.7677 19.1999 30.0397 18.9256C30.3118 18.6513 30.6348 18.5142 31.0088 18.5142H39.0716C40.0237 18.5142 40.7547 18.977 41.2648 19.9027L48.146 32.7599L55.0272 19.9027C55.5373 18.977 56.2683 18.5142 57.2204 18.5142Z", fill: "#889199" }),
  /* @__PURE__ */ jsx429("path", { d: "M6.08568 29.4141C6.08568 26.0141 7.48568 22.9903 10.2857 20.857C13.119 18.7236 16.9074 17.7429 21.4741 17.7429C26.5884 17.7429 30.2524 18.7736 33.1524 21.007C36.0858 23.2403 37.6384 25.9167 37.6384 28.35C37.6384 28.65 37.5217 28.9167 37.2884 29.15C37.0884 29.35 36.855 29.45 36.5884 29.45H26.0741C25.3074 29.45 25.1217 28.9096 24.4884 28.3429C23.855 27.7763 22.4908 27.4929 21.4241 27.4929C19.8241 27.4929 18.5098 28.2167 18.5098 29.15C18.5098 29.65 18.8931 30.2667 19.6598 30.6C20.4598 30.9333 22.955 31.2333 25.0884 31.5C30.055 32.1333 33.5884 33.3 35.6884 35C37.8217 36.6667 38.8884 39.2167 38.8884 42.45C38.8884 45.85 37.3217 49.1263 34.1884 51.2929C31.0884 53.4263 27.0217 54.4929 21.4741 54.4929C16.4408 54.4929 12.3095 53.4596 9.44282 51.3929C6.57616 49.3263 5.14282 46.3167 5.14282 43.35C5.14282 43.05 5.24282 42.8 5.44282 42.6C5.67616 42.3667 5.94282 42.25 6.24282 42.25H15.4285C16.1285 42.25 16.3622 42.5833 17.1955 43.25C18.0622 43.9167 20.2741 44.7429 21.7741 44.7429C24.7884 44.7429 26.0384 43.7833 26.0384 42.85C26.0384 42.25 25.5884 41.8 24.6884 41.5C23.7884 41.1667 21.0598 40.8333 18.5598 40.5C9.9598 39.3667 6.08568 35.6141 6.08568 29.4141Z", fill: "#F37321" }),
  /* @__PURE__ */ jsx429("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M29.8713 19.1265C29.7116 19.3551 29.6317 19.6138 29.6317 19.9028V29.45H36.5884C36.8551 29.45 37.0884 29.3499 37.2884 29.15C37.5218 28.9166 37.6384 28.65 37.6384 28.35C37.6384 25.9166 36.0858 23.2403 33.1525 21.0069C32.1579 20.241 31.0734 19.6164 29.8713 19.1265ZM29.6317 32.3245C32.279 32.9825 34.2979 33.8743 35.6884 35C37.8218 36.6666 38.8884 39.2166 38.8884 42.4499C38.8884 45.8499 37.3218 49.1262 34.1884 51.2929C32.9201 52.1657 31.49 52.8599 29.8629 53.3757C29.7088 53.15 29.6317 52.8953 29.6317 52.6114L29.6317 32.3245Z", fill: "#9B0000" })
] });
var AppSightMind_default = SvgAppSightMind;

// assets/images/Apps/AppOnCloud.svg
import * as React399 from "react";
import { jsx as jsx430, jsxs as jsxs94 } from "react/jsx-runtime";
var SvgAppOnCloud = (props) => /* @__PURE__ */ jsxs94("svg", { viewBox: "0 0 72 72", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: [
  /* @__PURE__ */ jsx430("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M55.1678 40.6285C54.6937 40.6285 54.2906 40.9573 54.1102 41.3958C53.3023 43.3599 51.3697 44.7427 49.1142 44.7427C46.1319 44.7427 43.7142 42.3251 43.7142 39.3427V32.657C43.7142 29.6747 46.1319 27.257 49.1142 27.257C51.674 27.257 53.8178 29.0382 54.3739 31.4287C54.4983 31.9638 54.9403 32.3999 55.4897 32.3999H64.7999C65.368 32.3999 65.8285 31.9394 65.8285 31.3713V30.3427C65.8285 29.3292 65.6816 28.3177 65.3174 27.3718C63.0907 21.589 57.4816 17.4856 50.9142 17.4856H47.3142C38.7932 17.4856 31.8856 24.3932 31.8856 32.9142V39.0856C31.8856 47.6066 38.7932 54.5142 47.3142 54.5142H50.9142C57.663 54.5142 63.3997 50.181 65.494 44.1451C65.7137 43.5119 65.8285 42.8415 65.8285 42.1713V41.657C65.8285 41.089 65.368 40.6285 64.7999 40.6285H55.1678Z", fill: "#889199" }),
  /* @__PURE__ */ jsx430("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M22.6285 17.4856C14.1076 17.4856 7.19995 24.3932 7.19995 32.9142V39.0856C7.19995 47.6066 14.1076 54.5142 22.6285 54.5142H26.2285C34.7495 54.5142 41.6571 47.6066 41.6571 39.0856V32.9142C41.6571 24.3932 34.7495 17.4856 26.2285 17.4856H22.6285ZM24.4285 27.257C21.4462 27.257 19.0285 29.6747 19.0285 32.657V39.3427C19.0285 42.3251 21.4462 44.7427 24.4285 44.7427C27.4109 44.7427 29.8285 42.3251 29.8285 39.3427V32.657C29.8285 29.6747 27.4109 27.257 24.4285 27.257Z", fill: "#F37321" }),
  /* @__PURE__ */ jsx430("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M36.7713 21.6497C33.7645 24.465 31.8856 28.4702 31.8856 32.9142V39.0857C31.8856 43.5297 33.7645 47.5349 36.7713 50.3502C39.7781 47.5349 41.657 43.5297 41.657 39.0857V32.9142C41.657 28.4702 39.7781 24.465 36.7713 21.6497Z", fill: "#9B0000" })
] });
var AppOnCloud_default = SvgAppOnCloud;

// assets/images/Apps/AppCloudPortal.svg
import * as React400 from "react";
import { jsx as jsx431, jsxs as jsxs95 } from "react/jsx-runtime";
var SvgAppCloudPortal = (props) => /* @__PURE__ */ jsxs95("svg", { viewBox: "0 0 72 72", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: [
  /* @__PURE__ */ jsx431("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M30.8639 40.5C30.4031 40.5 30.0111 40.8197 29.8358 41.246C29.0502 43.1556 27.1714 44.5 24.9785 44.5C22.079 44.5 19.7285 42.1495 19.7285 39.25V32.75C19.7285 29.8505 22.079 27.5 24.9785 27.5C27.4672 27.5 29.5515 29.2317 30.0921 31.5558C30.2131 32.076 30.6428 32.5 31.1769 32.5H40.2285C40.7808 32.5 41.2285 32.0523 41.2285 31.5V30.5C41.2285 29.5146 41.0857 28.5312 40.7316 27.6116C38.5668 21.9894 33.1135 18 26.7285 18H23.2285C14.9442 18 8.22852 24.7157 8.22852 33V39C8.22852 47.2843 14.9442 54 23.2285 54H26.7285C33.2898 54 38.8672 49.7872 40.9034 43.919C41.117 43.3034 41.2285 42.6516 41.2285 42V41.5C41.2285 40.9477 40.7808 40.5 40.2285 40.5H30.8639Z", fill: "#F37321" }),
  /* @__PURE__ */ jsx431("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M35.6195 18H51.4595C56.3967 18 59.2252 19.0629 62.0024 21.1886C64.7795 23.3143 66.1167 26.4514 66.1167 30.6C66.1167 34.7486 64.7795 38.3314 62.0024 40.32C59.2595 42.3086 56.431 43.3029 51.4595 43.3029H46.0595V52.6114C46.0595 52.9886 45.9224 53.3143 45.6481 53.5886C45.3738 53.8629 45.0481 54 44.671 54H35.6195C35.2424 54 34.9167 53.8629 34.6424 53.5886C34.3681 53.3143 34.231 52.9886 34.231 52.6114V19.3886C34.231 19.0114 34.3681 18.6857 34.6424 18.4114C34.9167 18.1371 35.2424 18 35.6195 18ZM51.2316 27.7717H45.8316V33.4288H51.2316C52.7938 33.4288 54.0602 32.1624 54.0602 30.6002C54.0602 29.0381 52.7938 27.7717 51.2316 27.7717Z", fill: "#889199" }),
  /* @__PURE__ */ jsx431("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M34.2295 40.4986V51.9916C37.3215 50.2029 39.7157 47.3421 40.9039 43.9176C41.1175 43.302 41.229 42.6502 41.229 41.9986V41.4986C41.229 40.9463 40.7813 40.4986 40.229 40.4986H34.2295ZM34.2295 20.0056V32.4986H40.229C40.7813 32.4986 41.229 32.0509 41.229 31.4986V30.4986C41.229 29.5132 41.0862 28.5298 40.7321 27.6102C39.4937 24.3939 37.1791 21.712 34.2295 20.0056Z", fill: "#9B0000" })
] });
var AppCloudPortal_default = SvgAppCloudPortal;

// assets/images/Apps/AppDMPro.svg
import * as React401 from "react";
import { jsx as jsx432, jsxs as jsxs96 } from "react/jsx-runtime";
var SvgAppDmPro = (props) => /* @__PURE__ */ jsxs96("svg", { viewBox: "0 0 72 72", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: [
  /* @__PURE__ */ jsx432("path", { d: "M29.1599 18H38.2113C38.5884 18 38.9141 18.1371 39.1884 18.4114C39.4627 18.6857 39.5999 19.0114 39.5999 19.3886V52.6113C39.5999 52.9885 39.4627 53.3142 39.1884 53.5885C38.9141 53.8628 38.5884 53.9999 38.2113 53.9999H29.1599C28.7827 53.9999 28.457 53.8628 28.1827 53.5885C27.9085 53.3142 27.7713 52.9885 27.7713 52.6113V41.6571H19.5428V52.6113C19.5428 52.9885 19.4056 53.3142 19.1313 53.5885C18.8571 53.8628 18.5313 53.9999 18.1542 53.9999H9.1028C8.72566 53.9999 8.39995 53.8799 8.12566 53.6399C7.85138 53.3656 7.71423 53.0228 7.71423 52.6113V19.3886C7.71423 19.0114 7.85138 18.6857 8.12566 18.4114C8.39995 18.1371 8.72566 18 9.1028 18H18.1542C18.5313 18 18.8571 18.1371 19.1313 18.4114C19.4056 18.6857 19.5428 19.0114 19.5428 19.3886V31.8857H27.7713V19.3886C27.7713 19.0114 27.9085 18.6857 28.1827 18.4114C28.457 18.1371 28.7827 18 29.1599 18Z", fill: "#F37321" }),
  /* @__PURE__ */ jsx432("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M36.1028 18H51.9428C56.8799 18 59.7084 19.0629 62.4856 21.1886C65.2627 23.3143 66.5999 26.4514 66.5999 30.6C66.5999 34.7485 65.2627 38.3314 62.4856 40.3199C59.7427 42.3085 56.9142 43.3028 51.9428 43.3028H46.5428V52.6113C46.5428 52.9885 46.4056 53.3142 46.1313 53.5885C45.8571 53.8628 45.5313 53.9999 45.1542 53.9999H36.1028C35.7257 53.9999 35.3999 53.8628 35.1257 53.5885C34.8514 53.3142 34.7142 52.9885 34.7142 52.6113V19.3886C34.7142 19.0114 34.8514 18.6857 35.1257 18.4114C35.3999 18.1371 35.7257 18 36.1028 18ZM51.9425 27.7717H46.5425V33.4288H51.9425C53.5047 33.4288 54.7711 32.1624 54.7711 30.6002C54.7711 29.0381 53.5047 27.7717 51.9425 27.7717Z", fill: "#889199" }),
  /* @__PURE__ */ jsx432("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M36.1028 53.9999L38.2113 53.9999C38.2124 53.9999 38.2136 53.9999 38.2147 53.9999C38.5904 53.9991 38.915 53.8619 39.1884 53.5885C39.4627 53.3142 39.5999 52.9885 39.5999 52.6113V19.3886C39.5999 19.0114 39.4627 18.6857 39.1884 18.4114C38.9141 18.1371 38.5884 18 38.2113 18H36.1028C35.7257 18 35.3999 18.1371 35.1257 18.4114C34.8514 18.6857 34.7142 19.0114 34.7142 19.3886V52.6113C34.7142 52.9885 34.8514 53.3142 35.1257 53.5885C35.3999 53.8628 35.7257 53.9999 36.1028 53.9999Z", fill: "#9B0000" })
] });
var AppDMPro_default = SvgAppDmPro;

// assets/images/Apps/AppACaaS.svg
import * as React402 from "react";
import { jsx as jsx433, jsxs as jsxs97 } from "react/jsx-runtime";
var SvgAppACaaS = (props) => /* @__PURE__ */ jsxs97("svg", { viewBox: "0 0 72 72", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: [
  /* @__PURE__ */ jsx433("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M30.3498 40.5C29.8889 40.5 29.497 40.8197 29.3216 41.246C28.5361 43.1556 26.6572 44.5 24.4644 44.5C21.5649 44.5 19.2144 42.1495 19.2144 39.25V32.75C19.2144 29.8505 21.5649 27.5 24.4644 27.5C26.9531 27.5 29.0373 29.2317 29.5779 31.5558C29.6989 32.076 30.1286 32.5 30.6627 32.5H39.7144C40.2666 32.5 40.7144 32.0523 40.7144 31.5V30.5C40.7144 29.5146 40.5715 28.5312 40.2174 27.6116C38.0526 21.9894 32.5994 18 26.2144 18H22.7144C14.4301 18 7.71436 24.7157 7.71436 33V39C7.71436 47.2843 14.4301 54 22.7144 54H26.2144C32.7757 54 38.3531 49.7872 40.3892 43.919C40.6028 43.3034 40.7144 42.6516 40.7144 42V41.5C40.7144 40.9477 40.2666 40.5 39.7144 40.5H30.3498Z", fill: "#F37321" }),
  /* @__PURE__ */ jsx433("path", { d: "M42.6343 18H52.7658C54 18 54.7715 18.5657 55.08 19.6971L66.5486 52.5086C66.5829 52.6114 66.6 52.7829 66.6 53.0229C66.6 53.2286 66.48 53.4514 66.24 53.6914C66.0343 53.8971 65.7772 54 65.4686 54H56.6486C55.62 54 54.9515 53.5714 54.6429 52.7143L53.4858 48.8571H42.1715L41.0143 52.7143C40.7058 53.5714 40.0372 54 39.0086 54H29.9315C29.6229 54 29.3486 53.8971 29.1086 53.6914C28.9029 53.4514 28.8 53.2286 28.8 53.0229C28.8 52.7829 28.8172 52.6114 28.8515 52.5086L40.3201 19.6971C40.6286 18.5657 41.4 18 42.6343 18ZM45.1029 39.0857H50.5543L47.8286 29.7257L45.1029 39.0857Z", fill: "#889199" }),
  /* @__PURE__ */ jsx433("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M33.0488 40.5001L28.8515 52.5087C28.8172 52.6115 28.8 52.783 28.8 53.023C28.8 53.2287 28.9029 53.4515 29.1086 53.6915C29.1181 53.6997 29.1277 53.7077 29.1373 53.7155C34.3938 52.6773 38.6634 48.8928 40.3892 43.9191C40.6028 43.3035 40.7143 42.6517 40.7143 42.0001V41.5001C40.7143 40.9478 40.2666 40.5001 39.7143 40.5001H33.0488ZM38.619 24.564L35.8451 32.5001H39.7143C40.2666 32.5001 40.7143 32.0524 40.7143 31.5001V30.5001C40.7143 29.5147 40.5715 28.5313 40.2174 27.6117C39.8008 26.5297 39.2624 25.5082 38.619 24.564Z", fill: "#9B0000" })
] });
var AppACaaS_default = SvgAppACaaS;

// assets/images/Apps/AppFlexAI.svg
import * as React403 from "react";
import { jsx as jsx434, jsxs as jsxs98 } from "react/jsx-runtime";
var SvgAppFlexAi = (props) => /* @__PURE__ */ jsxs98("svg", { viewBox: "0 0 72 72", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: [
  /* @__PURE__ */ jsx434("path", { d: "M41.0915 18.5144H51.2229C52.4572 18.5144 53.2286 19.0801 53.5372 20.2115L65.0058 53.023C65.0401 53.1258 65.0572 53.2973 65.0572 53.5373C65.0572 53.743 64.9372 53.9658 64.6972 54.2058C64.4915 54.4115 64.2343 54.5144 63.9258 54.5144H55.1058C54.0772 54.5144 53.4086 54.0858 53.1001 53.2287L51.9429 49.3715H40.6286L39.4715 53.2287C39.1629 54.0858 38.4943 54.5144 37.4658 54.5144H28.3886C28.0801 54.5144 27.8058 54.4115 27.5658 54.2058C27.3601 53.9658 27.2572 53.743 27.2572 53.5373C27.2572 53.2973 27.2743 53.1258 27.3086 53.023L38.7772 20.2115C39.0858 19.0801 39.8572 18.5144 41.0915 18.5144ZM43.5601 39.6001H49.0115L46.2858 30.2401L43.5601 39.6001Z", fill: "#889199" }),
  /* @__PURE__ */ jsx434("path", { d: "M13.2217 18.5144H42.3213C42.6996 18.5144 43.0264 18.652 43.3016 18.9272C43.5767 19.2023 43.7143 19.5291 43.7143 19.9075L43.7143 26.8928C43.7143 27.2711 43.5767 27.5979 43.3016 27.8731C43.0264 28.1482 42.6996 28.2858 42.3213 28.2858H23.6572V33.4287H39.2256C39.6039 33.4287 39.9307 33.5663 40.2059 33.8414C40.481 34.1166 40.6186 34.4434 40.6186 34.8218V41.8387C40.6186 42.217 40.481 42.5438 40.2059 42.819C39.9307 43.0942 39.6039 43.2317 39.2256 43.2317H23.6572L23.6955 53.2378C23.6955 53.6162 23.5579 53.943 23.2827 54.2181C23.0075 54.4933 22.6808 54.6309 22.3024 54.6309H13.2217C12.8433 54.6309 12.5165 54.4933 12.2414 54.2181C11.9662 53.943 11.8286 53.6162 11.8286 53.2378V19.9075C11.8286 19.5291 11.9662 19.2023 12.2414 18.9272C12.5165 18.652 12.8433 18.5144 13.2217 18.5144Z", fill: "#F37321" }),
  /* @__PURE__ */ jsx434("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M42.3204 18.5144H41.0911C39.8568 18.5144 39.0854 19.0801 38.7768 20.2115L35.9546 28.2858H42.3204C42.6988 28.2858 43.0256 28.1482 43.3007 27.8731C43.5759 27.5979 43.7135 27.2711 43.7135 26.8928L43.7135 19.9075C43.7135 19.5291 43.5759 19.2023 43.3007 18.9272C43.0256 18.652 42.6988 18.5144 42.3204 18.5144ZM34.157 33.4287H39.2247C39.6031 33.4287 39.9299 33.5663 40.205 33.8415C40.4802 34.1166 40.6178 34.4434 40.6178 34.8218V41.8387C40.6178 42.217 40.4802 42.5438 40.205 42.819C39.9299 43.0942 39.6031 43.2317 39.2247 43.2317H30.7306L34.157 33.4287Z", fill: "#9B0000" })
] });
var AppFlexAI_default = SvgAppFlexAi;

// assets/images/Apps/AppSightMindDark.svg
import * as React404 from "react";
import { jsx as jsx435, jsxs as jsxs99 } from "react/jsx-runtime";
var SvgAppSightMindDark = (props) => /* @__PURE__ */ jsxs99("svg", { viewBox: "0 0 72 72", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: [
  /* @__PURE__ */ jsx435("path", { d: "M57.2204 18.5142H65.2832C65.6572 18.5142 65.9802 18.6513 66.2523 18.9256C66.5243 19.1999 66.6603 19.5256 66.6603 19.9027V52.6113C66.6603 52.9884 66.5243 53.3142 66.2523 53.5884C65.9802 53.8627 65.6572 53.9999 65.2832 53.9999H56.691C56.3169 53.9999 55.9939 53.8627 55.7219 53.5884C55.4499 53.3142 55.3139 52.9884 55.3139 52.6113V36.977L50.5434 46.2421C50.3671 46.5846 50.0143 46.7999 49.6291 46.7999C49.32 46.7999 48.9726 46.7999 48.7772 46.7999H48.2161C47.8194 46.7999 47.2338 46.7999 46.7916 46.7999C46.4124 46.7999 46.0642 46.5913 45.8852 46.257L40.9139 36.977V52.6113C40.9139 52.9884 40.7779 53.3142 40.5058 53.5884C40.2338 53.8627 39.9108 53.9999 39.5368 53.9999H31.0088C30.6348 53.9999 30.3118 53.8627 30.0397 53.5884C29.7677 53.3142 29.6317 52.9884 29.6317 52.6113V19.9027C29.6317 19.5256 29.7677 19.1999 30.0397 18.9256C30.3118 18.6513 30.6348 18.5142 31.0088 18.5142H39.0716C40.0237 18.5142 40.7547 18.977 41.2648 19.9027L48.146 32.7599L55.0272 19.9027C55.5373 18.977 56.2683 18.5142 57.2204 18.5142Z", fill: "#62676C" }),
  /* @__PURE__ */ jsx435("path", { d: "M6.08574 29.4141C6.08574 26.0141 7.48574 22.9903 10.2857 20.857C13.1191 18.7236 16.9075 17.7429 21.4741 17.7429C26.5884 17.7429 30.2525 18.7736 33.1525 21.007C36.0858 23.2403 37.6384 25.9167 37.6384 28.35C37.6384 28.65 37.5218 28.9167 37.2884 29.15C37.0884 29.35 36.8551 29.45 36.5884 29.45H26.0742C25.3075 29.45 25.1218 28.9096 24.4884 28.3429C23.8551 27.7763 22.4908 27.4929 21.4242 27.4929C19.8241 27.4929 18.5099 28.2167 18.5099 29.15C18.5099 29.65 18.8932 30.2667 19.6599 30.6C20.4599 30.9333 22.9551 31.2333 25.0884 31.5C30.0551 32.1333 33.5884 33.3 35.6884 35C37.8218 36.6667 38.8884 39.2167 38.8884 42.45C38.8884 45.85 37.3218 49.1263 34.1884 51.2929C31.0884 53.4263 27.0218 54.4929 21.4741 54.4929C16.4408 54.4929 12.3095 53.4596 9.44288 51.3929C6.57622 49.3263 5.14288 46.3167 5.14288 43.35C5.14288 43.05 5.24288 42.8 5.44288 42.6C5.67622 42.3667 5.94288 42.25 6.24288 42.25H15.4286C16.1286 42.25 16.3622 42.5833 17.1956 43.25C18.0622 43.9167 20.2741 44.7429 21.7741 44.7429C24.7884 44.7429 26.0384 43.7833 26.0384 42.85C26.0384 42.25 25.5884 41.8 24.6884 41.5C23.7884 41.1667 21.0599 40.8333 18.5599 40.5C9.95986 39.3667 6.08574 35.6141 6.08574 29.4141Z", fill: "#D65400" }),
  /* @__PURE__ */ jsx435("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M29.8713 19.1265C29.7116 19.3551 29.6317 19.6138 29.6317 19.9028V29.45H36.5884C36.8551 29.45 37.0884 29.3499 37.2884 29.15C37.5218 28.9166 37.6384 28.65 37.6384 28.35C37.6384 25.9166 36.0858 23.2403 33.1525 21.0069C32.1579 20.241 31.0734 19.6164 29.8713 19.1265ZM29.6317 32.3245C32.279 32.9825 34.2979 33.8743 35.6884 35C37.8218 36.6666 38.8884 39.2166 38.8884 42.4499C38.8884 45.8499 37.3218 49.1262 34.1884 51.2929C32.9201 52.1657 31.49 52.8599 29.8629 53.3757C29.7088 53.15 29.6317 52.8953 29.6317 52.6114L29.6317 32.3245Z", fill: "#F37321" })
] });
var AppSightMindDark_default = SvgAppSightMindDark;

// assets/images/Apps/AppOnCloudDark.svg
import * as React405 from "react";
import { jsx as jsx436, jsxs as jsxs100 } from "react/jsx-runtime";
var SvgAppOnCloudDark = (props) => /* @__PURE__ */ jsxs100("svg", { viewBox: "0 0 72 72", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: [
  /* @__PURE__ */ jsx436("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M55.1679 40.6285C54.6938 40.6285 54.2907 40.9573 54.1104 41.3958C53.3024 43.3599 51.3698 44.7427 49.1143 44.7427C46.132 44.7427 43.7143 42.3251 43.7143 39.3427V32.657C43.7143 29.6747 46.132 27.257 49.1143 27.257C51.6741 27.257 53.8179 29.0382 54.374 31.4287C54.4985 31.9638 54.9404 32.3999 55.4898 32.3999H64.8C65.3681 32.3999 65.8286 31.9394 65.8286 31.3713V30.3427C65.8286 29.3292 65.6817 28.3177 65.3175 27.3718C63.0908 21.589 57.4818 17.4856 50.9143 17.4856H47.3143C38.7934 17.4856 31.8857 24.3932 31.8857 32.9142V39.0856C31.8857 47.6066 38.7933 54.5142 47.3143 54.5142H50.9143C57.6631 54.5142 63.3999 50.181 65.4942 44.1451C65.7139 43.5119 65.8286 42.8415 65.8286 42.1713V41.657C65.8286 41.089 65.3681 40.6285 64.8 40.6285H55.1679Z", fill: "#62676C" }),
  /* @__PURE__ */ jsx436("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M22.6286 17.4856C14.1076 17.4856 7.20001 24.3932 7.20001 32.9142V39.0856C7.20001 47.6066 14.1076 54.5142 22.6286 54.5142H26.2286C34.7495 54.5142 41.6572 47.6066 41.6572 39.0856V32.9142C41.6572 24.3932 34.7495 17.4856 26.2286 17.4856H22.6286ZM24.4286 27.257C21.4462 27.257 19.0286 29.6747 19.0286 32.657V39.3427C19.0286 42.3251 21.4462 44.7427 24.4286 44.7427C27.4109 44.7427 29.8286 42.3251 29.8286 39.3427V32.657C29.8286 29.6747 27.4109 27.257 24.4286 27.257Z", fill: "#D65400" }),
  /* @__PURE__ */ jsx436("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M36.7715 21.6497C33.7647 24.465 31.8857 28.4702 31.8857 32.9142V39.0857C31.8857 43.5297 33.7647 47.5349 36.7715 50.3502C39.7782 47.5349 41.6572 43.5297 41.6572 39.0857V32.9142C41.6572 28.4702 39.7782 24.465 36.7715 21.6497Z", fill: "#F37321" })
] });
var AppOnCloudDark_default = SvgAppOnCloudDark;

// assets/images/Apps/AppCloudPortalDark.svg
import * as React406 from "react";
import { jsx as jsx437, jsxs as jsxs101 } from "react/jsx-runtime";
var SvgAppCloudPortalDark = (props) => /* @__PURE__ */ jsxs101("svg", { viewBox: "0 0 72 72", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: [
  /* @__PURE__ */ jsx437("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M30.864 40.5C30.4031 40.5 30.0112 40.8197 29.8358 41.246C29.0503 43.1556 27.1714 44.5 24.9786 44.5C22.0791 44.5 19.7286 42.1495 19.7286 39.25V32.75C19.7286 29.8505 22.0791 27.5 24.9786 27.5C27.4673 27.5 29.5515 29.2317 30.0922 31.5558C30.2132 32.076 30.6429 32.5 31.1769 32.5H40.2286C40.7809 32.5 41.2286 32.0523 41.2286 31.5V30.5C41.2286 29.5146 41.0857 28.5312 40.7317 27.6116C38.5668 21.9894 33.1136 18 26.7286 18H23.2286C14.9443 18 8.22858 24.7157 8.22858 33V39C8.22858 47.2843 14.9443 54 23.2286 54H26.7286C33.2899 54 38.8673 49.7872 40.9034 43.919C41.117 43.3034 41.2286 42.6516 41.2286 42V41.5C41.2286 40.9477 40.7809 40.5 40.2286 40.5H30.864Z", fill: "#D65400" }),
  /* @__PURE__ */ jsx437("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M35.6194 18H51.4594C56.3966 18 59.2251 19.0629 62.0023 21.1886C64.7794 23.3143 66.1166 26.4514 66.1166 30.6C66.1166 34.7486 64.7794 38.3314 62.0023 40.32C59.2594 42.3086 56.4308 43.3029 51.4594 43.3029H46.0594V52.6114C46.0594 52.9886 45.9223 53.3143 45.648 53.5886C45.3737 53.8629 45.048 54 44.6708 54H35.6194C35.2423 54 34.9165 53.8629 34.6423 53.5886C34.368 53.3143 34.2308 52.9886 34.2308 52.6114V19.3886C34.2308 19.0114 34.368 18.6857 34.6423 18.4114C34.9165 18.1371 35.2423 18 35.6194 18ZM51.2315 27.7717H45.8315V33.4288H51.2315C52.7937 33.4288 54.0601 32.1624 54.0601 30.6002C54.0601 29.0381 52.7937 27.7717 51.2315 27.7717Z", fill: "#62676C" }),
  /* @__PURE__ */ jsx437("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M34.2295 40.4986V51.9916C37.3215 50.2029 39.7157 47.3421 40.9039 43.9176C41.1175 43.302 41.229 42.6502 41.229 41.9986V41.4986C41.229 40.9463 40.7813 40.4986 40.229 40.4986H34.2295ZM34.2295 20.0056V32.4986H40.229C40.7813 32.4986 41.229 32.0509 41.229 31.4986V30.4986C41.229 29.5132 41.0862 28.5298 40.7321 27.6102C39.4937 24.3939 37.1791 21.712 34.2295 20.0056Z", fill: "#F37321" })
] });
var AppCloudPortalDark_default = SvgAppCloudPortalDark;

// assets/images/Apps/AppDMProDark.svg
import * as React407 from "react";
import { jsx as jsx438, jsxs as jsxs102 } from "react/jsx-runtime";
var SvgAppDmProDark = (props) => /* @__PURE__ */ jsxs102("svg", { viewBox: "0 0 72 72", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: [
  /* @__PURE__ */ jsx438("path", { d: "M29.1599 18H38.2113C38.5885 18 38.9142 18.1371 39.1885 18.4114C39.4628 18.6857 39.5999 19.0114 39.5999 19.3886V52.6113C39.5999 52.9885 39.4628 53.3142 39.1885 53.5885C38.9142 53.8628 38.5885 53.9999 38.2113 53.9999H29.1599C28.7828 53.9999 28.4571 53.8628 28.1828 53.5885C27.9085 53.3142 27.7714 52.9885 27.7714 52.6113V41.6571H19.5428V52.6113C19.5428 52.9885 19.4057 53.3142 19.1314 53.5885C18.8571 53.8628 18.5314 53.9999 18.1543 53.9999H9.10286C8.72572 53.9999 8.40001 53.8799 8.12572 53.6399C7.85144 53.3656 7.71429 53.0228 7.71429 52.6113V19.3886C7.71429 19.0114 7.85144 18.6857 8.12572 18.4114C8.40001 18.1371 8.72572 18 9.10286 18H18.1543C18.5314 18 18.8571 18.1371 19.1314 18.4114C19.4057 18.6857 19.5428 19.0114 19.5428 19.3886V31.8857H27.7714V19.3886C27.7714 19.0114 27.9085 18.6857 28.1828 18.4114C28.4571 18.1371 28.7828 18 29.1599 18Z", fill: "#D65400" }),
  /* @__PURE__ */ jsx438("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M36.1029 18H51.9428C56.8799 18 59.7085 19.0629 62.4856 21.1886C65.2628 23.3143 66.5999 26.4514 66.5999 30.6C66.5999 34.7485 65.2628 38.3314 62.4856 40.3199C59.7428 42.3085 56.9142 43.3028 51.9428 43.3028H46.5428V52.6113C46.5428 52.9885 46.4057 53.3142 46.1314 53.5885C45.8571 53.8628 45.5314 53.9999 45.1543 53.9999H36.1029C35.7257 53.9999 35.4 53.8628 35.1257 53.5885C34.8514 53.3142 34.7143 52.9885 34.7143 52.6113V19.3886C34.7143 19.0114 34.8514 18.6857 35.1257 18.4114C35.4 18.1371 35.7257 18 36.1029 18ZM51.9426 27.7717H46.5426V33.4288H51.9426C53.5048 33.4288 54.7711 32.1624 54.7711 30.6002C54.7711 29.0381 53.5048 27.7717 51.9426 27.7717Z", fill: "#62676C" }),
  /* @__PURE__ */ jsx438("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M36.1029 53.9999L38.2113 53.9999C38.2125 53.9999 38.2136 53.9999 38.2148 53.9999C38.5905 53.9991 38.915 53.8619 39.1885 53.5885C39.4628 53.3142 39.5999 52.9885 39.5999 52.6113V19.3886C39.5999 19.0114 39.4628 18.6857 39.1885 18.4114C38.9142 18.1371 38.5885 18 38.2113 18H36.1029C35.7257 18 35.4 18.1371 35.1257 18.4114C34.8514 18.6857 34.7143 19.0114 34.7143 19.3886V52.6113C34.7143 52.9885 34.8514 53.3142 35.1257 53.5885C35.4 53.8628 35.7257 53.9999 36.1029 53.9999Z", fill: "#F37321" })
] });
var AppDMProDark_default = SvgAppDmProDark;

// assets/images/Apps/AppACaaSDark.svg
import * as React408 from "react";
import { jsx as jsx439, jsxs as jsxs103 } from "react/jsx-runtime";
var SvgAppACaaSDark = (props) => /* @__PURE__ */ jsxs103("svg", { viewBox: "0 0 72 72", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: [
  /* @__PURE__ */ jsx439("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M30.3497 40.5C29.8888 40.5 29.4969 40.8197 29.3216 41.246C28.536 43.1556 26.6572 44.5 24.4643 44.5C21.5648 44.5 19.2143 42.1495 19.2143 39.25V32.75C19.2143 29.8505 21.5648 27.5 24.4643 27.5C26.953 27.5 29.0373 29.2317 29.5779 31.5558C29.6989 32.076 30.1286 32.5 30.6627 32.5H39.7143C40.2666 32.5 40.7143 32.0523 40.7143 31.5V30.5C40.7143 29.5146 40.5715 28.5312 40.2174 27.6116C38.0525 21.9894 32.5993 18 26.2143 18H22.7143C14.43 18 7.71429 24.7157 7.71429 33V39C7.71429 47.2843 14.43 54 22.7143 54H26.2143C32.7756 54 38.353 49.7872 40.3891 43.919C40.6027 43.3034 40.7143 42.6516 40.7143 42V41.5C40.7143 40.9477 40.2666 40.5 39.7143 40.5H30.3497Z", fill: "#D65400" }),
  /* @__PURE__ */ jsx439("path", { d: "M42.6343 18H52.7657C54 18 54.7714 18.5657 55.08 19.6971L66.5486 52.5086C66.5828 52.6114 66.6 52.7829 66.6 53.0229C66.6 53.2286 66.48 53.4514 66.24 53.6914C66.0343 53.8971 65.7771 54 65.4686 54H56.6486C55.62 54 54.9514 53.5714 54.6428 52.7143L53.4857 48.8571H42.1714L41.0143 52.7143C40.7057 53.5714 40.0371 54 39.0086 54H29.9314C29.6228 54 29.3486 53.8971 29.1086 53.6914C28.9028 53.4514 28.8 53.2286 28.8 53.0229C28.8 52.7829 28.8171 52.6114 28.8514 52.5086L40.32 19.6971C40.6286 18.5657 41.4 18 42.6343 18ZM45.1028 39.0857H50.5543L47.8286 29.7257L45.1028 39.0857Z", fill: "#62676C" }),
  /* @__PURE__ */ jsx439("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M33.0488 40.5001L28.8514 52.5087C28.8171 52.6115 28.8 52.783 28.8 53.023C28.8 53.2287 28.9028 53.4515 29.1086 53.6915C29.1181 53.6997 29.1276 53.7077 29.1372 53.7155C34.3937 52.6773 38.6634 48.8928 40.3891 43.9191C40.6027 43.3035 40.7143 42.6517 40.7143 42.0001V41.5001C40.7143 40.9478 40.2666 40.5001 39.7143 40.5001H33.0488ZM38.6189 24.564L35.845 32.5001H39.7143C40.2666 32.5001 40.7143 32.0524 40.7143 31.5001V30.5001C40.7143 29.5147 40.5714 28.5313 40.2174 27.6117C39.8007 26.5297 39.2623 25.5082 38.6189 24.564Z", fill: "#F37321" })
] });
var AppACaaSDark_default = SvgAppACaaSDark;

// assets/images/Apps/AppFlexAIDark.svg
import * as React409 from "react";
import { jsx as jsx440, jsxs as jsxs104 } from "react/jsx-runtime";
var SvgAppFlexAiDark = (props) => /* @__PURE__ */ jsxs104("svg", { viewBox: "0 0 72 72", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: [
  /* @__PURE__ */ jsx440("path", { d: "M41.0914 18.5144H51.2229C52.4571 18.5144 53.2286 19.0801 53.5371 20.2115L65.0057 53.023C65.04 53.1258 65.0571 53.2973 65.0571 53.5373C65.0571 53.743 64.9371 53.9658 64.6971 54.2058C64.4914 54.4115 64.2343 54.5144 63.9257 54.5144H55.1057C54.0771 54.5144 53.4086 54.0858 53.1 53.2287L51.9429 49.3715H40.6286L39.4714 53.2287C39.1629 54.0858 38.4943 54.5144 37.4657 54.5144H28.3886C28.08 54.5144 27.8057 54.4115 27.5657 54.2058C27.36 53.9658 27.2571 53.743 27.2571 53.5373C27.2571 53.2973 27.2743 53.1258 27.3086 53.023L38.7771 20.2115C39.0857 19.0801 39.8571 18.5144 41.0914 18.5144ZM43.56 39.6001H49.0114L46.2857 30.2401L43.56 39.6001Z", fill: "#62676C" }),
  /* @__PURE__ */ jsx440("path", { d: "M13.2216 18.5144H42.3212C42.6996 18.5144 43.0263 18.652 43.3015 18.9272C43.5767 19.2023 43.7143 19.5291 43.7143 19.9075L43.7143 26.8928C43.7143 27.2711 43.5767 27.5979 43.3015 27.8731C43.0263 28.1482 42.6996 28.2858 42.3212 28.2858H23.6571V33.4287H39.2255C39.6039 33.4287 39.9306 33.5663 40.2058 33.8414C40.481 34.1166 40.6186 34.4434 40.6186 34.8218V41.8387C40.6186 42.217 40.481 42.5438 40.2058 42.819C39.9306 43.0942 39.6039 43.2317 39.2255 43.2317H23.6571L23.6954 53.2378C23.6954 53.6162 23.5578 53.943 23.2826 54.2181C23.0075 54.4933 22.6807 54.6309 22.3023 54.6309H13.2216C12.8433 54.6309 12.5165 54.4933 12.2413 54.2181C11.9661 53.943 11.8286 53.6162 11.8286 53.2378V19.9075C11.8286 19.5291 11.9661 19.2023 12.2413 18.9272C12.5165 18.652 12.8433 18.5144 13.2216 18.5144Z", fill: "#D65400" }),
  /* @__PURE__ */ jsx440("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M42.3204 18.5144H41.0911C39.8568 18.5144 39.0854 19.0801 38.7768 20.2115L35.9546 28.2858H42.3204C42.6988 28.2858 43.0256 28.1482 43.3007 27.8731C43.5759 27.5979 43.7135 27.2711 43.7135 26.8928L43.7135 19.9075C43.7135 19.5291 43.5759 19.2023 43.3007 18.9272C43.0256 18.652 42.6988 18.5144 42.3204 18.5144ZM34.157 33.4287H39.2247C39.6031 33.4287 39.9299 33.5663 40.205 33.8415C40.4802 34.1166 40.6178 34.4434 40.6178 34.8218V41.8387C40.6178 42.217 40.4802 42.5438 40.205 42.819C39.9299 43.0942 39.6031 43.2317 39.2247 43.2317H30.7306L34.157 33.4287Z", fill: "#F37321" })
] });
var AppFlexAIDark_default = SvgAppFlexAiDark;

// components/HVUserProfile/HVPermission/HVPermission.tsx
import { jsx as jsx441, jsxs as jsxs105 } from "react/jsx-runtime";
var getImageByType = (colorScheme, appType) => {
  switch (appType) {
    case "OC":
      return colorScheme === "dark" ? /* @__PURE__ */ jsx441(AppOnCloudDark_default, {}) : /* @__PURE__ */ jsx441(AppOnCloud_default, {});
    case "DM":
      return colorScheme === "dark" ? /* @__PURE__ */ jsx441(AppDMProDark_default, {}) : /* @__PURE__ */ jsx441(AppDMPro_default, {});
    case "AC":
      return colorScheme === "dark" ? /* @__PURE__ */ jsx441(AppACaaSDark_default, {}) : /* @__PURE__ */ jsx441(AppACaaS_default, {});
    case "CP":
      return colorScheme === "dark" ? /* @__PURE__ */ jsx441(AppCloudPortalDark_default, {}) : /* @__PURE__ */ jsx441(AppCloudPortal_default, {});
    case "FA":
      return colorScheme === "dark" ? /* @__PURE__ */ jsx441(AppFlexAIDark_default, {}) : /* @__PURE__ */ jsx441(AppFlexAI_default, {});
    case "SM":
      return colorScheme === "dark" ? /* @__PURE__ */ jsx441(AppSightMindDark_default, {}) : /* @__PURE__ */ jsx441(AppSightMind_default, {});
  }
};
var HVPermission = ({
  containerProps,
  appType,
  imgContainerProps,
  roleName,
  roleTextProps
}) => {
  let theme2 = useMantineColorScheme();
  return /* @__PURE__ */ jsxs105(
    HVFlex_default,
    {
      direction: "row",
      gap: "var(--mantine-spacing-1)",
      align: "center",
      className: styles16.container,
      ...containerProps,
      children: [
        /* @__PURE__ */ jsx441(Box8, { h: "28px", w: "28px", ...imgContainerProps, children: getImageByType(theme2.colorScheme, appType) }),
        /* @__PURE__ */ jsx441(
          HVText_default,
          {
            type: "Body-xs",
            c: "var(--hv-text-normal-secondary)",
            lineClamp: 1,
            ...roleTextProps,
            children: roleName
          }
        )
      ]
    }
  );
};
var HVPermission_default = HVPermission;

// components/HVUserProfile/HVPermissions/HVPermissions.tsx
import { Fragment as Fragment6 } from "react";
import { jsx as jsx442, jsxs as jsxs106 } from "react/jsx-runtime";
var HVPermissions = ({ permissions }) => {
  return /* @__PURE__ */ jsx442(
    HVFlex_default,
    {
      display: "grid",
      style: {
        gridTemplateColumns: "minmax(auto, 50%) auto minmax(auto, 50%)"
      },
      py: "4px",
      gap: "8px",
      align: "center",
      children: permissions.map((permission, index) => {
        return /* @__PURE__ */ jsxs106(Fragment6, { children: [
          /* @__PURE__ */ jsx442(
            HVPermission_default,
            {
              ...permission,
              containerProps: { justify: index % 2 > 0 ? "start" : "end" }
            }
          ),
          index % 2 === 0 && /* @__PURE__ */ jsx442(HVFlex_default, { h: "12px", w: "1px", bg: "var(--hv-border-default)" })
        ] }, index.toString());
      })
    }
  );
};
var HVPermissions_default = HVPermissions;

// components/HVUserProfile/HVUserProfile.tsx
import { jsx as jsx443, jsxs as jsxs107 } from "react/jsx-runtime";
var HVUserProfile = ({
  menuTargetProps,
  profileImageProps,
  menuDropDownProps,
  profileContainerProps,
  titleEmailContainerProps,
  title,
  titleTextProps,
  email,
  emailTextProps,
  permissions,
  menuItems,
  logoutMenuItem,
  menuBoxProps,
  containerProps,
  subContainerProps,
  borderFlexProps,
  logoutMenuProps,
  ...userProfileMenuProps
}) => {
  return /* @__PURE__ */ jsxs107(Menu2, { shadow: "md", width: "322px", position: "bottom-end", ...userProfileMenuProps, children: [
    /* @__PURE__ */ jsx443(Menu2.Target, { ...menuTargetProps, children: /* @__PURE__ */ jsx443(Box9, { className: styled2.targetBox, ...menuBoxProps, children: /* @__PURE__ */ jsx443(HVAvatar_default, { item: { size: "sm", ...profileImageProps }, group: false }) }) }),
    /* @__PURE__ */ jsxs107(
      Menu2.Dropdown,
      {
        ...menuDropDownProps,
        className: `${styled2.dropDown} ${menuDropDownProps?.className}`,
        children: [
          /* @__PURE__ */ jsxs107(
            HVFlex_default,
            {
              ...profileContainerProps,
              className: `${styled2.profileContainer} ${profileContainerProps?.className}`,
              children: [
                /* @__PURE__ */ jsx443(HVAvatar_default, { item: { size: "lg", ...profileImageProps }, group: false }),
                /* @__PURE__ */ jsxs107(
                  HVFlex_default,
                  {
                    ...titleEmailContainerProps,
                    className: `${styled2.titleEmailContainer} ${titleEmailContainerProps?.className}`,
                    children: [
                      /* @__PURE__ */ jsx443(HVText_default, { type: "Headline-2xs", weight: "Bold", ...titleTextProps, children: title }),
                      /* @__PURE__ */ jsx443(
                        HVText_default,
                        {
                          type: "Body-sm",
                          c: "var(--hv-text-normal-tertiary)",
                          ...emailTextProps,
                          children: email
                        }
                      )
                    ]
                  }
                ),
                /* @__PURE__ */ jsx443(HVPermissions_default, { permissions })
              ]
            }
          ),
          /* @__PURE__ */ jsxs107(HVFlex_default, { ...containerProps, gap: "var(--hv-spacing-2)", children: [
            /* @__PURE__ */ jsx443(HVFlex_default, { ...subContainerProps, h: "1px", bg: "var(--hv-border-default)", mx: "8px" }),
            menuItems.map(
              ({
                link,
                leftSection,
                rightSection,
                label,
                labelProps,
                onClick,
                ...menuItemProps
              }, index) => {
                return /* @__PURE__ */ jsx443(
                  Menu2.Item,
                  {
                    component: "a",
                    href: link,
                    leftSection: leftSection || /* @__PURE__ */ jsx443(HVIcon_default, { name: "empty" }),
                    rightSection: rightSection || /* @__PURE__ */ jsx443(HVIcon_default, { name: "link" }),
                    classNames: styled2,
                    onClick,
                    ...menuItemProps,
                    children: /* @__PURE__ */ jsx443(HVText_default, { type: "Body-sm", c: "inherit", ...labelProps, children: label })
                  },
                  index.toString()
                );
              }
            ),
            /* @__PURE__ */ jsx443(HVFlex_default, { ...borderFlexProps, h: "1px", bg: "var(--hv-border-default)", mx: "8px" }),
            /* @__PURE__ */ jsx443(
              Menu2.Item,
              {
                ...logoutMenuItem,
                leftSection: logoutMenuItem.leftSection || /* @__PURE__ */ jsx443(HVIcon_default, { name: "log-out" }),
                rightSection: logoutMenuItem.rightSection,
                classNames: styled2,
                onClick: logoutMenuItem?.onClick,
                children: /* @__PURE__ */ jsx443(HVText_default, { ...logoutMenuProps, type: "Body-sm", c: "inherit", children: logoutMenuItem.label })
              }
            )
          ] })
        ]
      }
    )
  ] });
};
var HVUserProfile_default = HVUserProfile;

// components/HVTreeView/HVTreeView.tsx
import { useState as useState6, useCallback as useCallback2, useRef as useRef4 } from "react";
import { Flex as Flex3, Portal } from "@mantine/core";

// components/HVTreeView/HVTreeItem/HVTreeItem.tsx
import { Flex as Flex2, TextInput as TextInput2 } from "@mantine/core";
import styles17 from "./HVTreeItem.module-5JRX2RNP.module.css";
import { useState as useState5 } from "react";
import { Fragment as Fragment7, jsx as jsx444, jsxs as jsxs108 } from "react/jsx-runtime";
var HVTreeItem = ({
  containerProps,
  type,
  leadingContainerProps,
  leadingCustomChildren,
  level = 0,
  open,
  showCaret,
  caretIcon,
  caretIconClick,
  showCheckbox,
  checkboxProps,
  showLeadIcon,
  leadIcon,
  labelContainerProps,
  label,
  labelProps,
  inputProps,
  count,
  countProps,
  trailingIcons,
  isSelected,
  isEditing,
  onEdit,
  onEditCancel,
  onClick
}) => {
  const [currentLabel, setCurrentLabel] = useState5(label);
  const handleChange = (e) => {
    setCurrentLabel(e.target.value);
  };
  return /* @__PURE__ */ jsxs108(
    Flex2,
    {
      className: styles17.container,
      "data-selected": isSelected,
      "data-type": type,
      onClick,
      ...containerProps,
      children: [
        /* @__PURE__ */ jsxs108(
          Flex2,
          {
            pl: level * 16,
            gap: "var(--mantine-spacing-1)",
            ...leadingContainerProps,
            children: [
              type === "parent" && showCaret && /* @__PURE__ */ jsx444(Flex2, { className: styles17.caretContainer, onClick: caretIconClick, children: caretIcon ? caretIcon : /* @__PURE__ */ jsx444(
                HVIcon_default,
                {
                  name: open ? "arrow-chevron-down" : "arrow-chevron-right",
                  svgProps: {
                    stroke: "currentColor",
                    width: 14,
                    height: 14,
                    strokeWidth: 1.5
                  }
                }
              ) }),
              showCheckbox && /* @__PURE__ */ jsx444(Flex2, { className: styles17.checkBoxContainer, children: /* @__PURE__ */ jsx444(HVCheckbox_default, { size: "16px", ...checkboxProps }) }),
              showLeadIcon ? leadIcon ? leadIcon : /* @__PURE__ */ jsx444(
                HVIcon_default,
                {
                  name: type === "parent" ? open ? "Folder-open" : "folder-close" : "dashboard",
                  svgProps: {
                    stroke: "currentColor",
                    width: 24,
                    height: 24,
                    strokeWidth: 1.5
                  }
                }
              ) : null,
              leadingCustomChildren && leadingCustomChildren
            ]
          }
        ),
        /* @__PURE__ */ jsx444(Flex2, { className: styles17.labelContainer, ...labelContainerProps, children: isEditing ? /* @__PURE__ */ jsx444(
          TextInput2,
          {
            size: "xs",
            styles: {
              input: {
                borderRadius: "4px",
                borderColor: "var(--hv-input-outline-default)"
              }
            },
            value: currentLabel,
            autoFocus: true,
            onChange: handleChange,
            onBlur: onEditCancel,
            onKeyDown: (e) => {
              if (e.key === "Enter") {
                onEdit?.(e.currentTarget.value);
                onEditCancel?.();
              }
              if (e.key === "Escape") {
                onEditCancel?.();
                setCurrentLabel(label);
              }
            },
            ...inputProps
          }
        ) : /* @__PURE__ */ jsxs108(Fragment7, { children: [
          /* @__PURE__ */ jsx444(HVText_default, { type: "Body-sm", ...labelProps, children: label }),
          type === "parent" && count && /* @__PURE__ */ jsx444(
            HVText_default,
            {
              type: "Body-xs",
              c: "var(--hv-text-normal-tertiary)",
              ...countProps,
              children: `(${count})`
            }
          )
        ] }) }),
        /* @__PURE__ */ jsx444(Flex2, { gap: "var(--mantine-spacing-1)", children: trailingIcons })
      ]
    }
  );
};
var HVTreeItem_default = HVTreeItem;

// components/HVTreeView/TreeViewUtils.ts
var TreeViewUtils_exports = {};
__export(TreeViewUtils_exports, {
  addChild: () => addChild,
  findNodeById: () => findNodeById,
  flattenTree: () => flattenTree,
  removeNode: () => removeNode,
  updateLabel: () => updateLabel
});
var addChild = (nodes, parentId, newNode) => {
  return nodes.map((node) => {
    if (node.id === parentId) {
      return {
        ...node,
        children: [...node.children ?? [], newNode]
      };
    } else if (node.children) {
      return {
        ...node,
        children: addChild(node.children, parentId, newNode)
      };
    }
    return node;
  });
};
var updateLabel = (nodes, id, newLabel) => {
  return nodes.map((node) => {
    if (node.id === id) {
      return { ...node, itemProps: { ...node.itemProps, label: newLabel } };
    }
    if (node.children) {
      return { ...node, children: updateLabel(node.children, id, newLabel) };
    }
    return node;
  });
};
var removeNode = (nodes, id) => {
  return nodes.filter((node) => node.id !== id).map((node) => ({
    ...node,
    children: node.children ? removeNode(node.children, id) : node.children
  }));
};
var findNodeById = (nodes, id) => {
  for (const node of nodes) {
    if (node.id === id) return node;
    if (node.children) {
      const found = findNodeById(node.children, id);
      if (found) return found;
    }
  }
  return void 0;
};
var flattenTree = (nodes, expandedNodes, level = 0) => {
  let result = [];
  for (const node of nodes) {
    result.push({ ...node, level });
    if (node.children && expandedNodes.has(node.id)) {
      result = result.concat(
        flattenTree(node.children, expandedNodes, level + 1)
      );
    }
  }
  return result;
};

// components/HVTreeView/HVTreeView.tsx
import styles18 from "./HVTreeView.module-C4FMW7KO.module.css";
import { jsx as jsx445, jsxs as jsxs109 } from "react/jsx-runtime";
var HVTreeView = ({
  data,
  editingNodeId,
  expandedNodes,
  onToggleExpansion,
  selectedNodeId,
  onTreeItemClick,
  defaultTreeItemProps,
  checkedNodes,
  indeterminateNodes,
  toggleCheck,
  onMoveNode
}) => {
  const autoExpandTimer = useRef4(null);
  const wrapperRefs = useRef4({});
  const dragPreviewRef = useRef4(null);
  const [dragOverState, setDragOverState] = useState6({
    isDragOvered: false,
    item: null
  });
  const [draggingItemId, setDraggingItemId] = useState6(null);
  const isNodeOpen = useCallback2(
    (id) => expandedNodes.has(id),
    [expandedNodes]
  );
  const handleTreeItemClick = (e, node) => {
    if (e.target.tagName === "INPUT") return;
    onTreeItemClick?.(node);
  };
  const handleDragStart = (e, id) => {
    e.dataTransfer.setData("application/node-id", id);
    setDraggingItemId(id);
    if (dragPreviewRef.current) {
      e.dataTransfer.setDragImage(dragPreviewRef.current, 0, 0);
    }
  };
  const handleDragEnd = () => {
    setDragOverState({ isDragOvered: false, item: null });
    setDraggingItemId(null);
  };
  const handleDragOver = (e, dragOverItem) => {
    e.preventDefault();
    e.dataTransfer.dropEffect = "move";
    if (autoExpandTimer.current === null) {
      autoExpandTimer.current = setTimeout(() => {
        onToggleExpansion(dragOverItem.id);
      }, 1e3);
    }
    if (autoExpandTimer.current && dragOverState.item?.id !== dragOverItem.id) {
      clearTimeout(autoExpandTimer.current);
      autoExpandTimer.current = null;
    }
    setDragOverState({ isDragOvered: true, item: dragOverItem });
  };
  const handleDragLeave = (e) => {
    if (autoExpandTimer.current) clearTimeout(autoExpandTimer.current);
    autoExpandTimer.current = null;
    if (e.currentTarget.contains(e.target)) return;
    setDragOverState({ isDragOvered: false, item: null });
  };
  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (autoExpandTimer.current) clearTimeout(autoExpandTimer.current);
    autoExpandTimer.current = null;
    const sourceId = e.dataTransfer.getData("application/node-id");
    const targetId = dragOverState.item?.itemProps?.type === "item" ? dragOverState.item?.parentId : dragOverState.item?.id;
    if (sourceId && dragOverState.isDragOvered && targetId) {
      onMoveNode(flatNodes, sourceId, targetId);
      onToggleExpansion(targetId);
    }
    setDragOverState({ isDragOvered: false, item: null });
  };
  const flatNodes = flattenTree(data, expandedNodes);
  const draggingItem = flatNodes.find(({ id }) => id === draggingItemId);
  return /* @__PURE__ */ jsxs109(Flex3, { direction: "column", children: [
    flatNodes.map((node) => {
      const isDropTarget = dragOverState.isDragOvered && node.id === dragOverState.item?.id;
      const open = isNodeOpen(node.id);
      const isChecked = checkedNodes?.has(node.id);
      const isIndeterminate = indeterminateNodes?.has(node.id);
      return /* @__PURE__ */ jsx445(
        Flex3,
        {
          direction: "column",
          ref: (el) => wrapperRefs.current[node.id] = el,
          onDragOver: (e) => handleDragOver(e, node),
          onDragLeave: handleDragLeave,
          onDrop: handleDrop,
          onDragEnd: handleDragEnd,
          bg: isDropTarget ? "var(--hv-interaction-hover)" : void 0,
          style: {
            border: isDropTarget ? "1px dashed var(--hv-border-default)" : void 0
          },
          children: /* @__PURE__ */ jsx445(
            HVTreeItem_default,
            {
              "aria-expanded": open,
              showCaret: !!node.children,
              showLeadIcon: true,
              showCheckbox: true,
              open,
              caretIconClick: () => onToggleExpansion(node.id),
              isEditing: editingNodeId === node.id,
              isSelected: selectedNodeId === node.id,
              onClick: (e) => handleTreeItemClick(e, node),
              checkboxProps: {
                checked: isChecked,
                indeterminate: isIndeterminate,
                onChange: (e) => toggleCheck?.(node, e.currentTarget.checked)
              },
              containerProps: {
                draggable: true,
                onDragStart: (e) => handleDragStart(e, node.id),
                style: { height: "100%" }
              },
              ...defaultTreeItemProps,
              ...node.itemProps,
              level: node.level
            }
          )
        },
        node.id
      );
    }),
    /* @__PURE__ */ jsx445(Portal, { children: /* @__PURE__ */ jsx445(Flex3, { p: 8, className: styles18.dragPreview, ref: dragPreviewRef, children: draggingItem?.itemProps?.label }) })
  ] });
};
var HVTreeView_default = HVTreeView;

// components/HVDatePicker/ScrollBar/ScrollBar.tsx
import styles19 from "./ScrollBar.module-Q2SOCQQF.module.css";

// components/HVDatePicker/ScrollBar/useScrollBar.tsx
import {
  useCallback as useCallback3,
  useEffect as useEffect3,
  useId,
  useRef as useRef5
} from "react";
var useScrollBar = () => {
  const uniqId = useId();
  const scrollbarRef = useRef5(null);
  const contentRef = useRef5(null);
  const onScrollContent = () => {
    const scrollbarEle = scrollbarRef.current;
    const contentEle = contentRef.current;
    if (scrollbarEle && contentEle) {
      const top = contentEle.scrollTop * 100 / contentEle.scrollHeight;
      scrollbarEle.style.top = top >= 0 ? `calc(${top}% + 6px)` : "0";
    }
  };
  const onChangeHeight = (entries) => {
    if (entries.length) {
      const { target } = entries[0];
      setTimeout(() => {
        const scrollbarEle = scrollbarRef.current;
        const ratio = target.clientHeight / target.scrollHeight;
        if (ratio < 1 && scrollbarEle) {
          scrollbarEle.style.display = ratio * target.clientHeight ? "block" : "none";
          scrollbarEle.style.height = `${ratio * target.clientHeight - 12}px`;
        }
        if (target.clientHeight === target.scrollHeight && scrollbarEle) {
          scrollbarEle.style.display = "none";
        }
      }, 100);
    }
  };
  const onMouseDown = useCallback3((e) => {
    const scrollbarEle = scrollbarRef.current;
    const contentEle = contentRef.current;
    if (scrollbarEle && contentEle) {
      const startPos = {
        x: e.clientX,
        y: e.clientY,
        top: contentEle.scrollTop
      };
      const onMouseMove = (e2) => {
        const dy = e2.clientY - startPos.y;
        const scrollRatio = contentEle.clientHeight / contentEle.scrollHeight;
        contentEle.scrollTop = startPos.top + dy / scrollRatio;
      };
      const onMouseUp = () => {
        document.removeEventListener("mousemove", onMouseMove);
        document.removeEventListener("mouseup", onMouseUp);
      };
      document.addEventListener("mousemove", onMouseMove);
      document.addEventListener("mouseup", onMouseUp);
    }
  }, []);
  const onKeyDown = (e) => {
    const contentEle = contentRef.current;
    if (contentEle) {
      const scrollAmount = 10;
      switch (e.key) {
        case "ArrowUp":
          contentEle.scrollTop -= scrollAmount;
          break;
        case "ArrowDown":
          contentEle.scrollTop += scrollAmount;
          break;
        default:
          return;
      }
      e.preventDefault();
      onScrollContent();
    }
  };
  useEffect3(() => {
    const scrollbarElement = document.getElementById(`scrollbar-${uniqId}`);
    let resizeObserver;
    if (scrollbarElement) {
      resizeObserver = new ResizeObserver(onChangeHeight);
      resizeObserver.observe(scrollbarElement);
    }
    return () => {
      if (resizeObserver && scrollbarElement) {
        resizeObserver.unobserve(scrollbarElement);
      }
    };
  }, []);
  return {
    onScrollContent,
    onMouseDown,
    onKeyDown,
    scrollbarRef,
    contentRef,
    uniqId
  };
};
var useScrollBar_default = useScrollBar;

// components/HVDatePicker/ScrollBar/ScrollBar.tsx
import { jsx as jsx446, jsxs as jsxs110 } from "react/jsx-runtime";
var ScrollBar = ({ children, onScroll }) => {
  const {
    onScrollContent,
    onMouseDown,
    onKeyDown,
    scrollbarRef,
    contentRef,
    uniqId
  } = useScrollBar_default();
  return /* @__PURE__ */ jsxs110("div", { className: styles19["scrollbar"], children: [
    /* @__PURE__ */ jsx446(
      "div",
      {
        id: `scrollbar-${uniqId}`,
        ref: contentRef,
        className: styles19["scrollbar-content"],
        "data-testid": "scrollbar-content",
        onScroll: (e) => {
          onScroll?.(e);
          onScrollContent();
        },
        children
      }
    ),
    /* @__PURE__ */ jsx446(
      "div",
      {
        ref: scrollbarRef,
        onMouseDown,
        onKeyDown,
        className: styles19["scrollbar-thumb"],
        tabIndex: 0,
        "aria-label": "scrollbar",
        role: "scrollbar",
        "aria-controls": `scrollbar-${uniqId}`,
        "aria-valuenow": 0
      }
    )
  ] });
};
var ScrollBar_default = ScrollBar;

// components/HVDatePicker/Calendar/Calendar.tsx
import { useCallback as useCallback4, useEffect as useEffect4, useId as useId3, useRef as useRef6 } from "react";

// components/HVDatePicker/resources/constants/constants.ts
var CALENDAR = {
  MAX_SELECTABLE_DAY: 1824
  // max selectable days
};
var CALENDAR_MODE_RANGE_TYPE = {
  TODAY: "today",
  CUSTOM: "custom",
  LAST_24_HOURS: "last_24_hours",
  LAST_7_DAYS: "last_7_days",
  LAST_30_DAYS: "last_30_days",
  LAST_90_DAYS: "last_90_days",
  LAST_180_DAYS: "last_180_days",
  LAST_365_DAYS: "last_365_days",
  YESTERDAY: "yesterday",
  DAY_BEFORE_YESTERDAY: "day_before_yesterday"
};
var FORMAT = {
  FULL_YEAR: "YYYY",
  //  2024
  TIME: "HH:mm:ss",
  //  14:25:36
  TIME_1: "HH:mm",
  //  14:25
  DATE: "MM-DD-YYYY",
  //  03-15-2024
  DATE2: "MM/DD/YYYY",
  // 03/15/2024
  DATE3: "MM/DD",
  //  03/15
  DATE4: "MM/DD/YYYY",
  // 03/15/2024
  DATE5: "MMM DD",
  // Mar 15
  DATE_MONTH: "YYYY-MMMM-DD",
  //  2024-April-26
  DATE_MONTH_TYPE: "MM/DD/YYYY",
  // 03/15/2024
  DATE_TIME_12H: "MM/DD/YYYY A hh:mm",
  // 03/15/2024 PM 02:30
  DATE_TIME_12H_FULL: "MM/DD/YYYY A hh:mm:ss",
  // 03/15/2024 PM 02:30:45
  DATE_TIME_12H_1: "MMM D, YYYY hh:mm A",
  // Apr 25, 2024 03:30 PM
  DATE_TIME_24H: "MM/DD/YYYY HH:mm",
  //   03/15/2024 14:30
  DATE_TIME2_24H: "MM/DD HH:mm",
  //   03/15 14:30
  DATE_TIME_24H_1: "YYYY-MM-DD HH:mm:ss",
  // 2024-01-01 14:30:45
  TIME_12H: "A hh:mm:ss",
  //  PM 02:30:45
  TIME_12H_1: "A hh:mm",
  //  PM 02:30
  TIME_12H_2: "hh:mm A",
  //   02:30 PM
  DATE_TIME_ISO: "YYYY-MM-DD[T]HH:mm:ssZ",
  //   2024-04-26T15:30:45Z
  MONTH_DATE_YEAR: "MMM/DD/yyyy",
  // Mar/15/2024
  MONTH_DATE_YEAR_1: "MMM DD, yyy",
  // Mar 15, 2024
  TIM12: "hh:mm:ss A",
  // 02:30:45 PM
  MONTH_DATE_YEAR_TIME: "MMM DD, yyyy hh:mm:ss A",
  //  Apr 25, 2024 03:30:15 PM
  MONTH_DATE_YEAR_TIME_2: "MMM DD, yyyy hh:mm A",
  //  Apr 25, 2024 03:30 PM
  MONTH_DATE_YEAR_TIME_3: "MMM DD, YYYY h:mm A",
  //  Apr 25, 2024 3:30 PM
  MONTH_DATE_TIME: "MMM DD, h:mm A",
  //  Apr 25, 3:30 PM
  DATE_MONTH_YEAR_TIME: "d MMM,YYYY A hh:mm",
  // 25 Apr, 2024 PM 03:30
  DATE_MONTH_YEAR: "D MMM, YYYY"
  // 25 Apr, 2024
};
var SESSION_STORAGE_KEY = {
  ACTIVE_DASHBOARD_ID: "ActiveDashboardID",
  SAVE_DEVICE_LOGIN_INFO: "SaveDeviceLoginInfo",
  ORG_ID: "org_id",
  TIME_ZONE: "TimeZone"
};
var MONTH = {
  JAN: "January",
  FEB: "February",
  MAR: "March",
  APR: "April",
  MAY: "May",
  JUN: "June",
  JUL: "July",
  AUG: "August",
  SEP: "September",
  OCT: "October",
  NOV: "November",
  DEC: "December"
};

// components/HVDatePicker/Calendar/Header/ContextMenu/ContextMenu.tsx
import { isArray } from "lodash";
import { useId as useId2, useState as useState7 } from "react";
import styles20 from "./ContextMenu.module-ZJ64XTQH.module.css";
import { Fragment as Fragment8, jsx as jsx447, jsxs as jsxs111 } from "react/jsx-runtime";
var ContextMenu = ({
  children,
  value,
  data = [],
  trigger = "hover",
  tabIndex = 0
}) => {
  const uniq = useId2();
  const [show, setShow] = useState7(false);
  return /* @__PURE__ */ jsxs111(
    "div",
    {
      id: `context-menu_${uniq}`,
      "aria-label": "context-menu",
      className: styles20["context-menu"],
      onMouseMove: () => trigger === "hover" && setShow(true),
      onMouseLeave: () => trigger === "hover" && setShow(false),
      onClick: () => trigger === "press" && setShow((prev) => !prev),
      role: "button",
      tabIndex,
      onKeyDown: (e) => {
        if (e.code === "Enter" || e.code === "Space") {
          setShow((prev) => !prev);
        }
      },
      children: [
        children,
        /* @__PURE__ */ jsx447(
          "ul",
          {
            style: { visibility: show ? "visible" : "hidden" },
            "data-visibility": show ? "visible" : "hidden",
            children: isArray(data) ? data.map((item, index) => {
              return /* @__PURE__ */ jsx447(
                "li",
                {
                  className: item.icon ? styles20["has-icon"] : "",
                  "aria-label": `context-menu-${index}`,
                  children: /* @__PURE__ */ jsxs111(
                    "button",
                    {
                      ...item.custom,
                      onClick: (e) => {
                        item.custom?.onClick?.(e);
                        item.custom?.onSelectItem?.(item);
                      },
                      onKeyDown: (e) => {
                        if (e.key === "Enter") {
                          e.currentTarget.click();
                        }
                      },
                      children: [
                        value && /* @__PURE__ */ jsx447("div", { style: { width: "16px", height: "16px" }, children: value === item.label ? /* @__PURE__ */ jsx447(icon_check_line_default, {}) : "" }),
                        item.icon || null,
                        item.label,
                        item.children && /* @__PURE__ */ jsxs111(Fragment8, { children: [
                          /* @__PURE__ */ jsx447("div", { className: styles20["icon"], children: /* @__PURE__ */ jsx447(IconArrowRight_default, {}) }),
                          item.children && /* @__PURE__ */ jsx447("ul", { children: item.children.map((sub) => /* @__PURE__ */ jsx447(
                            "li",
                            {
                              "aria-label": `sub-context-menu-${index}`,
                              children: /* @__PURE__ */ jsx447(
                                "button",
                                {
                                  ...sub.custom,
                                  onClick: (e) => {
                                    sub.custom?.onClick?.(e);
                                    sub.custom?.onSelectItem?.(sub);
                                  },
                                  children: sub.label
                                }
                              )
                            },
                            `sub-context-menu-${uniq}-${sub.label}`
                          )) })
                        ] })
                      ]
                    }
                  )
                },
                `context-menu-${uniq}-${item.label}`
              );
            }) : data
          }
        )
      ]
    }
  );
};

// components/HVDatePicker/Calendar/Header/Header.tsx
import styles21 from "./Header.module-X4DUYCMU.module.css";
import "./react-datepicker-HK4CQJ2F.css";

// components/HVDatePicker/resources/utils/utils.ts
var locale = "en-US";
var createDateTime = (date, hour, minute, second, period, timeZone) => {
  let hoursIn24Format;
  if (period === "PM" && hour < 12) {
    hoursIn24Format = hour + 12;
  } else if (period === "AM" && hour === 12) {
    hoursIn24Format = 0;
  } else {
    hoursIn24Format = hour;
  }
  const dateTime = new Date(date);
  dateTime.setHours(hoursIn24Format, minute, second, 0);
  const formatter = new Intl.DateTimeFormat(locale, {
    timeZone,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: false
  });
  const parts = formatter.formatToParts(dateTime);
  const dateTimeString = parts.reduce(
    (acc, part) => {
      if (part.type !== "literal") {
        acc[part.type] = part.value;
      }
      return acc;
    },
    {}
  );
  return (/* @__PURE__ */ new Date(
    `${dateTimeString.year}-${dateTimeString.month}-${dateTimeString.day}T${dateTimeString.hour}:${dateTimeString.minute}:${dateTimeString.second}`
  )).toISOString();
};
var formatMinuteSecond = (minSec) => minSec < 10 ? `0${minSec}` : minSec.toString();
var formatMode = (string) => {
  return string.toLowerCase().replace(/_/g, " ").replace(/^\w/, (c) => c.toUpperCase());
};
var getDateTime = (mode, start, end) => {
  const startDate = new Date(start);
  const endDate = end ? new Date(end) : new Date(start);
  const period = Math.floor(
    (endDate.getTime() - startDate.getTime()) / (1e3 * 60 * 60 * 24)
  );
  const formatDate2 = (date, timeZone2) => {
    const formatter = new Intl.DateTimeFormat(locale, {
      timeZone: timeZone2,
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit"
    });
    const parts = formatter.formatToParts(date);
    const dateTimeString = parts.reduce(
      (acc, part) => {
        if (part.type !== "literal") {
          acc[part.type] = part.value;
        }
        return acc;
      },
      {}
    );
    return (/* @__PURE__ */ new Date(
      `${dateTimeString.year}-${dateTimeString.month}-${dateTimeString.day}T${dateTimeString.hour}:${dateTimeString.minute}:${dateTimeString.second}`
    )).toISOString();
  };
  const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  switch (mode) {
    case CALENDAR_MODE_RANGE_TYPE.LAST_24_HOURS:
      return {
        start: formatDate2(new Date(Date.now() - 24 * 60 * 60 * 1e3), timeZone),
        end: formatDate2(/* @__PURE__ */ new Date(), timeZone),
        comparisonStart: formatDate2(
          new Date(Date.now() - 72 * 60 * 60 * 1e3),
          timeZone
        ),
        comparisonEnd: formatDate2(
          new Date(Date.now() - 48 * 60 * 60 * 1e3),
          timeZone
        )
      };
    case CALENDAR_MODE_RANGE_TYPE.LAST_7_DAYS:
      return {
        start: formatDate2(
          new Date(Date.now() - 6 * 24 * 60 * 60 * 1e3),
          timeZone
        ),
        end: formatDate2(/* @__PURE__ */ new Date(), timeZone),
        comparisonStart: formatDate2(
          new Date(Date.now() - 13 * 24 * 60 * 60 * 1e3),
          timeZone
        ),
        comparisonEnd: formatDate2(
          new Date(Date.now() - 7 * 24 * 60 * 60 * 1e3),
          timeZone
        )
      };
    case CALENDAR_MODE_RANGE_TYPE.LAST_30_DAYS:
      return {
        start: formatDate2(
          new Date(Date.now() - 29 * 24 * 60 * 60 * 1e3),
          timeZone
        ),
        end: formatDate2(/* @__PURE__ */ new Date(), timeZone),
        comparisonStart: formatDate2(
          new Date(Date.now() - 59 * 24 * 60 * 60 * 1e3),
          timeZone
        ),
        comparisonEnd: formatDate2(
          new Date(Date.now() - 30 * 24 * 60 * 60 * 1e3),
          timeZone
        )
      };
    case CALENDAR_MODE_RANGE_TYPE.LAST_90_DAYS:
      return {
        start: formatDate2(
          new Date(Date.now() - 89 * 24 * 60 * 60 * 1e3),
          timeZone
        ),
        end: formatDate2(/* @__PURE__ */ new Date(), timeZone),
        comparisonStart: formatDate2(
          new Date(Date.now() - 179 * 24 * 60 * 60 * 1e3),
          timeZone
        ),
        comparisonEnd: formatDate2(
          new Date(Date.now() - 90 * 24 * 60 * 60 * 1e3),
          timeZone
        )
      };
    case CALENDAR_MODE_RANGE_TYPE.LAST_180_DAYS:
      return {
        start: formatDate2(
          new Date(Date.now() - 179 * 24 * 60 * 60 * 1e3),
          timeZone
        ),
        end: formatDate2(/* @__PURE__ */ new Date(), timeZone),
        comparisonStart: formatDate2(
          new Date(Date.now() - 359 * 24 * 60 * 60 * 1e3),
          timeZone
        ),
        comparisonEnd: formatDate2(
          new Date(Date.now() - 180 * 24 * 60 * 60 * 1e3),
          timeZone
        )
      };
    case CALENDAR_MODE_RANGE_TYPE.LAST_365_DAYS:
      return {
        start: formatDate2(
          new Date(Date.now() - 364 * 24 * 60 * 60 * 1e3),
          timeZone
        ),
        end: formatDate2(/* @__PURE__ */ new Date(), timeZone),
        comparisonStart: formatDate2(
          new Date(Date.now() - 729 * 24 * 60 * 60 * 1e3),
          timeZone
        ),
        comparisonEnd: formatDate2(
          new Date(Date.now() - 365 * 24 * 60 * 60 * 1e3),
          timeZone
        )
      };
    case CALENDAR_MODE_RANGE_TYPE.YESTERDAY:
      return {
        start: formatDate2(new Date(Date.now() - 24 * 60 * 60 * 1e3), timeZone),
        end: formatDate2(new Date(Date.now() - 24 * 60 * 60 * 1e3), timeZone),
        comparisonStart: formatDate2(
          new Date(Date.now() - 48 * 60 * 60 * 1e3),
          timeZone
        ),
        comparisonEnd: formatDate2(
          new Date(Date.now() - 48 * 60 * 60 * 1e3),
          timeZone
        )
      };
    case CALENDAR_MODE_RANGE_TYPE.DAY_BEFORE_YESTERDAY:
      return {
        start: formatDate2(new Date(Date.now() - 48 * 60 * 60 * 1e3), timeZone),
        end: formatDate2(new Date(Date.now() - 48 * 60 * 60 * 1e3), timeZone),
        comparisonStart: formatDate2(
          new Date(Date.now() - 72 * 60 * 60 * 1e3),
          timeZone
        ),
        comparisonEnd: formatDate2(
          new Date(Date.now() - 72 * 60 * 60 * 1e3),
          timeZone
        )
      };
    case CALENDAR_MODE_RANGE_TYPE.CUSTOM:
      return {
        start: formatDate2(startDate, timeZone),
        end: formatDate2(endDate, timeZone),
        comparisonStart: formatDate2(
          new Date(
            startDate.getTime() - (period * 2 + 1) * 24 * 60 * 60 * 1e3
          ),
          timeZone
        ),
        comparisonEnd: formatDate2(
          new Date(startDate.getTime() - (period + 1) * 24 * 60 * 60 * 1e3),
          timeZone
        )
      };
    default:
      return {
        start: formatDate2(/* @__PURE__ */ new Date(), timeZone),
        end: formatDate2(/* @__PURE__ */ new Date(), timeZone),
        comparisonStart: formatDate2(
          new Date(Date.now() - 24 * 60 * 60 * 1e3),
          timeZone
        ),
        comparisonEnd: formatDate2(
          new Date(Date.now() - 24 * 60 * 60 * 1e3),
          timeZone
        )
      };
  }
};
var classNames = (data) => {
  return Object.keys(data).filter((key) => data[key]).join(" ");
};
var formatDate = (date, format) => {
  const options = {};
  if (format.includes("YYYY")) {
    options.year = "numeric";
  }
  if (format.includes("MM")) {
    options.month = "2-digit";
  }
  if (format.includes("DD")) {
    options.day = "2-digit";
  }
  return new Intl.DateTimeFormat(locale, options).format(date);
};
var formatMonth = (date) => {
  const formatter = new Intl.DateTimeFormat(locale, { month: "short" });
  return formatter.format(date);
};
var startOf = (date, type) => {
  switch (type) {
    case "YEAR":
      return new Date(date.getFullYear(), 0, 1, 0, 0, 0, 0);
    case "MONTH":
      return new Date(date.getFullYear(), date.getMonth(), 1, 0, 0, 0, 0);
    case "DAY":
      return new Date(
        date.getFullYear(),
        date.getMonth(),
        date.getDate(),
        0,
        0,
        0,
        0
      );
    case "HOUR":
      return new Date(
        date.getFullYear(),
        date.getMonth(),
        date.getDate(),
        date.getHours(),
        0,
        0,
        0
      );
    default:
      throw new Error(`Unsupported type: ${type}`);
  }
};
var endOf = (date, type) => {
  switch (type) {
    case "YEAR":
      return new Date(date.getFullYear(), 11, 31, 23, 59, 59, 999);
    case "MONTH":
      return new Date(
        date.getFullYear(),
        date.getMonth() + 1,
        0,
        23,
        59,
        59,
        999
      );
    case "DAY":
      return new Date(
        date.getFullYear(),
        date.getMonth(),
        date.getDate(),
        23,
        59,
        59,
        999
      );
    case "HOUR":
      return new Date(
        date.getFullYear(),
        date.getMonth(),
        date.getDate(),
        date.getHours(),
        59,
        59,
        999
      );
    default:
      throw new Error(`Unsupported type: ${type}`);
  }
};
var isSame = (date1, date2, type) => {
  switch (type) {
    case "YEAR":
      return date1.getFullYear() === date2.getFullYear();
    case "MONTH":
      return date1.getFullYear() === date2.getFullYear() && date1.getMonth() === date2.getMonth();
    case "DAY":
      return date1.getFullYear() === date2.getFullYear() && date1.getMonth() === date2.getMonth() && date1.getDate() === date2.getDate();
    case "HOUR":
      return date1.getFullYear() === date2.getFullYear() && date1.getMonth() === date2.getMonth() && date1.getDate() === date2.getDate() && date1.getHours() === date2.getHours();
    default:
      return false;
  }
};
var toDateWithTimezone = (timezone, date, format) => {
  if (format) {
    return new Intl.DateTimeFormat(locale, {
      timeZone: timezone,
      ...format
    }).format(date);
  }
  return new Intl.DateTimeFormat(locale, {
    timeZone: timezone,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit"
  }).format(date);
};

// components/HVDatePicker/Calendar/Header/Header.tsx
import { jsx as jsx448, jsxs as jsxs112 } from "react/jsx-runtime";
var Header = ({
  // date,
  monthDate,
  decreaseMonth,
  increaseMonth,
  changeMonth,
  changeYear,
  nextMonthButtonDisabled,
  prevMonthButtonDisabled
}) => {
  const months = Object.values(MONTH);
  return /* @__PURE__ */ jsx448(HVFlex_default, { direction: "row", className: styles21[`header`], children: /* @__PURE__ */ jsxs112(HVFlex_default, { direction: "row", className: styles21[`control`], children: [
    /* @__PURE__ */ jsxs112(HVFlex_default, { direction: "row", className: styles21[`month-year-menu`], children: [
      /* @__PURE__ */ jsx448(
        ContextMenu,
        {
          data: months.map((month, index) => ({
            label: month,
            custom: {
              onClick: () => {
                changeMonth(index);
              }
            }
          })),
          children: /* @__PURE__ */ jsxs112(HVFlex_default, { direction: "row", className: styles21["month-year"], children: [
            /* @__PURE__ */ jsx448(
              HVText_default,
              {
                type: "Body-md",
                weight: "Regular",
                style: { lineHeight: "inherit", color: "inherit" },
                children: formatMonth(monthDate || /* @__PURE__ */ new Date())
              }
            ),
            /* @__PURE__ */ jsx448("span", { className: styles21["icon-dropdown"], children: /* @__PURE__ */ jsx448(arrow_chevron_down_default, {}) })
          ] })
        }
      ),
      /* @__PURE__ */ jsx448(
        ContextMenu,
        {
          data: Array.from({ length: 6 }, (_2, i) => {
            const year = (/* @__PURE__ */ new Date()).getFullYear() - (5 - i);
            return {
              label: year.toString(),
              custom: {
                onClick: () => {
                  changeYear(year);
                }
              }
            };
          }),
          children: /* @__PURE__ */ jsxs112(HVFlex_default, { direction: "row", className: styles21["month-year"], children: [
            /* @__PURE__ */ jsx448(
              HVText_default,
              {
                type: "Body-md",
                weight: "Regular",
                style: { lineHeight: "inherit", color: "inherit" },
                children: formatDate(monthDate || /* @__PURE__ */ new Date(), FORMAT.FULL_YEAR)
              }
            ),
            /* @__PURE__ */ jsx448("span", { className: styles21["icon-dropdown"], children: /* @__PURE__ */ jsx448(arrow_chevron_down_default, {}) })
          ] })
        }
      )
    ] }),
    /* @__PURE__ */ jsxs112(HVFlex_default, { direction: "row", className: styles21["month-control"], children: [
      /* @__PURE__ */ jsx448(
        "button",
        {
          className: `${styles21["icon-arrow"]} up`,
          onClick: (e) => {
            e.preventDefault();
            e.stopPropagation();
            if (!prevMonthButtonDisabled) {
              decreaseMonth();
            }
          },
          children: /* @__PURE__ */ jsx448(arrow_chevron_up_default, {})
        }
      ),
      /* @__PURE__ */ jsx448(
        "button",
        {
          className: `${styles21["icon-arrow"]} down`,
          onClick: (e) => {
            e.preventDefault();
            e.stopPropagation();
            if (!nextMonthButtonDisabled) {
              increaseMonth();
            }
          },
          children: /* @__PURE__ */ jsx448(arrow_chevron_down_default, {})
        }
      )
    ] })
  ] }) });
};
var Header_default = Header;

// components/HVDatePicker/Calendar/Calendar.tsx
import DatePicker from "react-datepicker";
import styles22 from "./Calendar.module-GTZFOMLS.module.css";
import headerStyles from "./Header.module-X4DUYCMU.module.css";
import "./DatePicker-BMIWSBMK.css";
import { jsx as jsx449, jsxs as jsxs113 } from "react/jsx-runtime";
var Calendar = ({ today, ...props }) => {
  const uniq = useId3();
  const wrapperRef = useRef6(null);
  const renderWeekDay = useCallback4(
    (nameOfDay) => String(nameOfDay).substring(0, 3),
    []
  );
  const renderDayContents = useCallback4(
    (day, date) => {
      const startOfMonth = startOf(date, "MONTH");
      const endOfMonth = endOf(date, "MONTH");
      return /* @__PURE__ */ jsxs113(
        "div",
        {
          className: classNames({
            [styles22["date-picker-custom-today"]]: isSame(date, today, "HOUR"),
            [styles22["date-picker-custom-date"]]: true,
            [styles22["date-picker-start-of-month"]]: isSame(
              date,
              startOfMonth,
              "DAY"
            ),
            [styles22["date-picker-end-of-month"]]: isSame(
              date,
              endOfMonth,
              "DAY"
            )
          }),
          children: [
            /* @__PURE__ */ jsx449("span", { "data-day": day, children: date?.getDate() }),
            /* @__PURE__ */ jsx449("span", { className: styles22["shadow-date"], children: date?.getDate() })
          ]
        }
      );
    },
    [today]
  );
  useEffect4(() => {
    if (!wrapperRef.current) return void 0;
    const monthContainer = wrapperRef.current.querySelector(
      `.${["react-datepicker__month"]}`
    );
    const prevButton = wrapperRef.current.querySelector(
      `.${headerStyles["icon-arrow"]}.up`
    );
    const nextButton = wrapperRef.current.querySelector(
      `.${headerStyles["icon-arrow"]}.down`
    );
    const handleMouseWheelEvent = (e) => {
      e.preventDefault();
      e.stopPropagation();
      if (e.deltaY > 0) {
        nextButton?.click();
      } else {
        prevButton?.click();
      }
    };
    monthContainer?.addEventListener("wheel", handleMouseWheelEvent);
    return () => monthContainer?.removeEventListener("wheel", handleMouseWheelEvent);
  }, [wrapperRef.current]);
  return /* @__PURE__ */ jsx449(
    "div",
    {
      className: styles22["calendar"],
      ref: wrapperRef,
      id: `date-picker_${uniq}`,
      children: /* @__PURE__ */ jsx449(
        DatePicker,
        {
          formatWeekDay: renderWeekDay,
          renderDayContents,
          renderCustomHeader: (props2) => /* @__PURE__ */ jsx449(Header_default, { ...props2 }),
          ...props
        }
      )
    }
  );
};

// components/HVDatePicker/TimePicker/TimePicker.tsx
import styles23 from "./TimePicker.module-HKT7QMPL.module.css";
import { jsx as jsx450, jsxs as jsxs114 } from "react/jsx-runtime";
var TimePicker = ({
  timePicker,
  selectedMode,
  selectedTempDateTime,
  formatMinuteSecond: formatMinuteSecond2
}) => {
  const capitalizeFirstLetter = (string) => {
    return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
  };
  return /* @__PURE__ */ jsx450(HVFlex_default, { direction: "column", className: styles23["time-range"], children: Object.keys(timePicker).map(
    (type) => {
      const isTodayMode = selectedMode === CALENDAR_MODE_RANGE_TYPE.TODAY;
      const disabledClass = isTodayMode ? styles23["disabled"] : "";
      return /* @__PURE__ */ jsxs114(
        HVFlex_default,
        {
          direction: "column",
          className: styles23["time-group"],
          children: [
            /* @__PURE__ */ jsxs114(HVFlex_default, { direction: "row", className: styles23["time-label-date"], children: [
              /* @__PURE__ */ jsx450("div", { className: styles23["time-label"], children: /* @__PURE__ */ jsx450(
                HVText_default,
                {
                  type: "Body-sm",
                  weight: "Semibold",
                  style: {
                    fontWeight: "inherit",
                    lineHeight: "inherit",
                    color: "inherit"
                  },
                  children: capitalizeFirstLetter(timePicker[type].label)
                }
              ) }),
              /* @__PURE__ */ jsx450("div", { className: styles23["time-date"], children: /* @__PURE__ */ jsx450(
                HVText_default,
                {
                  type: "Body-sm",
                  weight: "Semibold",
                  style: {
                    fontWeight: "inherit",
                    lineHeight: "inherit",
                    color: "inherit"
                  },
                  children: formatDate(
                    new Date(
                      type === "start" ? selectedTempDateTime.start : selectedTempDateTime.end || selectedTempDateTime.start
                    ),
                    FORMAT.MONTH_DATE_YEAR_1
                  )
                }
              ) })
            ] }),
            /* @__PURE__ */ jsxs114(HVFlex_default, { direction: "row", className: styles23["time-input-group"], children: [
              /* @__PURE__ */ jsxs114(
                HVFlex_default,
                {
                  direction: "row",
                  className: styles23["input-arrow-container"],
                  children: [
                    /* @__PURE__ */ jsx450(
                      "input",
                      {
                        "aria-label": `${String(type)} hour`,
                        type: "number",
                        value: timePicker[type].hour,
                        className: disabledClass,
                        onChange: (e) => {
                          const value = Number(e.target.value);
                          timePicker[type].setHour(
                            value >= 1 && value <= 12 ? value : timePicker[type].hour
                          );
                        },
                        min: "1",
                        max: "12",
                        disabled: isTodayMode
                      }
                    ),
                    /* @__PURE__ */ jsxs114(
                      HVFlex_default,
                      {
                        direction: "column",
                        className: styles23["arrow-container"],
                        children: [
                          /* @__PURE__ */ jsx450(
                            "button",
                            {
                              className: disabledClass,
                              onClick: () => timePicker[type].setHour(
                                Math.min(timePicker[type].hour + 1, 12)
                              ),
                              "aria-label": `Increment ${String(type)} hour`,
                              disabled: isTodayMode,
                              children: /* @__PURE__ */ jsx450(icon_arrow_time_input_chevron_up_default, {})
                            }
                          ),
                          /* @__PURE__ */ jsx450(
                            "button",
                            {
                              className: disabledClass,
                              onClick: () => timePicker[type].setHour(
                                Math.max(timePicker[type].hour - 1, 1)
                              ),
                              "aria-label": `Decrement ${String(type)} hour`,
                              disabled: isTodayMode,
                              children: /* @__PURE__ */ jsx450(icon_arrow_time_input_chevron_down_default, {})
                            }
                          )
                        ]
                      }
                    )
                  ]
                }
              ),
              /* @__PURE__ */ jsx450("span", { children: ":" }),
              /* @__PURE__ */ jsxs114(
                HVFlex_default,
                {
                  direction: "row",
                  className: styles23["input-arrow-container"],
                  children: [
                    /* @__PURE__ */ jsx450(
                      "input",
                      {
                        "aria-label": `${String(type)} minute`,
                        className: disabledClass,
                        type: "number",
                        value: formatMinuteSecond2(timePicker[type].minute),
                        onChange: (e) => {
                          const value = Number(e.target.value);
                          timePicker[type].setMinute(
                            value >= 0 && value <= 59 ? value : timePicker[type].minute
                          );
                        },
                        min: "0",
                        max: "59",
                        disabled: isTodayMode
                      }
                    ),
                    /* @__PURE__ */ jsxs114(
                      HVFlex_default,
                      {
                        direction: "column",
                        className: styles23["arrow-container"],
                        children: [
                          /* @__PURE__ */ jsx450(
                            "button",
                            {
                              className: disabledClass,
                              onClick: () => timePicker[type].setMinute(
                                Math.min(timePicker[type].minute + 1, 59)
                              ),
                              "aria-label": `Increment ${String(type)} minute`,
                              disabled: isTodayMode,
                              children: /* @__PURE__ */ jsx450(icon_arrow_time_input_chevron_up_default, {})
                            }
                          ),
                          /* @__PURE__ */ jsx450(
                            "button",
                            {
                              className: disabledClass,
                              onClick: () => timePicker[type].setMinute(
                                Math.max(timePicker[type].minute - 1, 0)
                              ),
                              "aria-label": `Decrement ${String(type)} minute`,
                              disabled: isTodayMode,
                              children: /* @__PURE__ */ jsx450(icon_arrow_time_input_chevron_down_default, {})
                            }
                          )
                        ]
                      }
                    )
                  ]
                }
              ),
              /* @__PURE__ */ jsx450("span", { children: ":" }),
              /* @__PURE__ */ jsxs114(
                HVFlex_default,
                {
                  direction: "row",
                  className: styles23["input-arrow-container"],
                  children: [
                    /* @__PURE__ */ jsx450(
                      "input",
                      {
                        "aria-label": `${String(type)} second`,
                        className: disabledClass,
                        type: "number",
                        value: formatMinuteSecond2(timePicker[type].second),
                        onChange: (e) => {
                          const value = Number(e.target.value);
                          timePicker[type].setSecond(
                            value >= 0 && value <= 59 ? value : timePicker[type].second
                          );
                        },
                        min: "0",
                        max: "59",
                        disabled: isTodayMode
                      }
                    ),
                    /* @__PURE__ */ jsxs114(
                      HVFlex_default,
                      {
                        direction: "column",
                        className: styles23["arrow-container"],
                        children: [
                          /* @__PURE__ */ jsx450(
                            "button",
                            {
                              className: disabledClass,
                              onClick: () => timePicker[type].setSecond(
                                Math.min(timePicker[type].second + 1, 59)
                              ),
                              "aria-label": `Increment ${String(type)} second`,
                              disabled: isTodayMode,
                              children: /* @__PURE__ */ jsx450(icon_arrow_time_input_chevron_up_default, {})
                            }
                          ),
                          /* @__PURE__ */ jsx450(
                            "button",
                            {
                              className: disabledClass,
                              onClick: () => timePicker[type].setSecond(
                                Math.max(timePicker[type].second - 1, 0)
                              ),
                              "aria-label": `Decrement ${String(type)} second`,
                              disabled: isTodayMode,
                              children: /* @__PURE__ */ jsx450(icon_arrow_time_input_chevron_down_default, {})
                            }
                          )
                        ]
                      }
                    )
                  ]
                }
              ),
              /* @__PURE__ */ jsxs114(HVFlex_default, { direction: "row", className: styles23["am-pm-toggle"], children: [
                /* @__PURE__ */ jsx450(
                  "button",
                  {
                    className: `${styles23["toggle-button"]} ${timePicker[type].period === "AM" ? styles23["active"] : ""}`,
                    onClick: () => timePicker[type].setPeriod("AM"),
                    "aria-label": `${String(type)} AM`,
                    disabled: isTodayMode,
                    children: "AM"
                  }
                ),
                /* @__PURE__ */ jsx450(
                  "button",
                  {
                    className: `${styles23["toggle-button"]} ${timePicker[type].period === "PM" ? styles23["active"] : ""}`,
                    onClick: () => timePicker[type].setPeriod("PM"),
                    "aria-label": `${String(type)} PM`,
                    disabled: isTodayMode,
                    children: "PM"
                  }
                )
              ] })
            ] })
          ]
        },
        String(type)
      );
    }
  ) });
};
var TimePicker_default = TimePicker;

// components/HVDatePicker/HVDatePicker.tsx
import styles25 from "./HVDatePicker.module-W4UCQBNQ.module.css";
import "./DatePicker-BMIWSBMK.css";

// components/HVDatePicker/useDatePicker.tsx
import { useEffect as useEffect6, useMemo as useMemo2, useRef as useRef7, useState as useState9 } from "react";

// hooks/useSessionStorage.ts
import { useState as useState8, useEffect as useEffect5 } from "react";
function useSessionStorage(key, initialValue) {
  const storedValue = sessionStorage.getItem(key) || JSON.stringify(initialValue);
  const parsedValue = JSON.parse(storedValue);
  const [value, setValue] = useState8(parsedValue);
  useEffect5(() => {
    sessionStorage.setItem(key, JSON.stringify(value));
  }, [key, value]);
  return [parsedValue, setValue];
}
var useSessionStorage_default = useSessionStorage;

// components/HVDatePicker/useDatePicker.tsx
import "./DatePicker-BMIWSBMK.css";
import styles24 from "./HVDatePicker.module-W4UCQBNQ.module.css";
import { Fragment as Fragment9, jsx as jsx451, jsxs as jsxs115 } from "react/jsx-runtime";
var useDatePicker = ({
  dateTime,
  setDateTime,
  availableModeList,
  onlyDisplayDateTime,
  showTimePicker = false,
  disabled = false,
  tabIndex,
  rangeSelectLimit = 90,
  usePreview = false
}) => {
  const datePickerRef = useRef7(null);
  const [showDatePicker, setShowDatePicker] = useState9(!usePreview);
  const [previousTimeZone, setPreviousTimeZone] = useState9("");
  const [selectedDateTime, setSelectedDateTime] = useState9(dateTime);
  const [selectedTempDateTime, setSelectedTempDateTime] = useState9(dateTime);
  const [currentTime, setCurrentTime] = useState9();
  const intervalCurrentTime = useRef7(
    null
  );
  const [sessionStorageUtc] = useSessionStorage_default(
    SESSION_STORAGE_KEY.TIME_ZONE,
    Intl.DateTimeFormat().resolvedOptions().timeZone
  );
  const currentTimeZone = sessionStorageUtc || Intl.DateTimeFormat().resolvedOptions().timeZone;
  const {
    mode: selectedMode,
    start: selectedStart,
    end: selectedEnd
  } = selectedTempDateTime;
  const [startHour, setStartHour] = useState9(12);
  const [startMinute, setStartMinute] = useState9(0);
  const [startSecond, setStartSecond] = useState9(0);
  const [startPeriod, setStartPeriod] = useState9("AM");
  const [endHour, setEndHour] = useState9(11);
  const [endMinute, setEndMinute] = useState9(59);
  const [endSecond, setEndSecond] = useState9(59);
  const [endPeriod, setEndPeriod] = useState9("PM");
  const [reRender, setReRender] = useState9(false);
  const timePicker = {
    start: {
      label: "from",
      hour: startHour,
      minute: startMinute,
      second: startSecond,
      period: startPeriod,
      setHour: setStartHour,
      setMinute: setStartMinute,
      setSecond: setStartSecond,
      setPeriod: setStartPeriod
    },
    end: {
      label: "to",
      hour: endHour,
      minute: endMinute,
      second: endSecond,
      period: endPeriod,
      setHour: setEndHour,
      setMinute: setEndMinute,
      setSecond: setEndSecond,
      setPeriod: setEndPeriod
    }
  };
  const classNames2 = useMemo2(() => {
    const list = ["date-range-picker"];
    if (disabled) {
      list.push("disabled");
    }
    if (!usePreview) {
      list.push("disable-preview-mode");
    }
    return list.join(" ");
  }, [disabled, usePreview]);
  const onChangeMode = (currentMode) => {
    const newDateTime = getDateTime(currentMode, (/* @__PURE__ */ new Date()).toISOString());
    setEndHour(11);
    setEndMinute(59);
    setEndSecond(59);
    setEndPeriod("PM");
    setStartHour(12);
    setStartMinute(0);
    setStartSecond(0);
    setStartPeriod("AM");
    setSelectedTempDateTime({
      mode: currentMode,
      ...newDateTime
    });
    setReRender(true);
    setTimeout(() => setReRender(false), 10);
  };
  const onClickOutside = (event) => {
    if (datePickerRef.current && !datePickerRef.current.contains(event.target)) {
      setShowDatePicker(false);
    }
  };
  const onChangeDate = (date) => {
    if (date && Array.isArray(date)) {
      const [startDateTime, endDateTime] = date;
      let newDateTime = {
        mode: CALENDAR_MODE_RANGE_TYPE.CUSTOM,
        start: startDateTime?.toISOString() || "",
        end: endDateTime?.toISOString() || ""
      };
      if (endDateTime) {
        newDateTime = {
          ...newDateTime,
          ...getDateTime(
            newDateTime.mode,
            startDateTime?.toISOString() || "",
            endDateTime?.toISOString() || ""
          )
        };
      }
      setSelectedTempDateTime(newDateTime);
    }
  };
  const renderPeriod = useMemo2(() => {
    const { mode, start, end } = selectedDateTime;
    const isSingleDateMode = mode === CALENDAR_MODE_RANGE_TYPE.YESTERDAY || mode === CALENDAR_MODE_RANGE_TYPE.DAY_BEFORE_YESTERDAY;
    const formattedStartDate = toDateWithTimezone(
      currentTimeZone,
      new Date(start),
      {
        year: "numeric",
        month: "short",
        day: "2-digit"
      }
    );
    const formattedStartTime = showTimePicker ? `${startHour || 12}:${formatMinuteSecond(
      startMinute || 0
    )}:${formatMinuteSecond(startSecond || 0)} ${startPeriod || "AM"}` : "";
    const formattedEndDate = toDateWithTimezone(
      currentTimeZone,
      new Date(end || start),
      {
        year: "numeric",
        month: "short",
        day: "2-digit"
      }
    );
    const formattedEndTime = showTimePicker ? `${endHour || 11}:${formatMinuteSecond(
      endMinute || 0
    )}:${formatMinuteSecond(endSecond || 0)} ${endPeriod || "PM"}` : "";
    return /* @__PURE__ */ jsxs115(Fragment9, { children: [
      mode === CALENDAR_MODE_RANGE_TYPE.TODAY && /* @__PURE__ */ jsx451("div", { className: styles24["circle"] }),
      !onlyDisplayDateTime && /* @__PURE__ */ jsx451("p", { className: styles24["mode"], children: formatMode(mode) }),
      /* @__PURE__ */ jsx451("div", { className: styles24["time-start"], children: mode === CALENDAR_MODE_RANGE_TYPE.TODAY ? /* @__PURE__ */ jsxs115("span", { children: [
        formattedStartDate,
        "\xA0",
        currentTime
      ] }) : /* @__PURE__ */ jsxs115(Fragment9, { children: [
        /* @__PURE__ */ jsxs115("span", { children: [
          formattedStartDate,
          " ",
          formattedStartTime
        ] }),
        (showTimePicker || !isSingleDateMode) && /* @__PURE__ */ jsx451("span", { children: " - " }),
        /* @__PURE__ */ jsx451("span", { children: isSingleDateMode ? ` ${formattedEndTime}` : `${formattedEndDate || formattedStartDate} ${formattedEndTime}` })
      ] }) })
    ] });
  }, [selectedDateTime, currentTime, currentTimeZone]);
  useEffect6(() => {
    document.addEventListener("mousedown", onClickOutside);
    return () => {
      document.removeEventListener("mousedown", onClickOutside);
    };
  }, []);
  useEffect6(() => {
    return () => {
      if (intervalCurrentTime.current) {
        clearInterval(
          intervalCurrentTime.current
        );
        intervalCurrentTime.current = null;
      }
    };
  }, []);
  useEffect6(() => {
    if (!showDatePicker && selectedTempDateTime.mode !== dateTime.mode) {
      setSelectedTempDateTime(dateTime);
    }
  }, [dateTime.mode]);
  useEffect6(() => {
    if (!showDatePicker) {
      const newDateTime = getDateTime(
        dateTime.mode,
        dateTime.start,
        dateTime.end
      );
      setSelectedTempDateTime({
        ...dateTime,
        ...newDateTime
      });
    }
  }, [showDatePicker]);
  const setCurrentDateTime = (_timeFormat) => {
    setCurrentTime(
      toDateWithTimezone(currentTimeZone, /* @__PURE__ */ new Date(), {
        hour: "2-digit",
        minute: "2-digit",
        hour12: true
      })
    );
  };
  useEffect6(() => {
    if (dateTime.mode === CALENDAR_MODE_RANGE_TYPE.TODAY || dateTime.mode === CALENDAR_MODE_RANGE_TYPE.LAST_24_HOURS) {
      if (intervalCurrentTime.current === null) {
        setCurrentTime(
          toDateWithTimezone(currentTimeZone, /* @__PURE__ */ new Date(), {
            hour: "2-digit",
            minute: "2-digit",
            hour12: true
          })
        );
        intervalCurrentTime.current = setInterval(() => {
          setCurrentDateTime(` ${FORMAT.TIME_12H_2}`);
        }, 10 * 1e3);
      }
    } else if (intervalCurrentTime.current) {
      clearInterval(
        intervalCurrentTime.current
      );
      intervalCurrentTime.current = null;
    }
  }, [dateTime.mode]);
  const maxDate = useMemo2(() => {
    if (selectedTempDateTime.mode === CALENDAR_MODE_RANGE_TYPE.CUSTOM) {
      const customMaxDate = new Date(selectedStart);
      customMaxDate.setDate(customMaxDate.getDate() + (rangeSelectLimit - 1));
      const today = /* @__PURE__ */ new Date();
      return customMaxDate > today ? today : customMaxDate;
    }
    return /* @__PURE__ */ new Date();
  }, [selectedStart, selectedTempDateTime.mode]);
  useEffect6(() => {
    if (currentTimeZone !== previousTimeZone) {
      if (intervalCurrentTime.current) {
        clearInterval(
          intervalCurrentTime.current
        );
        intervalCurrentTime.current = null;
      }
      if (intervalCurrentTime.current === null) {
        setCurrentTime(
          toDateWithTimezone(currentTimeZone, /* @__PURE__ */ new Date(), {
            timeZone: currentTimeZone,
            hour: "2-digit",
            minute: "2-digit",
            hour12: true
          })
        );
        intervalCurrentTime.current = setInterval(
          () => setCurrentDateTime(` ${FORMAT.TIME_12H_2}`),
          10 * 1e3
        );
      }
      setPreviousTimeZone(currentTimeZone);
    }
  });
  const onClickSubmit = () => {
    const { mode, start, end } = selectedTempDateTime;
    const dateTime2 = getDateTime(mode, start, end);
    const startDateTime = createDateTime(
      startOf(
        new Date(toDateWithTimezone(currentTimeZone, new Date(start), {})),
        "DAY"
      ),
      startHour,
      startMinute,
      startSecond,
      startPeriod,
      currentTimeZone
    );
    const endDateTime = createDateTime(
      end ? endOf(
        new Date(toDateWithTimezone(currentTimeZone, new Date(end))),
        "DAY"
      ) : endOf(
        new Date(toDateWithTimezone(currentTimeZone, new Date(start))),
        "DAY"
      ),
      endHour,
      endMinute,
      endSecond,
      endPeriod,
      currentTimeZone
    );
    setSelectedDateTime({
      ...selectedTempDateTime,
      ...dateTime2,
      start: startDateTime,
      end: endDateTime
    });
    setDateTime({
      ...selectedTempDateTime,
      ...dateTime2,
      start: startDateTime,
      end: endDateTime,
      mode
    });
    setShowDatePicker(false);
  };
  const scrollBarChildren = () => {
    return Object.values(availableModeList || CALENDAR_MODE_RANGE_TYPE).filter((item) => item !== CALENDAR_MODE_RANGE_TYPE.LAST_24_HOURS).map((currentMode) => /* @__PURE__ */ jsx451(
      "button",
      {
        "aria-label": `Range ${currentMode.replaceAll("_", " ")} `,
        className: currentMode === selectedMode ? styles24["active"] : "",
        onClick: () => {
          onChangeMode(currentMode);
        },
        tabIndex,
        onKeyDown: (e) => {
          if (e.key === "Enter") {
            onChangeMode(currentMode);
          }
        },
        children: /* @__PURE__ */ jsx451(
          HVText_default,
          {
            type: "Body-sm",
            weight: "Regular",
            style: { lineHeight: "inherit", color: "inherit" },
            children: formatMode(currentMode)
          }
        )
      },
      currentMode
    ));
  };
  return {
    showDatePicker,
    setShowDatePicker,
    classNames: classNames2,
    renderPeriod,
    onChangeDate,
    scrollBarChildren,
    onClickSubmit,
    timePicker,
    reRender,
    maxDate,
    selectedMode,
    selectedStart,
    selectedEnd,
    selectedTempDateTime,
    currentTimeZone,
    onClickOutside,
    formatMinuteSecond,
    datePickerRef
  };
};
var useDatePicker_default = useDatePicker;

// components/HVDatePicker/HVDatePicker.tsx
import { jsx as jsx452, jsxs as jsxs116 } from "react/jsx-runtime";
var HVDatePicker = ({
  dateTime,
  setDateTime,
  availableModeList,
  showTimePicker = false,
  disabled = false,
  tabIndex,
  rangeSelectLimit = 90,
  usePreview = false,
  showModePicker = true,
  setShowDatePicker
}) => {
  const {
    onChangeDate,
    scrollBarChildren,
    onClickSubmit,
    timePicker,
    reRender,
    maxDate,
    selectedMode,
    selectedStart,
    selectedEnd,
    selectedTempDateTime,
    currentTimeZone,
    onClickOutside,
    formatMinuteSecond: formatMinuteSecond2
  } = useDatePicker_default({
    dateTime,
    setDateTime,
    availableModeList,
    showTimePicker,
    disabled,
    tabIndex,
    rangeSelectLimit,
    usePreview
  });
  return /* @__PURE__ */ jsx452("div", { className: styles25["date-range-popup"], children: /* @__PURE__ */ jsxs116(HVFlex_default, { direction: "row", children: [
    showModePicker && /* @__PURE__ */ jsx452("div", { className: styles25["date-range-popup-sidebar"], children: /* @__PURE__ */ jsx452(ScrollBar_default, { children: scrollBarChildren() }) }),
    /* @__PURE__ */ jsxs116(HVFlex_default, { direction: "column", className: styles25["date-range-calendar"], children: [
      /* @__PURE__ */ jsx452(
        Calendar,
        {
          inline: true,
          selectsRange: true,
          showPreviousMonths: true,
          focusSelectedMonth: true,
          today: new Date(toDateWithTimezone(currentTimeZone, /* @__PURE__ */ new Date())),
          selected: new Date(
            toDateWithTimezone(currentTimeZone, new Date(selectedStart))
          ),
          startDate: new Date(
            toDateWithTimezone(currentTimeZone, new Date(selectedStart))
          ),
          endDate: selectedEnd ? new Date(
            toDateWithTimezone(currentTimeZone, new Date(selectedEnd))
          ) : void 0,
          maxDate: new Date(
            toDateWithTimezone(
              currentTimeZone,
              new Date(maxDate.toISOString())
            )
          ),
          onChange: onChangeDate,
          onClickOutside,
          ...rangeSelectLimit ? {
            minDate: new Date(
              toDateWithTimezone(
                currentTimeZone,
                new Date(
                  (/* @__PURE__ */ new Date()).getTime() - CALENDAR.MAX_SELECTABLE_DAY * 24 * 60 * 60 * 1e3
                )
              )
            )
          } : {}
        },
        reRender.toString()
      ),
      showTimePicker && /* @__PURE__ */ jsx452(
        TimePicker_default,
        {
          timePicker,
          selectedMode,
          selectedTempDateTime,
          formatMinuteSecond: formatMinuteSecond2
        }
      ),
      /* @__PURE__ */ jsx452("div", { className: styles25["button-submit"], children: /* @__PURE__ */ jsx452(
        HVButton_default,
        {
          variant: "Primary",
          onClick: () => {
            onClickSubmit();
            setShowDatePicker?.(false);
          },
          children: "OK"
        }
      ) })
    ] })
  ] }) });
};
var HVDatePicker_default = HVDatePicker;
export {
  HVAlert_default as HVAlert,
  HVAppsMenu_default as HVAppsMenu,
  HVAvatar_default as HVAvatar,
  HVBreadcrumbs_default as HVBreadcrumbs,
  HVButton_default as HVButton,
  HVCheckbox_default as HVCheckbox,
  HVClickOutSide_default as HVClickOutSide,
  HVCore,
  HVDatePicker_default as HVDatePicker,
  HVDropdown_default as HVDropdown,
  HVElevation_default as HVElevation,
  HVEmpty_default as HVEmpty,
  HVFlex_default as HVFlex,
  HVIcon_default as HVIcon,
  icons_exports as HVIcons,
  HVInput_default as HVInput,
  HVLoader_default as HVLoader,
  HVLogo_default as HVLogo,
  HVMenu_default as HVMenu,
  HVModal_default as HVModal,
  HVNavigationBar_default as HVNavigationBar,
  HVPagination_default as HVPagination,
  HVRadio_default as HVRadio,
  HVRoleSelector_default as HVRoleSelector,
  HVScrollBar_default as HVScrollBar,
  HVTab_default as HVTab,
  HVTable_default as HVTable,
  HVTableProperties,
  HVTable_default2 as HVTableV2,
  HVText_default as HVText,
  HVThemeProvider_default as HVThemeProvider,
  HVToggle_default as HVToggle,
  HVTooltip_default as HVTooltip,
  HVTopBar_default as HVTopBar,
  HVTreeItem_default as HVTreeItem,
  HVTreeView_default as HVTreeView,
  TreeViewUtils_exports as HVTreeViewUtils,
  HVUserProfile_default as HVUserProfile,
  theme,
  useHVSnackbar_default as useHVSnackbar,
  useHVTheme_default as useHVTheme
};
